module.exports = {
  Cargo_CreatBy: 'Quoter',
  Cargo_TrunkLine: 'Trunk line',
  Cargo_Inquiry_MissingBusinessCannotSubmit: '{0} type has no business selected and cannot be submitted',
  Cargo_100Million: '100 million',
  Cargo_10Cents: '10 cents',
  Cargo_1St: '1st',
  Cargo_1StInvoiceNo: '1st Inv No.',
  Cargo_1Year: '1 year',
  Cargo_2NdDispatch: '2nd Dispatch',
  Cargo_2NdDispatchTime: '2nd Dispatch Time',
  Cargo_2NdReleaseTime: '2nd Release Time',
  Cargo_2NdTransitAirportAir: '2nd transit airport (air)',
  Cargo_2StUnit: '2st unit',
  Cargo_2Years: '2 year',
  Cargo_30DaysShpt: '30d (SHPT)',
  Cargo_3RdParty: '3rd party',
  Cargo_3RdTransitAirportAir: '3rd transit airport (air)',
  Cargo_3Years: '3 year',
  Cargo_60DaysShpt: '60d (SHPT)',
  Cargo_90DaysShpt: '90d (SHPT)',
  Cargo_AAPACRIG: 'As a prepayment, a corresponding record is generated.',
  Cargo_AbandonThisVoucher: 'Abandon this voucher?',
  Cargo_Abbreviation: 'Abbreviation',
  Cargo_AbbreviationOfConsignor: 'Abbreviation of Consignor',
  Cargo_ABCDC: 'All being confirmed. Discrepancies {0} confirmed.',
  Cargo_MessageTip1: 'You have',
  Cargo_MessageTip2: 'unread reminders.',
  Cargo_Abstract: 'Index',
  Cargo_AbstractRuleOfJournalEntry: 'Entry summary rules',
  Cargo_ABYBPSTCI23M: 'AA-Bidding yearly, in next 3 months.',
  Cargo_Accepted: 'Accepted',
  Cargo_AccordingBillExchangeRate: 'By exchange rate of bill',
  Cargo_AccordingForStatementFxRate: 'According for statement FX rate',
  Cargo_AccountClosedSuccessfully: 'Checkout completed.',
  Cargo_AccountInForeignCurrency: 'Does account by original currency?',
  Cargo_AccountingMethod: 'Accounting method',
  Cargo_AccountingOrganizationCode: 'Accounting organization code',
  Cargo_AccountingQuantity: 'Accounting quantity',
  Cargo_AccountingVoucher: 'Voucher',
  Cargo_AccountPeriod: 'Account period',
  Cargo_AccountPeriodDay: 'Account period (d)',
  Cargo_AccountQuantityOrNot: 'Does account by quantity?',
  Cargo_AccountsReconciliation: 'C/A',
  Cargo_AccountsReconciliation2: 'C/A 2',
  Cargo_AccountStatement: 'Statement',
  Cargo_AccountStatementNo: 'Statement No.',
  Cargo_AccountStatementNoP: 'SOA No.:',
  Cargo_AccountTitle: 'Title',
  Cargo_AccountTitle2: 'Title 2',
  Cargo_AccountTitleCanTBeEmpty: 'Title cannot be empty.',
  Cargo_AccountTitleCategory: 'Category',
  Cargo_AccountTitleClassification: 'Classification',
  Cargo_AccountTitleClassificationRule: 'Classification rule',
  Cargo_AccountTitleCode: 'Code',
  Cargo_AccountTitleCodeCanTBeEmpty: 'Code cannot be empty.',
  Cargo_AccountTitleCodeP: 'Account Title Code:',
  Cargo_AccountTitleGroupingCondition1: 'Grouping condition 1',
  Cargo_AccountTitleGroupingCondition2: 'Grouping condition 2',
  Cargo_AccountTitleGroupingCondition3: 'Grouping condition 3',
  Cargo_AccountTitleGroupingCondition4: 'Grouping condition 4',
  Cargo_AccountTitleGroupingCondition5: 'Grouping condition 5',
  Cargo_AccountTitleGroupingCondition6: 'Grouping condition 6',
  Cargo_AccountTitleLevel: 'Level',
  Cargo_AccountTitleMapping: 'Mapping',
  Cargo_AccountTitleName: 'Name',
  Cargo_AccountTitleNameCanTBeEmpty: 'Name cannot be empty.',
  Cargo_AccountTitleNameP: 'Account Title Name:',
  Cargo_AccountTitleOfProfitNotAllocated: 'Undistributed profit title',
  Cargo_AccountTitleOfProfitNotAllocatedP: 'Account Title of Profit not Allocated:',
  Cargo_AccrualDate: 'Accrual date',
  Cargo_JobAccrualDate: 'Business Accrual date',
  Cargo_AccrualReview: 'Accrual review',
  Cargo_AccrualStatus: 'Accrual status',
  Cargo_Accrue: 'Accrual',
  Cargo_Accrued: 'Accrued',
  Cargo_UsersAlreadyProvisionedToday: 'There are users who have already been provisioned today, please check',
  Cargo_AccumulatedCommissionProfit: 'Accumulated commission profit',
  Cargo_AConsiderChangeIfOffersCheap: 'A-Consider if cheap.',
  Cargo_ACPCOIM: 'System is checking out, Please check the result after a moment.',
  Cargo_Acquired: 'Acquired',
  Cargo_AcquireFilteredExpenseList: 'Get a list of filtered fees',
  Cargo_Acquirer: 'Acquirer',
  Cargo_AcquirerCanTBeEmpty: 'Acquirer cannot be empty.',
  Cargo_AcquireSelectedItems: 'Get the selected object',
  Cargo_AcquireTotalAROrAPAmount: 'Get the total amount receivable and payable',
  Cargo_Acquisition: 'Acquisition',
  Cargo_AcquisitionRecord: 'Acquisition Record',
  Cargo_AcquisitionTime: 'Acquisition Time',
  Cargo_AcquisitionTimeCanTBeEmpty: 'Acquisition time cannot be empty.',
  Cargo_ACSWASRATBTSWEAC: 'After confirmation, system will automatically set reconciliation amount to be the same with expense amount. Continue?',
  Cargo_ACSWASRATBTSWEANCOWOEWNBPC: 'All reconciliation amounts will be set based on the fee amount. Fees will be ignored that it had been confirmed or written off. Continue?',
  Cargo_ThereAreAlreadyExportedVouchers: 'There are already exported vouchers',
  Cargo_ActualChargedWeight: 'Actual billable weight',
  Cargo_ActualGrossWeight: 'Actual G.W.',
  Cargo_ActualQuantity: 'Actual Quantity',
  Cargo_ActualReceiptAmount: 'Actual received amount',
  Cargo_ActualReceiptAndPayment: 'Actual income and expenditure',
  Cargo_ActualVolume: 'Actual CBM',
  Cargo_ActualWeight: 'Actual Weight',
  Cargo_ActualWriteOffAmountRequired: 'The amount of required write-off',
  Cargo_OnlyImportedCurrentBranch: 'Only the import operation branch is the cost of the current branch',
  Cargo_Add: 'Add',
  Cargo_AddAdjustBill: 'Increase fee (Billing)',
  Cargo_AddAirBooking: 'Add air booking',
  Cargo_AddRailwayBooking: 'Add railway booking',
  Cargo_RailwayBooking: 'Railway booking',
  Cargo_AddAirFreightServiceItems: 'Add service',
  Cargo_AddAssetAccountTitle: 'Add asset title',
  Cargo_AddAssociatedPort: 'Add related port',
  Cargo_AddAwbSurcharge: 'Add surcharge',
  Cargo_AddBasePort: 'Add base port',
  Cargo_AddBill: 'Add Billing',
  Cargo_AddBillCharge: 'Add fee',
  Cargo_AddBLType: 'Add B/L type',
  Cargo_AddCashFlowItem: 'Add Cash-flow Item',
  Cargo_AddCharges: 'Add fee',
  Cargo_AddCostType: 'Add Cost Type',
  Cargo_EditFeeType: 'Edit Fee Type',
  Cargo_DeleteFeeType: 'Delete Fee Type',
  Cargo_ImportFeeType: 'Import Fee Type',
  Cargo_SelectBusinessOperation: 'Please select the correct business operation',
  Cargo_SelectSameDelegateUnit: 'Please select the business with the same delegate unit',
  Cargo_SelectSameBusinessType: 'Please select the business with the same business type',
  Cargo_SelectSameFbaStatus: 'Please select businesses with the same FBA status',
  Cargo_SelectSameBusinessTypeWithJobNo: 'Business type mismatch: {baseJobNo} and {currentJobNo}. Please select businesses with the same business type',
  Cargo_SelectSameFbaStatusWithJobNo: 'FBA status mismatch: {baseJobNo} and {currentJobNo}. Please select businesses with the same FBA status',
  Cargo_SelectFeeType: 'Please select a fee type!',
  Cargo_ReceivablePayableLocked: 'The selected business has receivables and payables locked, this operation cannot be performed!',
  Cargo_ReceivableLocked: 'The selected business has receivables locked, this operation cannot be performed!',
  Cargo_PayableLocked: 'The selected business has payables locked, this operation cannot be performed!',
  Cargo_PayableLockedStatusTag: '(Payables Locked)',
  Cargo_PleaseSelectTheManifestYouWishToDelete: 'Please select the manifest you wish to delete',
  Cargo_TheManifestYouWishToDeleteTips: '*Tips: LCL deletion must be deleted together with the manifest in the box, not separately!',
  Cargo_ConfirmDelete: 'Confirm the deletion',
  Cargo_AddCirculationDocumentType: 'Add circulation document type',
  Cargo_AddClientType: 'Add client type',
  Cargo_AddCollectionRecord: 'Add Collection Record',
  Cargo_AddCommissionRules: 'Add commission rules',
  Cargo_AddContinent: 'Add continent',
  Cargo_AddContract: 'Add Contract',
  Cargo_AddCustomizedServiceType: 'Add custom business type',
  Cargo_AddedAlreadyDoNotRepeat: '{0} added already, do not repeat.',
  Cargo_AddedSuccessfully: 'Added successfully.',
  Cargo_AddFees: 'Add',
  Cargo_AddHeadquartersToTheList: 'Add headquarters to the list.',
  Cargo_AddJournalEntry: 'Add Entry',
  Cargo_AddKeyword: 'Add sensitive words',
  Cargo_AddMscService: 'Add MSC service',
  Cargo_AddNewSoaOrNot: 'Need to add statement',
  Cargo_AddRailwayStation: 'Add station',
  Cargo_AddressTelNo: 'Add./Tel',
  Cargo_AddressTelNoP: 'Address & Tel:',
  Cargo_AddRoute: 'Add route',
  Cargo_AddSave: 'Add & Save',
  Cargo_AddSeaBooking: 'Add shipping booking',
  Cargo_IntelligentDocumentRecognition: 'Intelligent document recognition',
  Cargo_AddSoa: 'Add statement',
  Cargo_AddToBlackList: 'Add blacklist',
  Cargo_AdjustBillDate: 'Adjusted Billing Date',
  Cargo_AdjustDate: 'Adjustment Date',
  Cargo_AdjustedItem: 'Adjusted Item',
  Cargo_AdjustedOrNot: 'Need to adjust',
  Cargo_AdjustedSuccessfully: 'Adjusted successfully.',
  Cargo_AdjustedValue: 'Adjusted Value',
  Cargo_AdjustExpenseOrNot: 'Need to adjust fee',
  Cargo_AdjustFxRateEndOfPeriod: 'Adjust FX rate (end of period)',
  Cargo_AdjustmentDateCanTBeEmpty: 'Adjustment date can\'t be empty.',
  Cargo_AdjustmentExpense: 'Adjustment fee',
  Cargo_AdjustmentExpenseState: 'Adjustment State',
  Cargo_Advance: 'Prepaid',
  Cargo_AdvanceAP: 'Prepaid A.P.',
  Cargo_AdvanceAPDifferential: 'Balance of prepaid A.P.',
  Cargo_AdvanceChargeInfo: 'Collection payment',
  Cargo_AdvancedSearch: 'Advanced Search',
  Cargo_AdvanceMoneyForAnotherOrNot: 'Advance or not',
  Cargo_AdvanceOrNot: 'Need to collection payment',
  Cargo_AdvancePayment: 'Prepaid',
  Cargo_AdvancePaymentAmount: 'Prepaid Amount',
  Cargo_AdvancePaymentItem: 'Collection payment item',
  Cargo_AdvanceReceiptOrNot: 'Need to receive in advance',
  Cargo_AdvanceReceivedAmount: 'Advance receipt',
  Cargo_AdvanceReceivedAmountIs: 'Advance Received Amount is',
  Cargo_AEBPWTCW1Y: 'AAA-There is a fixed partner, no change within 1 year。',
  Cargo_AEFTSIST: 'Air export from/to Shanghai is similar to',
  Cargo_AEIMBOUF: 'Update failed, the fee has been modified by others.',
  Cargo_AEIMBOUFM: 'Update failed, the {0} fees has been modified by others.',
  Cargo_AGEBDAWI: 'Fee has been automatically adjustment when the invoice is issued.',
  Cargo_AgentBillNo: 'Agent billing No.',
  Cargo_Aging: 'A/R Ages(d)',
  Cargo_AgingOfCurrentBill: 'Aging',
  Cargo_Agree: 'Agree',
  Cargo_AILCNETOCERCTS: 'Amount in local currency not equal to (Original Currency)*(FX rate), continue to save?',
  Cargo_Air: 'Air',
  Cargo_AirExport: 'Air Export',
  Cargo_AirImport: 'Air Import',
  Cargo_AirImportExport: 'Air Import & Export',
  Cargo_Airline: 'Route',
  Cargo_AirlineCode: 'Route code',
  Cargo_AirlineCompany: 'Airline',
  Cargo_ShippingCompanyName: 'Chinese/English name of shipping company',
  Cargo_ShippingCompanyCode: 'Shipping company code',
  Cargo_ShippingCompanyScacCode: 'Shipping company SCAC CODE',
  Cargo_ShippingCompanyChineseName: 'Chinese name of shipping company',
  Cargo_ShippingCompanyEnglishName: 'English name of shipping company',
  Cargo_DataDuplication: 'The data already exists, please do not add it again',
  Cargo_AdditionFailed: 'Addition failed',
  Cargo_DeleteShipCompany: 'Are you sure you want to delete the selected information? <br> Reminder: After deletion, the associated deleted shipping companies in the tenant will be cleared by default',
  Cargo_AssociatedPlatformShippingCompany: 'Related platform shipping companies',
  Cargo_ShipCompanyThirdPartyCode: 'Shipping company third-party code',
  Cargo_MblCode: 'Bill of Lading Code',
  Cargo_AirlinePerson: 'Route supervisor',
  Cargo_Airport: 'Airport',
  Cargo_AirportOfDischarge: 'AOD',
  Cargo_AirService: 'Air freight service item',
  Cargo_AlertConfiguration: 'Reminder Configuration',
  Cargo_AlertDaysPriorToExpiryDate: 'Reminder before * days by expiry date',
  Cargo_All: 'All',
  Cargo_AllB: '(All)',
  Cargo_AllP: '[All]',
  Cargo_AllAmount: 'Total',
  Cargo_AllAmountP: 'Total:',
  Cargo_AllCurrencies: 'All Currencies',
  Cargo_AllForeignCurrencies: 'All Foreign Currencies',
  Cargo_AllSelectedBillsWrittenOff: 'All selected bills written off.',
  Cargo_AllSelectedRecordsConfirmed: 'All selected records confirmed.',
  Cargo_AllSelectedSoaWrittenOff: 'All selected statement(s) written off.',
  Cargo_WithoutDiscrepancies: 'Without discrepancies',
  Cargo_AllWithWithoutDiscrepancies: 'All with/without discrepancies',
  Cargo_AllWrittenOff: 'All written off.',
  Cargo_AlreadyAddedOrNot: 'Has been added',
  Cargo_AmendmentFee: 'Amendment Fee',
  Cargo_Amount: 'Amount',
  Cargo_AmountF: 'Amount.',
  Cargo_AmountCanTBeEmpty: 'Amount cannot be empty.',
  Cargo_AmountCanTBeZero: 'Amount can\'t be zero',
  Cargo_AmountCNY: 'Amount(CNY)',
  Cargo_AmountCNYP: 'Amount(CNY):',
  Cargo_AmountEnteredForReconciliation: 'Entered reconciliation amount',
  Cargo_AmountIncurredOfCurrentPeriod: 'Amount in the current period',
  Cargo_AmountInOriginalCurrency: 'Original currency amount',
  Cargo_AmountNotWrittenOff: 'Unwritten-off amount',
  Cargo_AmountNumber: 'Quantity',
  Cargo_AmountNumberP: 'Quantity:',
  Cargo_AmountOfActualCollectionPayment: 'Amount of Actual Collection/Payment',
  Cargo_AmountOfCurrentMonth: 'Amount of Current Month',
  Cargo_AmountOfPaidInOutOfPocket: 'Amount of Paid-in/Out-of-pocket',
  Cargo_AmountOfPaymentApplication: 'Application Amount',
  Cargo_AmountRange: 'Amount Range',
  Cargo_AmountRemark: 'Fee Remarks',
  Cargo_AmountSum: 'Total Amount',
  Cargo_AmountTo: 'Total',
  Cargo_AmountToDetail: 'TotalDetail',
  Cargo_CurrentMonthAmountTo: 'Total(CurrentMonth)',
  Cargo_CurrentYearAmountTo: 'Total(CurrentYear)',
  Cargo_TotalReportingCurrencyOfThisMonth: 'Total reporting currency of this month',
  Cargo_TotalReportingCurrencyOfThisYear: 'Total reporting currency of this year',
  Cargo_AmountToCNY: 'Total(Only CNY)',
  Cargo_AmountToP: 'Total:',
  Cargo_AmountToUSD: 'Total(Only USD)',
  Cargo_AmountUSD: 'Amount(USD)',
  Cargo_AmountUSDP: 'Amount(USD):',
  Cargo_AmsEnsCyCutOffDate: 'AMS/ENS closing date',
  Cargo_Annual: 'Annual',
  Cargo_AolAir: 'AOL',
  Cargo_AOPLVCTBE: 'Abstract of profit & loss voucher cannot be empty.',
  Cargo_APAR: 'A/P & A/R',
  Cargo_APBill: 'A/P Bill',
  Cargo_APEOFINNPPARFV: 'Please check that this invoice(s) have not passed the payment approval in below:\\n',
  Cargo_APInclusive: 'Does it include A/P?',
  Cargo_APInvoice: 'A/P Invoice',
  Cargo_Appendix: 'Appendix',
  Cargo_Applicant: 'Applicant',
  Cargo_ApplicationDateApplicationDate: 'Application Date / Application Date',
  Cargo_ApplicationDateBusinessDate: 'Application Date / Business Date',
  Cargo_ApplicationFormSavedSuccessfully: 'Application form saved successfully.',
  Cargo_ApplicationNo: 'Application Form No.',
  Cargo_ApplicationNoBill: '{0} requisition\'s fee(s) has not invoiced, business No. is {1}.',
  Cargo_ApplicationPermission: 'Application Permission',
  Cargo_ApplicationStatus: 'Application Status',
  Cargo_AppliedForPaymentOrNot: 'Payment requested',
  Cargo_ApplyForPayment: 'Payment Application',
  Cargo_Approval: 'Approved',
  Cargo_ApprovalStatus: 'Approval Status',
  Cargo_Approved: 'Verified',
  Cargo_ApprovedBy: 'Re-checked by',
  Cargo_ApprovedStatue: 'Re-check Status',
  Cargo_April: 'April',
  Cargo_APWriteOff: 'A/P Write-off',
  Cargo_APWriteOffAmount: 'A/P Write-off Amount',
  Cargo_APWrittenOff: 'A/P written off',
  Cargo_APWrittenOffP: 'A/P written off:',
  Cargo_ARAges: 'A/R Ages',
  Cargo_ARAmountCanTExceedAPAmount: 'A/R amount can\'t exceed A/P amount.',
  Cargo_ARAP: 'A/R & A/P',
  Cargo_ARAPItemsMustBeComplete: 'A/R & A/P items must be complete',
  Cargo_ARBill: 'A/R Bill',
  Cargo_ARegularExportVolume20TeuMonthly: 'A. Export regular volume 20TEU monthly.',
  Cargo_ARInvoice: 'A/R Invoice',
  Cargo_ARIPFCSC: 'A/R invoice push failed.(CJ Smart Cargo):',
  Cargo_ARNotWrittenOff: 'A/R not Written off',
  Cargo_ARNotWrittenOffP: 'A/R not Written off:',
  Cargo_AROrNot: 'A/R or not?',
  Cargo_InvoiceAROrNot: 'Invoice A/R or not?',
  Cargo_ArrivalDate: 'Arrival date',
  Cargo_ArrivalTime: 'Arrival time',
  Cargo_ARWriteOffAmount: 'A/R Write-off Amount',
  Cargo_ARWrittenOff: 'A/R Written off',
  Cargo_ARWrittenOffP: 'A/R Written off:',
  Cargo_ASRCCTD: 'All selected records confirmed, can\'t deny.',
  Cargo_AssessedClientLevel: 'Assessed client level',
  Cargo_AssignedClientsSuccessfully: 'Assigned {0} clients successfully',
  Cargo_AssignmentDate: 'Assignment date',
  Cargo_AssignToMe: 'Assign to me',
  Cargo_AssociatedPort: 'Associated port',
  Cargo_ATCIJECTBE: 'Title code of entry cannot be empty.',
  Cargo_AttachedDocuments: 'Attached Documents',
  Cargo_Attachment: 'Attachment',
  Cargo_AttachmentP: 'Attachment:',
  Cargo_AttachmentInvoice: 'Attachment Invoice',
  Cargo_AttachmentStorage: 'Attachment storage',
  Cargo_Audit: 'Verify',
  Cargo_AuditDate: 'Review Date',
  Cargo_Auditor: 'Auditor',
  Cargo_AuditorP: 'Auditor:',
  Cargo_AuditStatus: 'Audit Status',
  Cargo_AuditSuccessfully: 'Verification successfully',
  Cargo_AuditSuccessfullyF: 'Verification successfully.',
  Cargo_Guarantee: 'Guarantee',
  Cargo_GuaranteeName: 'Guarantee name',
  Cargo_GuaranteeType: 'Type of guarantee',
  Cargo_August: 'August',
  Cargo_AuthorizedClient: 'Consignor',
  Cargo_AvailableBranch: 'Available Branch',
  Cargo_AuthorizedCubage: 'Consigned CBM',
  Cargo_AuthorizedQuantity: 'Consigned quantity',
  Cargo_AutomaticallyEnterInvoiceNumber: 'Automatically enter invoice number',
  Cargo_AutomaticGenerated: 'Automatic generated',
  Cargo_AvailableOrNot: 'Available or not?',
  Cargo_AverageMonthlyCargoVolume: 'Average monthly cargo volume',
  Cargo_AwaitBusinessApproval: 'Pending Business Approval',
  Cargo_AwaitFinancialApproval: 'Pending Financial Approval',
  Cargo_Back: 'Back',
  Cargo_BackgroundParameter: 'Background Parameter',
  Cargo_BackgroundProcessing: 'Background processing.',
  Cargo_BackgroundReturnedErrorStatus: 'Background returned error status.',
  Cargo_BackToCancel: 'Back to Cancel',
  Cargo_BackToInvoicingStatus: 'Back to Invoicing Status',
  Cargo_BackToProcessingMethod: 'Back to Processing Method',
  Cargo_BackToSearchResults: 'Back to Search Results',
  Cargo_BaiwangInvoiceExport: 'InvoiceExport(Baiwang).xml',
  Cargo_Balance: 'Balance',
  Cargo_BalanceCalculation: 'Balance Calculation',
  Cargo_BalanceCNY: 'Balance(CNY)',
  Cargo_BalanceDirection: 'Direction',
  Cargo_BalanceOfActualCollectionPayment: 'Balance of Actual Collection/Payment',
  Cargo_BalanceSheet: 'Balance Sheet',
  Cargo_BalanceSheet2: 'Balance Sheet 2',
  Cargo_BalancesOfAccountTitle: 'Balances of Account Title',
  Cargo_BalancesOfAccountTitle2: 'Balances of Account Title 2',
  Cargo_BalanceUSD: 'Balance(USD)',
  Cargo_BangPic: 'Warehouse-in pictures',
  Cargo_Bank: 'Bank',
  Cargo_BankAccount: 'Bank Account',
  Cargo_BankAccountBalance: 'Bank Account Balance',
  Cargo_BankAccountNo: 'Bank Account No.',
  Cargo_BankOfPayment: 'Bank of Payment',
  Cargo_BankReceiptDetails: 'Bank Receipt Details',
  Cargo_BankReceiptNo: 'Bank Receipt No.',
  Cargo_ReceiptNo: 'Receipt No.',
  Cargo_BankReceiptRecord: 'Bank Receipt Record',
  Cargo_BankReceiptStatus: 'Bank Receipt Status',
  Cargo_BaseCurrency: 'Base Currency',
  Cargo_BasePort: 'Base port',
  Cargo_Basic: 'Basic',
  Cargo_ExternalInterface: 'External Interface',
  Cargo_Blacklisted: 'Has been blacklisted!',
  Cargo_BasicInfo: 'Basic information',
  Cargo_BasicInformation: 'Basic Information',
  Cargo_BasisForGrouping: 'Grouping condition',
  Cargo_BatchAudit: 'Batch Review',
  Cargo_BatchCancelAudit: 'Batch Cancel Review',
  Cargo_BatchCancelConfirmation: 'Batch cancel',
  Cargo_BatchConfirm: 'Batch Confirm',
  Cargo_BatchDelete: 'Batch Delete',
  Cargo_BatchDownload: 'Batch download',
  Cargo_BatchEnterModifyBusinessOrderNo: 'Batch enter/modify business order No.',
  Cargo_BatchNo: 'Batch No.',
  Cargo_BatchNoOfCollection: 'Collection batch No.',
  Cargo_BatchNoP: 'Batch No.:',
  Cargo_BatchPrint: 'Batch Print',
  Cargo_BatchProcessing: 'Batch Processing',
  Cargo_BatchRetrieval: 'Batch Retrieval',
  Cargo_BatchRetrievalButtonTrigger: 'Batch Retrieval Button Trigger',
  Cargo_BatchRevokeRetrieval: 'Batch Revoke Retrieval',
  Cargo_BatchTransfer: 'Batch Transfer',
  Cargo_BelowBillingAmountsIncorrect: 'Below billing amounts incorrect',
  Cargo_Bill: 'Bill',
  Cargo_BillCanTBeEmpty: 'Bill cannot be empty.',
  Cargo_BillConfirmed: 'Bill Confirmed.',
  Cargo_BillConfirmedM: 'Bill [{0}] Confirmed.',
  Cargo_BillDate: 'Billing Date',
  Cargo_DueDate: 'Due Date',
  Cargo_BillDeleteAdjustment: 'Delete Adjustment(Billing)',
  Cargo_BillDeletedSuccessfully: '{0} bill(s) deleted successfully.',
  Cargo_BilledOrNot: 'Billed',
  Cargo_BillingAmount: 'Billing Amount',
  Cargo_BillingCurrency: 'Billing Currency',
  Cargo_BillingData: 'Billing Data',
  Cargo_BillingDetails: 'Billing Details',
  Cargo_BillingExpenditure: 'Billing Expenditure',
  Cargo_BillingExpenditureDetails: 'Billing Expenditure Details',
  Cargo_BillingExpense: 'Billing Expense',
  Cargo_BillingMethod: 'Billing method',
  Cargo_BillingRevenue: 'Billing Revenue',
  Cargo_BillingRevenueExpenseDetails: 'Billing Revenue & Expense Details',
  Cargo_BillInvoiced: 'Bill [{0}] Invoiced',
  Cargo_BillIssued: 'Issued',
  Cargo_BillList: 'Bill List',
  Cargo_BillNo: 'Bill No.',
  Cargo_BillNoP: 'Bill No.:',
  Cargo_BillNotSelected: 'None Bill is selected.',
  Cargo_BillPaidInFullCanTRepeatWriteOff: 'The bill has been paid in full and cannot be written off again.',
  Cargo_BillStatus: 'Bill Status',
  Cargo_BillTo: 'Billing to',
  Cargo_BillType: 'Bill Type',
  Cargo_BillWrittenOff: 'Bill [{0}] written off.',
  Cargo_Blacklist: 'Blacklist',
  Cargo_BLControl: 'B/L Control',
  Cargo_BLMAEONRS: 'B/L method already exists or no record selected',
  Cargo_BLMethodMaintenance: 'B/L method maintenance',
  Cargo_BLMode: 'B/L method',
  Cargo_BLNo: 'B/L No.',
  Cargo_BLReleaseManagement: 'B/L Release Management',
  Cargo_MBLReleaseManagement: 'MB/L Release Management',
  Cargo_HBLReleaseManagement: 'HB/L Release Management',
  Cargo_BLReleaseReview: 'B/L Release Review',
  Cargo_MBLReleaseReview: 'MB/L Release Review',
  Cargo_HBLReleaseReview: 'HB/L Release Review',
  Cargo_BLReleaseReviewStatus: 'B/L Release Review Status',
  Cargo_BlReleasingNo: 'Delivery order number.',
  Cargo_BlReleasingNoP: 'Delivery order number.:',
  Cargo_BLRemoteReleaseFee: 'Foreign B/L fee',
  Cargo_BLRetrieved: 'Retrieved',
  Cargo_BLType: 'B/L Type',
  Cargo_HBLType: 'HB/L Type',
  Cargo_BNASPCTBBE: 'Job No. and settlement party cannot be both empty.',
  Cargo_BNTTPRS: 'Batch no. {0} transferred to prepayment record successfully.',
  Cargo_BOECTBCIWBII: 'Reverse fee(s) cannot create bill.',
  Cargo_Booking: 'Order',
  Cargo_BookingAgent: 'Booking Agent',
  Cargo_BookingAgentAbbreviation: 'Abbr.(Booking Agent)',
  Cargo_BookingAgentCode: 'Code(Booking Agent)',
  Cargo_BookingNo: 'Booking No.',
  Cargo_BookingOrderNotExistCanTBeAdded: 'Add failed, the booking does not exist.',
  Cargo_BookingWindow: 'Order/Change Window',
  Cargo_BookKeeper: 'Book Keeper',
  Cargo_BookKeepingDate: 'Book-keeping Date',
  Cargo_BookKeepingMethod: 'Book-keeping Method',
  Cargo_BookKeepingVoucher: 'Book-keeping Voucher',
  Cargo_BOPIOOPCTBLT: 'Balance of paid-in/out-of-pocket cannot be less than {0}.',
  Cargo_BOPIOOPCTBLTCWOA: 'Balance of paid-in/out-of-pocket can\'t be less than current write-off amount.',
  Cargo_BPHCCTBWO: 'The bill {0} cannot be written off, because it has been submitted to HQ.',
  Cargo_BranchBill: 'Branch Bill',
  Cargo_BranchCMP: 'Branch',
  Cargo_BranchCMPP: 'Branch:',
  Cargo_BranchCompany: 'Owned Branch',
  Cargo_BranchConfirmation: 'Confirm by branch',
  Cargo_BranchConfirmed: 'Confirmed by branch',
  Cargo_BranchFilter: 'Filter by branch',
  Cargo_BREVB20TM: 'B. Export regular volume less than 20 TEU monthly.',
  Cargo_BRNPNACW: 'Reference No. / Project No. / Actual Chargeable Weight',
  Cargo_BrokenDesc: 'Description of damage',
  Cargo_BrokenNumberDetection: 'Broken number detection',
  Cargo_Browse: 'Browse',
  Cargo_BRTSIOC: 'B-Recommend to superior if offers cheap.',
  Cargo_BSNMIR: 'Business status does not meet invoicing requirements.',
  Cargo_BSNMPCR: 'Business status does not meet payment claim requirements.',
  Cargo_BSNMWOR: 'Business status does not meet write-off requirements.',
  Cargo_BulkCargo: 'Bulk cargo',
  Cargo_BURCNBE: 'The pending Business cannot be edited.',
  Cargo_Business: 'Business',
  Cargo_BusinessAdjustment: 'Business Adjustment',
  Cargo_BusinessAdjustmentLog: 'Business Adjustment Log',
  Cargo_BusinessApproval: 'Business Approval',
  Cargo_BusinessApprovalDate: 'Business Approval Date',
  Cargo_BusinessApproved: 'Business approved.',
  Cargo_OfficeApproved: 'Office approved.',
  Cargo_BusinessCategory: 'Business Category',
  Cargo_BusinessCharacteristic: 'Business characteristic',
  Cargo_BusinessCommission: 'Commission of Business',
  Cargo_BusinessCreateDate: 'Business Created Date',
  Cargo_BusinessCreator: 'Business Created by',
  Cargo_BusinessDate: 'Business Date',
  Cargo_BusinessDateBusinessDate: 'Business Date / Business Date',
  Cargo_BusinessDateP: 'Business Date:',
  Cargo_BusinessDocNo: 'Business Doc No.',
  Cargo_BusinessDocNo2: 'Business Doc 2 No.',
  Cargo_BusinessDocNoP: 'Business Doc No.:',
  Cargo_BusinessHappenDate: 'Business Date',
  Cargo_BusinessHappenDateP: 'Business Date:',
  Cargo_BusinessInformation: 'Business Information',
  Cargo_BusinessModel: 'Business model',
  Cargo_BusinessNo: 'Business No.',
  Cargo_BusinessNoInBill: 'Business No. in Bill',
  Cargo_BusinessNotSelected: 'Business not Selected.',
  Cargo_BusinessReferenceNo: 'Business Reference No.',
  Cargo_GenerateNumberOfBusiness: 'Generate Number of Business Copies',
  Cargo_UpdateBusinessAgain: 'Modify and Generate Business Again',
  Cargo_Business_CustomerRefNo: 'Business/Customer Ref No',
  Cargo_BusinessStatus: 'Business status',
  Cargo_BusinessStatusChangeLog: 'Business Status Change Log',
  Cargo_DataPushResultRecords: 'Data push result records',
  Cargo_SendType: 'Send Type',
  Cargo_ReissueFees: 'Reissue fees',
  Cargo_ReissueFeesTips: 'Clicking this button will resend all charges that failed to send.',
  Cargo_BusinessType: 'Business type',
  Cargo_BusinessTypeP: 'Business type:',
  Cargo_BusinessTypeCanTBeEmpty: 'Business type can\'t be empty',
  Cargo_BusinessTypeInconsistent: 'Business type inconsistent.',
  Cargo_ButtonPermissionControl: 'Button Permission Control',
  Cargo_BuyingPrice: 'Purchase price',
  Cargo_BWNBCAED: 'No longer create a business after the contract expires.',
  Cargo_ByBill: 'By bill',
  Cargo_ByDetail: 'By detail',
  Cargo_ByInvoice: 'By invoice',
  Cargo_ByInvoiceFxRate: 'By invoice FX rate',
  Cargo_ByJob: 'By job',
  Cargo_ByJobNo: 'By job No.',
  Cargo_ByPaymentRequestFxRate: 'By payment request FX rate',
  Cargo_BySettlementAgent: 'Via settlement Agent',
  Cargo_SettlementAgentError: 'Via settlement Agent Error.',
  Cargo_CAEONRS: 'Currency already exists or none selected.',
  Cargo_CAIFCINFCAUU: 'Check Account in Foreign Currency, if no foreign currency available, use USD.',
  Cargo_CAIOCPCRY: 'Credit Amount Incurred of Current Period (CNY)',
  Cargo_CAIOCPUSD: 'Credit Amount Incurred of Current Period (USD)',
  Cargo_CalculateBalance: 'Calculate balance',
  Cargo_CalculateBalanceTotalToWriteOff: 'Calculate balance total to write off',
  Cargo_CalculateBillingAmount: 'Calculate Billing Amount',
  Cargo_CalculatedInOriginalCurrency: 'Calculated in Original Currency',
  Cargo_CalculateTaxRate: 'Calculate tax rate',
  Cargo_CallbackFunction: 'Callback Function',
  Cargo_CanBeConfirmedOrNot: 'Can be confirmed or not?',
  Cargo_CanBeDeletedOrNot: 'Can be deleted or not?',
  Cargo_CanBePrintedOrNot: 'Can be printed or not?',
  Cargo_CanBeVoidedOrNot: 'Can be voided or not?',
  Cargo_CANCA: 'Collect & Advance / Not Collect-&-Advance',
  Cargo_Cancel: 'Cancel',
  Cargo_CancelAccrue: 'Cancel Accrual',
  Cargo_CancelAudit: 'Cancel verification',
  Cargo_NewCustomerApplication: 'New Customer Application',
  Cargo_NewSupplierApplication: 'New Supplier Application',
  Cargo_RequiredFields: 'Please fill in the corresponding required fields of the form',
  Cargo_SelectTradeType: 'Please select trade type',
  Cargo_CancelCheckOfSelectedRecord: 'Cancel check of selected record?',
  Cargo_CancelClosure: 'Cancel Closure',
  Cargo_CancelConfirm: 'Cancel Confirmation',
  Cargo_CancelCurrentModification: 'Cancel Current Modification',
  Cargo_CancelDefaultsInBatch: 'Cancel defaults in batch',
  Cargo_CancelEditing: 'Cancel Editing',
  Cargo_CancelGetBack: 'Revoke Retrieval',
  Cargo_CancelIgnore: 'Cancel ignore',
  Cargo_CancelMark: 'Cancel Mark',
  Cargo_CancelMerging: 'Cancel Merging',
  Cargo_CancelModification: 'Cancel modification?',
  Cargo_CancelPublishment: 'Cancel Publishment',
  Cargo_DownloadImportTemplate: 'Download Import Template',
  Cargo_CancelReconciliation: 'Cancel Reconciliation',
  Cargo_CancelReturn: 'Cancel Return',
  Cargo_CancelSuccessfully: 'Cancelled successfully.',
  Cargo_CancelTheChargesAudit: 'Cancel Expense Review',
  Cargo_CancelWriteOff: 'Revoke Write-off',
  Cargo_CanNotProcessUnsavedNewExpense: 'Can not process unsaved new expense.',
  Cargo_CanNotRedoCancellation: 'Can not redo cancellation',
  Cargo_CanNotRemoveAllBills: 'Can not remove all bills.',
  Cargo_CanOnlyRetrieveAfterDelivered: 'Can only retrieve after delivered.',
  Cargo_CanTDeleteItemsWithInvoiceNo: 'Can\'t delete items with invoice no.',
  Cargo_CanTDeleteWrittenOffItem: 'Can\'t delete written-off item.',
  Cargo_CanTEditClosedItem: 'Can\'t edit closed item.',
  Cargo_CanTRepeatVoiding: 'Can\'t repeat voiding item [{0}].',
  Cargo_CanTSelectInvoiceNoForEInvoice: 'Can\'t select invoice no. for E-invoice.',
  Cargo_CanTSplitInvoicedItem: 'Can\'t split invoiced item.',
  Cargo_CanTVoidInvoiceWithoutInvoiceNo: 'Can\'t void invoice without invoice no.',
  Cargo_CanTVoidWrittenOffItem: 'Can\'t void written-off item [{0}].',
  Cargo_CAOPWWT: 'Calculate amount of price with / without tax',
  Cargo_Cargo: 'Cargo',
  Cargo_Remark: 'Cargo Remarks',
  Cargo_Remark_Check: 'Cargo remarks can only input 3999 uppercase/lowercase letters, numbers, and special characters: !"#%&\'()*+,-./:;<=>?@_0-9a-zA-Z\n\s',
  Cargo_CargoDetention: 'Detained ',
  Cargo_CargoInfo: 'Cargo description',
  Cargo_CargoName: 'Cargo Name',
  Cargo_CargoNature: 'Cargo nature',
  Cargo_CargoType: 'Type of goods',
  Cargo_CAROJE: 'Configure Abstract Rule of Journal Entry',
  Cargo_CarriedOver: 'Carried over',
  Cargo_Carrier: 'Carrier',
  Cargo_Carrier_Ship: 'Carrier ship',
  Cargo_Carrier_Air: 'Carrier air',
  Cargo_Carrier_Railway: 'Carrier railway',
  Cargo_CarrierAgent: 'Shipping Agent',
  Cargo_CarrierShip: 'Shipping Company',
  Cargo_CarryOverForeignExchange: 'Carry Over Foreign Exchange',
  Cargo_CarryOverInitialized: 'Carry-over initialized.',
  Cargo_CarryOverProfitLoss: 'Carry over Profit & Loss',
  Cargo_CarryOverProfitLoss2: 'Carry over Profit & Loss 2',
  Cargo_CarryOverToNextPeriod: 'Carry Over to Next Period',
  Cargo_CartonQuantity: 'Container Type & Quantity',
  Cargo_TicketCount: 'Tickets',
  Cargo_Cash: 'Cash',
  Cargo_CasualClientNonCasualClient: 'Casual Client / Non-casual Client',
  Cargo_NonCasualClient: 'Non-casual Client',
  Cargo_CasualClientOrNot: 'Casual client or not?',
  Cargo_Category: 'Category',
  Cargo_CategoryOfPartner: 'Category of Partner',
  Cargo_CATISExport: 'Golden Taxation Export',
  Cargo_CATISInvalid: 'Golden Taxation Void',
  Cargo_CATISPrint: 'Golden Taxation Print',
  Cargo_CBEIPCPTSINACSRANMPC: 'Current Branch E-invoice: Platform Code / Password / Taxpayer\'s Identification No. / Authorization Code / Service Request Address not maintained, please check.',
  Cargo_CBEIPCTSINACSRANMPC: 'Current Branch E-invoice: Platform Code / Taxpayer\'s Identification No. / Authorization Code / Service Request Address not maintained, please check.',
  Cargo_CBFCEBD: 'Create bill for confirmed expenses by default.',
  Cargo_CBISAWTSNM: 'Current Branch: Interface service address with taxation system not maintained.',
  Cargo_CBTSINNM: 'Current Branch: Taxpayer\'s Identification No. not maintained.',
  Cargo_CCOCM: 'Confirm Cancellation of Current Modification？',
  Cargo_CCOPLV: 'Create Carry-over Profit & Loss Voucher:',
  Cargo_CCRAIOC: 'C-Consider replacing agent if offers cheap.',
  Cargo_CCS: 'Confirmation cancelled successfully.',
  Cargo_CDOPRI: 'Confirm Denial of Payment Request Information',
  Cargo_Cent: 'Cent(s)',
  Cargo_AndTo: 'And {0} to {1}',
  Cargo_AlreadyHere: 'It\'s already here',
  Cargo_IsOver: '{0} is over{1}',
  Cargo_CERNM: 'Currency {0} exchange rate not maintained.',
  Cargo_CFCNAPM: '{0} does not join accounting, please modify.',
  Cargo_CGS1RV: 'Client gained successfully! {0} record(s) verified.',
  Cargo_ChangeContent: 'Change content',
  Cargo_ChangeInvoiceTitle: 'Change invoice title',
  Cargo_ChangeInvoiceTitleP: 'Change invoice title:',
  Cargo_ChangeSob: 'Change SOB',
  Cargo_ChangeTo: 'Change to',
  Cargo_ChangeToP: 'Change to:',
  Cargo_Charge: 'Charge',
  Cargo_Chargeback: 'Withdraw',
  Cargo_ChargebackFile: 'Withdrawal Document',
  Cargo_ChargeDetails: 'Charge',
  Cargo_ChargedWeight: 'Chargeable weight',
  Cargo_ChargeName: 'Expense Description',
  Cargo_ChargeOriginalAmount: 'Original Amount of Expense',
  Cargo_ChargeOriginalCurrency: 'Original Currency of Expense',
  Cargo_ChargeOriginalExchangeRate: 'Original Exchange Rate of Expense',
  Cargo_ChargesAudit: 'Expense Review',
  Cargo_ChargesContactPerson: 'Contact of Expense',
  Cargo_ChargesReject: 'Reject Expense',
  Cargo_ChargeStatus: 'Expense Status',
  Cargo_ChargesTotalAmount: 'Total Expense Amount',
  Cargo_ChargeType: 'Expense Category',
  Cargo_ChargeTypeP: 'Expense Category:',
  Cargo_CHBRNFOA: 'Contract has been renewed, no further operation allowed',
  Cargo_CheckAccountInForeignCurrency: 'Check Account in Foreign Currency',
  Cargo_CheckChargeDetailBranch: 'Data not belong to current branch or higher.',
  Cargo_CheckCreateBillWay: 'The settlement object or settlement agent must meet one of the same criteria',
  Cargo_CheckInvoiceQueryBranch: 'The current operating branch is inconsistent with the branch to which the data belongs. Please query the data again and process it again.',
  Cargo_CheckClientToExtendValidPeriod: 'Check client to extend valid period',
  Cargo_CheckIfSoaFullyWrittenOff: 'Check if SOA fully written off.',
  Cargo_CheckingStatus: 'B/L Status',
  Cargo_HblCheckingStatus: 'HB/L Status',
  Cargo_CheckingURLStatus: 'Proof-reading Status',
  Cargo_CheckInvoice: 'Check & Invoice',
  Cargo_CheckWriteOffDetails: 'Check Write-off Details',
  Cargo_ChineseCargoName: 'Commodity description(CN)',
  Cargo_StatusUpdateTime: 'Bill of Lading Status Change Time',
  Cargo_StatusUpdateUser: 'Bill of Lading Status Changer',
  Cargo_ChineseFirstVesselName: 'Vessel name',
  Cargo_ChineseName: 'Chinese name',
  Cargo_ChineseNameCanTBeEmpty: 'Chinese name can\'t be empty',
  Cargo_ChineseNameOfSettlingParty: 'Chinese Name of Settling Party',
  Cargo_Choose0P: 'Selected 0:',
  Cargo_ChooseByText: 'Choose by text',
  Cargo_ChooseFee: 'Choose fee',
  Cargo_ChooseFeeCNY: 'Choose fee(CNY)',
  Cargo_ChooseFeeUSD: 'Choose fee(USD)',
  Cargo_ChooseInvoicedFee: 'Choose invoiced fee',
  Cargo_ChooseP: 'Selected {0}:',
  Cargo_TicketCount: 'Tickets: ',
  Cargo_CIIRSBATTB: 'Confirm if invoicing requirement shall be added to the bill',
  Cargo_CIMJ: 'Courier Information Mandatoriness Judgement',
  Cargo_CIMS: 'Collection information modified successfully.',
  Cargo_City: 'City',
  Cargo_CityCode: 'City code',
  Cargo_CityMaintenance: 'City maintenance',
  Cargo_CityName: 'City name',
  Cargo_CityNotSelected: 'City not selected',
  Cargo_CityP: 'City',
  Cargo_Claim: 'Claim',
  Cargo_ClaimAdvanceReceipt: 'Claim Advance Receipt',
  Cargo_ClaimAR: 'Claim A/R',
  Cargo_ClaimBankReceipt: 'Claim Bank Receipt',
  Cargo_ClaimDate: 'Claim Date',
  Cargo_ClaimedBy: 'Claimed by',
  Cargo_ClaimInformation: 'Claim Information',
  Cargo_ClaimOrNot: 'Claim or not?',
  Cargo_ClaimState: 'Claim Status',
  Cargo_ClaimStatusOfAdvanceReceipt: 'Claim Status of Advance Receipt',
  Cargo_ClaimStatusOfAR: 'Claim Status of A/R',
  Cargo_Clear: 'Clear',
  Cargo_ClearData: 'Clear Data',
  Cargo_ClearFilter: 'Clear Filter',
  Cargo_ClickToFilter: 'Click to filter',
  Cargo_ClickToLoadParameter: 'Click to load parameter(s)',
  Cargo_ClickToQuery: 'Click to query',
  Cargo_ClientAllocationStatus: 'Client allocation status',
  Cargo_CLientCantBeEmpty: 'Client can\'t be empty.',
  Cargo_ClientContract: 'Customer Contract',
  Cargo_ClientEventNotSelected: 'Client event not selected',
  Cargo_ClientList: 'Client List',
  Cargo_ClientMovedToRecycleBin: 'Client moved to recycle bin',
  Cargo_ClientNo: 'Client No.',
  Cargo_ClientOverseasAgent: 'Client/Overseas agent',
  Cargo_ClientStatus: 'Client status',
  Cargo_ClientSVisit: 'Client\'s visit',
  Cargo_ClientVendor: 'Client/Vendor',
  Cargo_Close: 'Close',
  Cargo_Close2: 'Close',
  Cargo_CloseAccount: 'Close Account',
  Cargo_CloseAccount2: 'Close Account2',
  Cargo_CloseAccountOrNot: 'Close account or not?',
  Cargo_CloseDateOfContainerReturn: 'Return container date to',
  Cargo_CloseDetailWindow: 'Close Detail Window',
  Cargo_CloseWindow: 'Close Window',
  Cargo_ClosureNo: 'Closure No.',
  Cargo_ClosureTimeSelection: 'Closure Time Selection',
  Cargo_ClosureTitleOfAccount: 'Closure Title of Account',
  Cargo_CNY: 'CNY',
  Cargo_CNYHKD: 'CNY/HKD',
  Cargo_CNYInvoiceNo: 'CNY Invoice No.',
  Cargo_CNYP: 'CNY:',
  Cargo_COACP: 'Currency of Actual Collection/Payment',
  Cargo_Code: 'Code',
  Cargo_CodeCanTBeEmpty: 'Code can\'t be empty',
  Cargo_DuplicateCode: 'Duplicate code, please re-enter.',
  Cargo_CodeNotMaintained: 'Code not maintained.',
  Cargo_CodeOfExpenseDescription: 'Code of Expense Description',
  Cargo_CodeSearching: 'Search code',
  Cargo_CodeType: 'Code Type',
  Cargo_CodeTypeP: 'Code Type:',
  Cargo_Coding: 'Coding',
  Cargo_ApCoding: 'Payable Coding',
  Cargo_ArCoding: 'Receivable Coding',
  Cargo_CodingMapping: 'Coding Mapping',
  Cargo_CodingP: 'Coding:',
  Cargo_Collect: 'Collect',
  Cargo_CollectAndPrepaidOrNot: 'Collect-&-advance or not?',
  Cargo_CollectedExpenseDetails: 'Collected Expense Details',
  Cargo_CollectedExpenseDetailsP: 'Collected Expense Details:',
  Cargo_CollectedInFull: 'Collected in full',
  Cargo_CollectedNotCollectedInFull: 'Collected / Not Collected in full',
  Cargo_CollectFormation: 'Collection Information',
  Cargo_CollectInvoice: 'Check',
  Cargo_Collection: 'Collection',
  Cargo_CollectionCNY: 'Collection(CNY)',
  Cargo_CollectionDetails: 'Collection Details',
  Cargo_CollectionDifference: 'Collection Difference',
  Cargo_CollectionInformation: 'Collection Information',
  Cargo_CollectionPayment: 'Collection/Payment',
  Cargo_CollectionPaymentCleared: 'Collection/Payment cleared.',
  Cargo_CollectionPaymentDate: 'Collection/Payment Date',
  Cargo_CollectionPaymentInformation: 'Collection/Payment Information',
  Cargo_CollectionPaymentMethod: 'Collection/Payment Method',
  Cargo_CollectionPaymentTypeFilter: 'Collection/Payment Type Filter',
  Cargo_CollectionRecordByCarrier: 'Collection record by carrier',
  Cargo_CollectionSituation: 'Collection Status',
  Cargo_CollectionStatus: 'Collection Status',
  Cargo_CollectionUSD: 'Collection(USD)',
  Cargo_CoLoadConsol: 'Consignment LCL',
  Cargo_ColorOfControllingRow: 'Color of Controlling Row',
  Cargo_CombinedInvoicing: 'Combined Invoicing',
  Cargo_CombinedListNo: 'Combined List No.',
  Cargo_Commission: 'Commission',
  Cargo_CommissionAmount: 'Commission Amount',
  Cargo_CommissionedGrossWeight: 'Consigned G.W.',
  Cargo_CommissionItems: 'Commission items',
  Cargo_CommissionOrNot: 'Commission or not',
  Cargo_CommissionPercentage: 'Commission Percentage',
  Cargo_CommissionRules: 'Commission rules',
  Cargo_CommodityCode: 'Commodity code',
  Cargo_CommodityInspection: 'CIQ',
  Cargo_CommonlyUsedTradeTerms: 'Commonly used trade terms',
  Cargo_Company: 'Company',
  Cargo_CompanySelfRelease: 'Company\'s Self-prepared Document',
  Cargo_CompanySReceivingAccountNumber: 'Company\'s Receiving Account Number',
  Cargo_CompanySReceivingBank: 'Company\'s Receiving Bank',
  Cargo_Competitor: 'Competitor',
  Cargo_Completed: 'Complete',
  Cargo_CompleteDate: 'Date to',
  Cargo_CompletedOrNot: 'Completed or not?',
  Cargo_CompleteWriteOff: 'Complete Write-off',
  Cargo_CompletionTime: 'Completion Time',
  Cargo_ConditionOfSearch: 'Condition of Search',
  Cargo_ConditionType: 'Condition Type',
  Cargo_ConfiCNYill: 'Confirm Bill',
  Cargo_ConfigureAccountTitle: 'Configure Account Title',
  Cargo_Confirm: 'Confirm',
  Cargo_AMSEnsChannel: 'Counter terrorism manifest -ENS identifies suppliers',
  Cargo_SkipAll: 'Skip All',
  Cargo_SecondFlightSchedule: 'Second flight schedule',
  Cargo_TwoWayFreighter: 'Two way freighter',
  Cargo_EmailFormatError: 'Email format error',
  Cargo_CountryOfShipment: 'Country of shipment',
  Cargo_AirFreightRateDetails: 'Air freight rate details',
  Cargo_ConfirmAndCheckSelectedRecord: 'Confirm and check selected record?',
  Cargo_ConfirmAP: 'Confirm A/P',
  Cargo_ConfirmCancellationOfRecord: 'Confirm Cancellation of Record？',
  Cargo_ConfirmCombinedInvoice: 'Confirm combined invoice',
  Cargo_ConfirmDate: 'Confirmation Date',
  Cargo_Confirmed: 'Confirmed',
  Cargo_ConfirmedSuccessfully: 'Confirmed successfully.',
  Cargo_ConfirmExpenses: 'Confirm expenses',
  Cargo_ConfirmNotification: 'Confirm notification',
  Cargo_ConfirmOffset: 'Confirm Offset',
  Cargo_ConfirmOrNot: 'Confirm or not?',
  Cargo_ConfirmPartial: 'Confirm partial?',
  Cargo_ConfirmR: 'Confirm',
  Cargo_ConfirmRQ: 'Confirm?',
  Cargo_ConfirmRemarks: 'Remarks of Confirmation',
  Cargo_ConfirmSelectedItem: 'Confirm Selected Item',
  Cargo_ConfirmStatus: 'Confirmation Status',
  Cargo_ConfirmSubmissionOfPaymentOrder: 'Confirm Submission of Payment Order？',
  Cargo_ConfirmWriteOff: 'Confirm Write-off',
  Cargo_ConfirmWriteOffQ: 'Confirm write-off?',
  Cargo_ConfirmWrittenOffExpense: 'Confirm Written-off Expense',
  Cargo_ConflictExpenseDetails: 'Conflict Expense Details',
  Cargo_Consignation: 'Consignment',
  Cargo_ConsignationCompanyCannotBeNull: 'Consignor can\'t be empty',
  Cargo_Consignee: 'Consignee',
  Cargo_ConsigneeId: 'Consignee\'s code',
  Cargo_ConsigneeInfo: 'Consignee\'s information',
  Cargo_ConsigneeSName: 'Consignee\'s name',
  Cargo_ConsignorSCode: 'Consignor\'s Code',
  Cargo_ConsolidatedCNY: 'Consolidated (CNY)',
  Cargo_ConsolidatedCurrency: 'Combined Currency',
  Cargo_ConsolidatedLocalCurrency: 'Consolidated Local Currency',
  Cargo_ConsolidatedLocalCurrencyCNY: 'Consolidated Local Currency (CNY)',
  Cargo_ConsolidatedProfitLossIs: 'Consolidated profit & loss is',
  Cargo_ConsolidateOrNot: 'Consolidate or not?',
  Cargo_Contact: 'Contact Person',
  Cargo_ContactNumber: 'Tel No.',
  Cargo_ContainerAmount: 'Container quantity',
  Cargo_ContainerDescription: 'Quantity of Containers',
  Cargo_ContainerInfo: 'Packing information',
  Cargo_ContainerNo: 'Container no.',
  Cargo_ContainerSize: 'Container type',
  Cargo_ContainerType: 'Container type',
  Cargo_ContainerRule: 'Box ruler',
  Cargo_ContainerTypeCanTBeEmpty: 'Container type can\'t be empty',
  Cargo_ContainerTypeMaintenance: 'Container type maintenance',
  Cargo_ContainerTypeSea: 'Container type (Sea)',
  Cargo_ContentDescription: 'Content description',
  Cargo_ContentFailedToLoad: 'Content failed to load.',
  Cargo_ContentFailedToLoadP: 'Content failed to load.',
  Cargo_ContentOfAmount: 'Content of Amount',
  Cargo_ContentOfExpenseDescription: 'Content of Expense Description',
  Cargo_ContentPreviewOfPaymentNotice: 'Content Preview of Payment Notice',
  Cargo_Continent: 'Continent',
  Cargo_ContinueToAddData: 'Continue to add data',
  Cargo_ContinueToSave: 'Continue to save',
  Cargo_ContinuousFilter: 'Continuous Filter',
  Cargo_Contra: 'Contra',
  Cargo_ContraAmount: 'Contra Amount',
  Cargo_ContraAmountP: 'Contra Amount:',
  Cargo_ContraBalance: 'Contra Balance',
  Cargo_ContractAdministrator: 'Contract administrator',
  Cargo_ContractConfiguration: 'Contract Configuration',
  Cargo_Contracted: 'Contracted',
  Cargo_ContractedClientInformation: 'Contracted client information',
  Cargo_ContractExpired: 'Contract expired',
  Cargo_ContractNumber: 'Contract Number',
  Cargo_ContractNumberCanTBeEmpty: 'Contract number can\'t be empty',
  Cargo_ContractRateProperty: 'S/C Rate Category',
  Cargo_ContractSignedSuccessfully: 'Contract signed successfully',
  Cargo_ContractStatus: 'Contract Status',
  Cargo_RiskReason: 'Risk Reason',
  Cargo_ContractValidStatus: 'Contract Status',
  Cargo_ContractTerms: 'Contract terms',
  Cargo_CurrentCredit: 'Current Credit',
  Cargo_ContractCredit: 'Contract Credit',
  Cargo_ContractType: 'Contract Type',
  Cargo_ConversionAmountContent: 'Conversion Amount Content',
  Cargo_ConversionAmountInCNY: 'Conversion Amount in CNY',
  Cargo_ConversionRMB: 'Conversion RMB',
  Cargo_ConversionAP: 'Conversion A/P',
  Cargo_ConversionAPCNY: 'Conversion A/P(CNY)',
  Cargo_ConversionPaidCNY: 'Conversion Paid (CNY)',
  Cargo_ConversionAPCurrency: 'Conversion A/P({0})',
  Cargo_ConversionAR: 'Conversion A/R',
  Cargo_ConversionARCNY: 'Conversion A/R(CNY)',
  Cargo_ConversionReceivedCNY: 'Conversion Received (CNY)',
  Cargo_ConversionARCurrency: 'Conversion A/R({0})',
  Cargo_ConversionCurrencyAmount: 'Conversion Currency Amount',
  Cargo_ConversionOutstandingAR: 'Conversion Outstanding A/R',
  Cargo_ConversionOutstandingARCNY: 'Conversion Outstanding A/R(CNY)',
  Cargo_ConversionOutstandingARCurrency: 'Conversion Outstanding A/R({0})',
  Cargo_ConversionOutstandingReceivedCurrency: 'Conversion Outstanding Received({0})',
  Cargo_ConversionProfit: 'Conversion Profit',
  Cargo_ConversionProfitCNY: 'Conversion Profit(CNY)',
  Cargo_ConversionProfitCNYP: 'Conversion Profit(CNY):',
  Cargo_ConversionWriteOffAmountInCNY: 'Conversion Write-off Amount in CNY',
  Cargo_COPLOCP: 'Carry Over Profit & Loss of Current Period',
  Cargo_Copy: 'Copy',
  Cargo_CopyAndAddPoItems: 'Copy new items',
  Cargo_CopyExchangeRate: 'Copy exchange rate',
  Cargo_CopyFromExisting: 'Copy from existing',
  Cargo_InitializeLevelOneSubject: 'Initialize level one subject',
  Cargo_InitializeReport: 'Initialize Report',
  Cargo_Cost: 'Expenses',
  Cargo_CostInvoiceNo: 'Cost Invoice No.',
  Cargo_CounterpartySBankAccount: 'Counterparty\'s Bank Account',
  Cargo_CounterpartySBillingNo: 'Counterparty\'s Billing No.',
  Cargo_Country: 'Country',
  Cargo_CountryMaintenance: 'Country maintenance',
  Cargo_CountryRegion: 'Country Region',
  Cargo_CountryRegionCode: 'Country Region Code',
  Cargo_CourierOrderNo: 'Courier Order No.',
  Cargo_CPIOOPRCCTBV: 'Current paid-in/out-of-pocket record checked, can\'t be voided.',
  Cargo_CPIOOPRVCTBM: 'Current paid-in/out-of-pocket record voided, can\'t be modified.',
  Cargo_CPIOOPRWOCTBV: 'Current paid-in/out-of-pocket record written off, can\'t be voided.',
  Cargo_identifyTheResult: 'identify the result',
  Cargo_identifyTheResult2: 'Identifying bill of lading information',
  Cargo_SystemResult: 'System bill of lading information',
  Cargo_ContrastingSystem: 'Contrasting System',
  Cargo_SaveBillData: 'Save bill of lading information',
  Cargo_SaveBill2: 'Identification information directly overlays the bill of lading',
  Cargo_InAnalysis: 'Parsing, please wait',
  Cargo_UnopenedService: 'The service is not enabled and cannot be used',
  Cargo_F17Verify: 'F17 transmission requires that the master and house airwaybill numbers match',
  Cargo_Will: 'will',
  Cargo_DFI: 'Drag here for identification, or',
  Cargo_seaFile: 'The consignment documents from the sea',
  Cargo_seaFile2: 'Sea export booking note recognition',
  Cargo_siFile: 'Bill of lading documents for maritime entry',
  Cargo_siFile2: 'Sea import bill of lading recognition',
  Cargo_seBillFile: 'Maritime bill of lading documents',
  Cargo_seBillFile2: 'Sea export bill of lading recognition',
  Cargo_aeFile2: 'Air Export Booking Recognition',
  Cargo_aiFile2: 'Air Import Bill of Lading Recognition',
  Cargo_GenerateSiBusiness: 'Generate sea import business',
  Cargo_MaritimeIdentification: 'Maritime identification',
  Cargo_ApplicationIdentificationType: 'Application identification type',
  Cargo_IdentificationType: 'Identification Type',
  Cargo_IdentificationChannel: 'Identification channel',
  Cargo_OriginalMessage: 'Original message',
  Cargo_DataSource: 'Data Source',
  Cargo_InvoiceExport: 'Invoice Export',
  Cargo_InvoiceNoImport: 'Import invoice number',
  Cargo_profitMargin: 'profit margin',
  Cargo_Payment1: 'Payer',
  Cargo_PaymentCode: 'Payer Code',
  Cargo_PaymentName1: 'Payer Contact Name',
  Cargo_PaymentName: 'Payer Name',
  Cargo_SelectPayment: 'Select the payer',
  Cargo_ShowTab: 'Display the supplementary tab',
  Cargo_MscBookingInfo: 'MSC booking supplementary information',
  Cargo_PaymentInfo: 'Payer Information',
  Cargo_PaymentInfo1: 'Formatted Payer',
  Cargo_PaymentEnterpriseCode: 'Payer Enterprise Code',
  Cargo_Payment2: 'Payer Enterprise Name',
  Cargo_Payment3: 'Payer Detailed Address',
  Cargo_Payment4: 'Payer Phone Number',
  Cargo_Payment5: 'Payer Email Address',
  Cargo_Payment6: 'Payer Telex Number',
  Cargo_Province1: 'Province/State',
  Cargo_GeneralFormat: 'General Format',
  Cargo_DetailFormat: 'Detail Format',
  Cargo_BringInData: 'Bring In Data',
  Cargo_DefaultInvoiceIssuer: 'Default Invoice Issuer',
  Cargo_checkCabinTip: 'There are data with and without cabin space serial numbers; they cannot be operated together.',
  Cargo_checkCabinTip2: 'The orders you have selected will undergo the cabin space withdrawal process.',
  Cargo_RecoverText: 'Recover the cabin space and directly register the cabin cancellation. Are you sure?',
  Cargo_RecoverRemark: 'Cabin Cancellation Explanation',
  Cargo_RecoverTips: 'Recover and Cancel Cabin',
  Cargo_LinesArAp: 'Lines receivable/lines payable',
  Cargo_RInPay: 'Receivables include payables',
  Cargo_market: 'market',
  Cargo_GPExplain: 'GP explain',
  Cargo_ServiceLockSetting1: 'Auto-Job Close',
  Cargo_ServiceLockSettings: 'Automatic service configuration',
  Cargo_OnlyServiceDataLocked: 'Only business data is locked, and the expense TAB can be edited',
  Cargo_AutomaticallyLocksServiceData: 'Automatically locks service data',
  Cargo_AutomaticallySubmitServiceData: 'Automatically submit service data',
  Cargo_SystemAutomaticExecution: 'System Automatic Execution',
  Cargo_ServicesNotSubmittedAutomaticallySubmitted: 'Services that are not submitted are automatically submitted',
  Cargo_LockTheNumberOfDeferredDays: 'The lockout delay days range from 3 to 120',
  Cargo_checkBillingGroup: '[{0}] Bill status is not "{1}"',
  Cargo_AutoLock: 'Auto-Close',
  Cargo_BusinessDate1: 'After Job create date of',
  Cargo_Days1: 'day(s)',
  Cargo_SendBookingFail: 'Sending booking failed',
  Cargo_uploadErr: 'fail to upload',
  Cargo_Create: 'Create',
  Cargo_CreateAndExportDirectly: 'Create and Export Directly',
  Cargo_CreateBill: 'Create Bill',
  Cargo_BatchCreateBillTitle: 'Please select data range',
  Cargo_BatchCreateBillBySame: 'Create bill by same settlement Object',
  Cargo_BatchCreateBillByAll: 'Create bill by all records',
  Cargo_BatchCreateBillBySelected: 'Create bill by selected records',
  Cargo_BatchCreateBillSuccess: 'Operated successfully: Total {0} bills',
  Cargo_BatchCreateBill: 'Batch Create Bill',
  Cargo_CreateBillQ: 'Create bill?',
  Cargo_CreateCombination: 'Create Combination',
  Cargo_CreateCostInvoice: 'Create cost invoice?',
  Cargo_CreatedBy: 'Entry person',
  Cargo_CreatedDate: 'Creation Date',
  Cargo_CreatedSuccessfully: 'Created successfully.',
  Cargo_CreateInvoice: 'Create Invoice',
  Cargo_CreateListOfCombinedInvoices: 'Create List of Combined Invoices',
  Cargo_CreateOffsetExpense: 'Create Offset Expense',
  Cargo_CreatePaymentRequest: 'Create payment request',
  Cargo_CreatePaymentRequestChooseFees: 'Create payment request - select expenses',
  Cargo_CreatePaymentRequestDetails: 'Create payment request - Details',
  Cargo_BasicPaymentRequest: 'Payment Request (Basic Version)',
  Cargo_PendingSupervisorApproval: 'Pending Supervisor Approval',
  Cargo_PaymentRequestSettings: 'Payment Request Settings',
  Cargo_EnableUICustomization: 'Enable UI Custom Display',
  Cargo_AdditionalApprovalNode: 'Additional Approval Node',
  Cargo_DepartmentApprovalTab: 'Department Approval (Show Pending Dept Approval Tab)',
  Cargo_SupervisorApprovalTab: 'Supervisor Approval (Show Pending Supervisor Approval Tab)',
  Cargo_Settings: 'Settings',
  Cargo_PendingDepartmentApproval: 'Pending Department Approval',
  Cargo_PreApproval: 'Pre-Approval',
  Cargo_FinanceApproval: 'Finance Approval',
  Cargo_OperationReview: 'Operation Review',
  Cargo_DepartmentReview: 'Department Review',
  Cargo_SupervisorReview: 'Supervisor Review',
  Cargo_RuleBasedApproval: 'Only documents meeting rules enter this tab for additional approval',
  Cargo_NonRuleBypass: 'Allow documents not meeting specific rules to bypass supervisor approval',
  Cargo_AllPaymentRequests: 'Payment Requests (All)',
  Cargo_SupervisorReviewer: 'Supervisor Reviewer',
  Cargo_SupervisorReviewDate: 'Supervisor Review Date',
  Cargo_SettlementUnitContractStatus: 'Settlement Unit Contract Status',
  Cargo_ReturnToPreviousApprovalNode: 'Whether to return to the previous approval node',
  Cargo_CreateSoa: 'Create SOA',
  Cargo_CreateVoucher: 'Create Voucher',
  Cargo_Creator: 'Creator',
  Cargo_Credit: 'Credit',
  Cargo_CreditAmount: 'Credit Amount',
  Cargo_CreditAmount2: 'Credit Amount',
  Cargo_CreditAmountCNY: 'Credit Side (CNY)',
  Cargo_CreditAmountOccurred: 'Credit Amount Occurred',
  Cargo_CreditAmountOccurredCNY: 'Credit Amount Occurred (CNY)',
  Cargo_CreditAmountOccurredP: 'Credit Amount Occurred:',
  Cargo_CreditAmountOccurredUSD: 'Credit Amount Occurred (USD)',
  Cargo_CreditAmountTo: 'Credit Total',
  Cargo_CreditAmountToP: 'Credit Total:',
  Cargo_CreditAmountUSD: 'Credit Side (USD)',
  Cargo_CreditControlDetails: 'Credit control details',
  Cargo_CreditControlSettings: 'Credit control setup',
  Cargo_CreditLimitExceeded: 'Credit limit exceeded',
  Cargo_ETDSettingDays: 'ETD days setting',
  Cargo_ETDOccupyDays: 'ETD occupied days',
  Cargo_ETDExceeded: 'ETD exceeded',
  Cargo_CreditLimitRange: 'Credit limit range',
  Cargo_CreditLocalCurrency: 'Credit Local Currency',
  Cargo_CreditNotWrittenOff: 'Credit Not Written-off',
  Cargo_CreditOriginalAmount: 'Credit Original Amount',
  Cargo_CreditSide: 'Credit Side',
  Cargo_CreditUsed: 'Credit used',
  Cargo_CreditWriteOffAmount: 'Credit Write-off Amount',
  Cargo_CREVB5TM: 'C. Regular export volume below 5TEU monthly',
  Cargo_CRPI: 'Confirm Recording Prepayment Information?',
  Cargo_CSNPM: 'Consignee/Shipper/Notify Party maintenance',
  Cargo_CSR: 'Operator',
  Cargo_CSRGTIDDDI: 'Current search results greater than items displayed, data display incomplete.',
  Cargo_CSWTCSTR: 'Contract signed with this client, select to renew.',
  Cargo_CTMCWOPCCF: 'Can\'t modify checked write-off, please cancel check first.',
  Cargo_CTOPR: 'Confirm Transfer of Prepayment Record？',
  Cargo_CTORI: 'Confirm Transfer of Reconciliation?',
  Cargo_CTRCWOPCCF: 'Can\'t revoke checked write-off, please cancel check first.',
  Cargo_CTRLSPFCC: 'Confirm to release linked sales person from current client',
  Cargo_Cubage: 'CBM',
  Cargo_Currency: 'Currency',
  Cargo_CurrencyCanTBeEmpty: 'Currency can\'t be empty.',
  Cargo_CurrencyFXRateNoMaintained: '{0}\'s FX Rate not be maintained.',
  Cargo_CurrencyInconsistent: 'Currency inconsistent.',
  Cargo_CurrencyMaintenance: 'Currency maintenance',
  Cargo_CurrencyOfPayment: 'Currency of Payment',
  Cargo_CurrencyOfTotal: 'Currency of Total',
  Cargo_CurrencyP: 'Currency:',
  Cargo_CurrentClientIsContracted: 'Current client is contracted',
  Cargo_CurrentExchangeRate: 'Current Exchange Rate',
  Cargo_CurrentLoginUser: 'Current Login User',
  Cargo_CurrentMonth: 'Current month',
  Cargo_CurrentSelected: 'Current selected',
  Cargo_Reefer: 'Reefer',
  Cargo_ShowCharacteristics: 'Show characteristics check box',
  Cargo_ShowCharacteristicsTip: 'When select current Cargo Type,show “Electric” “Magnetic” “Powder” “Liquid” check box in order basic page.',
  Electric: 'Electric',
  Magnetic: 'Magnetic',
  Powder: 'Powder',
  Liquid: 'Liquid',
  Cargo_CurrentSelectedExpense: 'Current selected expense {0}',
  Cargo_CurrentSelectedSobIs: 'Current selected SOB is {0}',
  Cargo_CurrentSettlingParty: 'Current Settling Party',
  Cargo_CurrentWriteOffSerialNoCompleted: 'Current write-off serial no. completed.',
  Cargo_CurrentYearAccumulatedAmount: 'Amount of Current Year Cumulative',
  Cargo_CurrentYearProfitAccount: 'Account Title of Current Year Profit',
  Cargo_CurrentYearProfitAccountP: 'Account Title of Current Year Profit:',
  Cargo_CurrentYearTotal: 'Current Year Cumulative',
  Cargo_CurrentYearTotalAmout: 'Cumulative Amount Incurred of Current Year',
  Cargo_CurrentYearTotalAmoutCreditCNY: 'Cumulative credit amount incurred of current year in CNY',
  Cargo_CurrentYearTotalAmoutCreditUSD: 'Cumulative credit amount incurred of current year in USD',
  Cargo_CurrentYearTotalAmoutDebitCNY: 'Cumulative debit amount incurred of current year in CNY',
  Cargo_CurrentYearTotalAmoutDebitUSD: 'Cumulative debit amount incurred of current year in USD',
  Cargo_CursorPointedInvoiceNo: 'Cursor-pointed Invoice No.',
  Cargo_Customer: 'Client',
  Cargo_CustomerAddress: 'Client\'s address',
  Cargo_CustomerHasConfirm: 'No. {0}, customer has confirmed.',
  Cargo_CustomerLevel: 'Customer Level',
  Cargo_CustomerName: 'Client Name',
  Cargo_CustomerP: 'Client:',
  Cargo_CustomerProperty: 'Client nature',
  Cargo_CustomerReferenceNumber: 'Client\'s Reference No.',
  Cargo_CustomerSelfRelease: 'Client\'s Self-prepared Document',
  Cargo_CustomerService: 'Customer Service',
  Cargo_CustomerSpace2: 'Nomination cargo',
  Cargo_CustomerSpace3: 'Free-hand cargo',
  Cargo_CustomerType: 'Client type',
  Cargo_Customized: 'Customized',
  Cargo_CustomizedField1: 'Customized Field1',
  Cargo_CustomizedField2: 'Customized Field2',
  Cargo_CustomizedField3: 'Customized Field3',
  Cargo_CustomizedField4: 'Customized Field4',
  Cargo_CustomJobType: 'Customized Business Type',
  Cargo_CustomJobTypeP: 'Customized Business Type:',
  Cargo_CustomsApproval: 'Customs approval',
  Cargo_CustomsBroker: 'Customs broker',
  Cargo_CustomsBrokerFilter: 'Customs Broker Filter',
  Cargo_CustomsDeclaration: 'Customs declaration',
  Cargo_CustomsDeclarationSearchFailed: 'Customs declaration search failed.',
  Cargo_CustomsNo: 'Customs Code',
  Cargo_CWOIFCTTTEPRCOEA: 'Collection written off in full, can\'t transfer to expense, please redo collection or expense application.',
  Cargo_CYCutOffDate: 'Cut-off date',
  Cargo_CYSPATIPLVCTBE: 'Current year\'s profit account title in profit & loss voucher can\'t be empty.',
  Cargo_CYWRYTTPPATDWBMTRS: 'Clicking \'Yes\' will redirect you to the print page, and the document will be modified to \'Returned\' status.',
  Cargo_CYWRYTTPPATRDWBCTRS: 'Clicking \'Yes\' will redirect you to the print page, and the retrieved document will be changed to \'Returned\' status.',
  Cargo_DAIIUCTBD: 'Difference adjustment is in use, can\'t be deleted',
  Cargo_DAIOCPCNY: 'Dedit Amount Incurred of Current Period (CNY)',
  Cargo_DAIOCPUSD: 'Debit Amount Incurred of Current Period (USD)',
  Cargo_DataExport: 'Export',
  Cargo_DataExportPDF: 'Export PDF',
  Cargo_DataSent: 'Information Sent',
  Cargo_DataTransmissionStatus: 'Data Transmission Status',
  Cargo_DataType: 'Data Type',
  Cargo_DataTypeP: 'Data Type:',
  Cargo_Date: 'Date',
  Cargo_DateCanTBeEmpty: 'Date can\'t be empty.',
  Cargo_DateFrom: 'Date from',
  Cargo_DateFunction: 'Date Function',
  Cargo_DateNotInPeriod: 'Date not in period.',
  Cargo_DateOfApplication: 'Application Date',
  Cargo_DateOfCollectionCanTBeEmpty: 'Date of collection can\'t be empty.',
  Cargo_DateOfDeclaration: 'Filing Date',
  Cargo_DateOfDepartureCannotBeNull: 'ETD can\'t be empty',
  Cargo_DateOfDocument: 'Prepared Date',
  Cargo_DateOfInvoicingList: 'Date of Invoicing List',
  Cargo_DateP: 'Date:',
  Cargo_DateType: 'Date Tune',
  Cargo_DateType2: 'Date type 2',
  Cargo_Days: 'Day',
  Cargo_DaysFromContractSigned: 'Days from contract signed',
  Cargo_DaysOfSleep: 'Days of sleep',
  Cargo_DaysOverdue: 'Days Overdue',
  Cargo_DaysToContractExpiry: 'Days to contract expiry',
  Cargo_DBASBEICS: 'Default bank account should be empty if cash selected.',
  Cargo_Deadline: 'Deadline',
  Cargo_TempCredit: 'Temporary credit control',
  Cargo_EtdDays: 'Etd Days',
  Cargo_EtdExceedsDays: 'ETD exceeds {0} days, release number cannot be granted.',
  Cargo_EtdExceedsDaysOrder: 'ETD exceeds {0} days, (Bill of Lading / Order) cannot be released.',
  Cargo_ShippingDocumentsNotBeReleased: 'Shipping documents will not be released until all outstanding freight charges are settled.',
  Cargo_SpecialFeePaymentLimit: 'Restrictions on Special Fund Payment Applications',
  Cargo_PaymentOnlySpecificCosts: 'Payment applications for special funds may only include those specific expenses and must not contain any other costs.',
  Cargo_ThePaymentNotSettled: 'The payment for {0} has not been settled.',
  Cargo_UnconfirmedSum: '{0}+{1}+{2}+{3} unconfirmed, please confirm first!',
  Cargo_SpecialApproval2: 'Special Approval',
  Application_Item: 'Application Item',
  Application_Content: 'Application Content',
  Application_Reason: 'Reason for Application',
  Cargo_DomesticOverseas: 'Domestic/Overseas',
  Cargo_IncludeOverseasWarehouse: 'Include Overseas Warehouse',
  Cargo_SignContract2: 'Sign Contract',
  Cargo_LatestContractDate: 'Latest Contract Signing Date',
  Cargo_CreditControlSelfAssessment: 'Credit Control Self-Assessment Form',
  Cargo_CustomerFile: 'Customer File',
  Cargo_CustomerConsignmentNote: 'Customer Consignment Note',
  Cargo_HasContract: 'Has Contract',
  Cargo_NoContract: 'No Contract',
  Cargo_ContractStatus2: 'Contract Status',
  Cargo_SupplierFile: 'Supplier File',
  Cargo_ApprovalSummary: 'Approval Content Summary',
  Cargo_AlreadyExistsCannotSubmit: '{0} already exists, cannot submit application!',
  Action_AddAttachment: 'Add Attachment',
  Validation_ApplicationContentRequired: 'Application content cannot be empty.',
  Validation_ApplicationReasonRequired: 'Reason for application cannot be empty.',
  Cargo_AutoReceivablesWriteOff: 'Auto Write-off of Receivables',
  Cargo_WhetherIgnore: 'Weather Ignore',
  Cargo_TempCreditNotBeCross: 'The validity periods of temporary credit control cannot overlap.',
  Cargo_TempCreditNotice: 'Note: The credit limit and accounting period of temporary credit control are the same as the unit of the contract (effective the next day)',
  Cargo_CurrentCreditNotice: 'Note: For the account period limit that meets the conditions at the current time, the temporary credit control maintained on that day will be synchronized to the partner the next day.',
  Cargo_CurrentAvailableNotEntered: 'Current available number not entered',
  Cargo_Debit: 'Debit',
  Cargo_DebitAmount: 'Debit Amount',
  Cargo_DebitAmount2: 'Debit Amount',
  Cargo_DebitAmountCNY: 'Debit Amount (CNY)',
  Cargo_DebitAmountOccurred: 'Debit Amount Occurred',
  Cargo_DebitAmountOccurredCNY: 'Debit Amount Occurred (CNY)',
  Cargo_DebitAmountOccurredP: 'Debit Amount Occurred:',
  Cargo_DebitAmountOccurredUSD: 'Debit Amount Occurred (USD)',
  Cargo_DebitAmountTo: 'Debit Total',
  Cargo_DebitAmountToP: 'Debit Total:',
  Cargo_DebitAmountUSD: 'Debit Amount (USD)',
  Cargo_DebitLocalCurrency: 'Debit Local Currency',
  Cargo_DebitNotWrittenOff: 'Debit Not Written-off',
  Cargo_DebitOriginalAmount: 'Debit Original Amount',
  Cargo_DebitSide: 'Debit Side',
  Cargo_DebitSideCNY: 'Debit Side (CNY)',
  Cargo_DebitSideCreditSide: 'Debit Side / Credit Side',
  Cargo_DebitSideCreditSideP: 'Debit Side / Credit Side:',
  Cargo_DebitSideUSD: 'Debit Side (USD)',
  Cargo_DebitWriteOffAmount: 'Debit Write-off Amount',
  Cargo_December: 'December',
  Cargo_DeclareWarehouseLoadingContainer: 'Declare warehouse-loading container?',
  Cargo_DeemedPrinted: 'Deemed Printed',
  Cargo_VGMLog: 'VGM Log',
  Cargo_SendVGM: 'Send VGM',
  Cargo_VGMChannel: 'VGM Channel',
  Cargo_VGMBasicInfo: 'VGM Basic Info',
  Cargo_FriendlyReminder: 'Friendly reminder: please fill in the master bill number for consolidation',
  Cargo_VGMCutOffDate: 'VGM Cut-off Date',
  Cargo_ContainerHolder: 'Container Holder',
  Cargo_NotFilledIn: 'Not filled in, please fill in and send after completion.',
  Cargo_NotSelected: 'Not selected, please fill in and send after completion.',
  Cargo_PleaseMaintainCargoInfo: 'Please maintain cargo information',
  Cargo_IfYouHaveSentPreStowageManifest: 'If you have sent the pre-stowage manifest through the Sea Butler channel, the information will be synchronized from the pre-stowage information tab;',
  Cargo_IfYouHaveNotSentPreStowageManifest: 'if you have not sent the pre-stowage manifest through the Sea Butler channel, the information will be synchronized from the basic, booking tab.',
  Cargo_FriendlyReminderWithPort: 'Friendly reminder: Shanghai port, we suggest you send VGM information after pre-entry is completed, barge to ship, based on barge time',
  Cargo_TerminalInfoForReferenceOnly: 'Terminal information is for reference only, please refer to the booking port for details!',
  Cargo_TerminalInfoForReferenceWse: 'If the information of the booking port port does not match our reference port information, please contact customer service. Thank you!',
  Cargo_IfBookingPortTerminalInfoDoesNotMatchPleaseContactCustomerService: 'If the booking port terminal information does not match our reference terminal information, please contact customer service.',
  Cargo_FriendlyReminderWithCutOffTime: 'Friendly reminder: Please fill in the correct cut-off time, we will send multiple times according to this date,if late loading fees are incurred due to incorrect information, the platform will not bear it.',
  Cargo_TheShipperDeclares: 'The shipper hereby declares that the weight information of the cargo containers contained in this document is obtained in accordance with the method described in the "International Convention for the Safety of Life at Sea 1974", and the weighing point\'s measuring device has obtained a measurement verification certificate issued by a measurement technology institution, and the date of obtaining the weight is within the validity range of the certificate.',
  Cargo_RepeatedlySendingVGMWithTheSameContainerTips: 'Repeatedly sending VGM with the same container number will be charged multiple times. If you need to send again, please send after {0} S.',
  Cargo_Send_VGM_Reminder: 'Each container number will be deducted once for sending VGM, and repeated sending of the same container number will be deducted repeatedly. If you modify VGM information, you only need to send VGM information of the modified box. Please confirm whether to continue sending?',
  Cargo_ContinueSending: 'Continue sending',
  Cargo_ResendAfterS: 'Resend after s',
  Cargo_ShippingCompanyReceiptStatus: 'Shipping Company Receipt Status',
  Cargo_DeparturePortFieldNotFoundMatchingInfoWithSeaButlerPleaseCheck: 'Departure port field not found matching information with Sea Butler, please check.',
  Cargo_ShippingCompanyFieldNotFoundMatchingInfoWithSeaButlerPleaseCheck: 'Shipping company field not found matching information with Sea Butler, please check.',
  Cargo_CharLengthWithRange: 'Vary in length from {0} to {1} characters',
  Cargo_TheBoxNumberMustBe: 'The box number must be 4 letters + 7 digits',
  Cargo_LoadWharfTips: 'The dock information is for reference only, please refer to the booking hatch! If the booking hatch dock information does not match our reference dock information, please contact customer service, thank you!',
  Cargo_WhetherToContinueSendingVGM: 'whether to continue sending VGM?',
  Cargo_Default: 'Default',
  Cargo_DefaultAPUnitPrice: 'Default A/P unit price',
  Cargo_DefaultARCurrency: 'Default A/R currency',
  Cargo_DefaultAPCurrency: 'Default A/P currency',
  Cargo_DefaultARUnitPrice: 'Default A/R unit price',
  Cargo_DefaultDecimalPlaces: 'Default decimal places',
  Cargo_DefaultLine: 'Default Line',
  Cargo_DefaultMenuItems: 'Default Menu Items',
  Cargo_DefaultOrNot: 'Default or not',
  Cargo_DefaultPayee: 'Default payee',
  Cargo_DefaultPayer: 'Default payer',
  Cargo_DefaultSearchCondition: 'Default Search Condition',
  Cargo_DefaultValue: 'Default Value',
  Cargo_SeDefaultValue: 'Sea Export Default Value',
  Cargo_SiDefaultValue: 'Sea Import Default Value',
  Cargo_AeDfaultValue: 'Air Export Default Value',
  Cargo_AiDfaultValue: 'Air Import Default Value',
  Cargo_ReDfaultValue: 'Railway Export Default Value',
  Cargo_RiDfaultValue: 'Railway Import Default Value',
  Cargo_EditDefaultValue: 'Edit Default Value',
  Cargo_EditJobDefaultValueTip: `If the default value of each business type is different, please maintain it in the corresponding business type text box;
For example, if both the business type text box and the default value are maintained with values, the corresponding business type text box value will be obtained first according to the business type;`,
  Cargo_DefaultWriteOffCurrency: 'Default Write-off Currency',
  Cargo_DelayedTaxRefund: 'Delayed Tax Refund',
  Cargo_DelegationTypeRailway: 'Delegation type(Railway)',
  Cargo_Delete: 'Delete',
  Cargo_DeleteConfirmation: 'Are you sure you want to delete the selected record?',
  Cargo_DeleteBill: 'Remove Bill',
  Cargo_DisplayRules: 'Display rules',
  Cargo_ViewAttachments: 'View attachments',
  Cargo_DeleteCollectionRecord: 'Delete collection record',
  Cargo_DeletedBillList: 'Deleted Bill List',
  Cargo_DeletedSuccessfully: 'Deleted successfully.',
  Cargo_WithdrawSuccessfully: 'Withdraw successfully.',
  Cargo_DeletedNotHavePermission: 'You do not have permission to delete this quotation.',
  Cargo_DeletedNotIntoBusiness: 'Quotation has been carried into business expenses！',
  Cargo_DeleteEntry: 'Delete entry',
  Cargo_DeleteFailed: 'Deletion failed.',
  Cargo_DeleteFee: 'Delete fee',
  Cargo_DeleteFeeConfirmedListSync: 'Delete fee confirmed list(Sync)',
  Cargo_DeleteInvoice: 'Delete Invoice',
  Cargo_DeleteNotification: 'Delete notification',
  Cargo_DeleteOrNot: 'Delete or not?',
  Cargo_DeleteVoucher: 'Delete Voucher',
  Cargo_Delivered: 'Delivered',
  Cargo_DeliveredButNotRetrieved: 'Delivered but not retrieved.',
  Cargo_DeliveredSuccessfully: 'Delivered successfully.',
  Cargo_DeliveredToBranch: 'Delivered to branch?',
  Cargo_DeliverPartial: 'Deliver partial?',
  Cargo_DeliverySigned: 'Delivery signed.',
  Cargo_DenialReason: 'Denial Reason',
  Cargo_DenialReasonP: 'Denial Reason:',
  Cargo_Denied: 'Denied',
  Cargo_DeniedSuccessfully: 'Denied successfully.',
  Cargo_DenyApplication: 'Deny Application',
  Cargo_DenyPaymentApplication: 'Deny Payment Application',
  Cargo_Department: 'Department',
  Cargo_DepartmentApproval: 'Department Approval',
  Cargo_DepartmentP: 'Department:',
  Cargo_DepartureTime: 'Sailing Time',
  Cargo_DepositBank: 'Deposit Bank',
  Cargo_DepositBankAccountNo: 'Bank Account No.',
  Cargo_DepositBankAndAccountNo: 'Bank & Account No.',
  Cargo_DepositBankAndAccountNoP: 'Bank & Account No.',
  Cargo_DesCharge: 'Destination charge',
  Cargo_DescriptionCanTBeEmpty: 'Description can\'t be empty',
  Cargo_DescriptionOfCharge: 'Description of Charge',
  Cargo_DescriptionOfExpenseItem: 'Description of Expense Item',
  Cargo_DescriptionOfExpenseItemCNY: 'Description of Expense Item(CNY)',
  Cargo_DescriptionOfExpenseItemUSD: 'Description of Expense Item(USD)',
  Cargo_DescriptionOfExpenseItemJPY: 'Description of Expense Item(JPY)',
  Cargo_DescriptionOfExpenseItemEUR: 'Description of Expense Item(EUR)',
  Cargo_DescriptionOfPlan: 'Description of plan',
  Cargo_DescriptionOfQuantity: 'Description of Quantity',
  Cargo_DescriptionOfVoucherType: 'Description of Voucher Type',
  Cargo_DesignatedDepartment: 'Designated department',
  Cargo_DesignSubTitlesOfAccount: 'Design Sub-titles of Account',
  Cargo_Destination: 'Destination',
  Cargo_ChargeItemMaintenance: 'Charge item maintenance',
  Cargo_ZeroTaxRate: 'Zero tax rate',
  Cargo_DestinationAgent: 'Agent at Destination',
  Cargo_DestinationAgent1: 'Overseas Agent',
  Cargo_DestinationChargeOrNot: 'Destination charge or not',
  Cargo_DestinationPort: 'POD',
  Cargo_DestinationPortSea: 'POD(Sea)',
  Cargo_DestinationPortAir: 'POD(Air)',
  Cargo_OverseaWarehouse: 'Oversea Warehouse',
  Cargo_NoRestriction: 'No restriction',
  Cargo_Details: 'Details',
  Cargo_DetailsOfOutOfPocketRecord: 'Details of Out-of-pocket Record',
  Cargo_DetailsOfSingleWriteOff: 'Details of Single Write-off',
  Cargo_DetailsOfSingleWriteOffPDF: 'DetailsofSingleWriteoff.pdf',
  Cargo_DetailsOfSingleWriteOffXLS: 'DetailsofSingleWriteoff.xls',
  Cargo_DevelopedAtExhibitions: 'Developed at exhibitions',
  Cargo_Difference: 'Differential',
  Cargo_DifferenceAdjustment: 'Differential Adjustment',
  Cargo_DifferenceCNYCNY: 'Differential(CNY)',
  Cargo_DifferenceUSD: 'Differential(USD)',
  Cargo_DifferentialAdjustedSuccessfully: 'Differential adjusted successfully.',
  Cargo_DifferentialIs: 'Differential is {0}',
  Cargo_DifferentialProcessing: 'Differential Processing',
  Cargo_DifficultyIndex: 'Difficulty index',
  Cargo_DIITRLNLTSIT: 'Displayed items in the right list not linked to selected invoice type.',
  Cargo_DirectAssign: 'Direct assign',
  Cargo_DirectBusiness: 'Direct B/L',
  Cargo_DirectConsol: 'Direct consol.',
  Cargo_DirectConsolContainerNo: 'Direct Consol Container No.',
  Cargo_Direction: 'Direction',
  Cargo_DirectServiceOrNot: 'Direct service or not?',
  Cargo_DiscrepancyExist: 'Discrepancy exist.',
  Cargo_DiscrepancyFound: 'Discrepancy found.',
  Cargo_DisplayAmountOfDifferential: 'Display amount of differential?',
  Cargo_DisplayAmountOfReconciliation: 'Display amount of reconciliation?',
  Cargo_DisplayBatchOperation: 'Display batch operation?',
  Cargo_DisplayCashFlowItems: 'Display cash flow items?',
  Cargo_DisplayExpenseDetails: 'Display expense details?',
  Cargo_DisplayMonthSelector: 'Display month selector?',
  Cargo_DisplayOrder: 'Display order',
  Cargo_DisplayTotalCost: 'Display total cost?',
  Cargo_DisplayTotalIncome: 'Display total income?',
  Cargo_DisplayUnCodedRecordsOnly: 'Display un-coded records only.',
  Cargo_DisplayUnInvoicedAmount: 'Display un-invoiced amount?',
  Cargo_DistributedReconciliationAmount: 'Distributed Reconciliation Amount',
  Cargo_DistributionCostOrNot: 'Distribution cost or not?',
  Cargo_District: 'District',
  Cargo_DLCCLCCTBE: 'Debit Local Currency / Credit Local Currency can\'t be empty.',
  Cargo_DMROITE: 'Duplicate maintenance record of invoice type {0} exist.',
  Cargo_DNBTCBOHC: 'Data not belong to current branch or higher, continue?',
  Cargo_DORMBGTTDOR: 'Date of return must be greater than the date of retrieval.',
  Cargo_InvoiceNature: 'Tax rate mark',
  Cargo_InvoiceNatureTip: 'The tax rate can only be adjusted when the tax rate is marked as normal',
  Cargo_DOCOTS: 'Description of Cargo or Taxable Services',
  Cargo_DocReleaseAgainstPayment: 'Doc release against payment?',
  Cargo_DocumentationType: 'Documentation Type',
  Cargo_DocumentCirculation: 'Document circulation',
  Cargo_Documents: 'Documents',
  Cargo_DOEICTBE: 'Description of expense item can\'t be empty.',
  Cargo_Domestic: 'Domestic',
  Cargo_DomesticBill: 'Domestic Bill',
  Cargo_DomesticChargeInformation: 'Domestic Charge Information',
  Cargo_DomesticCollection: 'Domestic Collection',
  Cargo_DomesticDirectClient: 'Domestic Direct Client',
  Cargo_DomesticDirectClientOrNot: 'Domestic direct client or not?',
  Cargo_DomesticOrInternational: 'Domestic / Overseas',
  Cargo_DomesticPayment: 'Domestic Payment',
  Cargo_DomesticTrade: 'Domestic trade',
  Cargo_DoNotSelectMultipleItems: 'Do not select multiple items',
  Cargo_Door: 'Door',
  Cargo_DoorAddress: 'Door address',
  Cargo_DoorLoadingDelivery: 'Loading/pickup at door',
  Cargo_DoorPickup: 'Door pickup',
  Cargo_DOPNCTBLTAC: 'Difference of positive numbers can\'t be less than a cent.',
  Cargo_DoubleClickToView: 'Double-click to View',
  Cargo_DownloadCompleted: 'Download completed.',
  Cargo_DownloadFailed: 'download failed.',
  Cargo_DrawABillOrNot: 'Issue all invoice or not',
  Cargo_DRIRORIOCA: 'Dividend Receivable / Interest Receivable / Other Receivables / Inventory / Other Current Assets',
  Cargo_DSAIM: 'Display settlement and invoicing methods?',
  Cargo_DSCSDSCS: 'Debit Side / Credit Side / Debit Side / Credit Side',
  Cargo_Dues: 'A/P',
  Cargo_DuesB: '(A/P)',
  Cargo_DuesToCNY: 'Equivalent to CNY payable：',
  Cargo_EquivalentCNY: 'Equivalent to CNY deduction amount：',
  Cargo_DuesCNY: 'A/P(CNY)',
  Cargo_DuesEUR: 'A/P(EUR)',
  Cargo_DuesGBP: 'A/P(GBP)',
  Cargo_DuesHKD: 'A/P(HKD)',
  Cargo_DuesJPY: 'A/P(JPY)',
  Cargo_DuesNGN: 'A/P(NGN)',
  Cargo_DuesP: 'A/P:',
  Cargo_DuesUSD: 'A/P(USD)',
  Cargo_DuplicateCodePleaseTryItAgain: 'Duplicate code, please try it again',
  Cargo_DuplicateContent: 'Copy content',
  Cargo_DutyFree: 'Duty-free',
  Cargo_Uncertain: 'Uncertain',
  Cargo_DynamicCurrencyDisplayColumn: 'Dynamic Currency Display Column',
  Cargo_ECDICA: 'Empty Content Displayed in Central Area',
  Cargo_ECNETSFS: 'Enter code name etc. to start fuzzy search',
  Cargo_ECSNMIR: 'Expense confirmation status not meet invoicing requirements.',
  Cargo_ECSNMPAR: 'Expense confirmation status not meet payment application requirements.',
  Cargo_ECSNMWOR: 'Expense confirmation status not meet write-off requirements.',
  Cargo_EdiCode: 'EDI code',
  Cargo_EdiInterfaceTypeOfEInvocing: 'EDI Interface Type of E-Invocing',
  Cargo_EdiInterfaceTypeOfInvoicing: 'EDI Interface Type of Invoicing',
  Cargo_Edit: 'Edit',
  Cargo_EditAdjustment: 'Modify Adjustment',
  Cargo_EditAirFreightServiceItems: 'Edit air freight service items',
  Cargo_EditAssociatedPort: 'Edit associated port',
  Cargo_EditAwbSurcharge: 'Edit AWB surcharge',
  Cargo_EditBill: 'Edit bill',
  Cargo_EditBLType: 'Edit B/L type',
  Cargo_EditChargeFinancialDate: 'Modify Financial Date of Expense',
  Cargo_EditCirculationDocumentType: 'Edit circulation document type',
  Cargo_CirculationDocumentType: 'Circulation document type',
  Cargo_EditClientType: 'Edit client type',
  Cargo_EditCommissionRules: 'Edit commission rules',
  Cargo_EditContract: 'Edit contract',
  Cargo_EditCustomizedServiceType: 'Edit customized service type',
  Cargo_EditedSuccessfully: 'Modified successfully.',
  Cargo_EditField: 'Edited Field',
  Cargo_EditFinancialDate: 'Modify Financial Date',
  Cargo_EditFormula: 'Edit formula-',
  Cargo_EditKeyWord: 'Edit key word',
  Cargo_EditMscService: 'Edit MSC service',
  Cargo_EditOppositeVoucherNo: 'Edit opposite voucher No.',
  Cargo_EditOrNot: 'Edit or not?',
  Cargo_EditRemarks: 'Edit remarks',
  Cargo_EditRoute: 'Edit route',
  Cargo_EDTTTC: 'Expense Details to Transfer to Collections',
  Cargo_EDTTTCP: 'Expense Details to Transfer to Collections:',
  Cargo_EffectiveDate: 'Effective Date',
  Cargo_EffectiveMonth: 'Effective Month',
  Cargo_EICCMBU: 'Entries in \'Currency\' column must be unique',
  Cargo_EINDWI: 'Enter invoice no. directly when invoicing?',
  Cargo_EInvoiceCanTBePrinted: 'E-invoice can\'t be printed.',
  Cargo_EInvoiceCanTBeVoided: 'E-invoice can\'t be voided.',
  Cargo_EInvoicePaperInvoice: 'E-invoice / Paper invoice',
  Cargo_EmailAddress: 'Email address',
  Cargo_EMailAlertForTestOnly: 'E-mail alert (for test only)',
  Cargo_EmailSent: 'Email Sent',
  Cargo_Empty: 'Empty',
  Cargo_EmptyData: 'Empty data',
  Cargo_EmptyEntries: 'Empty Entries',
  Cargo_EmptyOriginalCurrency: 'Empty Original currency',
  Cargo_EMSSCM: 'E-mail sent successfully, check mailbox.',
  Cargo_EndDate: 'Cut-off Date',
  Cargo_EnglishCargoName: 'Commodity description(EN)',
  Cargo_EnglishCommodityNameMsc: 'English commodity name (MSC)',
  Cargo_EnglishName: 'English name',
  Cargo_EnglishNameCanTBeEmpty: 'English name can\'t be empty',
  Cargo_CannotDeleteUsedCustomerType: 'Deletion of already used client types is not allowed',
  Cargo_CannotDeleteUsedCustomerContactChannel: 'Deletion of used customer touch channels is not allowed',
  Cargo_Enter: 'Enter',
  Cargo_EnterBusinessTypeToStartSearch: 'Enter business type to start search',
  Cargo_EnterExpenseName: 'Enter expense name',
  Cargo_EnterInvoiceNo: 'Enter invoice no.',
  Cargo_EnterInvoiceNoDirectly: 'Enter invoice no. directly?',
  Cargo_EnterKeyWordsToStartFuzzySearch: 'Enter key words to start fuzzy search',
  Cargo_EnterManually: 'Enter Manually',
  Cargo_EnterSpecialInvoiceNo: 'Enter Special Invoice No.',
  Cargo_EnterVoucherInformation: 'Enter Voucher Information',
  Cargo_Entity: 'Entity',
  Cargo_EntryDate: 'Entry date',
  Cargo_EntryOfNumber: 'Entry of Number',
  Cargo_EqualTo: 'Equal to',
  Cargo_Error: 'Error',
  Cargo_ErrorNoDataFound: 'Error, no data found.',
  Cargo_ESNMIR: 'Expense status not meet invoicing requirements.',
  Cargo_ESNMPAR: 'Expense status not meet payment application requirements.',
  Cargo_ESNMWOR: 'Expense status not meet write-off requirements.',
  Cargo_EstTimeOfWarehouseIn: 'Est. time of warehouse-in',
  Cargo_EventOfSettlingParty: 'Event of Settling Party',
  Cargo_EventRecord: 'Event record',
  Cargo_EventTime: 'Event time',
  Cargo_EverCancelledWriteOff: 'Ever cancelled write-off?',
  Cargo_ExcelExport: 'Export excel',
  Cargo_ExcessiveOrNot: 'Excessive or not',
  Cargo_ExchangeCode: 'Exchange code',
  Cargo_ExchangeCodeCanTBeEmpty: 'Exchange code can\'t be empty',
  Cargo_ExchangeCurrency: 'Exchange Currency',
  Cargo_ExchangeGainsAndLosses: 'Exchange-rate Loss',
  Cargo_ExchangeRate: 'Exchange Rate',
  Cargo_ExchangeRateAdjustmentTable: 'Exchange-rate Adjustment Table',
  Cargo_ExchangeRateAdjustmentTableP: 'Exchange-rate Adjustment Table:',
  Cargo_ExchangeRateCanTBeEmpty: 'Exchange rate can\'t be empty.',
  Cargo_ExchangeRateDifference: 'Exchange-rate Difference',
  Cargo_ExchangeRateHKD: 'Exchange Rate(HKD)',
  Cargo_ExchangeRateList: 'Exchange rate list',
  Cargo_ExchangeRateOfHKD: 'Exchange Rate of HKD',
  Cargo_ExchangeRateP: 'Exchange Rate:',
  Cargo_ExchangeRateUSD: 'Exchange Rate(USD)',
  Cargo_ExclusionFilter: 'Exclusion Filter',
  Cargo_ExecutionMethodOfWindowClosure: 'Execution Method of Window Closure',
  Cargo_Existed: 'Existed.',
  Cargo_ExpectedReviewDate: 'Expected Review Date',
  Cargo_Expenditure: 'Expenditure',
  Cargo_ExpenseAdjustment: 'Expense Adjustment',
  Cargo_ExpenseAdjustmentOfCollection: 'Expense Adjustment of Collection',
  Cargo_ExpenseApprovalProcedure: 'Expense Approval Procedure',
  Cargo_ExpenseDescriptionCanTBeEmpty: 'Expense description can\'t be empty.',
  Cargo_ExpenseItemsCanTBeEmpty: 'Expense items can\'t be empty.',
  Cargo_ExpenseListNonEntity: 'Expense List Non-entity',
  Cargo_ExpenseNotSelected: 'Expense not Selected',
  Cargo_ExpenseRejectedSuccessfully: 'Expense rejected successfully.',
  Cargo_ExpenseRelated: 'Expense-related',
  Cargo_ExpenseReviewedBy: 'Expense Reviewed by',
  Cargo_ExpenseSearch: 'Expense Search',
  Cargo_ExpenseSelection: 'Expense Selection',
  Cargo_ExpenseSettlingParty: 'Expense Settling Party',
  Cargo_ExpenseWriteOffCanTBeEmpty: 'Expense write-off can\'t be empty,',
  Cargo_ExpenseWrittenOffCanTBeSplit: 'Expense written off, can\'t be split.',
  Cargo_ExpiryDateCanTBeEmpty: 'Expiry date can\'t be empty',
  Cargo_Export: 'Export',
  Cargo_ExportBaiwangInvoice: 'Export Baiwang Invoice',
  Cargo_ExportClientSuccessfully: 'Export client successfully',
  Cargo_ExportedSuccessfully: 'Exported successfully.',
  Cargo_ExportExcel: 'Export Excel',
  Cargo_ExportExpenses: 'Export expenses',
  Cargo_ExportFailed: 'Export failed.',
  Cargo_ExportOrNot: 'Export or not?',
  Cargo_ExportRecordsSuccessfully: 'Export records successfully',
  Cargo_ExportRequired: 'Export required.',
  Cargo_ExportResult: 'Export Result',
  Cargo_ExportSuccessfully: 'Export successfully.',
  Cargo_ExportVatInvoice: 'Export VAT Invoice',
  Cargo_ExportVatInvoiceXLS: 'ExportVATInvoice.xls',
  Cargo_ExportVoucher: 'Export Voucher',
  Cargo_ExportWriteOffDetails: 'Export Write-off Details',
  Cargo_ExpressAddress: 'Mailing Address',
  Cargo_ExpressInfo: 'Courier Information',
  Cargo_Extend: 'Whether to Suspend',
  Cargo_ExtendPeriod: 'Extend period',
  Cargo_ExtensionAfterExpiration: 'Extension after expiration',
  Cargo_ExtensionCycle: 'Suspended Period',
  Cargo_External: 'External',
  Cargo_Fax: 'Fax',
  Cargo_FCAEFAIIVWBIWBCCTV: '{0} financial certificates already exported for a invoice, if voided, write-back invoice will be created. Continue to void?',
  Cargo_FCAOCAE: 'Foreign currency accounting original currency amount exist.',
  Cargo_FCASPSCT: 'Foreign currency accounting selected, please select currency type.',
  Cargo_FCL: 'FCL',
  Cargo_SpecialSize: 'special size',
  Cargo_SpecialSizeTip: 'After checking, the packing information list can additionally display the "Size Specification (length * width * height unit M)" field.',
  Cargo_FclLclTypeSeaExport: 'FCL/LCL type (sea export)',
  Cargo_FclLclTypeSeaImport: 'FCL/LCL type (sea import)',
  Cargo_EstimatedArrivalTimeSeaExport: 'Estimated Port Departure Time (Sea Export)',
  Cargo_EstimatedArrivalTimeSeaImport: 'Estimated Port Arrival Time (Sea Import)',
  Cargo_EstimatedArrivalTimeAirExport: 'Estimated Arrival Time (Air Export)',
  Cargo_FDMOPPE0: 'Fixed date monthly or payment period exceeds 0',
  Cargo_February: 'February',
  Cargo_FeederOrNot: 'Feeder or not',
  Cargo_FIAICTR: 'Following invoice applications invoiced, can\'t revoke.',
  Cargo_FIDSEC: 'Fees include different settlement entity, continue?',
  Cargo_FileApplication: 'File Application',
  Cargo_FileDocumentation: 'Document',
  Cargo_FileFormat: 'File format',
  Cargo_FileHistory: 'File History',
  Cargo_FileLoadingFailed: 'File loading failed.',
  Cargo_FileName: 'File name',
  Cargo_FileNo: 'File No.',
  Cargo_FileNotFoundInCloud: 'File not found in cloud.',
  Cargo_FileRetrievedSuccessfully: 'File retrieved successfully.',
  Cargo_FileSize: 'File size',
  Cargo_FileStatus: 'File Status',
  Cargo_FileType: 'File Type',
  Cargo_FileTypeDescription: 'File Type Description',
  Cargo_Filter: 'Filter',
  Cargo_FilterP: 'Filter:',
  Cargo_FinalDestination: 'Final destination',
  Cargo_FinancialApprovalDate: 'Financial Approval Date',
  Cargo_FinancialApproved: 'Financial Approved',
  Cargo_FinancialAudit: 'Financial Review',
  Cargo_FinancialAuditDetail: 'Detail Financial Review',
  Cargo_FinancialChangeReview: 'Financial change review',
  Cargo_FinancialCharges: 'Financial Expense',
  Cargo_FinancialCode: 'Financial Code',
  Cargo_FinancialDate: 'Financial Date',
  Cargo_FinancialExpenseIs: 'Financial Expense is',
  Cargo_FinancialPeriod: 'Financial Period',
  Cargo_FinancialReceived: 'Received',
  Cargo_FinancialRemarks: 'Financial Remarks',
  Cargo_FinancialSoftware: 'Financial Software',
  Cargo_FinasialCheck: 'Financial Approval',
  Cargo_FindExistingCurrencies: 'Find existing currencies.',
  Cargo_FirstAccruedProfit: 'First accrued profit',
  Cargo_FirstAccruedTime: 'First accrued time',
  Cargo_FirstContactDate: 'First contact date',
  Cargo_FiscalPeriod: 'Fiscal Period',
  Cargo_Fit: 'FIT',
  Cargo_FixedAccountingCode: 'Fixed Accounting Code',
  Cargo_FixedDateMonthly: 'Fixed date monthly',
  Cargo_FJTLCTW: 'Following job tickets locked, can\'t withdraw.',
  Cargo_FLCLType: 'FCL/LCL type',
  Cargo_FlightVoyage: 'Flight/Voyage',
  Cargo_FollowingBillsInTheTextNotFound: 'Following bills in the text not found.',
  Cargo_ForAirBusiness: 'For air business',
  Cargo_ForAirExportBusiness: 'For air export business',
  Cargo_ForAirImportBusiness: 'For air import business',
  Cargo_ForRailwayBusiness: 'For Railway Business',
  Cargo_ForIntegratedJob: 'For Integrated Business',
  Cargo_ForFbaSeaBusiness: 'For FBA sea business',
  Cargo_ForFbaAirBusiness: 'For FBA air business',
  Cargo_ForFbaRailwayBusiness: 'For FBA railway business',
  Cargo_ForceDelete: 'Forced Deletion',
  Cargo_ForeignCurrency: 'Foreign Currency',
  Cargo_ForeignCurrencyAccounting: 'Foreign Currency Accounting',
  Cargo_ForeignCurrencyAccountingExist: 'Foreign currency accounting exist.',
  Cargo_ForeignTrade: 'Foreign trade',
  Cargo_Format: 'format',
  Cargo_FormLayout: 'Form Layout',
  Cargo_FormVerification: 'Form Verification',
  Cargo_ForOceanBusiness: 'For ocean business',
  Cargo_ForOtherBusiness: 'For other business',
  Cargo_ForRailwayExportBusiness: 'For railway export business',
  Cargo_ForSeaExportBusiness: 'For sea export business',
  Cargo_ForSeaImportBusiness: 'For sea import business',
  Cargo_FreeDetension: 'Free detention',
  Cargo_FreightForwardingFee: 'Freight Forwarding Fee',
  Cargo_FristApprovalDate: 'Application Time',
  Cargo_From: 'From',
  Cargo_Frozen: 'Frozen',
  Cargo_FrozenSuccessfully: 'Frozen successfully.',
  Cargo_FullPayment: 'Full Payment',
  Cargo_FullScreenDisplay: 'Full-screen display?',
  Cargo_Fumigation: 'Fumigation',
  Cargo_FunctionOfSuccessfulAcquisition: 'Function of Successful Acquisition',
  Cargo_FVOCPIOOPRECTBV: 'Financial voucher of current paid-in/out-of-pocket record exported, can\'t be voided.',
  Cargo_FVOVNP: 'Following verifications of voucher [{0}] not passed:',
  Cargo_GeneralInvoice: 'General Invoice',
  Cargo_GeneralLedger: 'General Ledger',
  Cargo_GeneralLedger2: 'General Ledger 2',
  Cargo_GeneralRate: 'General Rate',
  Cargo_GeneratedAccountStatement: 'SOA created or not?',
  Cargo_GeneratedBillsOrNot: 'Billed or not?',
  Cargo_GetBack: 'Retrieve',
  Cargo_GoldenTaxationExportPrint: 'Golden Taxation Export & Print',
  Cargo_GoOn: 'Continue',
  Cargo_ARAP_Locked: 'Selected jobs have both receivable and payable charges locked, cannot add charges.',
  Cargo_AR_Locked: 'Selected jobs have receivable charges locked, cannot add receivable charges.',
  Cargo_AP_Locked: 'Selected jobs have payable charges locked, cannot add payable charges.',
  Cargo_Only_AR: 'Current user can only add receivable charges.',
  Cargo_Only_AP: 'Current user can only add payable charges.',
  Cargo_Cannot_Add_Charge: 'Current user cannot add charges.',
  Cargo_ChargeLockStatusChanged: 'The receivable/payable lock status has changed, please re-query and submit the new charge again.',
  Cargo_GrandTotal: 'Grand Total',
  Cargo_GrandTotalP: 'Grand Total:',
  Cargo_GreaterThan: 'Greater than',
  Cargo_GroupCompany: 'Corporations',
  Cargo_GroupExchangeRate: 'Group Exchange Rate',
  Cargo_GroupingConditions: 'Grouping Conditions',
  Cargo_GroupingConditions1: 'Grouping Conditions 1',
  Cargo_GroupingConditions2: 'Grouping Conditions 2',
  Cargo_GroupingConditions3: 'Grouping Conditions 3',
  Cargo_GroupingConditions4: 'Grouping Conditions 4',
  Cargo_GroupingConditions5: 'Grouping Conditions 5',
  Cargo_GroupingConditions6: 'Grouping Conditions 6',
  Cargo_GroupingMethod: 'Grouping Method',
  Cargo_GroupingRulesOfJournalEntries: 'Grouping Rules of Journal Entries',
  Cargo_GroupingType: 'Grouping Type',
  Cargo_GroupingTypesOfJournalEntries: 'Grouping Types of Journal Entries',
  Cargo_GroupingTypesOfJournalEntriesP: 'Grouping Types of Journal Entries:',
  Cargo_HalfMonthly: 'Half-monthly Settlement',
  Cargo_Harbour: 'Seaport',
  Cargo_HaulageCompany: 'Transport company',
  Cargo_HaveHas: 'Have/Has',
  Cargo_HaveOrNot: 'Available or not?',
  Cargo_HazmatContained: 'Hazmat contained?',
  Cargo_HBLFreightTerm: 'HBL Freight Terms',
  Cargo_HBLMode: 'HB/L method',
  Cargo_MBLMode: 'MB/L method',
  Cargo_HBLTransitTerm: 'HBL shipping terms',
  Cargo_HedgingInvoice: 'Offset Invoicing',
  Cargo_HideQuantity: 'Hide Quantity',
  Cargo_HoldCargoOrNot: 'Hold cargo or not?',
  Cargo_HoldDoc: 'Hold Doc.',
  Cargo_SpecialApprovalOrder: 'Special approval order',
  Cargo_HoldSubmission: 'Pending',
  Cargo_HqSWriteOffPendingConfirmation: 'HQ\'s Write-off pending confirmation',
  Cargo_HsCode: 'HS code',
  Cargo_IADBD: 'Invoicing Application Date / Business Date',
  Cargo_IARS: 'Invoicing application revoked successfully.',
  Cargo_IBOCR: 'Insufficient balance of collection record：',
  Cargo_ICDOOAABBD: 'Initialize consolidated data of ocean and air business by default.',
  Cargo_IDVOCVDCCIATTC: 'Interface display version of customized voucher displays corresponding customized interface according to the configuration.',
  Cargo_Ignore: 'Ignore',
  Cargo_IgnoreP: 'Ignore?',
  Cargo_IICS: 'Invoice information created successfully.',
  Cargo_IINMCTBE: 'Invoice item name maintenance can\'t be empty.',
  Cargo_Import: 'Import',
  Cargo_ImportBankSlip: 'Import Bank Slip',
  Cargo_ImportExcel: 'Import Excel',
  Cargo_INABNCTBBE: 'Invoice no. and business no. can\'t be both empty',
  Cargo_INCBMDON: 'Invoice no. can be modified directly or not?',
  Cargo_IncludedToBusinessNo: 'Included to business no.',
  Cargo_IncludedToBusinessNoP: 'Included to business no.:',
  Cargo_InclusiveExpense: 'Inclusive Expense',
  Cargo_InclusiveExpenseP: 'Inclusive Expense:',
  Cargo_InclusiveOfAR: 'Inclusive of A/R?',
  Cargo_Income: 'Income',
  Cargo_IncorrectWriteOffRecord: 'Incorrect write-off record',
  Cargo_IncoTerm: 'Trade Terms',
  Cargo_IncreaseAdjustment: 'Increase adjustment',
  Cargo_IncrementValueDuty: 'Value-added tax',
  Cargo_ProductNameEn: 'Product Name (English)',
  Cargo_ContainerNumber: 'Container Number',
  Cargo_TotalDataCount: 'Total {0} data entries',
  Cargo_PalletDetails: 'Pallet Details',
  Cargo_PalletDimensions: 'Pallet Dimensions',
  Cargo_ShippingCompanyWebsite: 'Shipping Company Website',
  Cargo_OverseasWarehouseAddress: 'Overseas Warehouse Address',
  Cargo_Index: 'Index',
  Cargo_IndexCanTBeEmpty: 'Index can\'t be empty.',
  Cargo_IndexName: 'Index Name',
  Cargo_IndustrialTradingCompany: 'Industrial & trading company',
  Cargo_INEPREIN: 'Invoice no. existed, please re-enter invoice no.',
  Cargo_Infomation: 'Infomation',
  Cargo_InformationSentDate: 'Information Sent Date',
  Cargo_InformationSentTime: 'Information Sent Time',
  Cargo_InitialBalance: 'Initial Balance',
  Cargo_InitialBalanceImport: 'Initial balance import',
  Cargo_InitializePageSwitching: 'Initialize Page Switching',
  Cargo_InitializingPleaseWait: 'Initializing, please wait...',
  Cargo_InitialPeriod: 'Initial Period',
  Cargo_InitialPeriodCannotBeEmpty: 'Initial period cannot be empty.',
  Cargo_InitialPeriodCanTBeEmpty: 'Initial period can\'t be empty.',
  Cargo_InitialPeriodOrNot: 'Initial period or not?',
  Cargo_InitialPeriodP: 'Initial Period:',
  Cargo_InitiateContainerPickupRequest: 'Initiate Container Pickup Request',
  Cargo_INNECTCW: 'Invoice no. not entered, continue to close window?',
  Cargo_INNECTP: 'Invoice no. not entered, continue to print?',
  Cargo_INNECTS: 'Invoice no. not entered, continue to save?',
  Cargo_InputBusinessNumber: 'Please enter biz no.',
  Cargo_InputTime: 'Entry Time',
  Cargo_InsertJournalEntry: 'Insert Journal Entry',
  Cargo_InsidePacking: 'SKU package',
  Cargo_InsideQuantity: 'SKU quantity',
  Cargo_InstantMessengerQqWechatEtc: 'Instant messenger (QQ, WeChat, etc.)',
  Cargo_InsufficientRecordBalance: 'Insufficient record balance：',
  Cargo_IntentionStage: 'Intention stage',
  Cargo_InterfaceScheme: 'Interface Scheme',
  Cargo_Internal: 'Domestic',
  Cargo_InternalCode: 'Internal code',
  Cargo_InternalInvoice: 'Internal Invoice',
  Cargo_International: 'Overseas',
  Cargo_InternationalBill: 'Overseas Bill',
  Cargo_IntLFreight: 'Int\'l Freight',
  Cargo_IntLFreightForwardingServiceFee: 'Int\'l Freight Forwarding Service Fee',
  Cargo_IntLOceanFreight: 'Int\'l Ocean Freight',
  Cargo_InUseByBusinessCanTBeDeleted: 'In use by business, can\'t be deleted',
  Cargo_Invalid: 'Void',
  Cargo_InvalidDate: 'Expiration Date',
  Cargo_InvalidNavigation: 'Invalid navigation.',
  Cargo_InvalidOrNot: 'Void or not',
  Cargo_InvalidParameter: 'Invalid parameter',
  Cargo_InverseSelect: 'Inverse Select',
  Cargo_Invoice: 'Invoice',
  Cargo_Invoiceable: 'Invoiceable',
  Cargo_InvoiceAcquisition: 'Invoice Acquisition',
  Cargo_InvoiceAfterARAPOffset: 'Invoice after A/R & A/P Offset',
  Cargo_InvoiceAmount: 'Invoice Amount',
  Cargo_InvoiceAmountP: 'Invoice Amount:',
  Cargo_InvoiceConfirmation: 'Confirm Invoicing',
  Cargo_InvoiceContent: 'Invoice Content',
  Cargo_InvoiceCurrency: 'Invoice Currency',
  Cargo_InvoiceCurrencyP: 'Invoice Currency:',
  Cargo_Invoiced: 'Invoiced',
  Cargo_InvoiceDate: 'Invoicing Date',
  Cargo_InvoiceDateP: 'Invoicing Date:',
  Cargo_InvoicedBy: 'Invoiced by',
  Cargo_InvoicedByP: 'Invoiced by:',
  Cargo_InvoiceDeleted: 'Invoice deleted.',
  Cargo_InvoicedOrNot: 'Invoiced or not',
  Cargo_InvoiceHasBeenWrittenOff: 'Invoice has been written off.',
  Cargo_InvoiceHeader: 'Invoice Title or Header',
  Cargo_InvoiceInformation: 'Invoice Information',
  Cargo_InvoiceIssued: 'Invoice issued.',
  Cargo_InvoiceItemName: 'Invoice Item Name',
  Cargo_InvoiceItemNameSetup: 'Invoice Item Name Setup',
  Cargo_InvoiceNo: 'Invoice No.',
  Cargo_InvoiceNoCanTBeEmpty: 'Invoice no. can\'t be empty.',
  Cargo_InvoiceNoEntry: 'Invoice No. Entry',
  Cargo_InvoiceNoExist: 'Invoice No. exist.',
  Cargo_InvoiceNoExistedContinue: 'Invoice no. existed, continue?',
  Cargo_InvoiceNoExistedContinueToSave: 'Invoice no. existed, continue to save?',
  Cargo_InvoiceNoExistedRewrite: 'Invoice No. {0} existed, please rewrite.',
  Cargo_InvoiceNoIsEmpty: 'Invoice no. is empty.',
  Cargo_InvoiceNoIsEmptyContinue: 'Invoice no. is empty, continue?',
  Cargo_InvoiceNoMandatory: 'Invoice no. mandatory?',
  Cargo_InvoiceNoNotEntered: 'Invoice no. not entered.',
  Cargo_InvoiceNoP: 'Invoice No.:',
  Cargo_InvoiceNoSegment: 'Invoice No. segment',
  Cargo_InvoiceNoStatus: 'Invoice No. Status',
  Cargo_InvoicePrintedCanTBeDeleted: 'Invoice printed, can\'t be deleted.',
  Cargo_InvoicePrinting: 'Invoice Printing',
  Cargo_InvoiceRecord: 'Invoice Record',
  Cargo_InvoiceReIssued: 'Invoice re-issued.',
  Cargo_InvoiceRemark: 'Invoice Remarks',
  Cargo_InvoiceSavedSuccessfully: 'Invoice saved successfully.',
  Cargo_InvoiceSaveFailed: 'Invoice save failed.',
  Cargo_InvoiceStatus: 'Invoice Status',
  Cargo_InvoiceTitle: 'Invoice Title',
  Cargo_ChargeInvoiceTitle: 'Charge Invoice Title',
  Cargo_InvoiceTitleInvoiceNo: 'Invoice Title / Invoice No.',
  Cargo_InvoiceTitleNotMatched: 'Invoice title incompatible.',
  Cargo_InvoiceTitleP: 'Invoice Title:',
  Cargo_InvoiceType: 'Invoice Type',
  Cargo_InvoiceTypeIncompatible: 'Invoice type incompatible.',
  Cargo_InvoiceTypeP: 'Invoice Type:',
  Cargo_InvoiceTypeSelection: 'Invoice Type Selection',
  Cargo_InvoiceUse: 'Invoice Use',
  Cargo_InvoiceVoided: 'Invoice voided.',
  Cargo_InvoiceVoidedCanTBeDeleted: 'Invoice voided, can\'t be deleted.',
  Cargo_InvoiceVoucherAfterARAPOffset: 'Invoice Voucher after A/R & A/P Offset',
  Cargo_InvoiceWrittenOffCanTBeDeleted: 'Invoice written off, can\'t be deleted.',
  Cargo_InvoiceWrittenOffCanTBeVoided: 'Invoice written off, can\'t be voided.',
  Cargo_Invoicing: 'Invoicing',
  Cargo_InvoicingAccordingToCurrency: 'Invoicing by Currency',
  Cargo_InvoicingAddress: 'Invoicing Address',
  Cargo_InvoicingAmount: 'Invoicing Amount',
  Cargo_InvoicingApplicationDate: 'Invoicing Application Date',
  Cargo_InvoicingApplicationReview: 'Invoicing Application Review',
  Cargo_InvoicingCompleted: 'Invoicing completed.',
  Cargo_InvoicingCurrency: 'Invoice Currency',
  Cargo_InvoicingDateBusinessDate: 'Invoicing Date / Business Date',
  Cargo_InvoicingHeadCannotBeEmpty: 'Invoice title can\'t be empty.',
  Cargo_InvoicingInformation: 'Invoicing Information',
  Cargo_InvoicingListNo: 'Invoicing List No.',
  Cargo_InvoicingMachineNo: 'Invoicing Machine No.',
  Cargo_InvoicingMethod: 'Invoicing Method',
  Cargo_InvoicingMethodP: 'Invoicing Method:',
  Cargo_InvoicingMode: 'Invoicing Mode',
  Cargo_InvoicingPerBill: 'Single-bill Invoicing',
  Cargo_InvoicingPerMonth: 'Monthly Invoicing',
  Cargo_InvoicingRequirements: 'Invoicing Requirements',
  Cargo_InvoicingSearch: 'Invoicing Search',
  Cargo_InvoicingStatus: 'Invoicing Status',
  Cargo_InvoicingType: 'Invoicing Type',
  Cargo_InvoicingVerification: 'Invoicing Verification',
  Cargo_IOSPIM: 'Information of settling party is mandatory.',
  Cargo_IPCTFATROJE: 'Invalid parameters, can\'t find account title rules of journal entry.',
  Cargo_IsBroken: 'is broken',
  Cargo_IsExtended: 'Overdue or not',
  Cargo_IsItAR: 'Is it A/R?',
  Cargo_IsItCollection: 'Is it collection?',
  Cargo_IsItDefaultExpense: 'Is it default expense?',
  Cargo_IsCharterFlightCosts: 'Whether charter flight costs',
  Cargo_IsCharterVesselCosts: 'Whether charter vessel costs',
  Cargo_IsCharterFlight: 'Whether charter flight',
  Cargo_IsCharterVessel: 'Whether charter vessel',
  Cargo_Number_Of_Charter_Containers: 'Number of charter containers',
  Cargo_Charter_weight_Restrictions: 'Charter weight restrictions',
  Cargo_Charter_Volume_Restrictions: 'Charter volume restrictions',
  Cargo_Description_of_the_package_Information: 'Description of the package information',
  Cargo_Pallets_can_be_loaded_in_Weight: 'Pallets can be loaded in weight',
  Cargo_Packing_Plates_Can_Be_Loaded_In_Volume: 'Packing plates can be loaded in volume',
  Cargo_The_Total_Cost_Amount: 'The total cost amount',
  Cargo_Unit_Load_Device: 'Unit Load Device',
  Cargo_MountingInformation: 'Mounting information',
  Cargo_Please_Load_The_Main_Ticket: 'Please load the main ticket',
  Cargo_Please_Empty_And_Load_The_Main_Ticket_For_The_Operation: 'Please empty and load the main ticket for the operation',
  Cargo_OtherBusinessUse: 'Other Business Use',
  Cargo_DefaultArSettlementObject: 'Default a / R fixed settlement object',
  Cargo_DefaultArSettlementObjectNull: 'Is the default a / R object empty',
  Cargo_DefaultApSettlementObject: 'Default a / P fixed settlement object',
  Cargo_DefaultApSettlementObjectNull: 'Is the default a / P object empty',
  Cargo_IsItWriteOff: 'Is it write-off?',
  Cargo_IsoCode: 'ISO code',
  Cargo_IsShutOut: 'Shut out or not?',
  Cargo_IssuanceReceiptOfInvoice: 'Issuance & Receipt of Invoice',
  Cargo_Issued: 'Issued',
  Cargo_IssueHbl: 'Issue HBL?',
  Cargo_IssueInvoiceDirectly: 'Issue Invoice Directly',
  Cargo_IssueInvoiceDirectlyOrNot: 'Issue invoice directly or not?',
  Cargo_IssueOfTheYear: 'Issue {1} of Year {0}',
  Cargo_ISWBDC: '{0} item(s) will be deleted, continue?',
  Cargo_Item: 'Item',
  Cargo_Item1: 'Item 1',
  Cargo_Item2: 'Item 2',
  Cargo_ItemNo: 'Project no.',
  Cargo_ItemNo2P: 'Project no.2:',
  Cargo_ItemNoP: 'Project no.:',
  Cargo_ItemsAdded: '{0} items added.',
  Cargo_ItemsNBR: 'Quantity',
  Cargo_ReturnContainerAddress: 'Container return address',
  Cargo_LoadingAddress: 'Loading address',
  Cargo_ITIOCBNMPCBITIITBCPOTS: 'Invoicing terminal ID of current Branch not maintained, please configure Baiwang invoicing terminal ID in the basic configuration page of the system.',
  Cargo_ITPIEI: 'Invoicing Type / Paper Invoice / Electronic Invoice',
  Cargo_IYDTRIAACWTACYIYWTKTAABFFIACNCTCIA: 'If you decide to revoke invoice application after confirming with the applicant, click \'Yes\'. If you want to keep the application as basis for future invoice application, click \'No\'. Continue to cancel invoice application?',
  Cargo_January: 'January',
  Cargo_JEODTD: 'Journal entries of {0} data type deleted',
  Cargo_JEOOSC: 'Journal entry of overseas settlement center?',
  Cargo_JFOCP: 'Judgement Field of Collection/Payment',
  Cargo_JobListSearched: 'Job List Searched',
  Cargo_JobNo: 'Job No.',
  Cargo_JobNoP: 'Job No.:',
  Cargo_JobTypeImport: 'Import',
  Cargo_JournalEntryCategory: 'Journal Entry Category',
  Cargo_JournalEntryRule: 'Journal Entry Rule',
  Cargo_July: 'July',
  Cargo_June: 'June',
  Cargo_KeyWord: 'Key word',
  Cargo_KeyWordCanTBeEmpty: 'Key word can\'t be empty',
  Cargo_KingdeeCloudApprove: 'Kingdee Cloud Approve',
  Cargo_KingdeeCloudReview: 'Kingdee Cloud Review',
  Cargo_LastAccrualTime: 'Last accrual time',
  Cargo_LastDate: 'Last Date',
  Cargo_LastInvoiceNo: 'Last Invoice No.',
  Cargo_LastModificationTime: 'Last Modification Time:',
  Cargo_LastReceiveDate: 'Last receive date',
  Cargo_LastReceivingDate: 'Last Receiving Date',
  Cargo_LastTimeBalance: 'Last Balance',
  Cargo_LBNRYSTW: 'Linked business not reviewed yet, sure to withdraw?',
  Cargo_LegalUnit: 'Legal unit',
  Cargo_Lender: 'Lender',
  Cargo_LessThan: 'Less than',
  Cargo_Letter: 'Letter',
  Cargo_Level: 'Level',
  Cargo_Level1AccountTitle: 'Level 1 Account Title',
  Cargo_Level2AccountTitle: 'Level 2 Account Title',
  Cargo_Level3AccountTitle: 'Level 3 Account Title',
  Cargo_Level4AccountTitle: 'Level 4 Account Title',
  Cargo_Level5AccountTitle: 'Level 5 Account Title',
  Cargo_Level6AccountTitle: 'Level 6 Account Title',
  Cargo_Limit: 'AmAlint',
  Cargo_LinkBills: 'Link bills?',
  Cargo_LinkOffsetExpenseDifferentials: 'Link offset expense differentials?',
  Cargo_LinkPaymentRequests: 'Link payment requests?',
  Cargo_LinkToInvoice: 'Link to Invoice',
  Cargo_Load: 'Load',
  Cargo_LoadCache: 'Load Cache',
  Cargo_Loaded: 'Loaded',
  Cargo_LoadedAndSave: 'Loaded, click to save.',
  Cargo_LoadingAtDoor: 'Loading at Door',
  Cargo_LoadingAtFactory: 'Loading at factory',
  Cargo_LoadOrNot: 'Load or not?',
  Cargo_Loan: 'Loan',
  Cargo_LoanSwap: 'Loan Swap',
  Cargo_LocalAgent: 'Local agent',
  Cargo_LocalCharge: 'Local charge',
  Cargo_LocalChargeOrNot: 'Local charge or not',
  Cargo_LocalCurrency: 'Local Currency',
  Cargo_LocalizedName: 'Localized name',
  Cargo_Location: 'Location',
  Cargo_LocationOfCurrentVoucher: 'Location of Current Voucher',
  Cargo_LockCancellationDate: 'Lock Cancellation Date',
  Cargo_LockTheBill: 'Lock Business',
  Cargo_Log: 'Log',
  Cargo_LogisticsCompany: 'Logistics company',
  Cargo_LogRecord: 'Log Records',
  Cargo_LOTFINMBGT3D: 'Length of the first invoice no. must be greater than 3 digits.',
  Cargo_LowerCase: 'Lower-case',
  Cargo_MainLineTransport: 'Main-line transport',
  Cargo_MaintenanceOfShippingTerms: 'Maintenance of shipping terms',
  Cargo_ManagementOfWithdrawal: 'Management of Withdrawal',
  Cargo_ManageParameters: 'Manage parameters',
  Cargo_MANMWCSAISCTD: 'Mailing address not matched with client\'s address in system, continue to deliver?',
  Cargo_March: 'March',
  Cargo_Mark: 'Mark',
  Cargo_MarkTime: 'Mark Time',
  Cargo_Marker: 'Marker',
  Cargo_MarkStatus: 'Mark Status',
  Cargo_MarkCancelledSuccessfully: 'Mark cancelled successfully.',
  Cargo_MarkDate: 'Mark Date',
  Cargo_Marked: 'Marked',
  Cargo_MarkedBy: 'Marked by',
  Cargo_MarkOfConfirmation: 'Mark of Confirmation',
  Cargo_Marks: 'Marks',
  Cargo_MarkSymbols: 'Mark Symbols',
  Cargo_MasterBillNotSearched: 'Master bill not searched.',
  Cargo_May: 'May',
  Cargo_MBACM: 'Modify Billing Amount Calculation Method',
  Cargo_MBEIRPSUB: 'Marked bills exist in record, please select unmarked bills.',
  Cargo_MBLAudit: 'M/BL Verify',
  Cargo_MBLCargoDetention: 'M/BL Hold Cargo',
  Cargo_MBLFreightTerm: 'MBL freight payment terms',
  Cargo_MblNo: 'MBL No.',
  Cargo_MBLPayable: 'M/BL Payable',
  Cargo_MBLPaymentTime: 'M/BL Payment Time',
  Cargo_MBLReviewTime: 'M/BL Review Time',
  Cargo_MBLTimeOfCargoHolding: 'M/BL Time of Cargo Holding',
  Cargo_MBLTransitTerm: 'MBL shipping terms',
  Cargo_MDEPSBP: 'Modified data exist, please save before print.',
  Cargo_MDEPSBPIN: 'Modified data exist, please save before print invoice no. {0}',
  Cargo_Merge: 'Merge',
  Cargo_MergeOrNot: 'Merge or not?',
  Cargo_MethodOfClaim: 'Method of Claim',
  Cargo_MethodOfClaimP: 'Method of Claim:',
  Cargo_Metrics: 'Metrics',
  Cargo_MfnTaxRate: 'MFN tax rate',
  Cargo_Mode: 'Mode',
  Cargo_ModelSpecification: 'Model & Specification',
  Cargo_ModificationOfCollection: 'Modification of Collection',
  Cargo_ModificationTime: 'Modification Time',
  Cargo_ModifiedDataNotSavedCancel: 'Modified data not saved. Cancel?',
  Cargo_Modifier: 'Modified by',
  Cargo_Modify: 'Modify',
  Cargo_ModifyAccountTitle: 'Modify Account Title',
  Cargo_ModifyAccountTitleName: 'Modify Account Title Name.',
  Cargo_ModifyAdjustBill: 'Modify & Adjust Bill',
  Cargo_ModifyBillingInformation: 'Modify Billing Information',
  Cargo_ModifyCollectionInformation: 'Modify Collection Information',
  Cargo_ModifyInvoice: 'Modify Invoice',
  Cargo_ModifyPort: 'Modify port',
  Cargo_ModifyRailwayStation: 'Modify railway station',
  Cargo_ModifyOverseaWarehouse: 'Modify oversea warehouse',
  Cargo_AddOverseaWarehouse: 'Add FBA Warehouse',
  Cargo_NewOverseaWarehouse: 'New Oversea Warehouse',
  Cargo_CannotDeleteWarehouse: '{0} The warehouse code is already in use and cannot be deleted!',
  Cargo_ModifyRateWithTax: 'Modify Rate with Tax',
  Cargo_ModifySelectedInvoiceStatus: 'Modify Selected Invoice Status',
  Cargo_ModifyWriteOffRecord: 'Modify Write-off Record',
  Cargo_MOMAOB: 'Maintenance of Merchant-assisted Opening Balance',
  Cargo_MonetaryEquivalent: 'Conversion Amount',
  Cargo_MonetaryEquivalentCNY: 'Conversion Amount(CNY)',
  Cargo_Month: 'Month',
  Cargo_FinanceMonthUnitTip: 'Calendar months: the cutoff is N months back from the 1st of the current month; only records strictly before the cutoff are locked (cutoff day excluded). E.g. with 2 months set in September, records before July 1 (July 1 excluded) are locked',
  Cargo_Monthly: 'Monthly Payment',
  Cargo_MonthlyReconciliation: 'Monthly Reconciliation',
  Cargo_Months: 'Month',
  Cargo_MoreConditions: 'More Conditions',
  Cargo_MoreSearch: 'More Search',
  Cargo_Motorcade: 'Trucking company',
  Cargo_MscServiceCode: 'Service Code',
  Cargo_MultipleChoiceBox: '[Multiple-choice Box]',
  Cargo_MultipleCurrenciesExit: 'Multiple currencies exit.',
  Cargo_MultipleSettlingPartiesExist: 'Multiple settling parties exist',
  Cargo_MUPIOOPFWO: 'Must use paid-in/out-of-pocket for write-off?',
  Cargo_MustSelectTheSameClient: 'Must select the same client.',
  Cargo_MVOACP: 'Maintain voucher of advance collection & payment?',
  Cargo_MVOARAPOI: 'Maintain voucher of A/R & A/P offset invoice?',
  Cargo_Name: 'Name',
  Cargo_NameCanTBeEmpty: 'Name can\'t be empty.',
  Cargo_ExistDoorSite: 'The same door point information already exists.',
  Cargo_PleaseSelectCommissioningUnit: 'Please select the commissioning unit among the partners.',
  Cargo_PleaseInputOneDoorInfoAtLeast: 'Please enter at least one door point information.',
  Cargo_EnglishNameCheck: 'English name cannot be empty.',
  Cargo_LandTransportationDetails: 'Land transportation details editing',
  Cargo_NameP: 'Name:',
  Cargo_NAMISANOSNBCWBRS2DPTED: 'Note: Alert method is \'System alert\', notice of suspending new business configuration will be re-sent 2 days prior to expiry date.',
  Cargo_NatureOfSales: 'Nature of sales',
  Cargo_NBCTBGTC: 'Negative balance can\'t be greater than cent.',
  Cargo_NECDFTIC: 'No exceeding {0} currencies different from the invoicing currency.',
  Cargo_BillPaymentCurrencyBeyond: 'Cannot exceed {0} currencies that are different from the payment currency!',
  Cargo_PayByBillingRate: 'Pay at bill rate',
  Cargo_NeedAccountingPeriod: 'Sorry, in this version of Waltech financial software, account title can only be edited after the fiscal period has been set up.',
  Cargo_NeedAccrue: 'Need accrue',
  Cargo_NeedCustomsDeclare: 'Need customs declare',
  Cargo_NeedHqToWriteOffOrNot: 'Need HQ to write off or not?',
  Cargo_NeedInvoiceOrNot: 'Need to issue invoice or not?',
  Cargo_NeedMandatoryAccrue: 'Need mandatory accrue',
  Cargo_NeedToBillCNYToCNY: 'Need to bill {1} CNY to {0}CNY.',
  Cargo_NeedToConfiCNYankAccountOrNot: 'Need to confirm bank account or not?',
  Cargo_NeedToCreateBillOrNot: 'Need to create bill or not?',
  Cargo_NeedToExportOrNot: 'Need to export or not?',
  Cargo_NeedToPayTo: 'Need to pay {1} to {0}',
  Cargo_NEFEIDE: 'Non-empty filters exist in default export.',
  Cargo_NegotiationStage: 'Negotiation stage',
  Cargo_NEIAFPRPOCA: 'No expense in application form, please refresh page or contact administrator.',
  Cargo_NEICTBD: 'Non-electronic invoice can\'t be deleted.',
  Cargo_NetWork: 'Network',
  Cargo_NetworkName: 'Network name',
  Cargo_NetworkNameCanTBeEmpty: 'Network name can\'t be empty',
  Cargo_New: 'New',
  Cargo_NewAccountStatement: 'New SOA',
  Cargo_NewAccountTitle: 'New Account Title',
  Cargo_NewFiscalPeriod: 'New Fiscal Period',
  Cargo_NewInvoiceNo: 'New Invoice No.',
  Cargo_NewInvoiceNoP: 'New Invoice No.:',
  Cargo_NewPaymentRequest: 'Create Payment Application',
  Cargo_NewValue: 'New Value',
  Cargo_Next: 'Next Step',
  Cargo_NextItem: 'Next',
  Cargo_NextStep: 'Next step',
  Cargo_NextStepToSave: 'Next Step to Save',
  Cargo_NFFICSPRE: 'No files found in cloud storage, please re-export.',
  Cargo_NFMKWPEAW: 'Note: For multiple key words, please enter and wrap.',
  Cargo_NFPAFTS: 'No financial periods available for this SOB.',
  Cargo_NFPSCATWBSACYCTS: 'No fiscal period setup, current account title will be set as current year. Continue to save.',
  Cargo_NMT2MCTAIEAWO: 'No more than 2 mismatched currency types allowed in expense and write-off.',
  Cargo_NNTCVFCOPL: 'No need to create vouchers for carry-over profit & loss.',
  Cargo_NNTEIBOPLBFSOATBOTY: 'No need to enter initial balance of profit & loss balance for SOB opened at the beginning of the year.',
  Cargo_No: 'No',
  Cargo_NOATGCAAIODMBETTGMO: 'Numbers of account title grouping condition are arranged in order, data must be equal to title groups minus one.',
  Cargo_NoBillToConfirm: 'No bill to confirm.',
  Cargo_NoBillToCreateSoa: 'No bill to create SOA.',
  Cargo_NoBillToWriteOff: 'No bill to write off.',
  Cargo_NoBusinessNeedFinancialReview: 'No business need financial review.',
  Cargo_NoBusinessTypeSelected: 'No business type selected',
  Cargo_NoCitySelectedToEdit: 'No city selected to edit',
  Cargo_NoConfirmedBillToCancel: 'No confirmed bill to cancel.',
  Cargo_NoData: 'No data.',
  Cargo_NoDataModifiedNoNeedToSave: 'No data modified, no need to save.',
  Cargo_NoDataSelected: 'No data selected',
  Cargo_NoDataSelectedToDelete: 'No data selected to delete',
  Cargo_NoDataToExport: 'No data to export.',
  Cargo_NoDataToModify: 'No data to modify',
  Cargo_NoDataToPreview: 'No data to preview.',
  Cargo_NoDataToTransfer: 'No data to transfer.',
  Cargo_NoDoNotLink: 'No, do not link.',
  Cargo_NOEGT1ICTSTNWBST1C: 'Number of expenses greater than 1, if continue to split, the number will be set to 1. Continue?',
  Cargo_NoElectronicInvoiceNoToCreate: 'No electronic invoice no. to create.',
  Cargo_NoEligibleExpenseToPrint: 'No eligible expense to print.',
  Cargo_NoEligibleRecord: 'No eligible record.',
  Cargo_NoEligibleRecordsFound: 'No eligible records found.',
  Cargo_NoExpenseDifferentialsToProcess: 'No expense differentials to process.',
  Cargo_NoExpenseToBill: 'No expense to bill.',
  Cargo_NoExpenseToInvoice: 'No expense to invoice.',
  Cargo_NoExpenseToReject: 'No expense to reject.',
  Cargo_NoExpenseToReview: 'No expense to review.',
  Cargo_NoExpenseToWriteOff: 'No expense to write off.',
  Cargo_NoFileToRetrieve: 'No file to retrieve.',
  Cargo_NoFileToRevoke: 'No file to revoke.',
  Cargo_NoForeignCurrencyAccounting: 'No foreign currency accounting.',
  Cargo_NoInvoiceNo: 'No invoice no.',
  Cargo_NoInvoiceNoForInvoiceAmounted: 'No invoice no. for invoice amounted {0} .',
  Cargo_NoInvoiceNoToCheck: 'No invoice no. to check.',
  Cargo_NoMaintainedBankForClient: 'No maintained bank for client.',
  Cargo_NoMatchedRecordFound: 'No matched record found',
  Cargo_NominatedAgent: 'Nomination Cargo Agent',
  Cargo_NonAccrual: 'Non-accrual',
  Cargo_None: 'None',
  Cargo_NoneAnyBillable: 'None any billable.',
  Cargo_NoNeedToRepeatConfirmation: 'No need to repeat confirmation.',
  Cargo_NoNeedToSplitThisKeyWord: 'No need to split this key word',
  Cargo_NonElectronicInvoice: 'Non-electronic Invoice',
  Cargo_NonSplitWriteOffExpense: 'Non Split & Write-off Expense',
  Cargo_NoNumberBreak: 'No number break.',
  Cargo_NoOfPages: 'No. of Pages',
  Cargo_NoParentAccountTitles: 'No parent account titles.',
  Cargo_NoPortSelected: 'No port selected',
  Cargo_NoRecordChecked: 'No record checked',
  Cargo_NoRecordSelected: 'No record selected',
  Cargo_NoRecordToSave: 'No record to save.',
  Cargo_NoRelease: 'No Release',
  Cargo_NoReviewedExpenseToCancel: 'No reviewed expense to cancel.',
  Cargo_NoServiceTicketToDelete: 'No service ticket to delete.',
  Cargo_NoSiteSelected: 'No site selected',
  Cargo_NoSobSetUpCurrently: 'No SOB set up currently.',
  Cargo_NotAcquired: 'Not Acquired',
  Cargo_NotAdjustedExpense: 'Not Adjusted Expense',
  Cargo_NotAFinalAccountTitle: '[{0}] not a final account title.',
  Cargo_NotCarriedOver: 'Not Carried-over',
  Cargo_NotCollectAdvance: 'Not Collect-&-Advance',
  Cargo_NotCollected: 'Not Collected',
  Cargo_NotCollectedCNY: 'Not Collected(CNY)',
  Cargo_NotCollectedEUR: 'Not Collected(EUR)',
  Cargo_NotCollectedGBP: 'Not Collected(GBP)',
  Cargo_NotCollectedHKD: 'Not Collected(HKD)',
  Cargo_NotCollectedInFull: 'Not Collected in Full',
  Cargo_NotCollectedJPY: 'Not Collected(JPY)',
  Cargo_NotCollectedNGN: 'Not Collected(NGN)',
  Cargo_NotCollectedP: 'Not Collected:',
  Cargo_NotCollectedUSD: 'Not Collected(USD)',
  Cargo_Collected: 'Collected',
  Cargo_NotContracted: 'Not Contracted',
  Cargo_NotDisplayedIfMultipleItemsExist: 'Not displayed if multiple items exist.',
  Cargo_NOTDIST: 'Number of Templates Displayed in Search Tab',
  Cargo_NotificationOfPaymentFreeze: 'Notification of Payment Freeze',
  Cargo_NotificationOfUnfrozenPayment: 'Notification of Unfrozen Payment',
  Cargo_NotifyHq: 'Notify HQ',
  Cargo_NotifyId: 'Notify party\'s code',
  Cargo_NotifyInfo: 'Notify party\'s information',
  Cargo_NotifyParty: 'Notify party',
  Cargo_NotifyPartySName: 'Notify party\'s name',
  Cargo_NotifyUser: 'Remind User',
  Cargo_NotifyMethod: 'Notification method',
  Cargo_NotInvoicedMoney: 'Un-invoiced Amount',
  Cargo_NoTotal: 'No {0}, Total {1}',
  Cargo_NotReviewed: 'Not Reviewed',
  Cargo_NotSent: 'Not sent',
  Cargo_NotSet: 'Not set',
  Cargo_NotSubmittedCanTWithdraw: 'Not submitted, can\'t withdraw.',
  Cargo_NotTaxFree: 'Not Tax-free',
  Cargo_NotWrittenBack: 'Not Written-back',
  Cargo_NotWrittenOff: 'Not Written-off',
  Cargo_NotWrittenOff2: 'Not Written-off',
  Cargo_NotWrittenOffCurrency: 'Not Written-off {0}',
  Cargo_NotWrittenOffHKD: 'Not Written-off(HKD)',
  Cargo_NotWrittenOffUSD: 'Not Written-off(USD)',
  Cargo_NoUnInvoicedExpense: 'No un-invoiced expense.',
  Cargo_November: 'November',
  Cargo_NPDOSB: 'No preliminary data of subsidiary balance.',
  Cargo_NRFTAL: 'Self-delivery',
  Cargo_NSEFPCA: 'No split expense found, please contact administrator.',
  Cargo_NTWBWRLION: 'Need to write back with red-letter invoice or not?',
  Cargo_Number: 'Number',
  Cargo_NumberS: 'Number',
  Cargo_NumberOfAttachedDocuments: 'Number of Attached Documents',
  Cargo_NumberOfCopies: 'Number of Copies',
  Cargo_NumberOfCopiesCanTBe0: 'Number of copies can\'t be 0.',
  Cargo_NumberOfExpenseWriteOffs: 'Number of Expense Write-offs',
  Cargo_NumberOfNominatedAgents: 'Number of nominated agents',
  Cargo_OBCILC: 'Opening Balance Combined in Local Currency',
  Cargo_OBIMICMAWTCSCCPBR: 'Our Bank is mandatory if collection methods are wire transfer, cashier\'s check, collection & payment, bank receipt.',
  Cargo_OceanExport: 'Ocean Export',
  Cargo_OceanFreight: 'Ocean Freight',
  Cargo_OceanImport: 'Ocean Import',
  Cargo_OceanImportExport: 'Ocean Import & Export',
  Cargo_OCLWSPCBS: 'Only client linked with sales person can be selected',
  Cargo_October: 'October',
  Cargo_Oddment: 'Short Account',
  Cargo_ODWSSCBP: 'Only documents with same status can be printed.',
  Cargo_OEOSET: 'Owners\' Equity or Shareholders\' Equity Total',
  Cargo_OEVCBWB: 'Only exported vouchers can be written back.',
  Cargo_OFAOPOTFSIITPRPPDNOATRIC: 'Operation failed, all or part of the fee(s) is in the payment review process, please do not operate after the review is completed.',
  Cargo_OFCIIFPRNRN: 'Operation failed, cannot include invoiced fees, please reselect.\\nPayment request No.:',
  Cargo_OFCTCMT2: 'Operation failed, currency type cannot more than 2.',
  Cargo_OffsetDataSource: 'Offset Data Source',
  Cargo_OffsetEntity: 'Offset Entity',
  Cargo_OffsetOrNot: 'Offset or not?',
  Cargo_MustInvoiceNoAndTitle: 'The invoice number and billing name must be filled in',
  Cargo_OFGTECOBUFEIIC: 'Operation failed, "Golden Tax Export" can only be used for e-invoice in CNY.',
  Cargo_OFNBFSWWF: 'Operation failed, no billable fee(s) was/were found.',
  Cargo_OFTAPFSDNMTIR: 'Operation failed, the A/P fee status did not meet the invoiced requirements.',
  Cargo_OFTARFSDNMTIR: 'Operation failed, the A/R fee status did not meet the invoiced requirements.',
  Cargo_OFTCBDNMTTINSIIITIEI: 'Operation failed, the current branch does not maintain the taxpayer identification number, so it is impossible to issue e-invoice.',
  Cargo_OFTFRCWNM: 'Operation failed, the financial review conditions were not met.',
  Cargo_OFTFRCWNMCSRT: 'The financial review conditions were not met, pls change the setting and retry.',
  Cargo_OFTIISCBD: 'Operation failed, the invoiced item(s) cannot be deleted.',
  Cargo_OFTIRCBDTNIAF: 'Operation failed, the invoiced requisition cannot be deleted. The No. is as follows:',
  Cargo_OFTIRCBETNIAF: 'Operation failed, the invoiced requisition cannot be edited. The No. is as follows:',
  Cargo_OFTRFOTARFCBIITB: 'Operation failed, the reverse fee or the already reversed fee cannot be included in the bill.',
  Cargo_OFTUFSCBS: 'Operation failed, the unsaved fee(s) cannot be split.',
  Cargo_OFTWOANTBETTSOREGALFE: 'Operation failed, the write-off amount needs to be equal to the sum of received, exchange gains and losses, financial expenses, odd.',
  Cargo_OFWTIARTARMBGTTAP: 'Operation failed, when type is A/R, total A/R must be greater than total A/P.',
  Cargo_OIRWPSCBCAC: 'Only invoicing requests with \'Pending\' status can be combined and created.',
  Cargo_OIWWBCBP: 'Only invoices without write-backs can be printed.',
  Cargo_OnAccountHedge: '(On-account Hedge)',
  Cargo_OneClickRenewal: 'One-click renewal',
  Cargo_OnlyCheckedRecordsCanBeCancelled: 'Only checked records can be cancelled.',
  Cargo_OnlyReviewedVouchersCanBeDeleted: 'Only reviewed vouchers can be deleted.',
  Cargo_OnlyUnCheckedRecordsCanBeChecked: 'Only un-checked records can be checked.',
  Cargo_OOAPIICCTTTEPRCOEA: 'Only outstanding A/P items in collection, can\'t transfer to expense, please redo collection or expense application.',
  Cargo_OORCBSFASBI: 'Only one record can be selected for a single-bill invoicing.',
  Cargo_OpeningAmountOfTheYear: 'Opening Amount of the Year',
  Cargo_OpeningBalance: 'Opening Balance',
  Cargo_OpeningBalanceCreditCNY: 'Opening Balance Credit (CNY)',
  Cargo_OpeningBalanceCreditUSD: 'Opening Balance Credit (USD)',
  Cargo_OpeningBalanceDebitCNY: 'Opening Balance Debit (CNY)',
  Cargo_OpeningBalanceDebitUSD: 'Opening Balance Debit (USD)',
  Cargo_OperateBy: 'Operator',
  Cargo_OperatedSuccessfullyRefreshPage: 'Operated successfully, refresh page.',
  Cargo_OperatingCompany: 'Business Unit',
  Cargo_Operation: 'Operation',
  Cargo_OperationCompany: 'Operating company',
  Cargo_OperationComplete: 'Operation complete',
  Cargo_OperationDate: 'Operation Date',
  Cargo_OperationDepartment: 'Operations Department',
  Cargo_OperationOffice: 'Operations Office',
  Cargo_OperationFailed: 'Operation failed.',
  Cargo_OperationHistory: 'Operation history',
  Cargo_OperationModeAir: 'Operation mode (air)',
  Cargo_OperationModeAirExport: 'Operation mode (air export)',
  Cargo_OperationModeAirImport: 'Operation mode (air import)',
  Cargo_OperationRequirementType: 'Operation requirement type',
  Cargo_OperationSuccessfully: 'Operated successfully.',
  Cargo_OperationSymbol: 'Operation Symbol',
  Cargo_OperationType: 'Operation Type',
  Cargo_OperationTypeCanTBeEmpty: 'Operation type can\'t be empty',
  Cargo_Operator: 'Operator',
  Cargo_OperatorOfWithdrawal: 'Operator of Withdrawal',
  Cargo_OppositeVoucherNo: 'Opposite voucher No.',
  Cargo_OppositeVoucherNoP: 'Opposite voucher No.:',
  Cargo_OPVWES: 'Only process vouchers with examined status.',
  Cargo_Order: 'Order',
  Cargo_OrdinaryTaxRate: 'Ordinary tax rate',
  Cargo_ORDM: 'Operation requirement description maintenance',
  Cargo_Original: 'Original',
  Cargo_OriginalAmount: 'Original Amount',
  Cargo_OriginalAmountCNY: 'Original Amount(CNY)',
  Cargo_OriginalAmountInBill: 'Original Amount in Bill',
  Cargo_OriginalAmountUSD: 'Original Amount(USD)',
  Cargo_OriginalContent: 'Original Content',
  Cargo_OriginalCurrency: 'Original Currency',
  Cargo_OriginalCurrencyInBill: 'Original Currency in Bill',
  Cargo_OriginalCurrencyNotWrittenOff: 'Original Currency not Written off',
  Cargo_OriginalCurrencyP: 'Original Currency:',
  Cargo_OriginalExchangeRateInBill: 'Original Exchange Rate in Bill',
  Cargo_OriginalExpense: 'Original Expense',
  Cargo_OriginalExpenseAmount: 'Original Expense Amount',
  Cargo_OriginalExpenseP: 'Original Expense:',
  Cargo_OriginalInvoiceNo: 'Original Invoice No.',
  Cargo_OriginalInvoiceNoP: 'Original Invoice No.:',
  Cargo_OriginalInvoiceTitle: 'Original Invoice Title',
  Cargo_OriginalInvoiceTitleP: 'Original Invoice Title:',
  Cargo_OriginalValue: 'Original Value',
  Cargo_ChargeItemView: 'Charge item view',
  Cargo_ORORDCBO: 'Only retrieved or returned documents can be operated.',
  Cargo_ORVCBE: 'Only reviewed vouchers can be exported.',
  Cargo_OSVBMP: 'Only search vouchers by machine printed',
  Cargo_Other: 'Other',
  Cargo_OtherChargeItem: 'AWB surcharge',
  Cargo_OtherContact: 'Other Contact',
  Cargo_OtherConversionAP: 'Other Conversion A/P',
  Cargo_OtherConversionAPCNY: 'Other Conversion A/P(CNY)',
  Cargo_OtherConversionAPEUR: 'Other Conversion A/P(EUR)',
  Cargo_OtherConversionAPGBP: 'Other Conversion A/P(GBP)',
  Cargo_OtherConversionAPHKD: 'Other Conversion A/P(HKD)',
  Cargo_OtherConversionAPJPY: 'Other Conversion A/P(JPY)',
  Cargo_OtherConversionAPNGN: 'Other Conversion A/P(NGN)',
  Cargo_OtherConversionAR: 'Other Conversion A/R',
  Cargo_OtherConversionARCNY: 'Other Conversion A/R(CNY)',
  Cargo_OtherConversionAREUR: 'Other Conversion A/R(EUR)',
  Cargo_OtherConversionARGBP: 'Other Conversion A/R(GBP)',
  Cargo_OtherConversionARHKD: 'Other Conversion A/R(HKD)',
  Cargo_OtherConversionARJPY: 'Other Conversion A/R(JPY)',
  Cargo_OtherConversionARNGN: 'Other Conversion A/R(NGN)',
  Cargo_OtherCurrencies: 'Other Currencies',
  Cargo_OtherCurrencyExchangeRates: 'Other Currency Exchange Rates',
  Cargo_OtherExchangeRates: 'Other Exchange Rates',
  Cargo_OtherOutstandingConversionAP: 'Other Outstanding Conversion A/P',
  Cargo_OtherOutstandingConversionAPCNY: 'Other Outstanding Conversion A/P(CNY)',
  Cargo_OtherOutstandingConversionAPEUR: 'Other Outstanding Conversion A/P(EUR)',
  Cargo_OtherOutstandingConversionAPGBP: 'Other Outstanding Conversion A/P(GBP)',
  Cargo_OtherOutstandingConversionAPHKD: 'Other Outstanding Conversion A/P(HKD)',
  Cargo_OtherOutstandingConversionAPJPY: 'Other Outstanding Conversion A/P(JPY)',
  Cargo_OtherOutstandingConversionAPNGN: 'Other Outstanding Conversion A/P(NGN)',
  Cargo_OtherOutstandingConversionAR: 'Other Outstanding Conversion A/R',
  Cargo_OtherOutstandingConversionARCNY: 'Other Outstanding Conversion A/R(CNY)',
  Cargo_OtherOutstandingConversionAREUR: 'Other Outstanding Conversion A/R(EUR)',
  Cargo_OtherOutstandingConversionARGBP: 'Other Outstanding Conversion A/R(GBP)',
  Cargo_OtherOutstandingConversionARHKD: 'Other Outstanding Conversion A/R(HKD)',
  Cargo_OtherOutstandingConversionARJPY: 'Other Outstanding Conversion A/R(JPY)',
  Cargo_OtherOutstandingConversionARNGN: 'Other Outstanding Conversion A/R(NGN)',
  Cargo_OTNSOSICBD: 'Only the not-sent or sent items can be deleted.',
  Cargo_OTWOOCCI: 'Only the write-off operator can cancel it.',
  Cargo_OTWOOCMI: 'Only the write-off operator can modify it.',
  Cargo_OurAccount: 'Our Bank Account',
  Cargo_OurBank: 'Our Bank',
  Cargo_OurBankIsEmptySaveBankReceipt: 'Our bank is empty, save bank receipt?',
  Cargo_Outcomes: 'Outcomes',
  Cargo_OutstandingAP: 'Outstanding A/P',
  Cargo_OutstandingAPP: 'Outstanding A/P:',
  Cargo_OutstandingConversionAPInCNY: 'Outstanding Conversion A/P in CNY',
  Cargo_OutstandingConversionAPInCurrency: 'Outstanding Conversion A/P in {0}',
  Cargo_OutstandingConversionPaidInCurrency: 'Outstanding Conversion Paid in {0}',
  Cargo_OutstandingPaymentParties: 'Outstanding Payment Parties',
  Cargo_OutstandingWrittenOffItemsExist: 'Outstanding written-off items exist.',
  Cargo_OVDCBUFPLAT: 'Only virtual dept. can be used for profit & loss account title.',
  Cargo_Virtual: 'Virtual',
  Cargo_Over90DaysShpt: 'Over 90 days (shpt)',
  Cargo_OverdueExpenses: 'Overdue expenses',
  Cargo_Overseas: 'Overseas',
  Cargo_OverseasAgencyContract: 'Overseas Agent Contract',
  Cargo_OverseasAgent: 'Overseas Agent',
  Cargo_OverseasAgentOrNot: 'Overseas agent or not?',
  Cargo_OverseasCollection: 'Overseas Collection',
  Cargo_OverseasDirectClient: 'Overseas Direct Client',
  Cargo_OverseasDirectClientOrNot: 'Overseas direct client or not?',
  Cargo_OverseasDomestic: 'Overseas & Domestic',
  Cargo_OverseasOrNot: 'Overseas or not?',
  Cargo_OverseasPayment: 'Overseas Payment',
  Cargo_OverseasWriteOff: 'Overseas Write-off',
  Cargo_OverseasWriteOffOrNot: 'Overseas write-off or not?',
  Cargo_OverseasWriteOffSearch: 'Overseas Write-off Search',
  Cargo_OVICBETGTEI: 'Only VAT invoice can be exported to Golden Taxation E-invoice.',
  Cargo_OVWCSNCBE: 'Only vouchers with consecutive serial no. can be exported.',
  Cargo_OVWUSCBE: 'Only vouchers with unexamined status can be examined.',
  Cargo_OWCICGTSEEI: 'Only when currency is {0} can Golden Taxation system export electronic invoice.',
  Cargo_OwningDept: 'Owning dept.',
  Cargo_Package: 'Package',
  Cargo_PackageExistsOrSelectNull: 'Package already exists or no record selected',
  Cargo_PackageMaintenance: 'Package maintenance',
  Cargo_PackingInformationNotSelected: 'Packing Information not Selected.',
  Cargo_PADS: 'Payment application denied successfully.',
  Cargo_Page: 'Page',
  Cargo_Paid: 'Paid',
  Cargo_PaidInFull: 'Paid in Full',
  Cargo_PaidInOutOfPocket: 'Paid-in/out-of-pocket',
  Cargo_ReceiptPaymentpVoucher: 'Proof of receipt and payment',
  Cargo_PANMWEAPCAOCA: 'Payment application not matched with expense amount, please check amount or contact administrator.',
  Cargo_ParentAccountTitle: 'Parent Account Title',
  Cargo_PARGMSA: 'Payment application require General Manager\'s approval?',
  Cargo_Parter: 'Partner',
  Cargo_CreditAccountingPeriod: 'Credit accounting period',
  Cargo_CreditLine: 'Credit line',
  Cargo_ExceededAmount: 'Exceeded, {0} yuan',
  Cargo_Exceeded: 'Exceeded, {0} yuan',
  Cargo_PartialConfirmation: 'Partial Confirmation',
  Cargo_PartialExpense: 'Partial Expense',
  Cargo_PartialPayment: 'Partial Payment',
  Cargo_PartialReversalCompleted: 'Partial reversal completed',
  Cargo_PartialWriteOff: 'Partial Write-off',
  Cargo_Participant: 'Participant',
  Cargo_PartnerCanTBeEmpty: 'Partner can\'t be empty',
  Cargo_PartnerSCreditLimitExceeded: 'Partner\'s credit limit exceeded',
  Cargo_Password: 'Password',
  Cargo_PasswordField: 'Password Field',
  Cargo_PAWOCTBD: 'Payment application written off, can\'t be deleted.',
  Cargo_Pay: 'Pay',
  Cargo_Payable: 'Payable',
  Cargo_PayableNeedPay: 'Payable(NeedPay)',
  Cargo_PayableOrNot: 'Payable or not?',
  Cargo_PayablesWriteOfStatus: 'A/P write-off status',
  Cargo_Payee: 'Payee',
  Cargo_PayeeP: 'Payee:',
  Cargo_Payment: 'Payment',
  Cargo_PaymentAccount: 'Payment Account',
  Cargo_PaymentAgainstMonthlySoa: 'Payment against Monthly SOA',
  Cargo_PaymentAmount: 'Payment Amount',
  Cargo_PaymentApplicationDirectlySent: 'Payment Application directly sent',
  Cargo_PaymentApplicationInformation: 'Payment Application Information',
  Cargo_PaymentApplicationNo: 'Payment Application No.',
  Cargo_PaymentAppliedSuccessfully: 'Payment applied successfully.',
  Cargo_PaymentApprovalSlipDetails: 'Payment Approval Slip Details',
  Cargo_PaymentApprovalSlipNo: 'Payment Approval Slip No.',
  Cargo_PaymentCompany: 'Payment Company',
  Cargo_PaymentCompanyName: 'Payment Company Name',
  Cargo_PaymentCycle: 'Billing Cycle',
  Cargo_PaymentDate: 'Payment Date',
  Cargo_PaymentDateCanTBeEmpty: 'Payment date can\'t be empty.',
  Cargo_PaymentMethod: 'Payment Method',
  Cargo_PaymentNotApplied: 'Payment not Applied',
  Cargo_PaymentNotificationNo: 'Payment Notice No.',
  Cargo_PaymentPeriod: 'Payment Term',
  Cargo_PaymentPeriodExceeded: 'Exceeded billing period',
  Cargo_PaymentPeriodRange: 'Payment period range',
  Cargo_PaymentReceiveMethod: 'Collection/Payment Method',
  Cargo_PaymentReceiveMethodP: 'Collection/Payment Method:',
  Cargo_PaymentReceiveType: 'Collection/Payment Type',
  Cargo_PaymentReceiveTypeP: 'Collection/Payment Type:',
  Cargo_PaymentRequest: 'Payment Application',
  Cargo_PaymentRequestBusiness: 'Payment Application - Business',
  Cargo_PaymentRequestDetail: 'Detail Payment Application',
  Cargo_PaymentRequested: 'Payment Requested',
  Cargo_PaymentRequestedNotRequested: 'Payment Requested/Not Requested',
  Cargo_PaymentRequestsCreatedOrNot: 'Payment requests created or not?',
  Cargo_PaymentTime: 'Payment Time',
  Cargo_PaymentToBeChecked: 'Payment to be Checked',
  Cargo_CarryForwardList: 'Carry forward list',
  Cargo_PaymentType: 'Payment Type',
  Cargo_PaymentVerification: 'Payment Verification',
  Cargo_PayReceive: 'Collection/Payment',
  Cargo_PayReceiveDate: 'Collection/Payment Date',
  Cargo_PayUnit: 'Payment Unit',
  Cargo_PCAOCO: 'Please confirm {0} amount of current operation:',
  Cargo_PCHIUV: 'Public client hub items under verification',
  Cargo_PCITIHBI: 'Please check if the invoice has been issued',
  Cargo_INVOICE_NO_FILE: 'No corresponding electronic invoice file',
  Cargo_Pcs: 'pcs',
  Cargo_PCSALOA: 'Please click & select at least one applications.',
  Cargo_PCSALOI: 'Please click & select at least one invoices.',
  Cargo_Pcst: 'pcs',
  Cargo_PCTAOTCPI: 'Please confirm the amount of this collection/payment is:',
  Cargo_PCTOOPAIWOADSA: 'Please confirm the out-of-pocket amount is write-off amount / differential / short account.',
  Cargo_PDDPAF: 'Partial data displayed, please add filters.',
  Cargo_PeakSeason: 'Peak season',
  Cargo_PEALTVJE: 'Please enter at least two valid journal entries.',
  Cargo_PEATGR: 'Please enter account title grouping rule.',
  Cargo_PECCI: 'Please enter complete courier information.',
  Cargo_PECINSWACONIO: 'Please enter correct invoice no., system will automatically create other numbers in order.',
  Cargo_PEERAVC: 'Period-end exchange rate adjustment voucher created.',
  Cargo_PEFEA: 'Period-end Foreign Exchange Adjustment',
  Cargo_PEFEA2: 'Period-end Foreign Exchange Adjustment 2',
  Cargo_PEFEAS: 'Period-end foreign exchange adjusted successfully.',
  Cargo_PendingBusinessApplication: 'Pending Business Application',
  Cargo_PendingPrice: 'Under verification',
  Cargo_People: 'People',
  Cargo_PerformLetterFiltering: 'Perform Letter Filtering',
  Cargo_PERFROIRF: 'Please enter reason for re-open in Remarks field.',
  Cargo_Period: 'Period',
  Cargo_PeriodEndAmount: 'Period-end Amount',
  Cargo_PeriodEndBalance: 'Period-end Balance',
  Cargo_PeriodEndBalanceCreditCNY: 'Period-end Balance Credit (CNY)',
  Cargo_PeriodEndBalanceCreditUSD: 'Period-end Balance Credit (USD)',
  Cargo_PeriodEndBalanceDebitCNY: 'Period-end Balance Debit (CNY)',
  Cargo_PeriodEndBalanceDebitUSD: 'Period-end Balance Debit (USD)',
  Cargo_PeriodEndExchangeRateAdjustment: 'Period-end exchange rate adjustment？',
  Cargo_PeriodRange: 'Period Range',
  Cargo_Periods: 'Period',
  Cargo_PermissionCheck: 'Permission Check',
  Cargo_PermissionControl: 'Permission Control',
  Cargo_PermissionToSubmitExpense: 'Permission to Submit Expense',
  Cargo_PESAI: 'Please enter subsidiary accounting [{0}]\'s {1} information.',
  Cargo_PESAIN: 'Please enter subsidiary accounting [{0}]\'s item no.',
  Cargo_PESCSBA: 'Please enter sales company\'s bank account.',
  Cargo_PETSAINO: 'Please enter the supplementary accounting item number of {0}.',
  Cargo_PETSFIIB: 'Please enter the split fees information in below',
  Cargo_PEWOIPETS: 'Please enter write-off information, press \'Enter\' to search.',
  Cargo_PFAEFTS: 'Payment for Air Export from/to Shanghai',
  Cargo_PICNENCTSFS: 'Please input Chinese name, English name, code to start fuzzy search.',
  Cargo_PlaceOfDelivery: 'Place of delivery',
  Cargo_PlaceOfMblPayment: 'MBL freight payment location',
  Cargo_PlaceOfReceipt: 'Place of receipt',
  Cargo_PlanDescription: 'Plan description',
  Cargo_PlatformCode: 'Platform code',
  Cargo_PlatformCustomerService: 'Platform Customer Service',
  Cargo_CustomerServiceOverSea: 'Over Sea Customer Service',
  Cargo_PLCOS: 'Profit & loss carried over successfully.',
  Cargo_PleaseAddAtLeastOneContactPerson: 'Please add at least one contact person',
  Cargo_PleaseAddContactPerson: 'Please add contact person',
  Cargo_PleaseAddExpense: 'Please add expense.',
  Cargo_PleaseAddNominationCargoAgent: 'Please add nomination cargo agent.',
  Cargo_PleaseAddNominationCargoAgentP: 'Please add nomination cargo agent：',
  Cargo_PleaseAddTelNumbers: 'Please add tel. numbers',
  Cargo_PleaseBatchSelectInvoiceNo: 'Please batch select {0} invoice no.',
  Cargo_PleaseCheckClient: 'Please check client',
  Cargo_PleaseCheckInvoice: 'Please check invoice.',
  Cargo_PleaseChooseData: 'Please choose data.',
  Cargo_PleaseChooseFeeName: 'Please choose fee name.',
  Cargo_PleaseChooseSettlementEntity: 'Please choose settlement entity.',
  Cargo_PleaseClickSelectAnInvoice: 'Please click & select an invoice.',
  Cargo_PleaseClickSelectARecord: 'Please click & select a record.',
  Cargo_PleaseConfirmPaymentMade: 'Please confirm paymed to {0} {1} {2}.',
  Cargo_PleaseConfirmReviewDate: 'Please confirm review date.',
  Cargo_PleaseConfirmFinancialDate: 'Please confirm Financial date.',
  Cargo_PleaseConfirmTheDueAmount: 'Please confirm the due amount.',
  Cargo_PleaseConfirmThePaidInAmountIs: 'Please confirm the paid-in amount is:',
  Cargo_PleaseConfirmThisTime: 'Please confirm the {0} amount is:',
  Cargo_PleaseDeleteAfterVoid: 'Please delete after void.',
  Cargo_PleaseEnterAccountTitle: 'Please enter account title.',
  Cargo_PleaseEnterAmount: 'Please enter amount.',
  Cargo_PleaseEnterClientName: 'Please enter client name.',
  Cargo_PleaseEnterCode: 'Please enter code.',
  Cargo_PleaseEnterCorrectAmount: 'Please enter correct amount.',
  Cargo_PleaseEnterCorrectBillingParty: 'Please enter correct billing party.',
  Cargo_PleaseEnterCorrectExchangeRate: 'Please enter correct exchange rate.',
  Cargo_PleaseEnterCorrectNumber: 'Please enter correct number.',
  Cargo_PleaseEnterCurrencyExchangeRate: 'Please enter currency {0}\'s exchange rate.',
  Cargo_PleaseEnterDate: 'Please enter date.',
  Cargo_PleaseEnterDateOfReceipt: 'Please enter date of receipt.',
  Cargo_PleaseEnterDifferential: 'Please enter differential.',
  Cargo_PleaseEnterExpenseDescription: 'Please enter expense description.',
  Cargo_PleaseEnterExpenseDetails: 'Please enter expense details',
  Cargo_PleaseEnterFinancialCode: 'Please enter financial code.',
  Cargo_ApAndArCodeIsEmpty: 'The current \'Accounts Receivable Code\'/\'Accounts Payable Code\' are both empty. Please complete the data and try again.',
  Cargo_PleaseEnterFinancialDate: 'Please enter financial date',
  Cargo_PleaseEnterHsCode: 'Please enter HS code',
  Cargo_PleaseEnterInformationOf: 'Please enter {1} information of {0}',
  Cargo_PleaseEnterInvoiceInformation: 'Please enter invoice information.',
  Cargo_PleaseEnterInvoiceNo: 'Please enter invoice no.',
  Cargo_PleaseEnterInvoiceNoP: 'Please enter invoice no.',
  Cargo_PleaseEnterMailingAddress: 'Please enter mailing address.',
  Cargo_PleaseEnterName: 'Please enter name.',
  Cargo_PleaseEnterNewInvoiceNo: 'Please enter new invoice no.',
  Cargo_PleaseEnterNewInvoiceTitle: 'Please enter new invoice title.',
  Cargo_PleaseEnterOperationCode: 'Please enter operation code.',
  Cargo_PleaseEnterOurBankAccountNo: 'Please enter our bank account no.',
  Cargo_PleaseEnterPaidInAmount: 'Please enter paid-in amount.',
  Cargo_PleaseEnterPaidInDate: 'Please enter paid-in date.',
  Cargo_PleaseEnterPaymentParty: 'Please enter payment party.',
  Cargo_PleaseEnterPaymentTerm: 'Please enter payment term.',
  Cargo_PleaseEnterPlanName: 'Please enter plan name',
  Cargo_PleaseEnterGuarantrrName: 'Please enter guarantee name',
  Cargo_PleaseEnterRecipientSName: 'Please enter recipient\'s name.',
  Cargo_PleaseEnterReturnedCourierNo: 'Please enter returned courier no.',
  Cargo_PleaseEnterSalesCompanySBank: 'Please enter sales company\'s bank.',
  Cargo_PleaseEnterScarletLetterNumber: 'Please enter scarlet letter number',
  Cargo_PleaseEnterSearchInformation: 'Please enter search information.',
  Cargo_PleaseEnterSettlingParty: 'Please enter settling party.',
  Cargo_PleaseEnterSobCode: 'Please enter SOB code.',
  Cargo_PleaseEnterSobName: 'Please enter SOB name.',
  Cargo_PleaseEnterSplitAmount: 'Please enter split amount.',
  Cargo_PleaseEnterTableName: 'Please enter table name.',
  Cargo_PleaseEnterTelNo: 'Please enter Tel. no.',
  Cargo_PleaseEnterUserName: 'Please enter user name',
  Cargo_PleaseEnterValueOfCondition: 'Please enter value of condition.',
  Cargo_PleaseEnterVoucherLetter: 'Please enter voucher letter.',
  Cargo_PleaseEnterVoucherNo: 'Please enter voucher no.',
  Cargo_PleaseEnterVoucherType: 'Please enter voucher type.',
  Cargo_PleaseInputJobNo: 'Please enter job no.',
  Cargo_PleaseReselectTheVoucherToExport: 'Please reselect the voucher to export.',
  Cargo_PleaseSelect: 'Please select',
  Cargo_PleaseSelectP: '-Please select-',
  Cargo_PleaseSelect2OrMoreApplications: 'Please select 2 or more applications.',
  Cargo_PleaseSelectAccountTitle: 'Please select account title.',
  Cargo_PleaseSelectAnAdvanceReceipt: 'Please select an advance receipt.',
  Cargo_PleaseSelectAnExpenseItem: 'Please select an expense item.',
  Cargo_PleaseSelectAnInvoice: 'Please select an invoice.',
  Cargo_PleaseSelectAPAndARExpense: 'Please select A/P and A/R expense.',
  Cargo_PleaseSelectApplication: 'Please select application.',
  Cargo_PleaseSelectARecord: 'Please select a record.',
  Cargo_PleaseSelectBill: 'Please select bill.',
  Cargo_PleaseSelectBillToMark: 'Please select bill to mark.',
  Cargo_PleaseSelectBillToPrint: 'Please select bill to print.',
  Cargo_PleaseSelectBillToRemove: 'Please select bill to remove.',
  noRowsToShow: 'No results found.',
  Cargo_HblTeleReleaseGuarantee: 'Hbl tele release guarantee',
  Cargo_TeleReleaseBillType: 'Type of telex release bill of lading',
  Cargo_PleaseSelectBranch: 'Please select branch.',
  Cargo_SelectBranch: 'Select Branch',
  Cargo_ApplicationBranch: 'Application Branch',
  Cargo_ApplicationDepartment: 'Application Department',
  Cargo_MoreBusinessConditions: 'More Business Conditions',
  Cargo_MoreConditionsOptions: 'More Conditions Options',
  Cargo_BusinessConditionsOptions: 'Business Conditions Options',
  Cargo_PleaseSelectBusiness: 'Please select business.',
  Cargo_PleaseSelectBusinessDate: 'Please select business date.',
  Cargo_PleaseSelectBusinessOrderRecord: 'Please select business order record.',
  Cargo_PleaseSelectBusinessType: 'Please select business type',
  Cargo_PleaseSelectGuaranteeType: 'Please select guarantee type',
  Cargo_PleaseSelectClosureTime: 'Please select closure time.',
  Cargo_PleaseSelectContentToModify: 'Please select content to modify.',
  Cargo_PleaseSelectCurrency: 'Please select currency.',
  Cargo_PleaseSelectData: 'Please check data.',
  Cargo_PleaseSelectContainerGroup: 'Please select a container group to perform the add operation.',
  Cargo_PleaseSelectTemplate: 'Please select template.',
  Cargo_AutomaticReleaseTips: 'There is a bill of lading in the status of being available for release, and there is no need for special approval of the bill.',
  Cargo_PleaseSelectDataToDelete: 'Please select data to delete.',
  Cargo_PleaseSelectDataToRevoke: 'Please select the data to be invalidated.',
  Cargo_SuredRevokeJob: 'Are you sure to cancel the selected business?',
  Cargo_PleaseSelectDataToExport: 'Please select data to export.',
  Cargo_PleaseSelectDataType: 'Please select data type.',
  Cargo_PleaseSelectDataTypeToCreate: 'Please select data type to create.',
  Cargo_PleaseSelectDate: 'Please select date.',
  Cargo_PleaseSelectExpense: 'Please select expense.',
  Cargo_PleaseSelectExpenseToConfirm: 'Please select expense to confirm.',
  Cargo_PleaseSelectExpenseToSplit: 'Please select expense to split.',
  Cargo_PleaseSelectExpenseToWriteOff: 'Please select expense to write off.',
  Cargo_PleaseSelectFile: 'Please select file.',
  Cargo_OwnFileDelete: 'Insufficient Permissions: Cannot delete files uploaded by other users',
  Cargo_PleaseSelectFileType: 'Please select file type.',
  Cargo_PleaseSelectGroupingCondition: 'Please select grouping condition.',
  Cargo_PleaseSelectGroupingCondition2: 'Please select grouping condition 1.',
  Cargo_PleaseSelectIncludedBizNo: 'Please select included biz no.',
  Cargo_PleaseSelectInvoice: 'Please select invoice.',
  Cargo_PleaseSelectInvoiceNo: 'Please select invoice no.',
  Cargo_PleaseSelectOurBank: 'Please select our bank.',
  Cargo_PleaseSelectPaymentApplication: 'Please select payment application.',
  Cargo_PleaseSelectTheRecord: 'Plesae Select The Record.',
  Cargo_batchChangePaymentSuccess: 'Batch Change Payment Success',
  Cargo_batchChangePaymentFailed: 'Batch Change Payment Failed',
  Cargo_NotEmptyChangePaymentTime: 'The Change Payment Time Should Not Empty',
  Cargo_ApprovedSuccess: 'Approved successfully.',
  Cargo_ApprovedFaild: 'Approval failed.',
  Cargo_Rejected: 'Rejected',
  Cargo_Cancelled: 'Cancelled',
  Cargo_ReturnedSuccess: 'Returned successfully.',
  Cargo_ReturnedFaild: 'Returned failed.',
  Cargo_NoBusinessApproval: 'There is no data requiring business approval.',
  Cargo_NoDeptApproval: 'There is no data requiring department approval.',
  Cargo_NoFinanceApprovalData: 'No data requires financial approval',
  Cargo_NoSupervisorApprovalData: 'No data requires supervisor approval',
  Cargo_PleaseSelectPeriodRange: 'Please select period range.',
  Cargo_PleaseSelectRecord: 'Please select record.',
  Cargo_PleaseSelectRecordToInvoice: 'Please select record to invoice.',
  Cargo_PleaseSelectRecordToReview: 'Please select record to review.',
  Cargo_PleaseSelectRecordToCancelReview: 'Please select record to cancel review.',
  Cargo_PleaseSelectRecordToWriteOff: 'Please select record to write off.',
  Cargo_PleaseSelectReviewDate: 'Please select review date.',
  Cargo_PleaseSelectSameInvoiceType: 'Please select same invoice type.',
  Cargo_PleaseSelectServiceTicket: 'Please select service ticket.',
  Cargo_PleaseSelectSettlingParty: 'Please select settling party.',
  Cargo_AddTag: 'Add tag',
  Cargo_NotFoundNeedSaveCharges: 'There are no expenses to be added in the list.',
  Cargo_SureSaveBilling: 'Are you sure you want to save and generate the bill?',
  Cargo_SureSaveChargeOnly: 'Are you sure you want to save only expenses?',
  Cargo_SureCancelEdit: 'Are you sure you want to cancel editing?',
  Cargo_JobBillingChargeNotEqual: 'Business [{0}]\'s [{1}] [{2}] are inconsistent with the bill. Please remove the inconsistent fees before making any modifications!',
  Cargo_SaveGenerateBills: 'Save And Generate Bills',
  Cargo_GenerateExpensesOnly: 'Generate expenses only',
  Cargo_PleaseSelectSoa: 'Please select SOA.',
  Cargo_PleaseSelectSob: 'Please select SOB.',
  Cargo_PleaseSelectStartTime: 'Please select start time.',
  Cargo_PleaseSelectThePurchaser: 'Please select the purchaser.',
  Cargo_PleaseSelectTypeOfJournalEntries: 'Please select type of journal entries.',
  Cargo_PleaseSelectVatInvoice: 'Please select VAT invoice.',
  Cargo_PleaseSelectVatEiInvoice: 'Please select VAT EiInvoice.',
  Cargo_PleaseSelectVoucher: 'Please select voucher.',
  Cargo_PleaseSelectVoucherGroupingRule: 'Please select voucher grouping rule',
  Cargo_PleaseSelectVoucherToCancel: 'Please select voucher to cancel.',
  Cargo_PleaseSelectVoucherToReview: 'Please select voucher to review.',
  Cargo_PleaseSelectWriteOffDetails: 'Please select write-off details.',
  Cargo_PleaseSelectWriteOffRecord: 'Please select write-off record.',
  Cargo_PleaseSpecifyPaymentPeriodRange: 'Please specify payment period range',
  Cargo_PleaseUseComponent: 'Please use component.',
  Cargo_PlsInput: 'Please enter ',
  Cargo_PLVDCTBE: 'Profit & loss voucher date can\'t be empty.',
  Cargo_PLVDNITP: 'Profit & loss voucher date not in the period.',
  Cargo_PLVFCTBE: 'Profit & loss voucher field can\'t be empty.',
  Cargo_PLVNAPATCTBE: 'Profit & loss voucher not allocated profit account title can\'t be empty.',
  Cargo_PoaCustomsDeclaration: 'POA customs declaration',
  Cargo_PODcode: 'Port code',
  Cargo_FileFromQuotation: 'Files imported from Quote Management cannot be deleted',
  Cargo_FileFromInquiry: 'Files imported from Inquiry Management cannot be deleted',
  Cargo_PodSea: 'POD (sea)',
  Cargo_Unloading: 'Unloading',
  Cargo_ArrivalNotice: 'Arrival Notice',
  Cargo_PickUp: 'Pick Up',
  Cargo_AircraftGISPositioning: 'aircraft GIS positioning',
  Cargo_PointOfPermission: 'Point of Permission',
  Cargo_PointsToNote: 'Points to note?',
  Cargo_Pol: 'POL',
  Cargo_PolAgent: 'POL Agent',
  Cargo_POLCannotBeNull: 'POL can\'t be empty',
  Cargo_PolSea: 'POL (sea)',
  Cargo_Port: 'Port',
  Cargo_PortCodeCanTBeEmpty: 'Port code can\'t be empty',
  Cargo_PortGroup: 'Port group',
  Cargo_PortGroupCanTBeEmpty: 'Port group can\'t be empty',
  Cargo_PortOfDestinationCode: 'Port of Destination Code',
  Cargo_PortOfDischarge: 'POD',
  Cargo_PortOfDischargeCannotBeNull: 'POD can\'t be empty',
  Cargo_PortOfLoading: 'POL',
  Cargo_PortOfLoadingSea: 'POL(Sea)',
  Cargo_PortOfLoadingAir: 'POL(Air)',
  Cargo_PortPrompt: 'Please enter port name',
  Cargo_PortRequirement: 'Port requirement',
  Cargo_PositiveOperation: 'Positive operation',
  Cargo_Post: 'Post',
  Cargo_PotentialStage: 'Potential stage',
  Cargo_PPNCASA: 'Pre-payment not created as short account.',
  Cargo_PRCTBCFWOE: 'Payment request can\'t be created for written-off expense.',
  Cargo_PreCollection: 'Advance Receipt',
  Cargo_PreferredAgentAtDestination: 'Preferred agent at destination',
  Cargo_PreferredAirline: 'Preferred airline',
  Cargo_PreferredAirport: 'Preferred airport',
  Cargo_PreferredAirportAir: 'Preferred airport (air)',
  Cargo_PreferredCustomsBroker: 'Preferred customs broker',
  Cargo_PreferredOceanCarrier: 'Preferred ocean carrier',
  Cargo_PreferredPort: 'Preferred port',
  Cargo_PreferredPortSea: 'Preferred port (sea)',
  Cargo_PreferredShippingMethod: 'Preferred shipping method',
  Cargo_PreferredShippingRoute: 'Preferred shipping route',
  Cargo_PreferredShippingTerms: 'Preferred shipping terms',
  Cargo_PreferredTrucker: 'Preferred trucker',
  Cargo_PreferredTruckingService: 'Preferred trucking service',
  Cargo_PrepaidOrNot: 'Prepayment or not?',
  Cargo_PreparedBy: 'Prepared by',
  Cargo_PreparedByP: 'Prepared by:',
  Cargo_PrepareServiceTicket: 'Prepare Service Ticket',
  Cargo_PrePayment: 'Advance receipt or not?',
  Cargo_PrepaymentRecordedSuccessfully: 'Prepayment recorded successfully.',
  Cargo_PreReviewStatus: 'Pre-review status',
  Cargo_PreReviewAllStatus: 'Pre-review status (review)',
  Cargo_PreSubmission: 'Pre-submit',
  Cargo_PreviewEmailContent: 'Preview Email Content',
  Cargo_Previous: 'Previous',
  Cargo_PrimeCost: 'Cost',
  Cargo_Print: 'Print',
  Cargo_PrintAll: 'Print All',
  Cargo_PrintBill: 'Print Bill',
  Cargo_PrintedSuccessfully: 'Printed successfully.',
  Cargo_PrintInvoice: 'Print Invoice',
  Cargo_PrintList: 'Print List',
  Cargo_PrintOrNot: 'Print or not?',
  Cargo_LACKINVOICE: 'Lack invoice?',
  Cargo_Printout: 'Printout',
  Cargo_PrintPaymentList: 'Print Payment List',
  Cargo_PrintSoa: 'Print SOA',
  Cargo_PrintStatusSaved: 'Print status saved.',
  Cargo_PrintTheProfit: 'Print Profit',
  Cargo_PrintVerification: 'Print Verification',
  Cargo_PrintWithdrawalList: 'Print Withdrawal List',
  Cargo_ProcessedAsShortAccount: 'Processed as short account.',
  Cargo_ProcessedBy: 'Processed by',
  Cargo_ProcessingChangeRemarks: 'Processing change remarks',
  Cargo_ProcessingPleaseWait: 'Processing, please wait.',
  Cargo_ProcessingRemarks: 'Processing remarks',
  Cargo_ProcessingTime: 'Processing time',
  Cargo_ProductName: 'Plan name',
  Cargo_Profit: 'Profit',
  Cargo_ProfitLossAccount: 'Profit & loss account',
  Cargo_ProfitLoss: 'Profit & Loss',
  Cargo_ProfitLoss2: 'Profit & Loss 2',
  Cargo_ProfitLossVoucherNoCanTBeEmpty: 'Profit & loss voucher no. can\'t be empty.',
  Cargo_ProfitLossVoucherNotInThePeriod: 'Profit & loss voucher not in the period.',
  Cargo_Prompt: 'Prompt',
  Cargo_Proof: 'Voucher',
  Cargo_ProofDate: 'Voucher Date',
  Cargo_ProofDateP: 'Voucher Date:',
  Cargo_ProofOrNot: 'Create voucher?',
  Cargo_Property: 'Property',
  Cargo_Province: 'Province',
  Cargo_PRSCSCRICP: 'Please revoke shipping company\'s collection record in collection page.',
  Cargo_PSALOAPAARE: 'Please select at least one A/P and A/R expense.',
  Cargo_PSALOER: 'Please select at least one expense record.',
  Cargo_PSALOGODC: 'Please select at least one group of date condition.',
  Cargo_PSALOGODC2: 'Please select at least one filter condition.',
  Cargo_SelectLockOrderCondition: 'Select Lock Order Conditions',
  Cargo_PSBOTSSP: 'Please select bill of the same settling party.',
  Cargo_PSCI: 'Please select collection information.',
  Cargo_PSDTOVG: 'Please select data type of voucher grouping.',
  Cargo_PSEDTRWO: 'Please select expense details to revoke write-off.',
  Cargo_PSFDD: 'Pagination search for declaration document',
  Cargo_PSFPOTSY: 'Please select fiscal period of the same year.',
  Cargo_PleaseSelectVoucherRange: 'Please select voucher range',
  Cargo_PSGROJE: 'Please select grouping rule of journal entries',
  Cargo_PSOR: 'Please select operation requirements',
  Cargo_PSPAF: 'Please select payment application form.',
  Cargo_PSPATD: 'Please select payment application to delete.',
  Cargo_PSPATW: 'Please select payment application to withdraw.',
  Cargo_PSPATR: 'Please select payment application to return.',
  Cargo_PSPATS: 'Please select payment application to submit.',
  Cargo_PSROACP: 'Please select record of actual collection/payment.',
  Cargo_PSRTCPA: 'Please select record to create payment application.',
  Cargo_PSRTCV: 'Please select record to create voucher.',
  Cargo_PSSDOCD: 'Please select start date or closure date.',
  Cargo_PSUSPAF: 'Please select un-submitted payment application form.',
  Cargo_PSSPAF: 'Only unapproved payment requisitions can be withdrawn',
  Cargo_PSVOFS: 'Please select version of financial software.',
  Cargo_CurrencyMismatch: 'The currency of {0} does not match the bank account number, please modify the cancellation',
  Cargo_PublicClientHub: 'Public client hub',
  Cargo_Publish: 'Publish',
  Cargo_PublishStatus: 'Publish Status',
  Cargo_PurchasedBy: 'Purchased by',
  Cargo_PurchaseRecord: 'Purchase Record',
  Cargo_PurchaseRegisteredSuccessfully: 'Purchase registered successfully.',
  Cargo_PurchaseRegistration: 'Purchase Registration',
  Cargo_PurchasingParty: 'Purchasing Party',
  Cargo_PurchasingUnit: 'Purchasing Unit',
  Cargo_PUSBAANMRIDSS: 'Purchasing unit\'s bank and account not matched record in database, still save?',
  Cargo_PutARItemsOnTop: 'Put A/R items on top',
  Cargo_PYPALAA: 'Previous Yearly Profit and Loss Adjustment Account',
  Cargo_PYPALAAP: 'Previous Yearly Profit and Loss Adjustment Account:',
  Cargo_Query: 'Search',
  Cargo_QueryFailed: 'Search failed.',
  Cargo_QueryInvoice: 'Invoice Search',
  Cargo_QuickSearch: 'Quick Search',
  Cargo_QuotaCurrency: 'Currency for Amount',
  Cargo_QuotaRange: 'Quota range',
  Cargo_RAIAV: 'Reconciliation Amount in Absolute Value',
  Cargo_Railway: 'Railway',
  Cargo_RailwayExport: 'Railway Export',
  Cargo_RailwayImport: 'Railway Import',
  Cargo_RailwayBusiness: 'Railway Business',
  Cargo_IntegratedJob: 'Integrated Job',
  Cargo_FbaOrder: 'Fba Order',
  Cargo_FbaSea: 'FBA Ocean',
  Cargo_FbaAir: 'FBA Air',
  Cargo_FbaRailway: 'FBA Railway',
  Cargo_RailwayRoute: 'Railway route',
  Cargo_RCAFTPOY: 'Reverse close account for the {0} period of year {1}.',
  Cargo_RCBDIDL: 'Refresh Current Branch Data in Drop List',
  Cargo_RealPaid: 'Out-of-pocket',
  Cargo_RealPaidP: 'Out-of-pocket:',
  Cargo_ReasonNotEntered: 'Reason not entered',
  Cargo_ReasonOfCargoDetention: 'Reason of Holding',
  Cargo_ReasonOfCargoDetentionP: 'Reason of Holding:',
  Cargo_ReCalculateBillingAmount: 'Re-calculate Billing Amount',
  Cargo_Receipt: 'Collect',
  Cargo_ReceiptAmount: 'Amount Received',
  Cargo_Receivable: 'A/R',
  Cargo_ReceivableToCNY: 'Equivalent to CNY accounts receivable：',
  Cargo_ReceivableB: '(A/R)',
  Cargo_ReceivedCNY: 'Received CNY',
  Cargo_PayPaidCNY: 'Pay Paid CNY',
  Cargo_ReceivedUSD: 'Received USD',
  Cargo_ReceivedEUR: 'Received EUR',
  Cargo_ReceivedGBP: 'Received GBP',
  Cargo_ReceivedHKD: 'Received HKD',
  Cargo_ReceivedJPY: 'Received JPY',
  Cargo_ReceivedNGN: 'Received NGN',
  Cargo_PayPaidUSD: 'Pay Paid USD',
  Cargo_PayPaidEUR: 'Pay Paid EUR',
  Cargo_PayPaidGBP: 'Pay Paid GBP',
  Cargo_PayPaidHKD: 'Pay Paid HKD',
  Cargo_PayPaidJPY: 'Pay Paid JPY',
  Cargo_PayPaidNGN: 'Pay Paid NGN',
  Cargo_OtherConversionReceivedUSD: 'Other Conversion Received USD',
  Cargo_OtherConversionReceivedEUR: 'Other Conversion Received EUR',
  Cargo_OtherConversionReceivedGBP: 'Other Conversion Received GBP',
  Cargo_OtherConversionReceivedHKD: 'Other Conversion Received HKD',
  Cargo_OtherConversionReceivedJPY: 'Other Conversion Received JPY',
  Cargo_OtherConversionReceivedNGN: 'Other Conversion Received NGN',
  Cargo_OtherConversionPayPaidUSD: 'Other Conversion Pay Paid USD',
  Cargo_OtherConversionPayPaidEUR: 'Other Conversion Pay Paid EUR',
  Cargo_OtherConversionPayPaidGBP: 'Other Conversion Pay Paid GBP',
  Cargo_OtherConversionPayPaidHKD: 'Other Conversion Pay Paid HKD',
  Cargo_OtherConversionPayPaidJPY: 'Other Conversion Pay Paid JPY',
  Cargo_OtherConversionPayPaidNGN: 'Other Conversion Pay Paid NGN',
  Cargo_OtherConversionReceivedCNY: 'Other Conversion Received CNY',
  Cargo_OtherConversionPayPaidCNY: 'Other Conversion Pay Paid CNY',
  Cargo_ReceivableCNY: 'CNY A/R',
  Cargo_ReceivableEUR: 'A/R(EUR)',
  Cargo_ReceivableGBP: 'A/R(GBP)',
  Cargo_ReceivableHKD: 'HKD A/R',
  Cargo_ReceivableJPY: 'JPY A/R',
  Cargo_ReceivableNGN: 'NGN A/R',
  Cargo_ReceivableP: 'A/R:',
  Cargo_ReceivablesInvoicingDate: 'A/R Invoice Date',
  Cargo_ReceivablesInvoicingStatus: 'A/R Invoice Status',
  Cargo_ReceivablesWriteOfStatus: 'A/R write-off status',
  Cargo_ReceivableUSD: 'USD A/R',
  Cargo_Receive: 'Receive',
  Cargo_RevocationOfReceipt: 'Revocation of receipt',
  Cargo_Received: 'Received',
  Cargo_ReceivedDate: 'Date of Collection',
  Cargo_ReceiveMethod: 'Collection Method',
  Cargo_Receiver: 'Retrieved by',
  Cargo_Receiver2: 'Recipient',
  Cargo_ReceiverCompanyName: 'Recipient\'s Company',
  Cargo_ReceivingBank: 'Receiving Bank',
  Cargo_ReceivingBankAccount: 'Receiving Bank Account',
  Cargo_ReceivingDate: 'Retrieval Date',
  Cargo_Recheck: 'Re-check',
  Cargo_RecheckDate: 'Re-check Date',
  Cargo_ReCheckedSuccessfully: 'Re-checked successfully.',
  Cargo_ReCheckedFailed: 'Re-checked failed.',
  Cargo_CancelReCheckedSuccessfully: 'Cancel Re-checked successfully.',
  Cargo_RecheckOrNot: 'Check or not',
  Cargo_RecheckP: 'Re-check:',
  Cargo_ReCheckPermission: 'Re-check Permission',
  Cargo_RecipientOfWithdrawal: 'Recipient of Withdrawal',
  Cargo_RecipientSCompanyOfWithdrawal: 'Recipient\'s Company of Withdrawal',
  Cargo_ReconcileOrNot: 'Reconcile or not?',
  Cargo_Reconciliation: 'Reconciliation',
  Cargo_ReconciliationAmount: 'Reconciliation Amount',
  Cargo_ReconciliationConfirmation: 'Reconciliation Confirmation',
  Cargo_ReconciliationDate: 'Reconciliation Date',
  Cargo_ReconciliationOfAR: 'Reconciliation of A/R',
  Cargo_ReconciliationStatus: 'Reconciliation Status',
  Cargo_ReconciliationStatusControl: 'Reconciliation Status Control',
  Cargo_ReconciliationType: 'Reconciliation Type',
  Cargo_SendEmailByReconciliationDiff: 'Did send an email notification when saving that the reconciliation amount is inconsistent',
  Cargo_ReconciliationDiffConfirm: 'Reconciliation discrepancy handling',
  Cargo_ReconciliationDiffReason: 'Reasons for differences',
  Cargo_ReconciliationDiffConfirmTip: 'Did you send an email notification when saving that the reconciliation amount is inconsistent',
  Cargo_Record: 'Record',
  Cargo_RecordCount: 'Number of record',
  Cargo_Recorder: 'Recorder',
  Cargo_RecordLabel: 'Record Label',
  Cargo_RecordNoOfPaidIn: 'Record No. of Paid-in',
  Cargo_RecordOrNot: 'Record or not?',
  Cargo_RecordOutOfPocket: 'Record Out-of-pocket',
  Cargo_RecordPrepayment: 'Record Prepayment',
  Cargo_RecordsFound: '{0} records found.',
  Cargo_RecordsWithEmptyInvoiceTypeExist: 'Records with empty invoice type exist.',
  Cargo_RecordTime: 'Record time',
  Cargo_RedChargesOrNot: 'Write back or not?',
  Cargo_ReDeliveryOrNot: 'Re-delivery or not?',
  Cargo_ReferralFromExistingClient: 'Referral from existing client',
  Cargo_Reflush: 'Update',
  Cargo_RefNbr: 'Customs Declaration No.',
  Cargo_Refresh: 'Refresh',
  Cargo_RefreshCompleteStatus: 'Update completed.',
  Cargo_RefreshSearch: 'Refresh Search',
  Cargo_RefundAdvanceReceipt: 'Refund Advance Receipt',
  Cargo_RefundOfLclBusiness: 'Refund of LCL business?',
  Cargo_Refuse: 'Deny',
  Cargo_Region: 'Area',
  Cargo_RegisteredCapital: 'Registered capital',
  Cargo_RegisteredCapitalIn10Thousand: 'Registered capital/in 10 thousand',
  Cargo_RegistrationNumber: 'Taxpayer Identification Number',
  Cargo_RegistrationNumberP: 'Taxpayer Identification Number:',
  Cargo_ReIssuedInvoiceNo: 'Re-issued Invoice no.',
  Cargo_ReIssuedInvoiceNoP: 'Re-issued Invoice no.:',
  Cargo_ReIssueInvoice: 'Re-issue Invoice',
  Cargo_ReIssueVoidedInvoice: 'Re-issue Voided Invoice',
  Cargo_RelatedBLNo: 'Link to B/L No.',
  Cargo_Release: 'Release',
  Cargo_ReleaseHbl: 'Release HBL',
  Cargo_Releasing: 'B/L Release',
  Cargo_ReleasingStatus: 'B/L Release Status',
  Cargo_RemainingAmount: 'Remaining Amount',
  Cargo_RemainingPledgedAmount: 'Remaining Pledged Amount',
  Cargo_Remarks: 'Remarks',
  Cargo_SupervisorComments: 'Supervisor Comments',
  Cargo_RemarksCannotBeEmptyWhenWipeOut: 'Remarks cannot be empty when wipe out.',
  Cargo_RemarksOnAROrAPItems: 'Remarks on A/R or A/P items',
  Cargo_RemarksOnPayment: 'Remarks on Payment',
  Cargo_RemarksP: 'Remarks:',
  Cargo_ArOriginalCurrency: 'A / R (original currency)',
  Cargo_ApOriginalCurrency: 'A / P (original currency)',
  Cargo_RemarkTheLengthCannotExceedP: 'No exceeding length of remarks.',
  Cargo_RemarkTheLengthCannotExceedP256: 'No exceeding length of remarks.',
  Cargo_RemittanceFee: 'Remittance Fee',
  Cargo_Remove: 'Remove',
  Cargo_RemoveConfig: 'Remove Config',
  Cargo_AddConfig: 'Add Config',
  Cargo_RemoveBillCharge: 'Remove Expense',
  Cargo_RemoveDetails: 'Remove Details',
  Cargo_RemoveExpenseRemoveAll: 'Remove Expense / Remove All',
  Cargo_RemoveParameterFunction: 'Remove Parameter Function',
  Cargo_RemovePartial: 'Remove Partial',
  Cargo_OrderType: 'Order type',
  Cargo_TruckTrailer: 'Container trucking',
  Cargo_WholeVehicleAndLessThanCarload: 'Domestic FTL / LTL',
  Cargo_RemovePermissionToSubmitExpense: 'Remove Permission to Submit Expense',
  Cargo_RemoveSelectedData: 'Remove Selected Data',
  Cargo_RemoveSelectedExpense: 'Remove Selected Expense',
  Cargo_RenderStyle: 'Render Style',
  Cargo_Renew: 'Renewal',
  Cargo_RenewContract: 'Renew contract',
  Cargo_ReOpen: 'Re-open',
  Cargo_ReOpenedSuccessfully: 'Re-opened successfully.',
  Cargo_RepeatedMaintenance: 'Repeated Maintenance',
  Cargo_ReplaceBill: 'Replace bill',
  Cargo_ReportTo: 'Report to',
  Cargo_Reset: 'Reset',
  Cargo_ResetFilter: 'Reset Condition',
  Cargo_Restore: 'Restore',
  Cargo_RestoreSelectedClient: 'Restore selected client?',
  Cargo_RetreatASingle: 'Withdrawal List',
  Cargo_RetrievalFailureReturnFunction: 'Retrieval Failure Return Function',
  Cargo_RetrievalFunction: 'Retrieval Function',
  Cargo_RetrievalType: 'Retrieval Type',
  Cargo_RetrievalTypeP: 'Retrieval Type:',
  Cargo_Retrieved: 'Retrieved',
  Cargo_RetrievedButNotReturned: 'Retrieved but not returned.',
  Cargo_RetrieveMark: 'Retrieve mark',
  Cargo_Return: 'Return',
  Cargo_ReturnDate: 'Return Date',
  Cargo_Returned: 'Returned',
  Cargo_ReturnedSuccessfully: 'Returned successfully.',
  Cargo_ReturnExpressNumber: 'Courier No. of Return',
  Cargo_ReturnOrderExpressNumber: 'Courier No. of Withdrawal',
  Cargo_ReturnQuery: 'Back to Search',
  Cargo_ReturnToSearch: 'Return to search?',
  Cargo_Revenue: 'Revenue',
  Cargo_RevenueAndExpenditureType: 'Category of Income & Expenditure',
  Cargo_RevenueOrExpenditure: 'Income & Expenditure',
  Cargo_Reverse: 'Reverse',
  Cargo_ReversedCloseAccountSuccessfully: 'Reversed close account successfully.',
  Cargo_CloseAccountSuccessfully: 'Close account successfully.',
  Cargo_ReverseReview: 'Reverse Review',
  Cargo_ReverseReviewedSuccessfully: 'Reverse reviewed successfully.',
  Cargo_ReviewCancelledSuccessfully: 'Cancellation of review successful.',
  Cargo_ReviewedOrNot: 'Reviewed or not?',
  Cargo_ReviewOverallSearch: 'Review Overall Search',
  Cargo_ReviewTime: 'Review Time',
  Cargo_ReviewVoucher: 'Review Voucher',
  Cargo_Revoke: 'Revoke',
  Cargo_RevokeClaim: 'Revoke Claim',
  Cargo_RevokedSuccessfully: 'Revoked successfully.',
  Cargo_RevokeInvoicingApplication: 'Revoke Invoicing Application',
  Cargo_RevokeOrNot: 'Revoke or not?',
  Cargo_PushFailByCBMS: 'Push failed, please contact the staff for troubleshooting',
  Cargo_PushSuccessByCBMS: 'Push business succeeded',
  Cargo_RevokeReview: 'Revoke Review',
  Cargo_RevokeSelection: 'Revoke Selection',
  Cargo_RevokeWithdrawal: 'Revoke Withdrawal',
  Cargo_RevokeWithdrawalList: 'Revoke Withdrawal List',
  Cargo_RevokingRetrievalFailed: 'Revoking retrieval failed.',
  Cargo_RFPNMIS: 'Related financial period not maintained in SOB.',
  Cargo_RITSS: 'Record imported to system successfully.',
  Cargo_RTGTEOMCACC: 'Repeat the "Golden Tax Export" operation may cause additional costs. Continue?',
  Cargo_RTIAFRODI: 'Return to invoicing application for review, otherwise delete invoice.',
  Cargo_RTPIRS: 'Reset to pending invoice review status.',
  Cargo_Rule: 'Rule',
  Cargo_SABID: 'Skip adding basic information directly?',
  Cargo_SADNSUICAT: 'Subsidiary accounting data not set up in current account title.',
  Cargo_SailingDate: 'Sailing date',
  Cargo_SailingDay: 'Sailing Date',
  Cargo_ETD: 'ETD',
  Cargo_ETA: 'ETA',
  Cargo_ATD: 'ATD',
  Cargo_ATA: 'ATA',
  Cargo_LookDetail: 'View details',
  Cargo_Sales: 'Sales',
  Cargo_SalesP: 'Sales:',
  Cargo_SalesBranchCompany: 'Sales Branch',
  Cargo_SalesCommission: 'Sales commission',
  Cargo_SalesCompany: 'Sales company',
  Cargo_SalesDepartment: 'Sales Dept.',
  Cargo_SalesFreeHand: 'Sales free-hand',
  Cargo_Salesman: 'Sales Person',
  Cargo_SalesmanP: 'Sales Person:',
  Cargo_SalesParty: 'Sales Party',
  Cargo_SalesPerson: 'Sales Person',
  Cargo_SALOGROEI: 'Select at least one grouping requirements or enter indexes.',
  Cargo_SameYear: 'Same Year',
  Cargo_SAPPMBI: 'Selected actual payment parties must be identical.',
  Cargo_Save: 'Save',
  Cargo_SaveAll: 'Save All',
  Cargo_SaveAndAdd: 'Save & New',
  Cargo_SaveAndCalculateTotalAmount: 'Save & Calculate Total Amount',
  Cargo_SaveBill: 'Save Bill',
  Cargo_SaveCurrentSelection: 'Save Current Selection',
  Cargo_CurrentSelection: 'Current Selection',
  Cargo_Saved: 'Saved.',
  Cargo_SaveEditing: 'Save Editing',
  Cargo_SaveEntity: 'Save Entity',
  Cargo_SaveExchangeRateToCache: 'Save exchange rate to cache',
  Cargo_SaveFailed: 'Save failed.',
  Cargo_SaveGroupInfo: 'Save Group Info',
  Cargo_SaveInvoice: 'Save Invoice',
  Cargo_SaveInvoiceNo: 'Save Invoice No',
  Cargo_SaveOrNot: 'Save or not?',
  Cargo_SaveQueryP: 'Save',
  Cargo_SaveReconciliation: 'Save Reconciliation',
  Cargo_SaveSucceed: 'Saved successfully.',
  Cargo_Saving: 'Saving',
  Cargo_SBRASPATFRD: 'Skip business review and submit Payment Application to financial review directly.',
  Cargo_SBSPISB: 'Summarized by settlement party in same branch.',
  Cargo_ScaleOfCompany: 'Scale of company',
  Cargo_ScaleOfCompanyEmployees: 'Scale of company/employees',
  Cargo_SCNEIPMSL: 'Similar client name exists in \'Partner\' module, still link?',
  Cargo_SCOCCSC: 'Sales Commission / Operation Commission / Customer Service Commission',
  Cargo_SDNCCNTFL: 'SOA data not complete, click next to finish loading.',
  Cargo_SDNMBR: 'Status does not meet billing requirements.',
  Cargo_SDNMWOR: 'Status does not meet write-off requirements.',
  Cargo_SeaportOfDischarge: 'POD',
  Cargo_Search: 'Search',
  Cargo_SearchAlreadyExisted: 'Search already existed.',
  Cargo_SearchAPWriteOffs: 'Search A/P Write-offs',
  Cargo_SearchARWriteOff: 'Search A/R Write-off',
  Cargo_SearchCompleted: 'Search completed.',
  Cargo_SearchConditions: 'Search Conditions',
  Cargo_SearchCreated: 'Search Created',
  Cargo_SearchDisplayColumn: 'Search Display Column',
  Cargo_SearchError: 'Search error.',
  Cargo_SearchForBill: 'Search for Bill',
  Cargo_SearchForBusinessDeptApproved: 'Search for Business & Dept. Approved',
  Cargo_SearchForBusinessOfSameGroup: 'Search for Business of Same Group',
  Cargo_SearchForData: 'Search for data',
  Cargo_SearchForDataAsPerPermission: 'Search for data as per permission?',
  Cargo_SearchForExpenses: 'Search for Expenses',
  Cargo_SearchForMore: 'Search for more?',
  Cargo_SearchForOverseasExpense: 'Search for overseas expense?',
  Cargo_SearchForParameterTemplateList: 'Search for Parameter Template List',
  Cargo_SearchInformation: 'Search Information',
  Cargo_SearchMark: 'Search Mark',
  Cargo_SearchOperation: 'Search Operation',
  Cargo_SecondNotifyParty: '2nd notify party',
  Cargo_SecondVoyage: 'Voyage',
  Cargo_SecureBusiness: 'Secure business',
  Cargo_SEFInput: 'Enter Declaration Document',
  Cargo_Select: 'Select',
  Cargo_SelectAddPlatfoCNYLMethod: 'Select & add platform B/L method',
  Cargo_SelectAddPlatformContainerType: 'Select & add platform container type',
  Cargo_SelectAddPlatformCurrency: 'Select & add platform currency',
  Cargo_ShippingAddress: 'Shipping address',
  Cargo_AddModel: 'add model',
  Cargo_maintenance: 'Cargo Maintenance',
  cargo_container_type: 'Cargo Type',
  cargo_container_code: 'Cargo Code',
  cargo_container_number: 'Cargo Number',
  cargo_pallet: 'Pallet',
  cargo_container_max_weight: 'Cargo Max Weight (KG)',
  cargo_container_max_capacity: 'Cargo Max Capacity (m³)',
  cargo_loading_rate: 'Loading Rate',
  Cargo_Container_Type_Not_Configured: 'You have not maintained the container, you can go to [Basic Data-Container] to maintain the corresponding data.',
  cargo_please_enter_the_container: 'Please enter the cargo',
  cargo_please_enter_the_cost: 'Please enter the cost',
  Cargo_please_enter_flight_costs: 'Charter Flight/Charter Boarding Request, please enter flight costs.',
  Cargo_Please_enter_charter_details_or_flight_costs: 'Charter flight request, please enter charter details or flight costs.',
  cargo_please_enter_the_container_code: 'Please enter the cargo code',
  cargo_Please_select_a_container: 'Please select a container.',
  cargo_Charter_package_board_statistics: 'Charter package board statistics',
  Cargo_not_allowed_reconfiguration: 'In normal operation mode, reconfiguration of other services is not allowed.',
  Cargo_cross_flight_tips: 'cross flight will be associated with a new container and delete all container information associated with the original business',
  Cargo_CheckUldWeightOrCubage: 'Container code: {0}Cargo {1} exceeds the loadable cargo {2}, please confirm whether to save?',
  Cargo_master_reconfiguration_tips: 'After reconfiguration, all sub-tickets under the main ticket will be associated with the same hub. Do you want to proceed?',
  cargo_can_only_be_dragged_under_a_container: 'Can only be dragged under a cargo',
  cargo_requires_dragging_across_containers: 'Requires dragging across cargos',
  cargo_no_flight_information: 'No flights available for the current business and target location, no action required',
  cargo_unloaded_container_business: 'Unloaded cargo business',
  Cargo_SelectAddPlatformPackages: 'Select & add platform packages',
  Cargo_SelectAddPlatformShippingTerms: 'Select & add platform shipping terms',
  Cargo_SelectAddPlatformTradeMethod: 'Select & add platform trade method',
  Cargo_SelectAddPlatformTradeTerms: 'Select & add platform trade terms',
  Cargo_SelectAll: 'Select All',
  Cargo_SelectBusinessDateRange: 'Select Business Date Range',
  Cargo_SelectCopyContent: 'Select & copy content',
  Cargo_SelectCurrency: 'Select Currency',
  Cargo_Selected: 'Selected',
  Cargo_SelectedByDefault: 'Selected by Default',
  Cargo_SelectedData: 'Selected Data',
  Cargo_SelectedEntity: 'Selected Entity',
  Cargo_SelectedExpenseConfirmedExpense: 'Selected Expense / Confirmed Expense',
  Cargo_SelectedInvoice: 'Selected Invoice',
  Cargo_SelectedItems: 'Selected {0}',
  Cargo_SelectedP: 'Selected:',
  Cargo_SelectedVoucher: 'Selected voucher',
  Cargo_SelectedVoucherCantOver100: 'Selected {0} vouchers, can\'t over 100 items.',
  Cargo_SelectEventStatus: 'Select event status',
  Cargo_SelectEventToApprove: 'Select event to approve',
  Cargo_SelectFilesToDownload: 'Select files to download',
  Cargo_SelectInvoiceNo: 'Select Invoice No.',
  Cargo_SelectNewInvoiceNo: 'Select New Invoice No.',
  Cargo_SelectOrAddInvoiceNo: 'Select or Add Invoice No.',
  Cargo_SelectPaperInvoiceByDefault: 'Select Paper Invoice by Default',
  CargoMsg_Information_Supplement: 'Information Supplement',
  Cargo_SelectRecordsToExport: 'Select records to export',
  Cargo_SelectSalesPerson: 'Select sales person',
  Cargo_SelectSalesPersonDep: 'Please select a sales department',
  Cargo_SelectCsr: 'Please select customer service',
  Cargo_SelectCsrDep: 'Please select a customer service department',
  Cargo_SelectDoc: 'Please select a document',
  Cargo_SelectDocDep: 'Please select the document department',
  Cargo_SoldSlots: 'Sold slots',
  Cargo_RemainingSlots: 'Remaining slots',
  Cargo_SoldVolume: 'Sold volume',
  Cargo_RemainingVolume: 'Remaining volume',
  Cargo_FlightDateError: 'The flight date is not within the effective period of the route product, or the flight number corresponding to the flight date is not in the schedule maintained by the route product. Do you want to continue?',
  Cargo_SelectOverseaOp: 'Please choose overseas customer service',
  Cargo_SelectOverseaOpDep: 'Please select an overseas customer service department',
  Cargo_SelectCargoSales: 'Please choose sales of goods',
  Cargo_SelectPlanner: 'Please select the person in charge of the route',
  Cargo_SelectPlannerDep: 'Please select the department in charge of the route',
  Cargo_invalidBatchModifyBusiness: 'No business with the same operating branch and sales branch was found, please re-select and try again',
  Cargo_SelectSob: 'Select SOB',
  Cargo_SelectSubject: 'Select subject',
  Cargo_SelectToCopyInFutureDoNotAsk: 'Select to copy in future, do not ask.',
  Cargo_SelectVoucherDate: 'Select Voucher Date',
  Cargo_SelfDeclaration: 'Self-declaration',
  Cargo_SelfDeclareToCustoms: 'Self-declare to customs?',
  Cargo_SelfDelivery: 'Self-delivery',
  Cargo_SpecialApprovalIssuance: 'Special Approval Issuance',
  Cargo_CurrentAvailableQuantity: 'Current Available Quantity',
  Cargo_OccupiedBusinessNumber: 'Occupied Business Number',
  Cargo_BlacklistedWithRemainingAllocation: 'The current partner has been blacklisted, but still has a special approval allocation quota, and the remaining available quota is {0}.',
  Cargo_SpecialApprovalCreateBusiness: 'When the settlement object exceeds credit control and is configured with [Non-Saveable], special approval can be used to create business during the issuance process.',
  Cargo_CopyResult: 'Successfully copied {0} items, failed to copy {1} items',
  Cargo_SellingPrice: 'Sell Rate',
  Cargo_SellTitle: 'Sales Unit',
  Cargo_Send2: 'Delivered',
  Cargo_SendAll: 'Send All',
  Cargo_SendAllP: 'Send all?',
  Cargo_SendBack: 'Return',
  Cargo_SendConfirmationStatus: 'Send Confirmation Status',
  Cargo_SendFailed: 'Send failed.',
  Cargo_SendingDate: 'Delivery Date',
  Cargo_SendMessage: 'Send Message',
  Cargo_SendPartial: 'Send Partial',
  Cargo_SendToBranchCompany: 'Send Branch Information',
  Cargo_Sent: 'Sent',
  Cargo_SentDate: 'Sent date',
  Cargo_SeparateNumber: 'HBL No.',
  Cargo_September: 'September',
  Cargo_SequenceNumber: 'Serial number',
  Cargo_UNNumber: 'UN number',
  Cargo_ChargeUnit: ' charge unit',
  Cargo_DangerousGoods: ' Dangerous goods',
  Cargo_IndicatesRequired: ' *No. indicates required',
  Cargo_NewTo: 'New ',
  Cargo_EditTo: 'Edit ',
  Cargo_AccountingPeriodRange: 'Please specify the accounting period range.',
  Cargo_SerialNoOfBankReceipt: 'Serial no. of Bank Receipt',
  Cargo_AutoUpdateNote: 'Should the remarks be updated automatically?',
  Cargo_ConfirmBeforeEnable: 'Please confirm with the technical team before enabling. Do not enable it casually.',
  Cargo_MultiHeaderBankMode: 'Multi-header bank mode',
  Cargo_ServiceCodeCannotBeNull: 'Service code can\'t be empty',
  Cargo_ServiceItems: 'Service items',
  Cargo_ServiceName: 'Service name',
  Cargo_AutoGenerateFeeName: 'Auto-generate Fee Name',
  Cargo_AutoGenerateTaxRate: 'Auto-generate Tax Rate',
  Cargo_TaxNameRateConsistency: 'Tax/Fee Name and Tax Rate must both be provided or both be left empty.',
  Cargo_AutoGenerateOrDefaultTaxExclusive: 'Auto-generate Tax Rate and Default Tax Rate cannot be both enabled; only one can be active.',
  Cargo_ServiceNameCanTBeEmpty: 'Service name can\'t be empty',
  Cargo_ServiceRequestAddressForEInvoice: 'Service Request Address for E-invoice',
  Cargo_ServiceTicket: 'Service Ticket',
  Cargo_ServiceTicketState: 'Service Ticket State',
  Cargo_ServiceTicketCreatedOrNot: 'Service ticket created or not?',
  Cargo_ServiceTicketIssued: 'Service ticket issued.',
  Cargo_SetAging: 'Set Aging',
  Cargo_SetDefault: 'Set Default',
  Cargo_SetDefaultItemDescription: 'Set Default Item Description',
  Cargo_SetDefaultItemName: 'Set default item name?',
  Cargo_SetFocusToFileNoTextTable: 'Set Focus to File No. Text Table',
  Cargo_SetName: 'Set name',
  Cargo_SetsOfBooks: 'Sets of Books',
  Cargo_SetsOfBooksP: 'Sets of Books:',
  Cargo_SetText: 'Set Text',
  Cargo_SettleAccountsTo: 'Settling Party',
  Cargo_SettleByMonthly: 'Settle by monthly',
  Cargo_SettleByWeekly: 'Settle by weekly',
  Cargo_SettlementAgent: 'Settling Agent',
  Cargo_SettlementByBill: 'Payment by invoice',
  Cargo_SettlementCompany: 'Settling Company',
  Cargo_SettlementMethod: 'Settlement Method',
  Cargo_SettlementMethodP: 'Settlement Method:',
  Cargo_SettlementNotByBill: 'Payment without invoice',
  Cargo_SettlementNotice: 'Settlement Notice',
  Cargo_SettlementPartyDoesNotExist: 'Settlement party does not exist.',
  Cargo_SettlementStatus: 'Settlement Status',
  Cargo_SettlementType: 'Settlement Type',
  Cargo_DoNotSpecify: 'Do not specify',
  Cargo_DomesticAndForeign: 'Domestic/foreign',
  Cargo_CurrencyRequirements: 'Currency requirements',
  Cargo_NotSpecified: 'Not Specified',
  Cargo_Appoint: 'Appoint',
  Cargo_PaymentInOriginalCurrency: 'Payment in original currency',
  Cargo_SettlingAgentInconsistent: 'Settling agent inconsistent.',
  Cargo_SettlingCompanyMustBeIdentical: 'Settling company must be identical.',
  Cargo_SettlingCompanySAbbreviation: 'Settling Company\'s Abbreviation',
  Cargo_SettlingCompanySCode: 'Settling Company\'s Code',
  Cargo_SettlingPartyCanTBeEmpty: 'Settling party can\'t be empty.',
  Cargo_SettlingPartyIncompatible: 'Settling party incompatible.',
  Cargo_SettlingPartyInconsistent: 'Settling party inconsistent.',
  Cargo_SettlingPartyOrSettlementAgentInconsistent: 'The settlement object or settlement agent is inconsistent',
  Cargo_SettlingPartyIsMandatory: 'Settling party is mandatory.',
  Cargo_SettlingPartyMustBeConsistent: 'Settling party must be consistent.',
  Cargo_ProjectNumberNotNull: 'Business order No. cannot be blank',
  Cargo_SettlingPartyOfPayables: 'Settling Party of Payables',
  Cargo_SetToCurrentSob: 'Set to Current SOB',
  Cargo_SetUpDefaultsInBatch: 'Set up defaults in batch',
  Cargo_SetUpServiceTypesInBatch: 'Set up service types in batch',
  Cargo_SFEDOCSP: 'Search for Expense Details of Current Settling Party',
  Cargo_CollectFeeType: 'Charge type',
  Cargo_Shipper: 'Shipper',
  Cargo_ShipperId: 'Shipper\'s code',
  Cargo_ShipperInfo: 'Shipper\'s information',
  Cargo_ShipperSName: 'Shipper\'s name',
  Cargo_ShippingCompanyContractNo: 'Service contract no.',
  Cargo_ShippingCompanySAbbreviation: 'Shipping Company\'s Abbreviation',
  Cargo_ShippingCompanySCode: 'Shipping Company\'s Code',
  Cargo_ShippingInformation: 'Shipping information',
  Cargo_ShippingRouteArea: 'Shipping route/area',
  Cargo_ShortAccountIs: 'Short Account is',
  Cargo_ShowDetailedTitles: 'Show detailed titles',
  Cargo_ShowAdjustRateEntry: 'Include adjust rate entry',
  Cargo_ShowDetails: 'Show details',
  Cargo_ShowedByVessel: 'Showed by vessel',
  Cargo_ShowFromTo2: 'To',
  Cargo_ShowInvoiceDetails: 'Show invoice details',
  Cargo_ShowOpeningBalance: 'Show Opening Balance',
  Cargo_ShowRows: 'Number of displays',
  Cargo_ShowStatementInformation: 'Show statement information',
  Cargo_ShutOut: 'Shut out',
  Cargo_SIATEPIISOTT: 'Space is allocated to each person in initial segment of the template.',
  Cargo_SignContract: 'Sign contract',
  Cargo_SingleBillPrinting: 'Single-bill Printing',
  Cargo_SITCINCOSDHBFLBS: '{0} SOA in total, current is no. {1} (Confirm other SOA data has been fully loaded before save)',
  Cargo_SiteVisit: 'Site visit',
  Cargo_Size: 'Dimensions',
  Cargo_SkipPreviousStep: 'Skip previous step?',
  Cargo_SLNECTS: 'Scarlet letter not entered, continue to save?',
  Cargo_SoaConfirmed: '{0}\'s SOA confirmed.',
  Cargo_SoaCreated: 'SOA created.',
  Cargo_SoaCreatedM: 'SOA [{0}] created.',
  Cargo_SoaCreatedAlready: 'SOA created already.',
  Cargo_SoaNoAlreadyCreated: 'SOA no. already created.',
  Cargo_SobCode: 'SOB Code',
  Cargo_SobCodeAlreadyExists: 'SOB code already exists.',
  Cargo_SobDataLoadingFailed: 'SOB data loading failed.',
  Cargo_SobList: 'SOB List',
  Cargo_SobName: 'SOB Name',
  Cargo_SobNameP: 'SOB Name:',
  Cargo_SobSetup: 'SOB Setup',
  Cargo_Soc: 'SOC',
  Cargo_IsSoc: 'Is it SOC',
  Cargo_SoftwareVersion: 'Software Version',
  Cargo_SolicitationType: 'Cargo sales type',
  Cargo_SOSINTU: 'Status of selected invoice no. to update',
  Cargo_SOSINTUIU: 'Status of selected invoice no. to update is Used.',
  Cargo_SourceOfClient: 'Source of client',
  Cargo_SOWLC: 'Storage of Warehouse-loading Container',
  Cargo_Sp1: 'Invoice Slip',
  Cargo_Sp17: 'Unfold Details',
  Cargo_Sp18: 'Details of Combination',
  Cargo_Sp24: 'Financial Statement',
  Cargo_Sp27: 'Enterprise Signature & Seal',
  Cargo_Sp31: 'Expense Split',
  Cargo_SPABNCTBBE: 'Settling party and business no. can\'t be both empty.',
  Cargo_Space2: 'Invoice Date',
  Cargo_SPBNMNAL1SCR: 'Settling party, business no., MBL no, at least 1 search condition required.',
  Cargo_SpecialApproval: 'Special approval',
  Cargo_SpecialApprovalValidUntil: 'Special approval valid until',
  Cargo_BusinessExpirationDate: 'Business expiration date',
  Cargo_SpecialApprovalTip: 'Note: When the validity period is empty, special approval is granted for long-term validity.',
  Cargo_SpecialGoods: 'Special goods?',
  Cargo_SpecialInvoice: 'Special Invoice',
  Cargo_SpecialInvoiceGeneralInvoice: 'Special invoice/General invoice',
  Cargo_SpecialInvoiceInternalInvoice: 'Special invoice/Internal invoice',
  Cargo_SpecialPrice: 'Special rate',
  Cargo_SpecialPriceInstructions: 'Special rate description',
  Cargo_SpecifyCollectionPayment: 'Specify Collection/Payment',
  Cargo_SPIANA: 'Settling party inconsistent and non-affiliated.',
  Cargo_SPIANA_DiffSettlementAgent: 'Settling party inconsistent and non-affiliated, Settlement agents are also inconsistent.',
  Cargo_Split: 'Split',
  Cargo_SplitBillingFees: 'Split billing fees',
  Cargo_SplitBL: 'Split B/L',
  Cargo_SplitExpense: 'Split Expense',
  Cargo_SplitExpenseP: 'Split Expense:',
  Cargo_SplitHBL: 'Split HB/L',
  Cargo_SplitMBL: 'Split MB/L',
  Cargo_SplitOldDataToNew: 'Split (old data to new)',
  Cargo_SplitSuccessfully: 'Split successfully.',
  Cargo_SPNETRSC: 'Settling party not exist, try re-setting cache.',
  Cargo_SPWPWO: 'Settling Party with Pending Write-offs',
  Cargo_SSNMIR: 'SOA status not meet invoicing requirement.',
  Cargo_SSNMWOR: 'SOA status not meet write-off requirement.',
  Cargo_SSSFPR: 'Saved successfully, submit for pre-review?',
  Cargo_STAEONRS: 'Shipping terms already exist or no record selected',
  Cargo_Staff: 'Staff',
  Cargo_StaffP: 'Staff:',
  Cargo_StampOfSalesUnit: 'Stamp of Sales Unit',
  Cargo_StartDateOfContainerReturn: 'Start date of container return',
  Cargo_StartDateOfFinancialPeriod: 'Start Date of Financial Period',
  Cargo_StartingAccountTitle: 'Starting Account Title',
  Cargo_StartNo: 'Start No.',
  Cargo_StartReconciliation: 'Manual Reconciliation',
  Cargo_StatementOfBalance: 'Statement of Balance',
  Cargo_StatementOfBalance2: 'Statement of Balance 2',
  Cargo_Statistics: 'Summarize',
  Cargo_StatisticsWithoutMblExpenses: 'Statistics without MBL Expenses',
  Cargo_Status: 'Status',
  Cargo_StatusChanged: 'Status changed.',
  Cargo_StatusOfAdvanceReceipt: 'Status of Advance Receipt',
  Cargo_STCCOTB: 'Sure to cancel confirmation of the {0} bills?',
  Cargo_STDTATM: 'Sure to delete the account title mapping?',
  Cargo_STDTATNRAD: 'Sure to delete the account title? Not recoverable after deletion.',
  Cargo_STDTPA: 'Sure to delete the payment applications?',
  Cargo_STWTPA: 'Sure to withdraw the payment applications?',
  Cargo_STDTSPT: 'Sure to delete the search parameter template?',
  Cargo_STDTSRRAVWBDT: 'Sure to delete the SOB? Related rules and vouchers will be deleted too.',
  Cargo_STDTSVRJEWBDT: 'Sure to delete the selected voucher? Related journal entries will be deleted too.',
  Cargo_STDTSVRJEWBDTM: 'Sure to delete the selected {0} vouchers? Related journal entries will be deleted too.',
  Cargo_STDTVGR: 'Sure to delete the voucher grouping rule?',
  Cargo_STOAOWO: 'Show Total Outstanding Amount of Write-off',
  Cargo_Storage: 'Warehouse',
  Cargo_SendToEachRecipientSeparately: 'Send to each recipient separately',
  Cargo_SyncSendCCAddress: 'Send CC address synchronously',
  Cargo_SearchForTheDataYouWantToInsert: 'Search for the data you want to insert',
  Cargo_StorageRequired: 'Storage required?',
  Cargo_STRAEAAWORWBRC: 'Sure to revoke? All expense adjustments and write-off records will be reset. Confirm.',
  Cargo_StreetAddress: 'Street address',
  Cargo_StreetAddressCanTBeEmpty: 'Street address can\'t be empty',
  Cargo_STRTWOREAIIWBR: 'Sure to revoke the write-off? Related expense and invoice information will be reset.',
  Cargo_Stuff: 'Stuff',
  Cargo_STWBTSV: 'Sure to write back the selected {0} vouchers?',
  Cargo_SubCategoryOfAccountTitle: 'Sub-category of Account Title',
  Cargo_Submit: 'Submit',
  Cargo_SubmitExpenseForReviewDirectly: 'Submit expense for review directly?',
  Cargo_SubmitPaymentNotice: 'Submit Payment Notice',
  Cargo_SubmitStatusSelection: 'Submit Status Selection',
  Cargo_Submitted: 'Submitted',
  Cargo_SubmittedForPreReviewStatus: 'Submitted for pre-review status?',
  Cargo_SubmittedSuccessfully: 'Submitted successfully.',
  Cargo_SpecialFeeLimitReleaseApply: 'Application to remove special fee limit',
  Cargo_SpecialFeeLimitReleaseApplyContent: 'Apply to remove special fee limit for {0}',
  Cargo_SpecialFeeLimitReleaseApplyContentPlain: 'Apply to remove special fee limit',
  Cargo_ReleaseDocumentNumberApplication: 'Release Document/Number Application',
  Cargo_ReleaseNumberDocument: 'Release Number/Document',
  Cargo_IsPaymentReceived: 'Is Payment Received',
  Cargo_PaymentTime2: 'Payment Time',
  Cargo_ReleaseNumberQuantity: 'Release Number Quantity',
  Cargo_RelatedAttachments: 'Related Attachments',
  Cargo_ReleaseNumber: 'Release Number',
  Cargo_ReleaseDocument: 'Release Document',
  Cargo_RemainingTemporaryReleaseQuantity: 'Remaining Temporary Release Quantity',
  Cargo_TemporaryDocumentReleaseApplication: 'Temporary Document Release Application',
  Cargo_TemporaryNumberReleaseApplication: 'Temporary Number Release Application',
  Cargo_SubscribePOL: 'POL',
  Cargo_SubsidiaryAccounting: 'Subsidiary Accounting',
  Cargo_SubsidiaryAccountingClient: 'Subsidiary Accounting Client',
  Cargo_SubsidiaryAccountingCondition1: 'Subsidiary Accounting Condition 1',
  Cargo_SubsidiaryAccountingCondition2: 'Subsidiary Accounting Condition 2',
  Cargo_SubsidiaryAccountingCondition3: 'Subsidiary Accounting Condition 3',
  Cargo_SubsidiaryAccountingCondition4: 'Subsidiary Accounting Condition 4',
  Cargo_SubsidiaryAccountingCondition5: 'Subsidiary Accounting Condition 5',
  Cargo_SubsidiaryAccountingCondition6: 'Subsidiary Accounting Condition 6',
  Cargo_SubsidiaryAccountingItems: 'Subsidiary Accounting Items',
  Cargo_SubsidiaryAccountingStaff: 'Subsidiary Accounting Staff',
  Cargo_SubsidiaryLedger: 'Subsidiary Ledger',
  Cargo_SubsidiaryLedger2: 'Subsidiary Ledger 2',
  Cargo_SubtitlesOfAccount: 'Subtitles of Account',
  Cargo_SubTotal: 'Subtotal',
  Cargo_SubTotalOfOpeningBalance: 'Sub-total of Opening Balance',
  Cargo_Success: 'Successfully',
  Cargo_SummarizeDistributionExpense: 'Summarize distribution expense?',
  Cargo_SummarizeMblExpense: 'Summarize MBL expense?',
  Cargo_SupervisionMethod: 'Supervision Method',
  Cargo_SupplierContract: 'Supplier Contract',
  Cargo_Surcharge: 'Surcharge',
  Cargo_Controlled: 'Controlled item',
  Cargo_NeedInvoice: 'Need invoice item',
  Cargo_SurchargeOrNot: 'Surcharge or not',
  Cargo_SureToAddToBlackList: 'Sure to add to black list?',
  Cargo_SureToBatchConfirmTheBill: 'Sure to batch confirm the {0} bills?',
  Cargo_SureToBatchReviewTheExpense: 'Sure to batch review the {0} expenses?',
  Cargo_SureToCancel: 'Sure to cancel?',
  Cargo_SureToCancelConfirmation: 'Sure to cancel confirmation?',
  Cargo_SureToCancelConfirmationYes: 'Sure to cancel confirmation? Yes.',
  Cargo_SureToCancelReviewOfTheExpense: 'Sure to cancel review of the {0} expenses?',
  Cargo_SureToCancelReviewOfTheVoucher: 'Sure to cancel review of the {0} voucher?',
  Cargo_SureToCancelReviewOfTheExpenseCheck: 'The selected fee exists {0} <br/>',
  Cargo_Billinged: 'Bill generated',
  Cargo_WriteOffed: 'Verified off',
  Cargo_SureToCancelVerification: 'Are you sure you want to cancel the review?',
  Cargo_SureToCarryOver: 'Sure to carry over?',
  Cargo_SureToConfirmWriteOffRecord: 'Sure to confirm write-off record?',
  Cargo_SureToCreateInvoice: 'Sure to create invoice?',
  Cargo_SureToCreateListOfCombinedBills: 'Sure to create list of combined bills?',
  Cargo_SureToDelete: 'Sure to delete?',
  Cargo_SureToDeleteWarehouse: 'After deletion, all warehouse entry information will be cleared, whether to continue?',
  Cargo_SureToDeleteInvoice: 'Sure to delete invoice?',
  Cargo_SureToDeleteSelectedRecord: 'Sure to delete selected record?',
  Cargo_SureToDeleteTheAbstractRule: 'Sure to delete the abstract rule?',
  Cargo_SureToDeleteTheAdvanceReceipt: 'Sure to delete the advance receipt?',
  Cargo_SureToDeleteTheBill: 'Sure to delete the {0} bill(s)?',
  Cargo_SureToDeleteTheExchangeRate: 'Sure to delete the exchange rate?',
  Cargo_SureToDeleteTheInvoice: 'Sure to delete the {0} invoices?',
  Cargo_SureToDeleteTheMapping: 'Sure to delete the mapping?',
  Cargo_SureToDeleteTheRecord: 'Sure to delete the record?',
  Cargo_SureToDeleteTheRule: 'Sure to delete the rule?',
  Cargo_SureToDeleteThisSoaItem: 'Sure to delete this {0} SOA items?',
  Cargo_SureToDeliverToBranch: 'Sure to deliver to branch?',
  Cargo_SureToDeny: 'Sure to deny?',
  Cargo_SureToFreezeApplication: 'Sure to freeze application?',
  Cargo_SureToHoldSubmission: 'Sure to hold submission?',
  Cargo_SureToIssueCombinedInvoice: 'Sure to issue combined invoice?',
  Cargo_SureToModifyBillingDate: 'Sure to modify billing date?',
  Cargo_SureToPrint: 'Sure to print?',
  Cargo_SureToPrintDetailList: 'Sure to print detail list?',
  Cargo_SureToReIssueInvoice: 'Sure to re-issue invoice?',
  Cargo_SureToRejectIt: 'Sure to reject it?',
  Cargo_SureToRejectTheExpenseItem: 'Sure to reject the {0} expense items?',
  Cargo_SureToRemoveTheBill: 'Sure to remove the {0} bills?',
  Cargo_SureToRemoveTheExpenseItem: 'Sure to remove the {0} expense items?',
  Cargo_SureToReturnApplication: 'Sure to return application?',
  Cargo_SureToReviewTheBills: 'Do you confirm to review these jobs?',
  Cargo_SureToReviewTheVoucher: 'Sure to review the {0} vouchers?',
  Cargo_SureToRevokeContractWith: 'Sure to revoke contract *** with ***?',
  Cargo_SureToRevokeRetrieval: 'Sure to revoke retrieval?',
  Cargo_SureToRevokeWithdrawal: 'Sure to revoke withdrawal?',
  Cargo_SureToVoid: 'Sure to void?',
  Cargo_SureToVoidInvoice: 'Sure to void invoice?',
  Cargo_SureToVoidTheInvoice: 'Sure to void the invoice?',
  Cargo_SureToVoidTheInvoiceM: 'Sure to void the {0} invoices?',
  Cargo_SUSBODNMWBACTS: 'Sales unit\'s bank of deposit not matched with bank account, continue to save?',
  Cargo_SUSBODNMWRISCTS: 'Sales unit\'s bank of deposit not matched with record in system, continue to save?',
  Cargo_SUTCPALVIBC: 'Set up the carryover profit and loss voucher information before checkout',
  Cargo_SVSFPHBC: 'Selected voucher\'s financial period has been closed.',
  Cargo_SVSMHBC: 'Selected voucher\'s month has been closed.',
  Cargo_SWDE: 'Statistics without Distributed Expenses',
  Cargo_Switch: 'Switch',
  Cargo_SwitchBasisToAcquireDocument: 'Switch Basis to Acquire Document',
  Cargo_SwitchCurrency: 'Switch Currency',
  Cargo_SwitchFile: 'Switch File',
  Cargo_SwitchInvoice: 'Switch Invoice',
  Cargo_SwitchMethodOfClaim: 'Switch Method of Claim',
  Cargo_SwitchSob: 'Switch SOB',
  Cargo_Symbol: 'Symbol',
  Cargo_SynchronousCodingPartners: 'Synchronous coding (Partners)',
  Cargo_SystemAlertForPayment: 'System Alert for Payment',
  Cargo_SystemBusy: 'System busy',
  Cargo_SystemBusyPRL: 'System busy, pls retry later.',
  Cargo_TableFilter: 'Table Filter',
  Cargo_TakeByCustomsBroker: 'Customs Broker Selection',
  Cargo_TAOPLFESAMBETCWOA: 'Total amount of profit & loss, financial expense, short account must be equal to current write-off amount.',
  Cargo_TAOPLFESAMBETCWOANoFinance: 'Total amount of profit & loss, short account must be equal to current write-off amount.',
  Cargo_TAOPLFESAMBETCWOAPC: 'Total amount of profit & loss, financial expense, short account must be equal to current write-off amount, please check.',
  Cargo_TAPBACTBLTARAWIETIAP: 'Total A/P billing amount can\'t be less than A/R amount when income & expenditure type is A/P.',
  Cargo_Tax: 'Tax',
  Cargo_TaxAmount: 'Tax Amount',
  Cargo_TaxAmountP: 'Tax Amount:',
  Cargo_TaxationNbr: 'Tax Registration No.',
  Cargo_TaxExcludedPrice: 'Rate without Tax',
  Cargo_TaxExcludedPriceP: 'Rate without Tax:',
  Cargo_TaxFreeAmount: 'Amount without Tax',
  Cargo_TaxIncludedPrice: 'Rate with Tax',
  Cargo_TaxIncludedPriceP: 'Rate with Tax:',
  Cargo_TaxpayerAuthorizationCode: 'Taxpayer Authorization Code',
  Cargo_TaxRate: 'Tax Rate',
  Cargo_TaxRateP: 'Tax Rate:',
  Cargo_TaxRatePct: 'Tax Rate(%)',
  Cargo_TBTRS: 'Transferred back to reconciliation successfully.',
  Cargo_TDCBODNBTTCBOTULBC: 'The data currently being operated does not belong to the current branch or the upper-level branch. Continue?',
  Cargo_TeamLeader: 'Team leader',
  Cargo_TeamLeaderAssignment: 'Team leader assignment',
  Cargo_Tel: 'TEL',
  Cargo_TelexReleaseApplicant: 'Telex Release Applicant',
  Cargo_TelexReleaseApplicationDate: 'Telex Release Application Date',
  Cargo_TelexReleaseFee: 'Telex Release Fee',
  Cargo_TelexReleaseMaterial: 'Telex Release Material',
  Cargo_TelexReleaseNo: 'Telex Release No.',
  Cargo_ExpenseBoxNo: 'Expense box No',
  Cargo_TemplateDownload: 'Download Templates',
  Cargo_TemplateDownloadFailed: 'Template download failed.',
  Cargo_TenDigitCode: 'Decimal Code',
  Cargo_TenThousandYuan: 'Ten thousand yuan',
  Cargo_TEYAPHBMBSEC: 'The expense you are processing has been modified by someone else, continue?',
  Cargo_TFCFDTECNIPSDOACS: 'The following clients failed due to existing client no. in partner\'s database. Others are contracted successfully.',
  Cargo_TFOTPCTBCWOP: 'Time frame of the period can\'t be crossed with other periods.',
  Cargo_TFSIIUDNA: 'The following site is in use, deletion not allowed.',
  Cargo_The1StInvoiceNoCanTBeEmpty: 'The 1st invoice no. can\'t be empty.',
  Cargo_TheAmountOfWrittenOff: 'Written-off Amount',
  Cargo_TheExpenseNotBoundToInvoice: 'The expense not bound to invoice.',
  Cargo_TheLast: 'The Last',
  Cargo_TheLastPage: 'Previous',
  Cargo_TheNextPage: 'Next',
  Cargo_TheOppositeSideAccount: 'Counterparty\'s Bank Account',
  Cargo_TheOppositeSideBank: 'Counterparty\'s Bank',
  Cargo_TheOppositeSideCompany: 'Counterparty',
  Cargo_TheOppositeSideInvoiceNo: 'Counterparty\'s Invoice No.',
  Cargo_ThisFeeHasBeenInvoiced: 'This fee has been invoiced.',
  Cargo_ThisFeeHasBeenWrittenOff: 'This fee has been written off.',
  Cargo_ThisTimeBalance: 'Current Balance',
  Cargo_ThisTimeWriteOff: 'Current Write-off',
  Cargo_ThisTimeWriteOffEq: 'Current Write-off = Amount received + Summary profit/loss + Finance costs + Short account',
  Cargo_ThisWriteOffNoIs: 'This write off No. is:',
  Cargo_TIBYEIB: 'The initial balance you entered is balanced.',
  Cargo_TIBYEIUPDCTBSAIS: 'The initial balance you entered is unbalanced, please double check the balance sheet and income statement.',
  Cargo_Time: 'Time',
  Cargo_TimeFrame: 'Time Frame',
  Cargo_TimeOfCargoHolding: 'Time of Cargo Holding',
  Cargo_TimeOfDocHolding: 'Time of Doc. Holding',
  Cargo_TimeOfPurchase: 'Time of Purchase',
  Cargo_TimeOfPurchaseCanTBeEmpty: 'Time of Purchase can\'t be empty.',
  Cargo_TimeOfUse: 'Time of Use',
  Cargo_TimeOfUseCanTBeEmpty: 'Time of use can\'t be empty.',
  Cargo_Tips: 'Prompt',
  Cargo_PleaseSelectTheSailingScheduleBelow: 'Please select the sailing schedule below',
  Cargo_ChooseShippingSchedulesTips1: '1. Please select the corresponding sailing schedule. If you do not make a choice, you may not be able to obtain the planned berthing time, port opening and interception time, and actual berth time related to the sailing schedule',
  Cargo_ChooseShippingSchedulesTips2: '2. If you are still unable to confirm the sailing schedule, you can click the [Do not select] button, and then click the [Select Schedule] button to select the sailing schedule',
  Cargo_MoreShippingSchedulesTips: 'The port area returns the sailing schedule of multiple terminals, which will affect the display and push of sailing schedule information, please select the sailing schedule information you want',
  Cargo_ChooseShippingSchedules: 'Choose Shipping Schedules',
  Cargo_NoSelectYet: 'Don\'t select it yet',
  Cargo_ChangePayment: 'Change Payment Request',
  Cargo_PaymentTimeLimit: 'Payment Limit',
  Cargo_Title: 'Title',
  Cargo_TitleOfAccount: 'Title of Account',
  Cargo_TLOOSE: 'Total Liabilities & Owners or Shareholders\' Equities',
  Cargo_TMAEONRS: 'Trade method already exists or no record selected',
  Cargo_To: 'To',
  Cargo_FROM: 'From',
  Cargo_ToDetermineIfEditableWhenViewing: 'To determine if editable when viewing',
  Cargo_TOEIAADFIA: 'Totals of expense items and amounts differ from invoice amount.',
  Cargo_ChargeAmountCannotExceedInvoiceAmount: 'The expense item amount cannot exceed the invoice amount.',
  Cargo_ChargeAlreadyAssociatedInvoice: '{0} expense has already been associated with an invoice.',
  Cargo_TORFRS: 'Total of {0} records found, {1} records selected.',
  Cargo_Total0: 'Total: {0}',
  Cargo_TotalAmount: 'Total Amount',
  Cargo_TotalAmountNotWrittenOff: 'Total Amount not Written off',
  Cargo_TotalAmountOfCurrentPeriod: 'Total Amount of Current Period',
  Cargo_TotalAmountPJ: 'Total Amount-',
  Cargo_TotalAmountP: 'Total Amount:',
  Cargo_TotalAmountToWriteOff: 'Total Amount to Write Off',
  Cargo_TotalAPAmount: 'Total A/P Amount',
  Cargo_TotalARAmount: 'Total A/R Amount',
  Cargo_TotalBalance: 'Total Balance',
  Cargo_TotalCommissionAmount: 'Total Commission Amount',
  Cargo_TotalCommissionAmountP: 'Total Commission Amount:',
  Cargo_TotalCost: 'Total Cost',
  Cargo_TotalCurrency: 'Total by Currency',
  Cargo_TotalCurrentLiabilities: 'Total Current Liabilities',
  Cargo_TotalIncome: 'Gross Revenue',
  Cargo_TotalLiabilities: 'Total Liabilities',
  Cargo_TotalNonCurrentAssets: 'Total Non-current Assets',
  Cargo_TotalNonCurrentLiabilities: 'Total Non-current Liabilities',
  Cargo_TotalOfVouchersEntered: 'Total of {0} vouchers entered.',
  Cargo_TotalOutstandingAmountByCurrency: 'Total Outstanding Amount by Currency',
  Cargo_TotalPriceWithTaxInWords: 'Total Price with Tax in Words',
  Cargo_TotalProfit: 'Total profit',
  Cargo_TotalRevenue: 'Total revenue',
  Cargo_TotalWriteOffAmount: 'Total Write-off Amount',
  Cargo_Choose: 'Choose',
  Cargo_TotalWriteOffs: 'Total Write-off Amount',
  Cargo_TotalWriteOffsP: 'Total Write-off Amount:',
  Cargo_TPOPNOINOE: 'Total profit / Operating profit / Non-operating income / Non-operating expense',
  Cargo_TPTODIDDYCTMAGV: 'The payment type or direction is different. Do you continue to merge and generate vouchers?',
  Cargo_TradeTerm: 'Trade method',
  Cargo_TradeTerms: 'Transaction terms',
  Cargo_TradeTermsMaintenance: 'Trade terms maintenance',
  Cargo_TradeType: 'Trade Type',
  Cargo_TradingCompany: 'Trading company',
  Cargo_Transfer: 'Transfer',
  Cargo_TransferAllToReconciliation: 'Transfer All to Reconciliation',
  Cargo_TransferBackAmount: 'Transfer-back Amount',
  Cargo_TransferBackGrandTotal: 'Transfer-back Grand Total',
  Cargo_TransferBackToReconciliation: 'Transfer back to Reconciliation',
  Cargo_TransferCash: 'Transfer Cash',
  Cargo_TransferExpense: 'Transfer Expense',
  Cargo_TransferIntoCollection: 'Transfer into Collection',
  Cargo_TransferOutToCollection: 'Transfer out to Collection',
  Cargo_TransferPort: 'Transit Port',
  Cargo_TransferToCNY: 'Transfer to CNY',
  Cargo_TransitPortSea: 'Transit port (sea)',
  Cargo_TransitTerm: 'Shipping terms',
  Cargo_Transportation: 'Transport',
  Cargo_TRAYEINR: 'The reconciliation amount you entered is not reasonable.',
  Cargo_TRFRBLFDAF: 'Telex Release Fee / Remote B/L Fee / Doc Amendment Fee',
  Cargo_TrialBalance: 'Trial Balance',
  Cargo_TrialBalanceCheck: 'Trial Balance Check',
  Cargo_TRNAPUCWOFISI: 'Total revocation not allowed, please use cancel write-off function in search interface.',
  Cargo_TruckCompany: 'Trucker',
  Cargo_TruckingCompany: 'Trucking Company',
  Cargo_TSASOBMBTS: 'The settlement agent(s) of bill must be the same!',
  Cargo_TSBADNCTCC: 'The selected bank account does not contain this currency, continue?',
  Cargo_TTAEONRS: 'Trade terms already exist or no record selected',
  Cargo_TTOAFNTCCPM: 'The title only accounts for {0}, not the current currency {1}, please modify.',
  Cargo_TUPAOTPALVCBE: 'The undistributed profit account of the profit and loss voucher cannot be empty.',
  Cargo_TWORHBRCC: 'This write off record has been reversed, cannot cancelled.',
  Cargo_Type: 'Type',
  Cargo_MaximumTakeOffWeight: 'Maximum take-off weight',
  Cargo_Charter_Flights_Tips: 'In the case of charter flights, flight costs can be maintained here',
  Cargo_Charter_package_board: 'Charter package board',
  Cargo_Board_Tips: 'The wrapping business is used for subsequent load ratio and profit analysis',
  Cargo_Flight_costs: 'Flight costs',
  Cargo_NumberOfCartridges: 'Number of cartridges',
  Cargo_Please_Select_The_Model_You_Want_To_Edit: 'Please select the model you want to edit',
  Cargo_Please_Select_The_Model_To_Be_Deleted: 'Please select the model to be deleted',
  Cargo_Please_Select_The_Uld_You_Want_To_Edit: 'Please select the unit load device you want to edit',
  Cargo_Please_Select_The_Uld_To_Be_Deleted: 'Please select the unit load device to be deleted',
  Cargo_WeightRestrictions: 'Weight restrictions',
  Cargo_VolumeLimit: 'Volume limit',
  Cargo_LoadableCapacity: 'Loadable capacity',
  Cargo_LoadableWeight: 'Loadable weight',
  Cargo_DeadWeight: 'dead weight',
  Cargo_LSize: 'Size (L)',
  Cargo_WSize: 'Size (W)',
  Cargo_HSize: 'Size (H)',
  Cargo_ApplicableModels: 'Applicable models',
  Cargo_ApplicableContainerType: 'Container Type',
  Cargo_ApplicableContainerCode: 'Container Code',
  Cargo_ApplicableContainerNumber: 'Container Number',
  Cargo_CharterPack: 'Charter/Pack',
  Cargo_TypeOfBill: 'Type of Bill',
  Cargo_TypeOfGoods: 'Type of goods',
  Cargo_TypeOfPort: 'Type of port',
  Cargo_UBEIRPSMB: 'Unmarked bills exist in record, please select marked bills.',
  Cargo_UCOVEIIDPCTD: 'Unmaintained clients or vendors exist in imported data, please click to download.',
  Cargo_Unbilled: 'Unbilled',
  Cargo_Uncommitted: 'Not Submitted',
  Cargo_Unconfirmed: 'Not Confirmed',
  Cargo_UnderConfirmation: 'Under Confirmation',
  Cargo_UnfrozenSuccessfully: 'Unfrozen successfully.',
  Cargo_UnInvoiced: 'Un-invoiced',
  Cargo_Unissued: 'Unissued',
  Cargo_UnissuedServiceTicket: 'Unissued Service Ticket',
  Cargo_Unit: 'Unit',
  Cargo_UnitOfMeasurement: 'Measure Unit',
  Cargo_UnitOfPaymentPeriod: 'Unit of payment period',
  Cargo_UnitPrice: 'Unit Rate',
  Cargo_UnitPriceP: 'Unit Rate:',
  Cargo_Unknown: 'Unknown',
  Cargo_UnKnownStatus: 'Status unknown.',
  Cargo_Unlimited: 'Unlimited',
  Cargo_Unpaid: 'Unpaid',
  Cargo_UnpaidClear: 'Outstanding',
  Cargo_UnpaidCNY: 'Unpaid(CNY)',
  Cargo_UnpaidEUR: 'Unpaid(EUR)',
  Cargo_UnpaidGBP: 'Unpaid(GBP)',
  Cargo_UnpaidHKD: 'Unpaid(HKD)',
  Cargo_UnpaidJPY: 'JPYUnpaid(JPY)',
  Cargo_UnpaidNGN: 'Unpaid(NGN)',
  Cargo_UnpaidP: 'Unpaid:',
  Cargo_SimpleUnpaidP: 'Unpaid',
  Cargo_UnpaidUSD: 'Unpaid(USD)',
  Cargo_ReceivedP: 'Received',
  Cargo_PaidP: 'Paid',
  Cargo_EmptyValue: 'Empty',
  Cargo_UnsavedNewExpenseCanTBeSplit: 'Unsaved new expense can\'t be split!',
  Cargo_UpdateBar: 'Update Bar',
  Cargo_UpdateBusinessDate: 'Modify Business Date',
  Cargo_UpdatedSuccessfully: 'Updated successfully.',
  Cargo_UpdateFailed: 'Update failed.',
  Cargo_UpdatePageDisplay: 'Update Page Display',
  Cargo_UpdatePrintButtonStatus: 'Update Print Button Status',
  Cargo_Upload: 'Upload',
  Cargo_UploadAttachment: 'Upload attachment',
  Cargo_DeleteAttachment: 'Delete Attachment',
  Cargo_UploadContract: 'Upload contract',
  Cargo_UploadContractAttachments: 'Upload contract attachments',
  Cargo_UploadData: 'Upload Data',
  Cargo_URVUTSWBRIKC: 'Un-reviewed vouchers under the SOB will be reviewed in Kingdee, continue?',
  Cargo_USD: 'USD',
  Cargo_USDAmount: 'USD',
  Cargo_USDExchangeRate: 'USD Exchange Rate',
  Cargo_USDInvoiceNo: 'USD Invoice No.',
  Cargo_USDP: 'USD:',
  Cargo_Use: 'Use',
  Cargo_Used: 'Used',
  Cargo_UseGroupExchangeRate: 'Use Group Exchange Rate',
  Cargo_UseOriginalTemporarily: 'Use original temporarily.',
  Cargo_User: 'User',
  Cargo_UserCanTBeEmpty: 'User can\'t be empty.',
  Cargo_UseShouldBeTemporarily: 'Use \'Should be\' temporarily.',
  Cargo_ValidityOfInvoice: 'Validity of Invoice',
  Cargo_Value: 'Value',
  Cargo_VatGeneralInvoice: 'VAT General Invoice',
  Cargo_VatInvoice: 'VAT Invoice',
  Cargo_VatInvoiceIssuingMachineNo: 'VAT Invoice Issuing Machine No.',
  Cargo_VatSpecialInvoice: 'VAT Special Invoice',
  Cargo_Vendor: 'Vendor',
  Cargo_VendorCantBeEmpty: 'Vendor can\'t be empty.',
  Cargo_VendorClient: 'Vendor Client',
  Cargo_VendorModification: 'Vendor Modification',
  Cargo_VendorP: 'Vendor:',
  Cargo_VendorSInvoiceNo: 'Vendor\'s Invoice No.',
  Cargo_VerificationCancelled: 'Verification cancelled',
  Cargo_VerificationPassed: 'Verification passed?',
  Cargo_VerificationRejected: 'Verification rejected',
  Cargo_VerifiedSuccessfullyClickToSave: 'Verified successfully, click to save.',
  Cargo_VerifiedSuccessfullyClickToExport: 'Verified successfully, click to export.',
  Cargo_Verify: 'Verify',
  Cargo_VerifyARAPExpense: 'Verify A/R & A/P expense',
  Cargo_VerifyInvoiceNo: 'Verify Invoice No.',
  Cargo_VerifyJournalEntry: 'Verify Journal Entry',
  Cargo_VesselAndVoyage: 'Vessel/Voyage',
  Cargo_VesselVoyageFlight: 'Vessel/Voyage/Flight',
  Cargo_VGIVSI: 'VAT General Invoice VAT Special Invoice',
  Cargo_VHBCFSACCTBC: 'Voucher has been created for subsidiary accounting client, can\'t be cancelled.',
  Cargo_VHBCFSADCTBC: 'Voucher has been created for subsidiary accounting department, can\'t be cancelled.',
  Cargo_VHBCFSAICTBC: 'Voucher has been created for subsidiary accounting Items, can\'t be cancelled.',
  Cargo_VHBCFSASCTBC: 'Voucher has been created for subsidiary accounting staff, can\'t be cancelled.',
  Cargo_VHBCFSAVCTBC: 'Voucher has been created for subsidiary accounting vendor, can\'t be cancelled.',
  Cargo_ASCCCTBC: ' has been confirmed by company, can\'t be cancelled.',
  Cargo_VHBEFCWOWBRWBCITWORSTWB: 'Voucher has been exported for current write-off, write-back record will be created if the write-off revoked. Sure to write back?',
  Cargo_View: 'View',
  Cargo_ViewAllBusiness: 'View all Business',
  Cargo_ViewAllExpenses: 'View all Expenses',
  Cargo_ViewBill: 'View Bill',
  Cargo_ViewBusinessOfSameGroup: 'View Business of Same Group',
  Cargo_ViewDetail: 'View Details',
  Cargo_ViewDetails: 'View Details',
  Cargo_ViewDetailsOfRemovals: 'View details of removals',
  Cargo_ViewedByFee: 'Viewed by fee',
  Cargo_ViewedByJob: 'Viewed by job',
  Cargo_ViewExpensesOfSameGroup: 'View Expenses of Same Group',
  Cargo_ViewFile: 'View files',
  Cargo_ViewInvoice: 'View Invoice',
  Cargo_ViewSelfBusiness: 'View Self Business',
  Cargo_ViewSoa: 'View SOA',
  Cargo_ViewUploadedDeclarationDocInfo: 'View Uploaded Declaration Doc Info.',
  Cargo_ViewVoucher: 'View Voucher',
  Cargo_ViolationOfUniquenessConstraint: 'Violation of Uniqueness Constraint',
  Cargo_VOCMEICSR: 'Vouchers of closed month exist in current selected records.',
  Cargo_VoidCompleted: 'Void completed.',
  Cargo_Voided: 'Voided',
  Cargo_VoidedBy: 'Voided by',
  Cargo_VoidedInvoice: 'Voided Invoice',
  Cargo_VoidedInvoiceNo: 'Voided Invoice No.',
  Cargo_VoidedInvoiceNoP: 'Voided Invoice No.:',
  Cargo_VoidedSuccessfully: 'Voided successfully.',
  Cargo_VoidStatus: 'Void Status',
  Cargo_VoidTime: 'Void Time',
  Cargo_AssociatedExpenseID: 'Associated Expense ID',
  Cargo_ChargeID: 'Charge ID',
  Cargo_VOPLCOCTBD: 'Voucher of profit & loss carry-over can\'t be deleted.',
  Cargo_StateDeleteError: 'The certificate system has been imported and cannot be deleted',
  Cargo_VoucherAbstract: 'Voucher Abstract',
  Cargo_VoucherCannotBeEmpty: 'Voucher cannot be empty!',
  Cargo_VoucherCreatedOrNot: 'Voucher created or not?',
  Cargo_VoucherCreatedSuccessfully: '{0} Vouchers created successfully.',
  Cargo_VoucherDateCanTBeEmpty: 'Voucher date can\'t be empty.',
  Cargo_VoucherEntryCanTBeEmpty: 'Voucher entry can\'t be empty.',
  Cargo_VoucherGroupingRule: 'Voucher Grouping Rule',
  Cargo_VoucherGroupingType: 'Voucher Grouping Type',
  Cargo_VoucherGroupingTypeP: 'Voucher Grouping Type:',
  Cargo_VoucherLetter: 'Voucher Letter',
  Cargo_VoucherLetterCanTBeEmpty: 'Voucher letter can\'t be empty.',
  Cargo_VoucherLetterNo: 'Voucher Letter No.',
  Cargo_VoucherLetterP: 'Voucher Letter:',
  Cargo_VoucherList: 'Voucher List',
  Cargo_VoucherMonth: 'Voucher Month',
  Cargo_VoucherNo: 'Voucher No.',
  Cargo_VoucherNoCanTBeEmpty: 'Voucher no. can\'t be empty.',
  Cargo_VoucherNoP: 'Voucher No.:',
  Cargo_VoucherNotCreatedCreateItNow: 'Voucher not created, create it now?',
  Cargo_VoucherOfAdvance: 'Voucher of Advance',
  Cargo_VoucherPeriod: 'Voucher Period',
  Cargo_VoucherPeriodCanTBeEmpty: 'Voucher period can\'t be empty.',
  Cargo_VoucherRule: 'Voucher Rule',
  Cargo_VoucherSearch: 'Voucher Search',
  Cargo_VoucherStatus: 'Voucher Status',
  Cargo_VoucherType: 'Voucher Type',
  Cargo_VoyageFlight: 'Voyage/Flight',
  Cargo_VoyageNo: 'Voyage',
  Cargo_VRDBR: 'View Removal Details by Reconciliation',
  Cargo_VSRAOGTEPAEIADPERAPIT: 'Verification & service request addresses of Golden Taxation exported paper and electronic invoices are different, please export respectively as per invoice types.',
  Cargo_Warehouse: 'Warehouse',
  Cargo_WarehouseDoor: 'Warehouse/door',
  Cargo_WarehouseLoading: 'Warehouse Loading',
  Cargo_WarehouseLoadingStorage: 'Loading at warehouse/storage',
  Cargo_WarehouseNo: 'Warehouse-in no.',
  Cargo_WBOWBVCTBD: 'Write-back or written-back vouchers can\'t be deleted.',
  Cargo_WBOWBVCTBWB: 'Write-back or written-back vouchers can\'t be written back.',
  Cargo_REVERSE: 'Write-back voucher succeeded.',
  Cargo_WCDCOVCWBDBOSRCCWBIDDRWNOPC: 'When checked, detailed columns of various currencies will be displayed basing on search result, customized configurations will be ignored. Dynamic displayed result will not overwrite previous configurations.',
  Cargo_WDPCCS: 'Wrong data, please contact customer service.',
  Cargo_Wechat: 'WeChat',
  Cargo_Week: 'Week',
  Cargo_Weight: 'Weight',
  Cargo_WHCode: 'Warehouse-in no.',
  Cargo_WhetherOrNotBroken: 'Damaged?',
  Cargo_WipeOut: 'Wipe out',
  Cargo_WithdrawalAddress: 'Withdrawal Address',
  Cargo_WithdrawalListOfLinkedConsignors: 'Withdrawal List of Linked Consignors',
  Cargo_WithdrawExpense: 'Withdraw Expense',
  Cargo_WONCPPC: 'Write-off no. confirmed, payment procedures completed.',
  Cargo_WORIPCPARO: 'Write-off record incorrect, please close page and re-open.',
  Cargo_WorkSetAfterSearch: 'Work Set after Search',
  Cargo_WriteBack: 'Write Back',
  Cargo_WriteBackVoucher: 'Write-back Voucher',
  Cargo_WriteOff: 'Write off',
  Cargo_WriteOffAll: 'Write off All',
  Cargo_WriteOffAllP: 'Write off all?',
  Cargo_WriteOffAmount: 'Write-off Amount',
  Cargo_WriteOffAmountCNY: 'Write-off Amount(CNY)',
  Cargo_WriteOffAmountIs: 'Write-off Amount is',
  Cargo_WriteOffAmountUSD: 'Write-off Amount(USD)',
  Cargo_WriteOffAR: 'Write off A/R',
  Cargo_WriteOffBalance: 'Write-off Balance',
  Cargo_WriteOffBalanceIs: 'Write-off balance is',
  Cargo_WriteOffCurrency: 'Write-off Currency',
  Cargo_WriteOffDate: 'Write-off Date',
  Cargo_WriteOffDetails: 'Write-off Details',
  Cargo_WriteOffEntry: 'Write-off Entry',
  Cargo_WriteOffFailed: 'Write-off failed,',
  Cargo_WriteOffInputError: 'The expenses selected for write-off contain items of Payment Application Form, write off the items after the Payment Application approval is completed.',
  Cargo_WriteOffList: 'Write-off Details',
  Cargo_WriteOffListPDF: 'WriteoffDetails.pdf',
  Cargo_WriteOffListXLS: 'WriteoffDetails.xls',
  Cargo_WriteOffNo: 'Write-off No.',
  Cargo_WriteOffOfAdvance: 'Write-off of Advance',
  Cargo_WriteOffOrNot: 'Write off or not?',
  Cargo_WriteOffP: 'Write off',
  Cargo_WriteOffPerson: 'Written off by',
  Cargo_WriteOffRate: 'Exchange Rate of Write-off',
  Cargo_WriteOffRecordsNotSelected: 'Write-off Records not Selected.',
  Cargo_WriteOffRemarks: 'Write-off Remarks',
  Cargo_WriteOffReverseWriteOff: 'Write-off / Reverse Write-off',
  Cargo_WriteOffRevokedSuccessfully: 'Write-off revoked successfully.',
  Cargo_WriteOffSerialNumber: 'Serial No. of Write-off',
  Cargo_WriteOffStartingPeriod: 'Write-off Starting Period',
  Cargo_WriteOffStartingPeriodP: 'Write-off Starting Period:',
  Cargo_WriteOffStatus: 'Write-off Status',
  Cargo_WriteOffType: 'Write-off Type',
  Cargo_WriteOffTypeP: 'Write-off Type:',
  Cargo_WrittenOff: 'Written off',
  Cargo_WrittenOff2: 'Written off',
  Cargo_WrittenOffItemsCanTBeModified: 'Written-off items can\'t be modified.',
  Cargo_WrittenOffItemsExist: 'Written-off items exist.',
  Cargo_WrittenOffNotWrittenOff: 'Written off / Not Written off',
  Cargo_WrittenOffSuccessfully: 'Written off successfully',
  Cargo_WrongInvoicingMachineNoEntered: 'Wrong invoicing machine no. entered.',
  Cargo_WroteOff: 'Write off or not?',
  Cargo_WroteOffOrNot: 'Written off or not?',
  Cargo_X10: 'x 10',
  Cargo_X100: 'x 100',
  Cargo_X1000: 'x 1000',
  Cargo_X10000: 'x 10,000',
  Cargo_YadongKingdee: 'Yadong Kingdee',
  Cargo_YesControlled: 'Controlled',
  Cargo_NotControlled: 'Not Controlled',
  Cargo_Year: 'Year',
  Cargo_Years: 'Year',
  Cargo_Yes: 'Yes',
  Cargo_YesLink: 'Yes, link it.',
  Cargo_YesNo: 'Yes/No',
  Cargo_Yuan: 'Yuan',
  Cargo_ContentIsEmpty: 'Content is empty.',
  Cargo_PleaseSelectExpenseToProcess: 'Please select expense to process.',
  Cargo_EditSoa: 'Edit SOA',
  Cargo_InvalidParameterCFR: 'Invalid parameter, can\'t find rule.',
  Cargo_SuccessItemsFailedItems: '{0} items successed, the {1} item failed.',
  Cargo_BADNMOPRTB: '{0}\'s billing agent does not match others, please remove this bill and save.',
  Cargo_IVCNBVPDTORTI: '{0} invoice(s)\'s voucher can not be voided, please delete the voucher(s) or reverse the invoice(s).',
  Cargo_Temp: '-Temp-',
  Cargo_OperationCommission: 'Operation Commission',
  Cargo_CSCommission: 'Customer Service Commission',
  Cargo_ViewPaymentRequest: 'View payment request',
  Cargo_WantToAddThemToTheBill: 'The selected expenses include written off expenses. Do you want to add them to the bill?',
  Cargo_AddAllToTheBill: 'Add all to the bill',
  Cargo_OnlyTheUnwrittenOffExpenses: 'Only the unwritten off expenses are added',
  Cargo_ImportAndQueryOfBillNumber: 'Import and query of bill number',
  Cargo_DebitAmountCN: 'Debit Amount',
  Cargo_CreditAmountCN: 'Credit Amount',
  Cargo_PushMiddleTable: 'Push intermediate table',
  Cargo_IfError: 'Error or not',
  Cargo_ErrorInfo: 'Error message',

  Cargo_AIOCER: 'Amount in Original Currency Exchange Rate',
  Cargo_BalanceInRmb: 'Balance in RMB',
  Cargo_BalanceInUsd: 'Balance in USD',
  Cargo_CanTDeleteInvoicedItems: 'Can\'t delete invoiced items.',
  Cargo_CanTDeleteIssuedInvoice: 'Can\'t delete issued invoice.',
  Cargo_CardAccessControl: 'Card Access Control',
  Cargo_CCTBEVCTBE: 'Client can\'t be empty, vendor can\'t be empty.',
  Cargo_ConfirmAPP: 'Confirm A/P?',
  Cargo_ConfirmBill: 'Confirm Bill',
  Cargo_CreditSideRmb: 'Credit Side (RMB)',
  Cargo_CreditSideUsd: 'Credit Side (USD)',
  Cargo_CurrencyIncompatible: 'Currency incompatible.',
  Cargo_CustomizedField: 'Customized Field',
  Cargo_IssuedUnissued: 'Issued Unissued',
  Cargo_NoExpensesToBeInvoiced: 'No expenses to be invoiced.',
  Cargo_OVICBETGTEI_2: 'Only VAT invoice can be canceled to Golden Taxation E-invoice.',
  Cargo_OWCICGTSEEI_2: 'Only when currency is RMB can Golden Taxation system cancel electronic invoice.',
  Cargo_PleaseSelectAnBillPayment: 'Please select an billPayment.',
  Cargo_PleaseSelectPurchaser: 'Please select purchaser.',
  Cargo_SelectAddPlatformBLMethod: 'Select & add platform B/L method',
  Cargo_SettlingPartyMustBeIdentical: 'Settling party must be identical.',
  Cargo_Space5: 'Half-monthly Settlement',
  Cargo_TARBACTBLTAPAWIETIAR: 'Total A/R billing amount can\'t be less than A/P amount when income & expenditure type is A/R.',
  Cargo_BillNotAllowEditEtowerOne: 'The bill from EtowerOne is not allowed to be processed!',
  Cargo_CanNotRemovedAllCharge: 'Can not remove all charge!',
  Cargo_NoSubmit_SR: 'NoSubmit',
  Cargo_AwaitApproval_SR: 'Await Approval',
  Cargo_Approved_SR: 'Approved',
  Cargo_ModifyFilter: 'Modify Filter',
  Cargo_SaveChanges: 'Save Changes',
  Cargo_SaveAsScheme: 'Save As Scheme',
  Cargo_QueryScheme: 'Query Scheme',
  Cargo_QuerySchemeManagement: 'Query Scheme Management',
  Cargo_SchemeName: 'Scheme Name',
  Cargo_SelectQueryCriteria: 'Select Query Criteria',
  Cargo_ApplicationForm: 'Application Form',
  Cargo_ApprovalHistory: 'Approval History',
  Cargo_AllQueryCriteria: 'All Query Criteria',
  Cargo_MyQueryCriteria: 'My Query Criteria',
  Cargo_DisplayName: 'Display Name',
  Cargo_ConditionalExpression: 'Conditional Expression',
  Cargo_ProcessingDifference: 'Processing Difference',
  Cargo_NotFoundTemplate: 'No corresponding print template was found!',
  Cargo_NoPaymentMethodPermissionOfReconciliation: 'Insufficient privileges, please contact the administrator to configure the rights of Page Check Payment!',
  Cargo_NoFeeTypePermissionOfReconciliation: 'Insufficient permissions, please contact the administrator to configure the permissions for the type of checking fees!',
  Cargo_SearchDataForReconciliation: 'Please query the data before proceeding with the reconciliation!',
  Cargo_ChargeUpdateFailed: 'There are {0} fees modified by others, not updated successfully!',
  Cargo_SaveReconciliationSuccess: 'Saving reconciliation succeeded!',
  Cargo_RemoveAll: 'Delete All',
  Cargo_ViewDeleteChargeDetail: 'View/DeleteChargeDetail',
  Cargo_DeleteAdjustment: 'Delete Adjustment',
  Cargo_PleaseSelectedCancelConfirmCharge: 'Please select the fee to cancel the confirmation',
  Cargo_PleaseSelectedConfirmCharge: 'Please select the fee to be confirmed',
  Cargo_PleaseSelectedBillingDate: 'Please select the billing date!',
  PleaseSelectSplitCharge: 'Please select the fee to be split',
  OnlySelectOneChargeToSplit: 'Only one expense can be selected for splitting!',
  ChargeHasInvoicedOrWriteOff: 'This expense has been invoiced or written off, please select again!',
  NoChargeForSplit: 'There is no actual split cost, please re select!',
  Cargo_exportExcelAll: 'Export all',
  Cargo_PleaseInputKeyWordsForQuery: 'Please input key words for query',
  Cargo_AccountNumber: 'Account',
  Cargo_OwnerBankOfDeposit: 'OwnerBank Of Deposit',
  Cargo_JoinBill: 'Add Bill',
  Cargo_SelectedUnConfirmedCharge: 'Please select the fee to cancel the confirmation!',
  Cargo_NoChargeForSplit: 'There is no actual split cost, please select again!',
  Cargo_InputTaxAmount: 'Please input the price including tax!',
  Cargo_ReconciliationTypeP: 'Reconciliation Type:',
  Cargo_ByFee: 'By Fee',
  Cargo_SelectBill: 'Select Bill',
  Cargo_BillOfType: 'Bill Type:',
  Cargo_BillDateP: 'Bill Date:',
  Cargo_StatementDateP: 'Statement date：',
  Cargo_RegistrationAddress: 'Registration Address',
  Cargo_OriginalCurrency2: 'Original Currency',
  Cargo_ExchangeRate2: 'Exchange rate',
  Cargo_BillRateEmpty: 'Exchange rate of original currency cannot be blank!',
  Cargo_BillCurrencyMore: 'The bill fee currency cannot exceed three',
  Cargo_BillCurrencyEmpty: 'Bill currency cannot be empty!',
  Cargo_SettlementAgentEmpty: 'Settlement agent cannot be empty!',
  Cargo_IncludingTaxAmountZero: 'Price including tax cannot be zero!',
  RequiredAccrueDate: 'please input accue date',
  RequiredCancelDate: 'please input cancel date',
  Cargo_NoChargeForBillPayment: 'There is no fee to create a payment request!',
  Cargo_CancelSpecialApproval: 'Cancel special approval',
  Cargo_LockTheBillTime: 'Lock the bill time',
  Cargo_CreditControlObject: 'Credit control object',
  Cargo_SpecialApprovalTime: 'Special approval time',
  Cargo_SpecialApprovalUser: 'Special approval user',
  Cargo_AmountExceeded: 'Amount Exceeded',
  Cargo_DateExceeded: 'Date Exceeded',
  Cargo_CreditControlInfo: 'Credit control info',
  Cargo_OperateTime: 'Operate time',
  Cargo_DownloadLog: 'Download Log',
  Cargo_Times: 'times',
  Cargo_LockTheBillDate: 'Lock the bill date',
  Cargo_SpecialApprovalDate: 'Special approval date',
  Cargo_OperateDate: 'Operate Date',
  Cargo_LockTheBillUser: 'Lock the bill user',
  Cargo_sono: 'SoNo',
  Cargo_pono: 'PO.No.',
  Cargo_PolAir: 'POL (air)',
  Cargo_keyWordsTip: 'Please enter keywords',
  Cargo_sopDoubleClickTip: 'Double-click the text box to select the node status query.',
  Cargo_NewQueryScheme: 'New query scheme',
  Cargo_TheQueryItemSelected: 'The query item [{0}] has been selected',
  Cargo_SchemeSaveSuccess: 'Scheme Saves Success',
  Cargo_BillLogManagement: 'Bill of lading log management',
  Cargo_ModifyContent: 'Modify content',
  Cargo_CheckPermission: 'You don‘t have permission to view the business!',
  Cargo_CheckBusinessType: 'Please select the same business type',
  Cargo_MasterChargeWhetherShareOrNot: 'Master charge whether share or not',
  Cargo_DepartmentPrefixNotSelected: 'Settle Department not Selected',
  Cargo_SalesIsEmpty: 'Current customer sales is empty, cannot sign!',
  Cargo_Distribution: 'distribution',
  Cargo_SalesNotSelected: 'Sales not selected!',
  Cargo_ReviewedByLeader: 'Assigned, this customer will be reviewed by the original team leader:',
  Cargo_AllocationSucceeded: 'Allocation succeeded！',
  Cargo_FormerGroupLeader: 'Former group leader',
  Cargo_ChineseNameIsEmpty: 'The Chinese name of the customer is empty!',
  Cargo_OriginalTeamLeaderIsEmpty: 'The name of the original team leader is empty！',
  Cargo_DoNotOperate: 'It is forbidden to operate on current customers. Please contact the sales manager for solution!',
  Cargo_RestoreCurrentCustomer: 'Are you sure you want to restore the current customer?',
  Cargo_CustomerInformationIsEmpty: 'Customer information is empty!',
  Cargo_CannotBeDeleted: 'The customer has been used by the business and cannot be deleted!',
  Cargo_DeleteSuccessfully: 'Delete successfully, the customer is moved to the customer recycle bin!',
  Cargo_AreYouSureDelete: 'Are you sure you want to delete it?',
  Cargo_PleaseSelectForDelete: 'Please select the customer you want to delete!',
  Cargo_ChineseNameAlreadyExists: 'Chinese name already exists',
  Cargo_EnglishNameAlreadyExists: 'English name already exists',
  Cargo_ChineseOrEnglishAlreadyExists: 'Chinese name or English name already exists',
  Cargo_ContactPersonToFillInA: 'Fill in at least one contact person of the customer！',
  Cargo_PleaseInvoicingRequirementsTab: 'Please fill in the currency requirements in the Invoicing Requirements tab!',
  Cargo_SignOrNot: 'Sign or not',
  Cargo_DangerousChemicals: 'Dangerous chemicals',
  Cargo_DaysNotFollowedUp: 'Days not followed up',
  Cargo_CustomerNotSelected: 'Customer not selected!',
  Cargo_AssignedClientsSuccessfully2: '{0} customers assigned',
  Cargo_examine: 'The customer is to be reviewed by the original team leader',
  Cargo_CreateSource: 'Create Source',
  Cargo_Tenant: 'Tenant',
  Cargo_Platform: 'Platform',
  Cargo_DistributionSales: 'Customer successfully assigned sales',
  Cargo_MoreThan1Year: 'More than 1 year',
  Cargo_list: 'list',
  Cargo_MyClients: 'My clients',
  Cargo_CustomersInThisGroup: 'Customers in this group',
  Cargo_CustomerRecycleBin: 'Customer recycle bin',
  Cargo_PleaseSelectTheCustomerToExport: 'Please select the customer to export!',
  Cargo_city: 'city',
  Cargo_email: 'email',
  Cargo_add: 'add',
  Cargo_Append: 'Append',
  Cargo_PSCF: 'Please select the contact first!',
  Cargo_NCS: 'No contact selected!',
  Cargo_CNATCBE: 'Contact name and telephone number cannot be empty!',
  Cargo_ERF: 'Error removing file!',
  Cargo_FDS: 'File deleted successfully!',
  Cargo_AYSDF: 'Are you sure you want to delete the file?',
  Cargo_PSAEF: 'Please select an event first',
  Cargo_theme: 'theme',
  Cargo_FTMFT: 'Failed to modify file type',
  Cargo_EventStatus: 'event Status',
  Cargo_TaskTime: 'task time',
  Cargo_CustomerChineseName: 'Chinese name of customer',
  Cargo_CustomerEnglishName: 'English name of customer',
  Cargo_NextTask: 'The next step task',
  Cargo_RWSR: '{0} record was successfully rejected',
  Cargo_isActive: 'Activated',
  Cargo_OverdueLimit: 'Overdue Limit',
  Cargo_OverdueDays: 'Overdue Days',
  Cargo_Enable: 'Enable',
  Cargo_Disable: 'Disable',
  Cargo_EnableStatus: 'Enable status',
  Cargo_Enabled: 'Enabled',
  Cargo_Disabled: 'Disabled',
  Cargo_amount: 'Amount',
  Cargo_HasChosen: 'Has Chosen',
  Cargo_RemoveToBlackList: 'Remove BlackList',
  Cargo_SureToRemoveToBlackList: 'Sure to remove to black list?',
  Cargo_Flight: 'Flight',
  Cargo_OutstandingAmount: 'Outstanding amount (expense)',
  Cargo_WriteOffAmountCharge: 'Write off amount (expense)',
  Cargo_ReceivableExcludingTax: 'Receivable excluding tax (invoice)',
  Cargo_TaxIncludedReceivable: 'Receivable tax included (invoice)',
  Cargo_PayableExcludingTax: 'Payable excluding tax (invoice)',
  Cargo_TaxPayable: 'Tax payable (invoice)',
  Cargo_TotalExcludingTax: 'Tax payable (invoice)',
  Cargo_TotalTaxIncluded: 'Total invoice (tax included)',
  Cargo_PleaseEnterBoxTypeOrBoxType: 'Please enter box type or box type!',
  Cargo_EffectiveDateMustBeLessThanTheExpirationDate: 'The effective date must be less than the expiration date',
  Cargo_MaintenanceOfExpenseDetails: 'Maintenance of expense details',
  Cargo_CustomerQuickSearch: 'Quick search: Customer Chinese name / English name',
  Cargo_WechatAccount: 'Wechat Account',
  Cargo_Download: 'Download',
  Cargo_ChineseNamed: 'Chinese Name',
  Cargo_EnglishNamed: 'English Name',
  Cargo_SignContractTip: 'An enterprise with a similar name already exists in the partner module, do you need to associate it?',
  Cargo_SignContractTipYes: 'Yes, I want to connect',
  Cargo_SignContractTipNo: 'No, I do not want a connection.',
  Cargo_CooperationStage: 'Cooperation Stage',
  Cargo_Financial_Year: 'Financial year',
  Cargo_ConfirmCloseWindow: 'Are you sure to close the window?',
  Cargo_NoteUpdatedSuccessfully: 'Note Updated Successfully',
  Cargo_PleaseSelectAPieceOfData: 'Please select a piece of data.',
  Cargo_SelectDataIsNotAuditState: 'Only businesses that are temporarily not submitted for pre-approval status are supported. Please check again.',
  Cargo_SelectDataIsNotSubmittedTemporarilyOrRejectState: 'Only businesses with a pre-approval status of not yet submitted or rejected are supported. Please check again.',
  Cargo_SelectAtLeastOneRecord: 'Please select at least one record',
  Cargo_FieldDisplay: 'Field display',
  Cargo_ControlSelection: 'Control selection',
  Cargo_EnumValue: 'Enum value',
  Cargo_StatusIsNotPending: 'Status is not pending.',
  Cargo_NotSubmittedAndRejectedStatusTips: 'Not submitted and rejected status tips.',
  Cargo_subimitPreStatusTips: 'Subimit pre status tips？',
  Cargo_TransitCannotBeNull: 'Transit port cannot be empty',
  Cargo_TheClientDoesNotBelongToYourCustomerTips: 'The client does not belong to your customer tips',
  Cargo_ThereAreBargesTips: 'There are barges, please input the closing date of barges',
  Cargo_ClosingDateCannotBeGreaterThanTheSailingDate: 'Closing date cannot be greater than the sailing date',
  Cargo_ClosingDateOfBargeTips: 'The closing date of barge cannot be greater than the closing date',
  Cargo_CurrentAccount: 'Current account',
  Cargo_BusinessNoAndChargeName: 'BusinessNo/Expense Description',
  Cargo_BusinessNum: 'Business Number',
  Cargo_UploadTime: 'Upload Time',
  Cargo_Finished: 'finished',
  Cargo_OperationRequirement: 'Operating Requirements',
  Cargo_measurements: 'Size cm (length * width * height * number of pieces)',
  Cargo_VoucherLineNumberSetting: 'Voucher LineNumber Setting',
  Cargo_VoucherLine: 'Voucher Line',
  Cargo_UseRmbEntrytypeByInvoice: 'Is the invoice voucher entry for [original currency amount] directly taken from [functional currency amount], with an exchange rate of 1',
  Cargo_UseRmbEntrytypeByInvoiceTip: '(Separated by ",": 1=accounts receivable 3=accounts payable 5=operating revenue 7=operating costs)',
  Cargo_UseRmbEntrytypeByFact: 'Is the entry in the receipt/payment voucher directly taken from the original currency amount and the exchange rate 1',
  Cargo_UseRmbEntrytypeByFactTip: '(Separated by ",": 1=accounts receivable 3=accounts payable 73=accounts payable (personal) 40=account receivable (merge) 41=account payable (merge) 42=revenue (merge) 43=cost (merge))',
  Cargo_UseRmbEntrytypeByPre: 'Is the pre payment voucher entry for [original currency amount] directly taken from [functional currency amount], with an exchange rate of 1',
  Cargo_UseRmbEntrytypeByPreTip: '(Separated by ",": 1=accounts receivable 3=accounts payable 26=advance receipts 44=advance payments)',
  Cargo_Note: 'Note',
  Cargo_ChooseEdiTemplate: 'Please Choose Edi Template',
  Cargo_OperatedFailed: 'Operation failed',
  Cargo_SelectPurchaseRecord: 'Select Purchase Record.',
  Cargo_SelectAcquiredRecord: 'Select Acquired Record.',
  Cargo_CheckInvoiceInvalidState: 'The current selection contains invalid or used invoice numbers.',
  Cargo_CheckInvoiceUsedState: 'No invoice selected or no used status selected.',
  Cargo_InvoiceRestoreSuccessfully: 'Invoice recovered successfully.',
  Cargo_CheckInvoiceRestoreState: 'The current selection contains an invoice number that is not invalid.',
  Cargo_ConfirmRestoreInvoice: 'Are you sure you want to restore the invalid invoice?',
  Cargo_InvoiceInvalidSuccessfully: 'Invoice invalidated successfully?',
  Cargo_CheckInvoiceType: 'Inconsistent invoice types.',
  Cargo_CheckInvoiceRecipientState: 'The current selection contains used records.',
  Cargo_LocalAmount: 'Local',
  Cargo_SourceAmount: 'Source',
  Cargo_DebitAmountOccurredLocal: 'Debit Amount Occurred(Local)',
  Cargo_DebitAmountOccurredSource: 'Debit Amount Occurred(Source)',
  Cargo_CreditAmountOccurredLocal: 'Credit Amount Occurred(Local)',
  Cargo_CreditAmountOccurredSource: 'Credit Amount Occurred(Source)',
  Cargo_hidePop: 'Hide Total',
  Cargo_dispPop: 'Disp Total',
  Cargo_SchemeUserTips: 'Note: The user\'s fee plan is maintained, which is only applicable to users in the following list',
  Cargo_NoDataCanBeModified: 'No data can be modified.',
  Cargo_BalanceLocal: 'Balance(Local)',
  Cargo_BalanceSource: 'Balance(Source)',
  Cargo_DebitAmountLocal: 'Debit Amount(Local)',
  Cargo_DebitAmountSource: 'Debit Amount(Source)',
  Cargo_DebitSideLocal: 'Debit Side (Local)',
  Cargo_DebitSideSource: 'Debit Side (Source)',
  Cargo_CreditAmountLocal: 'Credit Amount(Local)',
  Cargo_CreditAmountSource: 'Credit Amount(Source)',
  Cargo_BatchUpload: 'Batch Upload',
  Cargo_PleaseSelectBusinessData: 'Please select the business data to match the file name',
  Cargo_DocumentsBack: 'Documents Back',
  Cargo_CanNotWriteOffForDifferentExpenseTypes: 'Domestic And Foreign Expenses Cannot Be Written Off At The Same Time!',
  Cargo_VehicleRequestForm: 'Use Car Application Form',
  Cargo_VehicleOrder: 'Car Form',
  Cargo_BatchGenerateVehicleOrder: 'Batch Generate Car Form',
  Cargo_VehicleRequestFormNo: 'Car Application Form No.',
  Cargo_PickUpDelivery: 'Pickup/Delivery',
  Cargo_EstimatedPickUpDate: 'Estimated Pickup Date',
  Cargo_Port2: 'Port',
  Cargo_VehicleOrderNo: 'Car Form No.',
  Cargo_VehicleTime: 'Departure Time',
  Cargo_CancelVehicleOrder: 'Cancel Vehicle Order',
  Cargo_VehicleDispatched: 'Vehicle Dispatched',
  Cargo_CancelVehicleStatus: 'Cancel Vehicle Status',
  Cargo_CancelCompletedStatus: 'Cancel Completed Status',
  Cargo_StatusUpdateRecord: 'Status Update Record',
  Cargo_UpdateVehicleOrderStatus: 'Update Vehicle Order Status',
  Cargo_CancelCondition: 'Vehicle order can only be canceled when the status is "Not Dispatched"',
  Cargo_ConfirmCancelVehicleOrder: 'Confirm cancel vehicle order?',
  Cargo_SelectNotDispatched: 'Please select a vehicle order with "Not Dispatched" status to proceed.',
  Cargo_SelectDispatched: 'Please select a vehicle order with "Dispatched" status to proceed.',
  Cargo_SelectStatusConsistent: 'The status of the selected vehicle orders must be consistent.',
  Cargo_VehicleOrderCompleted: 'The vehicle order status has been completed.',
  Cargo_SelectCompleted: 'Please select a vehicle order with "Completed" status to proceed.',
  Cargo_CompletionTimeNotEarlierThanDispatchTime: '"Completion time" cannot be earlier than "Dispatch time"',
  Cargo_ActualPickupDate: 'Actual Pickup Date',
  Cargo_DispatchTaskLinkedToVehicle: 'The dispatch task has been linked to a vehicle order and cannot be deleted. Unbind first before making changes.',
  Cargo_DispatchTaskLinkedToVehicle_ArrivalMethod: 'The dispatch task has been linked to a vehicle order and the "Arrival Method" cannot be modified. Unbind first before making changes.',
  Cargo_DispatchTaskLinkedToVehicle_DestinationPort: 'The dispatch task has been linked to a vehicle order and the "Destination Port Dispatch" cannot be canceled. Unbind first before making changes.',
  Cargo_Port_Airport: 'Port (Airport)',
  Cargo_VehicleRequestDifferentPorts: 'The vehicle request order belongs to different ports. Should it be merged and generated?',
  Cargo_VehicleOrderGeneratedSuccess: 'Vehicle order generated successfully',
  Cargo_VehicleOrderSerialNumber: 'The vehicle order serial number is',
  Cargo_BusinessCreationTime: 'Business creation time',

  Cargo_CurrencyMustBeTheSame: 'Currency Must Be The Same！',
  Cargo_AccountContacts: 'Account Contacts',
  Cargo_AccountAddr: 'Account Address',
  Cargo_AccountContactsTel: 'Contact Telephone',
  Cargo_CustomsDeclarationInformationOujian: 'Customs declaration information （Currently, the customs clearance mode of special regulatory areas is not supported）',
  Cargo_ChargeSubmit: 'Whether the fee is submitted',
  Cargo_ContractRatePropertySE: 'S/C Rate Category (SE)',
  Cargo_ContractRatePropertySI: 'S/C Rate Category (SI)',
  Cargo_TaxRevenueShortName: 'Product Code',
  Cargo_TaxRevenueName: 'Product Shortname',
  Cargo_TaxRevenueToolTip: 'Note:[Product Code] is China national tax Code, Eg: 3040802010200000000. [Product Shortname] is the corresponding shortname, Eg: Brokerage and agency services',
  Cargo_CargoSourceTip: 'Whether to switch the purchase type to [{0}]?',
  Cargo_AccountingMonthMaintain: 'Financial monthly maintenance',
  Cargo_FclApproximatePrice: 'FCL Approximate price',
  Cargo_LclApproximatePrice: 'LCL Approximate price',
  Cargo_AddContractNo: 'Add an appointment number',
  Cargo_Income20: '20\' adjustment',
  Cargo_Income40: '40\' adjustment',
  Cargo_Income40HC: '40HC\' adjustment',
  Cargo_Income45: '45\' adjustment',
  Cargo_WeightPriceAdjust: 'Weight Price adjustment',
  Cargo_CubagePriceAdjust: 'Cubage Price adjustment',
  Cargo_MinimumPriceAdjust: 'Minimum Price adjustment',
  Cargo_GrossMargin: 'Gross margin',
  Cargo_IncorrectExpenseStatus: 'Incorrect expense status!',
  Cargo_ExpenseStatusModifiedSuccessfully: 'Expense status modified successfully!',
  Cargo_DestinationSelection: 'Destination selection',
  Cargo_AciPortCode: 'Aci Port Code',
  Cargo_InlandLocation: 'Inland Location',
  Cargo_SubLocationCode: 'Sub Location Code',
  Cargo_DeleteBillTips: 'Only unconfirmed bills with no generated bill number can be deleted!',
  Cargo_ForceDeleteBillTips: 'Only bills in unconfirmed, confirmed, printed and voided status can be deleted!',
  Cargo_ConfirmDeleteCategoryAndType: 'Are you sure you want to delete the selected category and type?',
  Cargo_RangeAndGE: 'Range(≥)',
  Cargo_RangeAndLT: 'Range(<)',
  Cargo_FinancialDateCheckNull: 'Financial date cannot be blank !',
  Cargo_CurrencyCheckNull: 'Currency cannot be blank !',
  Cargo_FinancialDateCheckBefore: 'The selected date cannot be later than the current date!',
  Cargo_OperatingCompanyCannotBeEmpty: 'The operating company cannot be empty!',
  Cargo_DeliveryCannotBeNull: 'The delivery cannot be null!',
  Cargo_DesignatedCannotBeNull: 'The designated cannot be null!',
  Cargo_SalesCannotBeEmpty: 'The sales cannot be empty!',
  Cargo_ItemNumberCannotBeEmpty: 'The item number cannot be empty!',
  Cargo_PleaseSelectLoadingPort: 'Please select loading port!',
  Cargo_PleaseChooseTheDestinationPort: 'Please choose the destinationPort!',
  Cargo_UserManagement: 'User management',
  Cargo_Search2: 'Search',
  Cargo_RecordAmount: 'Record amount',
  Cargo_RoleUserSettings: 'Role user settings',
  Cargo_SystemAdministrator: 'System administrator',
  Cargo_UserCode: 'User code',
  Cargo_UserDepartment: 'User department',
  Cargo_UserCompany: 'User company',
  Cargo_IncludingElectricitySupplierAccount: 'Including Electricity supplier account',
  Cargo_ValidOrNot: 'Valid or not',
  Cargo_Valid: 'Valid',
  Cargo_Invalid2: 'Invalid',
  Cargo_LoginName: 'Login name',
  Cargo_MobilePhoneNo: 'Mobile phone No',
  Cargo_PasswordExpirationDate: 'Password expiration date',
  Cargo_NetworkManagementCode: 'Network management code',
  Cargo_Superior: 'Superior',
  Cargo_OfficeAndDep: 'Branch/Department',
  Cargo_ConfirmBatchModifyUser: 'Batch replacement of checked data corresponding to [{0}]',
  Cargo_BatchModifyUserSucceed: 'Successfully modified {0} transfer data [{1}] to [{2}]',
  Cargo_ExternalAssociationCode: 'External Association Code',
  Cargo_ExternalAssociationCodeValidMessage: 'External association code can only be letters or numbers',
  Cargo_Activation: 'Activation',
  Cargo_ElectricitySupplierAccountOrNot: 'E-commerce account',
  Cargo_SystemAdministratorOrNot: 'System Administrator',
  Cargo_BatchModify: 'Batch Edit',
  Cargo_TheCompanyToWhichTheAccountBelongs: 'Account ownership',
  Cargo_EditPermission: 'Edit permission',
  Cargo_AddUser: 'Add user',
  Cargo_DeleteUser: 'Delete user',
  Cargo_RemoveUser: 'Remove User',
  Cargo_Filter2: 'Filter',
  Cargo_Import2: 'Import',
  GOODS_INFO_IMPORT: 'Goods info import',
  Cargo_ContinueToCreate: '{0} This partner has been maintained under, continue to create?',
  Cargo_AssignRolesToUsers: 'Assign roles to users',
  Cargo_SelectARangeOfUsers: 'Select a range of users',
  Cargo_NotSubmittedOrRejectedTips: 'Only businesses that are not submitted or rejected can be deleted. Please select again',
  Cargo_SelectedMoreThenNPieces: 'The data you selected has exceeded the limit of {0}, please select again',
  Cargo_SmallTicketCannotBeRemoved: ' The small ticket contains apportioned expenses and cannot be removed.',
  Cargo_invoiceNotInconsistent: 'Invoice type and invoice type are inconsistent. Continue?',
  Cargo_OnlyBillsWithBillingNumbersCanBeSubmitted: 'Only bills with billing numbers can be submitted.',
  Cargo_SureDoThis: 'Are you sure you want to do this?',
  Cargo_BillHasBeenSubmitted: 'Bill [{0}] has been submitted.',
  Cargo_BillWasNotSubmitted: 'Bill [{0}] not submitted status.',
  Cargo_OnlyBillsWithBillingNumbersCanBeWriteOff: 'Only bills with billing numbers can be write off',
  Cargo_BillsHasBeenPaidInFull: 'The bill {0} has been paid in full and cannot be cancelled again.',
  Cargo_NotAllowWriteOffFee: 'Among the fees to be written off, there are fees payable that have not been requested for payment or the payment application process has not been completed, and cancellation is not allowed.',
  Cargo_BillsAlreadyWriteOffFee: 'The bill {0}  has been written off and cannot be returned.',
  Cargo_RevokeAll: 'Revoke all',
  Cargo_ConfirmAndNotityHQ: 'Confirm and notify headquarters?',
  Cargo_AllBillingHasBeenSentToBranches: 'All currently selected billing objects have been sent to branches.',
  Cargo_Sender: 'sender',
  Cargo_SendDate: 'EDI date',
  Cargo_VersionNo: 'version',
  Cargo_BookingLog: 'Booking Log',
  Cargo_BookingSubscribe: 'Subscribe',
  Cargo_BookingSubscribeSync: 'Sync Data',
  Cargo_BookingSubscriptionStatus: 'Subscription Details',
  Cargo_SubscribeDataType: 'Data Type',
  Cargo_SubscribeStatus: 'Subscription Status',
  Cargo_BatchUpdateExchangeRate: 'Batch Update ExchangeRate',
  Cargo_UpdateExchangeRate: 'Update ExchangeRate',
  Cargo_SelectAccountAndCurrency: 'Please select a settlement object and currency to modify the exchange rate:',
  Cargo_InputRate: 'Enter exchange rate:',
  Cargo_ConfirmUpdateExchangeRate: 'Are you sure to update the exchange rate?',
  Cargo_PleaseInputRate: 'Please enter the exchange rate to be changed!',
  Cargo_PleaseSelectAccountAndCurrency: 'Please select the settlement object / currency whose exchange rate needs to be changed!',
  Cargo_ValidateUpdateRateTips: 'Operation failed. The settlement unit / currency of the exchange rate updated this time is not in the selected business!',
  Cargo_UpdateRateConfirmTipsHead: 'Batch update exchange rates include generation ',
  Cargo_UpdateRateConfirmTipsTail: 'This time, only the exchange rate of the original fee is updated, and the data cannot be recovered after modification. Do you want to continue?',
  Cargo_BillVoidTipForState: 'Bills can only be voided in unconfirmed status!',
  Cargo_BillVoidTipForReview: 'Bills can only be voided in unchecked status!',
  Cargo_DuplicatedCode: 'Duplicated Code.',
  Cargo_billPaymentNo: 'BillPayment No',
  Cargo_RangeSmaller: 'Make Sure Range Smaller',
  Carge_ConfirmDate: 'Confirm Date',
  Carge_ConfirmUser: 'Confirm User',
  Carge_BillingConfirmDate: 'Billing Confirm Date',
  Carge_BillingConfirmUser: 'Billing Confirm User',
  Carge_BillingGroupConfirmDate: 'Billing Group Confirm Date',
  Carge_BillingGroupConfirmUser: 'Billing Group Confirm User',
  Carge_ChinessNameExist: 'Chinese Name Already Exists, Please Modify',
  Carge_EnglishNameExist: 'English Name Already Exists, Please Modify',
  Cargo_Dep: 'Entry department',
  Cargo_SyncFinanceCode: 'This will write the partner code into the customer supplier code. Continue?',
  Cargo_SyncFinanceCodeSuccess: 'Write the partner code into the customer supplier code successfully',
  Cargo_contactInformationCopy: 'Contact information - copy of DOC No',
  Cargo_contactInformationCode: 'Contact information - code retrieval',
  Cargo_auditResult: 'Audit Result',
  Cargo_number: 'number',
  Cargo_PlatformCode2: 'Platform code',
  Cargo_InterchaneeCode: 'Interchange code',
  Cargo_abbreviation: 'abbreviation',
  Cargo_TemplateDescribe: 'Template Describe',
  Cargo_Describe: 'Describe',
  Cargo_BillingHeaderName: 'Billing header name',
  Cargo_EnglishNameOfBank: 'English name of bank',
  Cargo_ContactName: 'Contact Name',
  Cargo_TenantID: 'Tenant ID',
  Cargo_AppendQuery: 'Append Query',
  Cargo_CollapseList: 'Collapse List',
  Cargo_SetAsDefault: 'Set as default',
  Cargo_MultipleWorkNoEnter: 'Please enter multiple work numbers with enter',
  Cargo_DeleteConfirm: 'The data will not be recoverable after deletion. Do you want to continue?',
  Cargo_EachPage: 'each page',
  Cargo_DataBar: ' Data bar',
  Cargo_ClientNumberMaintenance: 'Client Number Maintenance',
  Cargo_BillingPointCode: 'Billing Point Code',
  Cargo_UseDepartment: 'Use Department',
  Cargo_CanNotEmpty: 'Can Not Empty！',
  Cargo_CanNotRepeat: 'Can Not Repeat！',
  Cargo_BeforeCurrentDisplay: 'Before current display ',
  Cargo_ReceivableChargeInput: 'Whether fees receivable are recorded or not',
  Cargo_CostChargeInput: 'Whether the fees payable are recorded or not',
  Cargo_ConvertToCnyAr: 'Receivable: converted to RMB',
  Cargo_ConvertToCnyAp: 'Payable: converted to RMB',
  Cargo_FeeModifier: 'Fee modifier',
  Cargo_FeeModifyDate: 'Cost modification time',
  Cargo_SoNoChangeTips: 'If the quantity of the customs clearance doc No. is changed, do you want to refresh the original expense based on the customs clearance doc No?',
  Cargo_EditSaleInfo: 'Sales information adjustment',
  Cargo_PleaseSelectChargeApplyData: 'Please select charge application data.',
  Cargo_PleaseSelectExportChargeDetailData: 'Please tick the application record and try again',
  Cargo_BeyondMaxExportChargeDetailData: 'Export application records cannot exceed 5000, please select again',
  Cargo_ExportChargeDetailDataSucceed: 'Export details successful',
  Cargo_NotSameEtd: 'The departure date and month of the checked business are inconsistent!',
  Cargo_BatchModifyJobNoMore: 'The business number of a single batch modification cannot exceed 100!',
  Cargo_BatchModifyJobNoSuccess: 'Batch modification succeeded: {0}',
  Cargo_VolumeIsChanged: 'If the actual volume is changed, do you want to refresh the original cost in volume price?',
  Cargo_DealingsCustomer: 'Dealings by Customer',
  Cargo_AllowsExceptionProofExport: 'Allows exception certificate exports to be skipped',
  Cargo_ChargeChanger: 'Expense Changer',
  Cargo_ChargeCreadBy: 'Expense Creator',
  Cargo_DeleteData: 'Data has been deleted',
  Cargo_MasterTicketShareCharge: 'The cost of the main ticket has been apportioned. Please reallocate the cost for the new ticket.',
  Cargo_CreateBillNo: 'Generate bill number',
  Cargo_CalcShareAmount: 'Calculate the allocation amount',
  Cargo_CalcShareAmountTip: 'Please click the Calculate Allocation Amount button to recalculate and confirm.',
  Cargo_CancelOrder: 'Successfully cancelled {0} orders, failed to cancel {1} orders. Only orders in the active operation status can be cancelled.',
  Cargo_CancelOrderTip1: 'The following orders cannot be cancelled. Do you want to continue?',
  Cargo_CancelOrderTip2: 'This order has left the port and has a trunk line business number. It cannot be cancelled',
  Cargo_CancelOrderTip3: 'This order has left the port and cannot be cancelled',
  Cargo_CancelOrderTip4: 'This order has a trunk business number and cannot be cancelled',
  Cargo_CancelOrderTip5: 'Do you want to cancel this {0} order in batch?',
  Cargo_CancelOrderTip6: 'Cancellation Of Order',
  Cargo_CancelOrderTip7: 'This is for submitting {0} orders. The following orders cannot be cancelled. Do you want to continue?',
  Cargo_CancelOrderTip8: 'The order status is {0} and cannot be cancelled',
  Cargo_Reason: 'Reason',
  Cargo_PushResultLog: 'Push Result Log',
  Cargo_SendContent: 'Send Content',
  Cargo_ResultSuccess: 'Result Status',
  Cargo_ResultMessage: 'Result Message',
  Cargo_DesignatedCargoWarehouseNo: 'When designating cargo, the warehouse entry number is equal to the business reference number.',
  Cargo_SelfCargoWarehouseNo: 'When self-handling cargo, the warehouse entry number is equal to the business reference number.',
  Cargo_BusinessMark: 'business marking',
  Cargo_ModifyBusiness: 'Modify and regenerate business',
  Cargo_SelectJobNo: 'Please select a business number',
  Cargo_ClosingRecord: 'Closing record',
  Cargo_ClosingAudit: 'Closing audit',
  Cargo_AccountKeeper: 'Closing account personnel',
  Cargo_ClosingMonth: 'Closing account month',
  Cargo_ClosingBranch: 'Closing account subsidiary',
  Cargo_AccountClosingType: 'Closing account type',
  Cargo_ClosingDate: 'Closing Date',
  Cargo_FinancialClosing: 'Financial closing',
  Cargo_BusinessClosing: 'Business closing',
  Cargo_SelectClosingDate: 'Select closing date',
  Cargo_SelectDeleteTip: 'Please select the template information you want to delete.',
  Cargo_SelectDeleteTip2: '{0} is in use and cannot be deleted.',
  Cargo_SelectDeleteTip3: 'Are you sure you want to delete the selected configuration? After deletion, the interface will no longer return data.',
  Cargo_SameCurrencyForMultipleRecord: 'Please check the actual receipt and payment records in the same currency to write off!',
  Cargo_SamePayReceiveDateForMultipleRecord: 'Please choose the same receipt and payment date as the actual receipts and payments.',
  Cargo_DefaultTaxRete: 'Default Tax Rate',
  Cargo_TaxRateRange: 'Tax rate range',
  Cargo_TaxRateRangeLimit: '{0}, the current tax rate is not available. Please verify and if necessary, contact your supervisor to maintain the available tax rate for this expense!',
  Cargo_BargeETD: 'Barge ETD',
  Cargo_DataModifyDate: 'Data Change Time',
  Cargo_sendOcOrder: 'Send OcOrder',
  Cargo_sendOcTracking: 'Send OcTracking',
  Cargo_sendOcFile: 'Send OcFile',
  Cargo_sendOcBilling: 'Send OcBilling',
  Cargo_chargeUpdater: 'Cost update personnel',
  Cargo_WriteOffForMultipleRemainTipAr: 'The paid in amount selected this time is insufficient. It is recommended to modify the write off amount this time!',
  Cargo_SharedChargeRecord: 'Shared Charge Record',
  Cargo_ExcludingTaxAmount: 'Excluding TaxAmount',
  Cargo_IncludedTaxAmount: 'Included TaxAmount',
  Cargo_ShareScheme: 'Share Scheme',
  Cargo_ChargeSyncStatus: 'Charge synchronization status',
  Cargo_ChargeSyncConfirmStatus: 'Charge synchronization confirm status',
  Cargo_WriteOffForMultipleRemainTipAp: 'The selected payment amount is insufficient. It is recommended to modify the current write off amount!',
  Cargo_GroupScene: 'Group Scene',
  Cargo_GroupName: 'Group Name',
  Cargo_GroupType: 'Group Type',
  Cargo_CcPerson: 'Cc Person',
  Cargo_UpdatePerson: 'Renewed person',
  Cargo_Common: 'Common',
  Cargo_Personal: 'Personal',
  Cargo_ReleasePerson: 'Release Person ',
  Cargo_MailGroupType: 'Please select at least one type.',
  Cargo_MailGroupName: 'Please enter a group name.',
  Cargo_MailGroupEmail: 'Please enter at least a email address.',
  Cargo_MailGroupCheckEmail: 'Please check the entered message format.',
  Cargo_MailGroupDelete: 'The deletion cannot be undone. Are you sure you want to delete the data?',
  Cargo_ChargeRate: 'Charge Rate',
  Cargo_BillingRate: 'Billing Rate',
  Cargo_GroupChargeRate: 'Group Charge Rate',
  Cargo_BranchRate: 'Branch Rate',
  Cargo_EnabledChildOffice: 'The current exchange rate is effective for subordinate subsidiaries',
  Cargo_ShowParentRateOffice: 'Application: {0} exchange rate',
  Cargo_SetEnabledChild: 'Setting up subsidiaries to take effect',
  Cargo_SetEnabledChildDialog: 'Set effective for subordinate subsidiaries',
  Cargo_SetEnabledChildCheckbox: 'Effective for subordinate subsidiaries',
  Cargo_CopyOfficeRate: 'Copy branch exchange rate',
  Cargo_CopyHqRate: 'Copy the group exchange rate',
  Cargo_ConfirmCopyBillingRateTip: 'Overwrite existing data?',
  Cargo_Cover: 'Cover',
  Cargo_NotCover: 'Not overwrite',
  Cargo_PleaseSelectExportData: 'Please select the data you want to export!',
  Cargo_UploadRateTip: 'The uploaded file can only be in XLS or xlsx format!',
  Cargo_UploadDataSizeMore: 'File size cannot be greater than 2MB!',
  Cargo_UploadDataFailed: 'Import failed, please contact the administrator!',
  Cargo_UploadFailedCheckExcel: 'Import failed, please contact the administrator!',
  Cargo_ValidateUploadRateTip1: 'The original currency value is {0}, and the benchmark currency value is {1}, which is duplicate with other data in Excel!',
  Cargo_ValidateUploadRateTip2: 'The original currency value is {0} and the benchmark currency value is {1}, which is duplicate with the existing data in the table!',
  Cargo_ValidateUploadRateTip3: 'The data is duplicate with the existing data in the table!',
  Cargo_DefaultReceivableMode: 'Default receivable mode',
  Cargo_DefaultReceivableRate: 'Default receivable rate',
  Cargo_SecondReceivableRate: 'Second receivable rate',
  Cargo_ChargeableAmountInterval: 'Chargeable amount interval',
  Cargo_ReceivableIntervalType: 'Receivable interval type',
  Cargo_DefaultUnitPrice: 'Default unit price',
  Cargo_DefaultRate: 'Default rate',
  Cargo_Suit: 'Suit',
  Cargo_DefaultPayableMode: 'Default payable mode',
  Cargo_DefaultPayableRate: 'Default payable rate',
  Cargo_SecondRatePayable: 'Second rate payable',
  Cargo_PayableAmountInterval: 'Payable amount interval',
  Cargo_PayableIntervalType: 'Payable interval type',
  Cargo_EDIFileType: 'EDI file type when sending(UploadFileSuffix)',
  Cargo_MarkOrCargoEnglishNameChangeTip: 'The basic tab {0} has been changed. Refresh the bill of lading tab data?',
  Cargo_ShareChargeCheckCurrency: 'The currency of cost sharing and the direction of receipt and payment should be consistent.',
  Cargo_ShareChargeCheck: 'The sum of the shared expenses of the receipt is not equal to the original expenses!',
  Cargo_PleaseSelectedSalesForCustomer: 'Please maintain the corresponding sales of customers!',
  Cargo_PleaseSelectServicePersonnel: 'Please maintain the corresponding service personnel!',
  Cargo_PleaseSelectedLevelForCustomer: 'Please maintain the corresponding customer level for the customer!',
  AutomaticReconciliation: 'Automatic reconciliation',
  AutomaticReconciliationHistory: 'Automatic reconciliation history',
  CheckHistory: 'Check the history',
  ReconciliationResult: 'Reconciliation result',
  ImportReconciliationExcel: 'Import reconciliation excel',
  Cargo_BatchUpdateChargeConfirmSerialNumber: 'Batch Modify Batch',
  Cargo_BatchUpdateChargeConfirmSerialNumberTip: 'The selected expense will be modified to the following batch number',
  Cargo_InputChargeConfirmSerialNumber: 'Please enter the batch number',
  Cargo_ChargeConfirmSerialNumber: 'Expense Confirmation Batch Number',
  Cargo_ChargeConfirmSerialNumberLengthMore: 'Batch number cannot exceed 20 digits!',
  Cargo_PleaseSelectSolicitationType: 'Please select a collection type!',
  Cargo_WriteoffSeqNo: 'WriteOff SeqNo',
  Cargo_CustomerContactChannel: 'Customer Contact Channel',
  Cargo_AgentBilling: 'Agent Billing',
  Cargo_AgentBillingCanNotEdit: 'The agent sharing bill cannot be edited!',
  Cargo_RecheckBillingCanNotEdit: 'The rechecked bill cannot be edited!',
  Cargo_ContainsAgentBilling: 'It contains the agent sharing bill, please select other statements to operate!',
  Cargo_HasAgentBilling: 'It contains the agent sharing bill, please select another bill to operate!',
  Cargo_ForeignBillStatusError: 'Foreign bill status does not meet printing requirements.',
  Cargo_ExportBillVoucherStatus: 'Export Bill Voucher Status',
  Cargo_BillGeneratedNoCancel: 'Bill number has been generated, review cannot be cancelled',
  Cargo_OverseasBillReverseRule1: 'Overseas bills must have a bill number to be reversed',
  Cargo_WriteOffStatusReverseRule: 'Written-off status cannot be reversed',
  Cargo_VoidStatusReverseRule: 'Void-status bills cannot be reversed',
  Cargo_AlreadyReversedRule: 'Already reversed bills cannot be reversed again',
  Cargo_NoBillToReverse: 'No bills available for reversal',
  Cargo_ConfirmReverseBills: 'Are you sure you want to reverse these {0} bills?',
  Cargo_ReversedBillNoInvoice: 'Reversed bills cannot be invoiced again',
  Cargo_BillInvoicedNoReverse: 'Bill has been invoiced and cannot be reversed',
  Cargo_BillPaymentAppliedNoReverse: 'Bill has been used for payment application and cannot be reversed',
  Cargo_BillStatementMadeNoReverse: 'Bill has been used for statement and cannot be reversed',
  Cargo_BillWrittenOffNoReverse: 'Bill has been written off and cannot be reversed',
  Cargo_Config: 'Config',
  Cargo_OrderTemplateName: 'Template name',
  Cargo_TemplateTips: 'Tips:',
  Cargo_Blue: 'If the font is blue',
  Cargo_MusetSelectd: 'It is a required item and cannot be deleted. The header name of the template must be configured. If the template has no value, please configure the order default value',
  Cargo_StartLine: 'Start line (with title)',
  Cargo_TemplateDefault: 'If there are no required fields in the template, you can maintain the default value of the order generated by import here',
  Cargo_TemplateDefaultValue: 'Template value',
  CargoFieldDescription: 'Field Description',
  Cargo_FieldDropdownValue: 'Field Dropdown Value',
  Cargo_ActualFieldName: 'Actual business field name',
  Cargo_TemplateHeaderName: 'Template header name',
  Cargo_TemplateImportValue: 'Template import value',
  Cargo_OrderDefaultValue: 'Order defaults',
  Cargo_OrderOperation: 'Operation',
  Cargo_OrderDelete: 'Delete',
  Cargo_CloseAccountTips: 'The current adjustment date has been closed for accounting, please choose again.',
  Cargo_CloseAccountTips2: 'The current financial date has been closed for accounting, please select again.',
  Cargo_PayableOrderCreationDate: 'Payable order creation date',
  Cargo_InvoiceHistoryEmail: 'Invoice history email',
  Cargo_SendCc: 'Send carbon copies to the synchronized address',
  Cargo_DoInvoiceTip: 'Only {0} permission, cannot operate ticket collection',
  Cargo_DoInvoiceTip2: 'Only {0} permission, cannot operate receivable and payable mixed invoicing',
  Cargo_CallBackTip: 'The insurance record marked as \'Submitted and Policy Issued\' cannot go back to the previous step.',
  Cargo_CabinSpaceSerialNo: 'Cabin Space Serial Number',
  Cargo_CabinSpaceStatus: 'Cabin Space Status',
  Cargo_CabinSpaceNote: 'Cabin Space Note',
  Cargo_AllocationStatus: 'Allocation Status',
  Cargo_QuantityInconsistency: 'S/O or MBL quantity is inconsistent with the cabin space quantity.',
  Cargo_VesselCallSign: 'Vessel Call Sign',
  Cargo_SORecognitionNewAdd: 'SO Recognition New Addition',
  Cargo_ShutOut2: 'Shut Out',
  Cargo_CabinSpaceBackFill: 'Cabin Space Backfill',
  Cargo_RevokeAllocation: 'Revoke Allocation',
  Cargo_CancelCabinReservation: 'Cancel Cabin Reservation',
  Cargo_AllocateCabinSpace: 'Allocate Cabin Space',
  Cargo_Allocate1: 'Allocate - Associate with Business',
  Cargo_Allocate2: 'Allocate - Create Business',
  Cargo_SelectBusinessTip: 'Please select a business to modify and replicate',
  Cargo_GuidedSellingPrice: 'Guided Selling Price',
  Cargo_CabinCancellationNote: 'Cabin Cancellation Note',
  Cargo_CutOffDate: 'Cut-off Date',
  Cargo_DeclarationCutOffDate: 'Declaration Cut-off Date',
  Cargo_CutOffDate2: 'Customer Cut-off Date for Customs',
  Cargo_ReturnDateForCustoms: 'Customer Return Date for Customs',
  Cargo_CutOffTime: 'Cut-off Time',
  Cargo_FreeStorageDays: 'Free Storage Days',
  Cargo_TotalPiecesMismatchContinue: 'Total piece count does not match. Do you want to continue?',
  Cargo_BasicData: 'Basic Data',
  Cargo_CustomerVendorRating: 'Customer/Vendor Rating',
  Cargo_DeliveryOperator: 'Delivery Operator',
  Cargo_DeliveryOperationTime: 'Delivery Operation Time',
  Cargo_DeliveryOperationMethod: 'Delivery Operation Method',
  Cargo_PartnerApprovalRequired: 'The selected partner must go through an approval process before becoming effective and cannot be used during the review. Do you want to initiate the approval now?',
  Cargo_ContractApprovalRequired: 'This contract must go through an approval process before it becomes effective. During the review, editing, renewal, and document management are not allowed. Do you want to initiate the approval now?',
  Cargo_ViewPartnerDetails: 'View Partner Details',
  Cargo_PartnerApplicationForm: 'Partner Application Form',
  Cargo_ContractApplicationForm: 'Contract Application Form',
  Cargo_PartnerApplicationApprovalProcess: 'Partner Application & Approval Process',
  Cargo_ContractApplicationApprovalProcess: 'Contract Application & Approval Process',
  Cargo_UnderReview: 'Under Review',
  Cargo_CanSubmitOnlyUnreviewedPartner: 'You can only submit partners whose status is "Unreviewed". Please reselect and try again.',
  Cargo_DataUnderReviewCheckRetry: 'Data under review exists; please check and retry',
  Cargo_ViewContractDetails: 'View Contract Details',
  Cargo_WeightOutOperator: 'Weight-Out Operator',
  Cargo_WeightOutOperationTime: 'Weight-Out Operation Time',
  Cargo_WeightOutOperationMethod: 'Weight-Out Operation Method',
  Cargo_ConfirmBatchOperation: 'Confirm batch operation?',
  Cargo_AutomationConfig: 'Automation Configuration',
  Cargo_TaskScenario: 'Task Scenario',
  Cargo_TimingMethod: 'Timing Method',
  Cargo_LastExecutionTime: 'Last Execution Time',
  Cargo_ExecutionFrequency: 'Execution Frequency',
  Cargo_PerHour: 'Per Hour',
  Cargo_Daily: 'Daily',
  Cargo_Weekly: 'Weekly',
  Cargo_Monthly2: 'Monthly',
  Cargo_VesselEnglishName: 'Vessel English Name',
  Cargo_ActualSailingTime: 'Actual Sailing Time',
  Cargo_EstimatedSailingTime: 'Estimated Sailing Time',
  Cargo_ShippingCompanyName2: 'Shipping Company Name',
  Cargo_ActualAmount: 'Actual Amount (Final Fee Amount)',
  Cargo_FeeCreationTime: 'Fee Creation Time',
  Cargo_StartExecutionTime: 'Start Execution Time',
  Cargo_Every: 'Every',
  Cargo_Hour: 'Hour',
  Cargo_EffectiveTime: 'Effective Time',
  Cargo_TaskResult: 'Task Result',
  Cargo_TaskResultReminder: 'Task Result Notification (Email with Excel attachment)',
  Cargo_ScenarioName: 'Scenario Name',
  Cargo_AutomationTask: 'Automation Task',
  Cargo_SpecifiedWeekday: 'Specified Weekday',
  Cargo_SpecifiedDay: 'Specified Day',
  Cargo_LastDayOfMonth: 'Last Day of Month',
  Cargo_Day29to31Fallback: 'If 29, 30 or 31 is selected and the month does not have that day, execution will automatically fall back to the last day of the month.',
  Cargo_ExecuteCommand: 'Execute Command',
  Cargo_AutoInvoicing: 'Auto Invoicing',
  Cargo_TaskName: 'Task Name',
  Cargo_MultiLegVoyageManagement: 'Multi-Leg Voyage Management',
  Cargo_ScheduleSelection: 'Schedule Selection',
  Cargo_Leg1: 'Leg 1',
  Cargo_Leg2: 'Leg 2',
  Cargo_Leg3: 'Leg 3',
  Cargo_Leg4: 'Leg 4',
  Cargo_Leg5: 'Leg 5',
  Cargo_OnlyOneVoucherForCopy: 'Only one voucher can be selected for copying!',
  Cargo_VoyageInfoCannotBeEmpty: '{0} in voyage information cannot be empty',
  Cargo_AutoExecute: 'Auto Execute',
  Cargo_TaskNameCannotBeEmpty: 'Task name cannot be empty!',
  Cargo_TaskNameAlreadyExists: 'Task name "{0}" already exists; duplicates are not allowed!',
  Cargo_TaskScenarioAutoExecuteCannotDelete: 'This task scenario is configured for auto-execution and cannot be deleted!',
  Cargo_EnabledStatusCannotDelete: '{0} It is currently enabled; please disable it before deleting.',
  Cargo_ConfirmDeleteTaskScenario: 'Are you sure you want to delete this task scenario?',
  Cargo_ScenarioSettings: 'Scenario Settings',
  Cargo_TransmissionRule: 'Transmission Rule',
  Cargo_Script: 'Script',
  Cargo_AccountPassword: 'Account & Password',
  Cargo_GetTokenUrl: 'Token Acquisition URL',
  Cargo_InterfaceUrl: 'Interface URL',
  Cargo_TransmissionSample: 'Transmission Format Sample',
  Cargo_RuleSettings: 'Rule Settings',
  Cargo_CommandSettings: 'Command Settings',
  Cargo_DataScript: 'Data Script',
  Cargo_DataDisplay: 'Data Display',
  Cargo_DeleteFromLastLeg: 'Please delete from the last leg',
  Cargo_PreviewData: 'Preview Data',
  Cargo_NotificationPersonnel: 'Notification Personnel',
  Cargo_DebugExecute: 'Debug Execute',
  Cargo_ConditionName: 'Condition Name',
  Cargo_SendToExchangeTime: 'Sent to Shipping Exchange Time',
  Cargo_EnterYourRequirement: 'Please enter your requirement',
  Cargo_ConfigExecuteCommands: 'Configure execution commands (execute in sequence by number)',
  Cargo_CommandName: 'Command Name',
  Cargo_SelectCommand: 'Select Command',
  Cargo_ConfirmRuleSettings: 'Please confirm the rule settings',
  Cargo_ScenarioDescription: 'Scenario Description',
  Cargo_Command: 'Command',
  Cargo_ExecutionTime: 'Execution Time',
  Cargo_HistoryDetails: 'History Details',
  Cargo_ExecutionScenario: 'Execution Scenario',
  Cargo_DataID: 'Data ID',
  Cargo_ExecuteCommandName: 'Execute Command Name',
  Cargo_ManualRun: 'Manual Run',
  Cargo_AsyncExecutingCheckLogLater: 'Executing asynchronously, please check the execution log later',
  Cargo_ExecutionLog: 'Execution Log',
  Cargo_Execute: 'Execute',
  Cargo_NoOutboundCommandConfirmPickList: '{0},No outbound command issued; do you confirm generating the pick list?',
  Cargo_CabinSpaceAllocationDate: 'Cabin Space Allocation Date',
  Cargo_AssociatedBusinessNo: 'Associated Business Number',
  Cargo_AssociatedBusinessStatus: 'Associated Business Status',
  Cargo_FirstTimeSalesAllocation: 'First-Time Sales Allocation',
  Cargo_FirstTimeAllocationEntrustingUnit: 'First-Time Allocation to Entrusting Unit',
  Cargo_CabinCancellationExplanation: 'Cabin Cancellation Explanation',
  Cargo_CabinSpaceRecord: 'Cabin Space Record',
  Cargo_VoyageInformation: 'Voyage Information',
  Cargo_AssociatedBusinessStatus2: 'Associated business status',
  Cargo_UploadFileOver50: 'Due to the large amount of data, the upload speed may be slow, please check later.',
  Cargo_UserSecurityPolicy: 'User Security Policy',
  Cargo_RoleGroupManagement: 'Role Group Management',
  Cargo_RoleGroupName: 'Role Group Name',
  Cargo_UnmaintainedRoleGroupPermissions: 'Corresponding role group permissions not maintained',
  Cargo_RoleGroup: 'Role Group',
  Cargo_RoleGroupCountLessThanTwo: 'Role Group Count < 2',
  Cargo_PolicySettings: 'Policy Settings:',
  Cargo_EnableUserSecurityPolicy: 'Enable User Security Policy',
  Cargo_PasswordLengthRange: 'Password Length Range:',
  Cargo_MaxLengthRange8to20: 'Maximum length 8-20 characters',
  Cargo_CompositionRule: 'Composition Rule:',
  Cargo_RequireNumUpperLower: 'Must contain digits, uppercase and lowercase letters',
  Cargo_MustIncludeSpecialChars: 'Must include special characters: !,$,%,&,_,|,-,@,#,*,=',
  Cargo_PasswordHistoryCheck: 'Password History Check:',
  Cargo_HistoryLength0to10: 'Set 0-10; 0 disables history check, 3 means no repeat within last 3 passwords',
  Cargo_PasswordErrorLock: 'Password Error Lock:',
  Cargo_LockLength0to10: 'Set 0-10; 0 disables lock, otherwise account is disabled after set errors',
  Cargo_AdminApplication: 'Admin Application:',
  Cargo_AdminPwdFollowPolicy: 'Admin passwords follow the same user security policy',
  Cargo_NoRepeatLastNPasswords: 'Must not match the last {0} passwords',
  Cargo_PasswordRulePrompt: 'Please follow password rules: length {0}-{1}, must contain digits, uppercase and lowercase letters',
  Cargo_DimensionsExceedRouteProductLimits: 'Dimensions exceed route product-voyage limits, proceed?',
  Cargo_FlightReassignment: 'Flight reassignment',
  Cargo_InformationMaintenance: 'Information Maintenance',
  Cargo_VehicleInformation: 'Vehicle Information',
  Cargo_CountyDistrict: 'County/District',
  Cargo_TownStreet: 'Town/Street',
  Cargo_VillageCommunity: 'Village/Community',
  Cargo_FleetPhoneNumber: 'Fleet Phone Number',
  Cargo_DoorPointName: 'Door Point Name',
  Cargo_DeliveryArea: 'Delivery Area',
  Cargo_EstimatedLoadingTime: 'Estimated Loading Time',
  Cargo_ActualLoadingTime1: 'Actual Loading Time',
  Cargo_DeliverySequenceNumber: 'Delivery Sequence Number',
  Cargo_DispatchVehicleNoteFields: 'Please ensure the following fields are completed during the vehicle dispatch operation:',
  Cargo_TTDEG: 'Transport Company, Trailer Fee, Door Point Name, Estimated Loading Time, Gross Weight',
  Cargo_RouteMarking: 'Route marking',
  Cargo_SecondaryConfirmation: 'Secondary confirmation',
  Cargo_BookingCompleted: 'Booking has already been completed, please check:',
  Cargo_DataNotPendingConfirmation: 'There are non-pending confirmation data, please check:',
  Cargo_PortMismatch: 'The ports of departure and destination are not fully consistent, are you sure you want to continue?',
  Cargo_DataNotConfirmed: 'There are non-confirmed data, please check:',
  Cargo_RouteNotConfirmedOrDoubleConfirmed: 'There are data that are not route-confirmed or have been double-confirmed, please check:',
  Cargo_SelectOneMasterBill: 'Select only one master bill at most',
  Cargo_DataNotRouteDoubleConfirmed: 'There are non-route double-confirmed data, please check:',
  Cargo_GrossProfitAmount: 'Gross Profit Amount',
  Cargo_SpecialExpenseIndicator: 'Sales Special Expense Indicator',
  Cargo_BusinessSpecialExpenseIndicator: 'Business Special Expense Indicator',
  Cargo_IsNoInvoiceExpense: 'No-invoice expense',
  Cargo_SpecialExpenseApplication: 'Special expense application',
  Cargo_SpecialExpensePayableTotal: 'Total Special Expenses Payable',
  Cargo_SpecialExpensePayableCurrency: 'Currency for Special Expenses Payable',
  Cargo_SpecialExpenseReceivableTotal: 'Total Special Expenses Receivable',
  Cargo_SpecialExpenseReceivableCurrency: 'Currency for Special Expenses Receivable',
  Cargo_BookingCompletion: 'Booking completion',
  Cargo_RouteConfirmation: 'Route confirmation',
  Cargo_RouteConfirmationStatus: 'Route confirmation status',
  Cargo_FlightDateRange: 'Flight date range',
  Cargo_RouteConfirmationPerson: 'Route confirmation person',
  Cargo_RouteConfirmationTimeRange: 'Route confirmation time range',
  Cargo_IsBookingCompleted: 'Is booking completed',
  Cargo_OrderNumber: 'Order number',
  Cargo_FlightNumber: 'Flight number',
  Cargo_SecondLegFlight: 'Second leg flight',
  Cargo_SecondLegAirline: 'Second leg airline',
  Cargo_SecondLegDocumentNumber: 'Second leg document number',
  Cargo_SecondLegETD: 'Second leg ETD',
  Cargo_SecondLegETA: 'Second leg ETA',
  Cargo_ThirdLegFlight: 'Third leg flight',
  Cargo_ThirdLegAirline: 'Third leg airline',
  Cargo_ThirdLegDocumentNumber: 'Third leg document number',
  Cargo_ThirdLegETD: 'Third leg ETD',
  Cargo_ThirdLegETA: 'Third leg ETA',
  Cargo_FreightUnitPrice: 'Freight unit price',
  Cargo_SignatureWeight: 'Signature weight',
  Cargo_SignatureDimensions: 'Signature dimensions',
  Cargo_SignatureRemarks: 'Signature remarks',
  Cargo_FoldedWeightRemarks: 'Folded weight remarks',
  Cargo_TotalPrice: 'Total price',
  Cargo_TransshipmentFee: 'Transshipment fee',
  Cargo_HumanResourcePerformance: 'Human Resource Performance',
  Cargo_AIEngine: 'AI Engine',
  Cargo_ProvisionReport: 'Provision Report',
  Cargo_ScriptName: 'Script Name',
  Cargo_ScriptDescription: 'Script Description',
  Cargo_GenerateScript: 'Generate Script',
  Cargo_RuleDescription: 'Rule Description',
  Cargo_ScriptPreview: 'Script Preview',
  Cargo_CommissionRole: 'Commission Role',
  Cargo_CommissionPersonnel: 'Commission Personnel',
  Cargo_ApplicableScript: 'Applicable Script',
  Cargo_RuleApplication: 'Rule Application',
  Cargo_ApplicablePersonnel: 'Applicable Personnel',
  Cargo_BusinessVolume: 'Business Volume',
  Cargo_ApplicableRule: 'Applicable Rule',
  Cargo_CustomsProvision: 'Customs Provision',
  Cargo_OperationProvision: 'Operation Provision',
  Cargo_CustomerServiceProvision: 'Customer Service Provision',
  Cargo_BusinessProvision: 'Business Provision',
  Cargo_SalesProvision: 'Sales Provision',
  Cargo_OperationTicketProvision: 'Operation Ticket Provision',
  Cargo_SalesSupervisorProvision: 'Sales Supervisor Provision',
  Cargo_OperationSupervisorProvision: 'Operation Supervisor Provision',
  Cargo_ConfirmCancelProvision: 'Confirm to cancel the provision?',
  Cargo_LockLimit: 'Lock Limit',
  Cargo_ReceivableFullWriteOffTime: 'Time for Full Receivable Write-off',
  Cargo_LockAccountsReceivableAndPayableEntry: 'Lock Accounts Receivable and Payable Entry',
  Cargo_ViewDetailedBusiness: 'View Detailed Business',
  Cargo_TestRun: 'Test Run',
  Cargo_ProvisionLimit: 'Provision Limit',
  Cargo_ViewProvisionDetails: 'View Provision Details',
  Cargo_ProvisionBatchNumber: 'Provision Batch Number',
  Cargo_ProvisionPerson: 'Provision Person',
  Cargo_ProvisionTime: 'Provision Time',
  Cargo_ProvisionRole: 'Provision Role',
  Cargo_PendingProvision: 'Pending Provision',
  Cargo_ProvisionHistory: 'Provision History',
  Cargo_ResponsibleCustomerService: 'Responsible customer service',
  Cargo_ResponsibleOperator: 'Responsible operator',
  Cargo_ConfirmAndBookingCompleted: 'Confirmed and booking completed',
  Cargo_OrderQuantity: 'Order quantity',
  Cargo_FinancialStatus: 'Financial Status',
  Cargo_FinancialColorTip: 'Table Color Control Configuration Range: \nAir Booking - List\nAir Operation - List\nIntegrated Logistics - List\nRailway Operation - List\nRemote Booking - List\nSales Query - List\nSea Export - List\nSea Operation - List\nSea Import - Forecast - List\nSales Query - Overseas Department - List\nSales Query - Sales Department - List\nSea Export - Bill of Lading - List\nSea Export - EDI - List\nFinance Audit - List\nFinance Audit - Closing - List\nAir Export - Customs Declaration - List\nAir Export - Pre-Warehouse - List\nAir Export - Warehouse - List\nSea Import - Warehouse Operation - List',
  Cargo_CurrentInvoiceDifferentRates: 'The current invoicing involves expenses with different tax rates. Invoices will be split by tax rate and issued separately, using the default tax code for maintenance. Do you want to continue this operation?',
  Cargo_CurrentSelectionContains9TaxPointsAndOthers: 'The current selection contains 9 tax points and other tax points. Due to the special nature of the goods transportation invoice, please apply for it separately. It does not support submitting the invoice together.',
  Cargo_Allocated: 'Allocated',
  Cargo_NotAllocated: 'Not Allocated',
  Cargo_PriceAuditEventFclTitle: 'Freight rate audit update reminder',
  Cargo_FillSO: 'Fill S/O',
  Cargo_FillMBL: 'Fill MBL',
  Cargo_FillALL: 'Fill Both MBL and S/O',
  Cargo_CustomsReturnAndRecovery: 'Customs Return and Recovery',
  Cargo_CheckDTip: 'MBL NO. or SO NO. already exists, confirm to continue creation?',
  Cargo_BatchUpdateTitle1: 'Batch Update - Cabin Space Backfill',
  Cargo_WindowTip1: '*Bulk update of bill of lading information.',
  Cargo_WindowTip2: '**If there are differences in box type and quantity in the batch selected orders, please fill in the cabin space backfill individually.',
  Cargo_CheckDTip2: 'Cannot perform operations in the "Canceled" or "Allocated" state',
  Cargo_CheckDTip3: 'Please select cabin space with consistent box type and quantity for operation.',
  Cargo_NoItems_NoAudit: 'No {0}, no need for audit',
  Cargo_Audited_NoNeedAudit: 'Audited, no need for audit',
  Cargo_AvailableCabinSpace: 'Available Cabin Space',
  Cargo_QueryTip: 'Quick search: Cabin space serial number',
  Cargo_PriceUpdateUser: 'Freight rate modifier',
  Cargo_BookingPreAudit: 'Booking Pre-Audit',
  Cargo_UniversalIntelligentRecognition: 'Universal intelligent recognition',
  Cargo_PromptWords: 'Prompt',
  Cargo_PleaseUploadFile: 'Please upload file',
  Cargo_BatchImportAr1: 'Batch Import of Receipt Write-off',
  Cargo_BatchImportAp1: 'Batch Import of Payment Write-off',
  Cargo_BatchImportAr2: 'Download receipt import template',
  Cargo_BatchImportAp2: 'Download payment import template',
  Cargo_ImportingDataSuccess1: 'This operation is asynchronous, you can check the results in',
  Cargo_ImportingDataSuccess2: 'File Storage -> Upload Logs',
  Cargo_ImportingDataSuccess3: 'View import results',
  Cargo_RecordsWrittenOff: '{0} record(s) have been written off.',
  Cargo_lockLabel1: 'Lock purchase price',
  Cargo_lockLabel2: 'Lock selling price',
  Cargo_lockLabel3: 'Unlock purchase price',
  Cargo_lockLabel4: 'Unlock selling price',
  Cargo_UnLockLabel: 'Unlock',
  Cargo_LockLabel: 'Lock',
  Cargo_LockSuccess: '{0}{1} successful',
  Cargo_DisplayByBillOfLading: 'Display by Bill of Lading',
  Cargo_DisplayByDateAndVoyageNo: 'Display by Date and Voyage Number',
  Cargo_ShowSeaExportJob: 'Merge and view outbound booking data',
  Cargo_OperatingSpaceOnly: 'Operating space only',
  Cargo_IsCabinSpace: 'Is Cabin Space Available',
  Cargo_CheckBoxTip: 'The box type and quantity do not match the cabin space, please verify.',
  Cargo_CheckBoxTip2: 'The vessel name, voyage number, shipping company, and ETD (Estimated Time of Departure) of the order are inconsistent with the cabin space, please confirm whether to continue.',
  Cargo_CheckBoxTip3: 'The pending associated business already has an MBL NO. or SO NO., and cannot be associated.',
  Cargo_AllocationSuccess: 'Allocation successful!',
  Cargo_AllocationCancel: 'Confirm to revoke allocation?',
  Cargo_CabinReturn: 'Return cabins simultaneously.',
  Cargo_CabinReturnTip: 'Please provide a reason for the cabin return.',
  Cargo_CancelCabinTip1: 'Revocation completed.',
  Cargo_CancelCabinTip2: 'Cabin return completed.',
  Cargo_CancelCabinTip3: 'There are associated businesses with the cabin space, please cancel the association first.',
  Cargo_CancelCabinTip4: 'The associated business with the cabin space is still in the booking pre-audit phase, if you want to revoke the allocation, please reject it in the booking pre-audit.',
  Cargo_CancelCabinTip5: 'The associated business with the cabin space has not yet been returned to customs, please return to customs first.',
  Cargo_CancelCabinTip6: 'There are unallocated cabin spaces, please check.',
  Cargo_BusinessProcessStage: 'Business Process Stage',
  Cargo_PleaseSelectDataAndUpload: 'Please select data and upload files in batches.',
  Cargo_PleaseSelectDataAndUpload2: 'Please select the same business type and upload files in batches.',
  Cargo_BatchUploadFile: 'Batch upload files',
  Cargo_BatchUploadFile2: 'Upload failed, unsupported format',
  Cargo_Allocate3: 'Allocate - Create Business',
  Cargo_CabinCreate1: 'Create to Booking Pre-Audit',
  Cargo_CabinCreate2: 'Create to Sea Freight Booking',
  Cargo_CabinCreate3: 'Business order number generated:',
  Cargo_CloseAndCopyNumber: 'Close and Copy Order Number',
  Cargo_AllocateCheck1: 'There is allocated data, please check',
  Cargo_AllocateCheck2: 'There is data that is not released for cabin space, please check',
  Cargo_OnlyReturnTheCabin: 'Only delete return the cabin',
  Cargo_CabinManagement: 'cabin management',
  Cargo_TheRedFontFieldWillOverwriteTheSeaExportWithTheValueOfTheSpaceManagement: 'The red font field will overwrite the sea export with the value of the space management',
  Cargo_OriginalValueOfTheSeaExportAndWillNotBeOverwritten: 'The blue font field will retain the original value of the sea export and will not be overwritten',
  Cargo_ImportedMultipleBusiness: 'Imported and matched multiple business tickets',
  Cargo_UploadedRepeatedly: 'Uploaded repeatedly',
  Cargo_BoxType2: 'Corresponding box type and category',
  Cargo_BoxTypeAndCategory: 'Box type and category',
  Cargo_CheckBoxSize: 'Please specify the box type',
  Cargo_UsedQuota: 'Used quota',
  Cargo_PleaseSelectTheConsignee: 'Please select the consignee',
  Cargo_ViewingMessage: 'Viewing the original message',
  Cargo_ChangeSettlement: 'Modify the settlement object',
  Cargo_CanNotEditTips: 'Contains non-editable expenses, please check!',
  Cargo_PleaseSelectExpenseToModify: 'Please select the expense to modify.',
  Cargo_ArChargeSettlementCannotModify: 'The settlement object of A/R expense cannot be modified.',
  Cargo_ChargeSettledCannotModify: 'The expense has been billed/invoiced/payment applied/written off and cannot be modified.',
  Cargo_ArChargeSettlementCannotModifyDetail: 'Expense {0} is A/R and its settlement object cannot be modified.',
  Cargo_ChargeSettledCannotModifyDetail: 'Expense {0} has been billed/invoiced/payment applied/written off and cannot be modified.',
  Cargo_CanNotEditChargeDetail: 'Expense {0} has no edit permission and cannot be modified.',
  Cargo_CheckChargeDetailBranchDetail: 'Expense {0} belongs to a branch that cannot be operated.',
  Cargo_BeforeAdjustment: 'Before adjustment',
  Cargo_AfterAdjustment: 'After adjustment',
  Cargo_SetAMarginAlert2: 'Set Margin Alert',
  Cargo_SetAMarginAlert: 'Set Remaining Quantity Alert',
  Cargo_ApplicableBranch: 'Applicable Branch',
  Cargo_AdditionalRemark: 'Additional Remarks',
  Cargo_FixedLastNumber: 'Fixed Last Number 00',
  Cargo_GenerativeRule: 'Generation Rule',
  Cargo_StartNumber: 'Start Number',
  Cargo_EndNumber: 'End Number',
  Cargo_MarginTip1: 'Company number shortage reminder',
  Cargo_MarginTip2: 'User number shortage reminder',
  Cargo_MarginTip3: 'If a reminder is needed, please enter the number shortage quantity in the corresponding field.',
  Cargo_useTip: 'The number must not have been used before',
  Cargo_useTip2: 'An invalid order number cannot be assigned',
  Cargo_DeleteTip: 'Only the voided numbers can be deleted',
  Cargo_PrefixTip: 'The main number prefix is incorrect',
  Cargo_StarTip: 'The start number, end number does not conform to the rule',
  Cargo_StarNoTip: 'The start number is abnormal',
  Cargo_MarginTip4: 'Please fill in the person in charge.',
  Cargo_NumberErrTip: '*The number of digits in the number is insufficient',
  Cargo_NumberErrTip2: 'The number does not conform to the generation rule',
  Cargo_AlreadyExistTip: 'Import failed, the imported number already exists.<br/>{0}',
  Cargo_ImportStarTip: 'Import failed, the prefix of the imported order number is incorrect.<br/>{0}',
  Cargo_ImportNoTip: 'Import failed, the imported order number is abnormal.<br/>{0}',
  Cargo_EmptyNoTip: 'The imported Excel file does not contain MBL numbers',
  Cargo_CarrierCheck: 'Please enter the shipping company first',
  Cargo_NumberMarginUse: 'The current user order number margin is below {0}',
  Cargo_NumberMarginCompany: 'The current companys order number margin is below {0}',
  Cargo_receiveTip: 'The order number you entered has been taken. Please confirm if you want to continue?',
  Cargo_receiveTip2: 'The main order number does not match the data maintained in \'Main Order Number Management\'. Are you sure you want to continue using this order number?',
  Cargo_ImperialUnits: 'Imperial units',
  Cargo_Metric: 'Metric',
  Cargo_Imperial: 'Imperial',
  Cargo_AirExportEnableImperialUnits: 'Enable imperial unit input for air export',
  Cargo_Inch: 'Inch',
  Cargo_Pound: 'Pound',
  Cargo_CubicFoot: 'Cubic foot',
  Cargo_Centimeter: 'Centimeter',
  Cargo_Kilogram: 'Kilogram',
  Cargo_CubicMeter: 'Cubic meter',
  Cargo_measurements2: 'Size in (length * width * height * number of pieces)',
  Cargo_GrossProfit: 'Gross profit',
  Cargo_MustEnterComplete: 'Must enter complete',
  Cargo_CostVirtualImplementationToConsolidationPlan: 'Cost virtual implementation to consolidation plan',
  Cargo_EstimatedDeliveryDate: 'Estimated Delivery Date',
  Cargo_CheckWarehouseInConfig: 'Please select the warehouse',
  Cargo_SelectScales: 'Please select the scales',
  Cargo_ReceivablesWriteoffDate: 'Receivables write-off date',
  Cargo_PayablesWriteoffDate: 'Payables write-off date',
  Cargo_PleaseEnterPieceCount: 'Please enter the piece count',
  Cargo_PleaseConfirm: 'Please confirm the warehouse entry serial number/warehouse delivery order number',
  Cargo_WarehouseInState: 'Business warehousing status',
  Cargo_LocationConfigurationError: 'Pallet cannot be duplicated or is already occupied, please check',
  Cargo_KeyNull: 'appKey is not configured',
  Cargo_TokenNull: 'Token is empty',
  Cargo_CameraNull: 'Camera configuration error',
  Cargo_Reading: 'Reading',
  Cargo_FeeInvoiceTitle: 'Fee invoice title',
  Cargo_PaymentApplicationTitle: 'Payment application title',
  Cargo_ReadingTip: 'Multiple dimensions are separated by commas \',\' or semicolons \';\'\nFormat: LengthWidthHeight/Number of Pieces; Length×Width×Height/Number of Pieces\nExample: 354030/3;35×40×30/3;',
  Cargo_ReadingTip2: 'Please specify the weighbridge configuration in the warehouse',
  Cargo_CargoTerminalGrossWeight: 'Cargo terminal gross weight (KG)',
  Cargo_FileUpload: 'Attachment upload',
  Cargo_inputMblTip: 'Please scan/enter the master airway bill number',
  Cargo_OutboundWeight2: 'Outbound weight operation',
  Cargo_FileInfo: 'Attachment information',
  Cargo_DeliveryOperation: 'Delivery operation',
  Cargo_MasterAirwayBill: 'Master airway bill number',
  Cargo_DeliveryCargoStation: 'Delivery cargo terminal',
  Cargo_SplitOrderNumber: 'Number of split orders',
  Cargo_TotalPieces: 'Total number of pieces',
  Cargo_TotalGrossWeight: 'Total gross weight',
  Cargo_TotalChargeableWeight: 'Total chargeable weight',
  Cargo_TotalVolume: 'Total volume',
  Cargo_PrintCheck1: 'The print range or number of copies is incorrect, please check',
  Cargo_PrintRange: 'Print range',
  Cargo_PrintNumber: 'Number of copies',
  Cargo_GrossWeight3: 'Gross weight',
  Cargo_DimensionsEntry: 'Dimensions entry',
  Cargo_WarehouseTip3: 'Cancel outbound order completed',
  Cargo_WarehouseTip2: 'Outbound order completed',
  Cargo_WarehouseTip1: 'Packing not completed, please check',
  Cargo_CancelOutboundOrder: 'Cancel outbound order',
  Cargo_OutboundOrder: 'Outbound order',
  Cargo_GoodsArrived: 'Goods arrived',
  Cargo_Pallet3: 'Pallet',
  Cargo_WeightedInfo: 'Weighed information',
  Cargo_ScaleReading: 'Weighbridge reading',
  Cargo_ScalePhoto: 'Weighbridge photo',
  Cargo_Tip: 'Tip: Supports warehouse entry serial number/warehouse delivery order number',
  Cargo_ReadScale: 'Read scale',
  Cargo_TakePhoto: 'Take photo',
  Cargo_Weighing: 'Weighing',
  Cargo_WeightRecord: 'Weighing record',
  Cargo_WeightHandling: 'Weighing handling',
  Cargo_SaveDone: 'Save and complete warehousing',
  Cargo_DeliverySecurityCheck: 'Delivery',
  Cargo_OutboundWeight: 'Outbound weight',
  Cargo_CurrentBusinessAlreadyWeighedOut: 'Current business has already been weighed out; duplicate operation is prohibited.',
  Cargo_CurrentBusinessAlreadyDelivered: 'Current business has already been delivered; duplicate operation is prohibited.',
  Cargo_NetGrossWeight: 'Net and Gross Weight',
  Cargo_VolumeWeight: 'Volumetric Weight',
  Cargo_BatchEnterDimensions: 'Batch Entry of Dimensions',
  Cargo_CoveringSizeAndQuantity: 'Note: Will fully overwrite existing size and quantity information',
  Cargo_Recognition: 'Recognition',
  Cargo_EstimatedDeliveryDateError: 'Recognition Error',
  Cargo_ScaleWeight: 'Weighbridge Weight',
  Cargo_OurPallet: 'Our Pallet',
  Cargo_TareWeight: 'Tare Weight',
  Cargo_GrossWeight2: 'Gross Weight',
  Cargo_Location2: 'Storage Location',
  Cargo_FrontEndWarehouseOperation: 'Front-end Warehouse Operation',
  Cargo_CargoTerminalOperation: 'Cargo Terminal Operation',
  Cargo_FileSizeCannotExceed20m2: 'File size cannot exceed 20M, supports .xls and .xlsx formats',
  Cargo_StateUpdate: 'Status update',
  Cargo_NotData: 'No data found',
  Cargo_LclHasMaster: 'The small ticket has already been associated with a master ticket',
  Cargo_ParamError: 'Parameter error, please check',
  Cargo_CheckInventory: 'Check inventory',
  Cargo_ReleaseLocation: 'Release storage location',
  Cargo_LocationCode: 'Storage location code',
  Cargo_Warehouse2: 'Warehouse',
  Cargo_LocationType: 'Storage location type',
  Cargo_LocationStatus: 'Storage location status',
  Cargo_LocationDeleteTip: 'Storage location is occupied, cannot delete',
  Cargo_ReadFailure: 'Read failure',
  Cargo_PalletDeleteTip: 'Current pallet is occupied, cannot delete',
  Cargo_NoLocationSelected: 'No location selected',
  Cargo_PackingCondition: 'Packing condition',
  Cargo_SpecialHandling: 'Special handling',
  Cargo_PalletNumber: 'Pallet number',
  Cargo_InventoryCheck: 'Inventory check',
  Cargo_ApplyRuleToAllScenarios: 'Apply rule settings to all scenarios',
  Cargo_DocumentsWithCargo: 'Documents with Cargo',
  Cargo_PalletConfiguration: 'Pallet management',
  Cargo_Pallet2: 'Pallet',
  Cargo_PalletID: 'Pallet ID',
  Cargo_PalletStatus: 'Pallet status',
  Cargo_PalletMaterial: 'Pallet material',
  Cargo_RecyclingType: 'Recycling type',
  Cargo_PalletTareWeight: 'Pallet tare weight',
  Cargo_AirCargoTerminal: 'Air Cargo Terminal',
  Cargo_WarehouseType: 'Warehouse Type',
  Cargo_WarehouseCode2: 'Warehouse Code',
  Cargo_WarehouseName: 'Warehouse Name',
  Cargo_WarehouseAddress: 'Warehouse Address',
  Cargo_Terminal: 'Terminal',
  Cargo_TerminalCode: 'Terminal Code',
  Cargo_TerminalName: 'Terminal Name',
  Cargo_AirportCode: 'Airport Code',
  Cargo_TerminalAddress: 'Terminal Address',
  Cargo_DeliveryMap: 'Delivery Map',
  Cargo_RecipientContact: 'Recipient Contact',
  Cargo_RecipientContactPhone: 'Recipient Contact Phone',
  Cargo_SecurityCheckMachineWidthLimit: 'Security Check Machine Width Limit',
  Cargo_SecurityCheckMachineHeightLimit: 'Security Check Machine Height Limit',
  Cargo_CustomsCode: 'Customs Code',
  Cargo_WeighbridgeNumber: 'Weighbridge Number',
  Cargo_WeighbridgeBaudRate: 'Weighbridge Baud Rate',
  Cargo_Checksum: 'Checksum',
  Cargo_AutoFinanceAuditLockOrder: 'Automatic Finance Audit Lock Order',
  Cargo_UnSubmittedBusinessLockOrder: 'Unsubmitted business will automatically execute lock order operation (Business status: In Progress -> Audited)',
  Cargo_PollingFrequency: 'Polling Frequency',
  Cargo_SpecificDateMonthly: 'Specific Date Monthly',
  Cargo_DailyOnce: 'Once Daily',
  Cargo_PhotoTaken: 'Photo Taken',
  Cargo_CameraConfiguration: 'Camera Configuration',
  Cargo_WeighbridgeTest: 'Weighbridge Test',
  Cargo_Test: 'Test',
  Cargo_MonitoringInterface: 'Monitoring Interface',
  Cargo_DeviceNumber: 'Device Number',
  Cargo_MonitoringChannel: 'Monitoring Channel',
  Cargo_MonitoringInterface1: 'Yingshi Cloud',
  Cargo_DeleteTip1: 'You are about to delete {0} terminal information entries. Please proceed with caution.',
  Cargo_GeneralCargoWarehouse: 'General Cargo Warehouse',
  Cargo_WoodenPackagingType: 'Wooden packaging type',
  Cargo_ClearSave: 'Clear and save',
  Cargo_OrderModificationTimes: 'Order modification times',
  Cargo_ServiceStatisticalArea: 'Service Statistical Area',
  Cargo_DangerousGoodPackage: 'Dangerous Goods Packaging',
  Cargo_DangerousGoodPackageCode: 'Dangerous Goods Packaging code',
  Cargo_OOGTEU: 'OOG TEU Volume',
  Cargo_SeaRailTransport: 'Sea-Rail Transport',
  Cargo_BoxOneWay: 'Container Usage (One-Way/Circulation)',
  Cargo_OOGTEUTip: 'Please enter the OOG TEU Volume',
  Cargo_OneWay: 'One-Way',
  Cargo_Circulation: 'Circulation',
  Cargo_Grade: 'Secondary Custom Business Type',
  Cargo_Grade2: 'Parent Custom Business Type',
  Cargo_LotteryDraw: 'Ticket Draw',
  Cargo_SchoolMonth: 'Monthly School',
  Cargo_WithdrawTheEntrustment: 'Withdraw the entrustment',
  Cargo_checkData1: 'No entrusted data found or it has already been reviewed.',
  Cargo_ContractTip: 'If you need to adjust the contract agreement, you must first revoke the contract.',
  Cargo_DetailMakeInvoice: 'Detailed Invoice Issuance',
  Cargo_SplitMakeInvoice: 'Split Currency Invoice Issuance',
  Cargo_RemarkAddContent: 'Add Content to Invoice Remarks',
  Cargo_RemarkAddContent3: 'Invoice remarks on exchange rate content',
  Cargo_BillResults: 'Bill of Lading Recognition Fields',
  Cargo_BillResults2: 'System Bill of Lading Data',
  Cargo_NotUpdate: 'Non-updatable',
  Cargo_UpdateCheck1: 'Please note that the container type and quantity do not match the selected packing information',
  Cargo_CustomerAssociatedFactory: 'Customer associated factory',
  Cargo_FactoryName: 'Factory Name',
  Cargo_AddAssociatedFactory: 'Add associated factory',
  Cargo_BatchOperationSameEntrustedUnit: 'This batch operation is only supported when the business involves the same entrusted unit. Please reselect.',
  Cargo_ImportFailMessage: 'Import failed: The batch import costs do not meet the restriction of settlement object = entrusting unit or associated factory. Please adjust and try again',
  Cargo_SaveAndConfirm: 'Save and Confirm',
  Cargo_ExportUndoHistory: 'Export undo history',
  Cargo_RevocationBy: 'revocation',
  Cargo_RevocationByDate: 'Revocation time',
  Cargo_billingTip: 'Invoice according to billing requirements',
  Cargo_remarkAddContent2: 'Add Additional Remarks',
  Cargo_detailMakeInvoice2: 'Detailed Invoice Issuance',
  Cargo_splitMakeInvoice2: 'Split Currency Invoice Issuance',
  Cargo_rmbGoodsName: 'RMB Invoice Item',
  Cargo_usdGoodsName: 'USD Invoice Item',
  Cargo_CarrierCode: 'ship edi code',
  Cargo_OrderTemplateSaveSuccess: 'Order template configuration saved successfully',
  Cargo_ContinueSave: 'The template header name is not configured. The actual business field name will be used. Continue?',
  Cargo_OrderTemplateSaveFail: 'Failed to save order template configuration',
  Cargo_DownImportTemplate: 'Download import template',
  Cargo_DownImportTemplate_Simple: 'Download import simple template',
  Cargo_DownImport_Simport: 'Import Simple',
  Cargo_ImportingData: 'Importing data...',
  Cargo_ImportingDataSuccess: 'This operation is an asynchronous operation. You can view the import results in file storage - > upload log',
  Cargo_WriteOffHeader: 'Write-Off Header',
  Cargo_PackageNo: 'Package No:',
  Cargo_DeletePackage: 'Delete packages',
  Cargo_WareHoused: 'These packages have been warehoused',
  Cargo_NotWareHoused: 'These packages are not warehoused',
  Cargo_CheckPackage: 'Are you sure to delete the corresponding package? If confirmed, the actual warehousing data will also be deleted.',
  Cargo_SureDeletePackageIn: 'These packages have been warehoused. Are you sure to delete the corresponding packages? If confirmed, the actual warehousing data will also be deleted.',
  Cargo_SelectPackage: 'Please select the package data to be deleted',
  Cargo_SureDeleteAbovePackage: 'Are you sure to delete the above packages?',
  Cargo_BalanceSheetQuarter: 'Balance Sheet Quarter',
  Cargo_ProfitLossQuarter: 'Profit Loss Quarter',
  Cargo_BalanceSheetYear: 'Balance Sheet Year',
  Cargo_ProfitLossYear: 'Profit Loss Year',
  Cargo_ReasonForJudgment: 'Reason for judgment',
  Cargo_CheckSavePoInfoItem: 'This product has been associated with packaging. Please disassociate it first!',
  Cargo_HasBillingGroup: 'This document has generated a statement and cannot be edited!',
  Cargo_HasInvoice: 'This document has been invoiced and cannot be edited!',
  Cargo_HasWriteOff: 'This document has been written off and cannot be edited!',
  Cargo_HasConfirm: 'This order has been confirmed and cannot be edited!',
  ContinueOperation: 'Continue operation',
  CancelOperation: 'Cancel operation',
  Cargo_BackTopPreviousVersion: 'Back to previous version',
  Cargo_Combine: 'Combine',
  Cargo_DataEnableSuccess: 'Data enabled successfully!',
  Cargo_DataDisEnableSuccess: 'Data disabled successfully!',
  Cargo_CombineChargeItem: 'Combine ChargeItem',
  Cargo_ConsolidatedChargeItem: 'Consolidated ChargeItem:',
  Cargo_ChargeItemHasUsedForCombine: '{0} has been disabled, please select other charge items to merge!',
  Cargo_CombineChargeItemTips: 'After consolidation, all {1} related charges will be refreshed to {0} and set to disabled status. Do you want to continue?',
  Cargo_CombineChargeItemTipsOne: 'Merging, please wait.',
  Cargo_CombineChargeItemTipsTwo: 'You can leave this interface. It is expected that the merger will be completed within 10 minutes. Please check later.',
  Cargo_CombineChargeItemTipsThree: 'Please select different charge items to merge!',
  Cargo_PayService: 'Pay Service：',
  InvoiceTitleCannotBeBlank: 'Invoice Title cannot be blank',
  InvoiceTitleCannotBeDuplicate: 'Invoice header cannot be duplicate',
  TaxControlPanelCannotBeDuplicate: 'A tax control panel [{0}] cannot be associated with multiple invoicing headers',
  CheckTaxControlPanelNo: '[{0}] Multiple tax control disk numbers have been maintained. Do you want to continue?',
  TaxControlPanelNoHasInvoiceTitle: 'The tax control information has been associated with the invoicing header and cannot be deleted. Please cancel the association first!',
  ChinaAdditionalTaxRateIsEmpty: 'The [China additional tax rate] field is empty. Are you sure you want to continue saving?',
  SpecialCharactersExcept: 'There are other special characters except English, numbers and punctuation marks',
  Cargo_ThePreAllocatedManifestHasBeenSentForThisTicketBusiness: 'Import failed, The pre allocated manifest has been sent for this ticket business.',
  EstimatedDeliveryDate: 'Estimated delivery date',
  ActualDeliveryDate: 'Actual delivery date',
  LatestDeliveryDate: 'Latest delivery date',
  DischargingWay: 'Discharging way',
  Cargo_DownloadSource: 'Download Source',
  Cargo_canOnlyBeUppercaseCharactersAndNumbers: 'Can only be uppercase characters and numbers',
  Cargo_numbersNotLetters: 'Numbers, not letters',
  Cargo_pleaseSelectShippingTerms: 'Please select shipping terms',
  Cargo_pleaseSelectTheTypeOfGoods: 'Please select the type of goods',
  Cargo_pleaseSelectTheBillOfLadingMethod: 'Please select the bill of lading method',
  Cargo_pleaseEnterTheFullEnglishNameOfThePortInCapitalLetters: 'Please enter the full name of the port in uppercase English',
  Cargo_PortOfDischargeTipText: 'Transit filling in transit port, direct to fill in destination port',
  Cargo_pleaseEnterTheNameOfTheShipOnlyUppercaseCharactersAndNumbers: 'Can only be letters, numbers, \'.\', \'-\', \'spaces\'',
  Cargo_PortPreRateCode: 'Port pre-rate code',
  Cargo_SideLineType: 'Side line type',
  Cargo_EndRouteRateCode: 'End route rate code',
  Cargo_DeliveryAddressType: 'Delivery address type',
  Cargo_DirectHaul: 'Direct haul',
  Cargo_SideLine: 'Side line',
  Cargo_HuzhouSeaRail: 'Huzhou sea-rail',
  Cargo_HaiNingBranch: 'Hai Ning Branch',
  Cargo_ZhapuSideLine: 'Zhapu side line',
  Cargo_OriginPortInfo: 'Origin port information',
  Cargo_ChargeByContainerType: 'Charge by container type entry',
  Cargo_ChargeNotByContainerType: 'Charge not by container type entry',
  Cargo_SpecialRemark: 'Special remark',
  Cargo_AddEntry: 'Add entry',
  Cargo_FreeUseContainer: 'Free use container',
  Cargo_FreeStorage: 'Free storage',
  Cargo_ThirdPartyAddress: 'Third-party address',
  Cargo_AmazonWarehouse: 'Amazon warehouse',
  Cargo_WalmartWarehouse: 'Walmart warehouse',
  Cargo_YiCang: 'YiCang warehouse',
  Cargo_DestinationPortInfo: 'Destination port information',
  Cargo_Shelving: 'Shelving',
  Cargo_PleaseSelectNonNormalRateForShelving: 'Please select a non-"normal" rate for shelving.',
  Cargo_PleaseSelectValidRateForShelving: 'Please select a rate with an active validity period for shelving.',
  Cargo_PleaseSelectNormalRateForUnShelving: 'Please select a "normal" rate for un-shelving.',
  Cargo_SeaFreightFullContainer: 'Full Container Load (FCL)',
  Cargo_SeaFreightLessThanContainer: 'Less than Container Load (LCL)',
  Cargo_EnquiryNumber: 'Enquiry Number',
  Cargo_EnquirySource: 'Enquiry Source',
  Cargo_Enquirer: 'Enquirer',
  Cargo_EnquiryStatus: 'Enquiry Status',
  Cargo_FirstLegQuoteStatus: 'Port Quotation Status',
  Cargo_MainlineQuoteStatus: 'Mainline Quote Status',
  Cargo_LastLegQuoteStatus: 'Last Leg Quote Status',
  Cargo_PalletType: 'Pallet Type',
  Cargo_DirectOrTransshipment: 'Direct/Transshipment',
  Cargo_Range: 'Range',
  Cargo_Dimensions: 'Length, Width, Height',
  Cargo_Terms: 'Service Terms',
  Cargo_DeliveryAddress: 'Delivery Address',
  Cargo_NameHSCode: 'Product Name (HS Code)',
  Cargo_MainlineRate: 'Mainline Rate',
  Cargo_PrePortRate: 'Pre-Port Rate',
  Cargo_EndRouteRate: 'End Route Rate',
  Cargo_RateCode: 'Rate Code',
  Cargo_MatchQuote: 'Match Quote',
  Cargo_Select_Inquiry_Responsible: 'Select Inquiry Responsible Person',
  Cargo_Multiple_Route_Leaders: 'Multiple route leaders found. Please select the person to initiate the inquiry:',
  Cargo_Pre_Port_Rate_Leader: 'Pre-Port Rate Responsible Person',
  Cargo_Mainline_Rate_Leader: 'Mainline Rate Responsible Person',
  Cargo_End_Route_Rate_Leader: 'End Route Rate Responsible Person',
  Cargo_NoMatchFound: 'No match found [{0}]',
  Cargo_CombinationPlanQuery: 'Combination Plan Query',
  Cargo_FillQueryConditions: 'Fill Query Conditions',
  Cargo_SelectMatchingRate: 'Select Matching Rate',
  Cargo_GenerateCombinationPlan: 'Generate Combination Plan',
  Cargo_ReturnToPreviousStep: 'Return to Previous Step',
  Cargo_PrePortPrice: 'Pre-Port Price',
  Cargo_MainlinePrice: 'Mainline Price',
  Cargo_LastMilePrice: 'Last Mile Price',
  Cargo_AssociatedPrePortQuoteNumber: 'Associated Pre-Port Quote Number',
  Cargo_AssociatedLastMileQuoteNumber: 'Associated Last Mile Quote Number',
  Cargo_20GPQuantity: '20GP Quantity',
  Cargo_40GPQuantity: '40GP Quantity',
  Cargo_40HCQuantity: '40HC Quantity',
  Cargo_45HCQuantity: '45HC Quantity',
  Cargo_20NORQuantity: '20NOR Quantity',
  Cargo_40NORQuantity: '40NOR Quantity',
  Cargo_20FootNORQuantity: '20\' NOR Quantity',
  Cargo_40FootNORQuantity: '40\' NOR Quantity',
  Cargo_SubmitQuotation: 'Submit Quotation',
  Cargo_WithdrawQuotation: 'Withdraw Quotation',
  Cargo_RejectQuotation: 'Reject Quotation',
  Cargo_InquiryManagement: 'Cargo Inquiry Management',
  Cargo_PrePort: 'Pre-port',
  Cargo_FinalMile: 'Final mile',
  Cargo_OriginAreaSelection: 'Origin Area Selection',
  Cargo_ShippingAddressSelection: 'Shipping address selection',
  Cargo_AddArea: '+Add Area',
  Cargo_AddAddress: '+Add address',
  Cargo_AddressDisabledTip: 'Multiple areas can be added. When two or more streets/towns are selected, the detailed address will be disabled.',
  Cargo_PleaseMaintainAtLeastOne: 'Please maintain at least one.',
  Cargo_CannotMatchPleaseFill: '{0} cannot be matched, please fill in [{1}].',
  Cargo_Match: 'Match',
  Cargo_QuoteStatusNotAllowedSave: 'Saving is not allowed in quoted status',
  Cargo_SaveDraft: 'Save Draft',
  Cargo_PublishDirectly: 'Publish Directly',
  Cargo_SelectPendingQuoteSubmittedCancel: 'Please select the pending quote and submitted inquiry order to cancel',
  Cargo_LastMileDeliveryAddress: 'Last Mile Delivery Address',
  Cargo_PackingDoorPoint: 'Packing Door Point',
  Cargo_BoxTypeNotAllowedDuplicate: 'Box type cannot be duplicated',
  Cargo_PrePortBusinessLeader: 'Pre-port Business Leader',
  Cargo_MainlineBusinessLeader: 'Mainline Business Leader',
  Cargo_LastMileBusinessLeader: 'Last Mile Business Leader',
  Cargo_OverseaTracking: 'Oversea Tracking',
  Cargo_OverseaTracker: 'Oversea Tracker',
  Cargo_EndCommerceSynced: 'Synced',
  Cargo_EndCommerceAudited: 'Audited',
  Cargo_EndCommerceNotSynced: 'Not Synced',
  Cargo_EndCommerceFinalStepAudit: 'Final Step Audit',
  Cargo_EndCommerceNotAudited: 'Not Audited',
  Cargo_EndCommerceNoAuditRequired: 'No Audit Required',
  Cargo_EndCommerceAuditPassBtn: 'Audit Pass',
  Cargo_EndCommerceAuditSuccessCount: 'Audit successful {count} items',
  Cargo_EndCommerceSelectedAudited: 'Selected data already audited',
  Cargo_EndCommerceSelectedNoAuditRequired: 'Selected data does not require audit',
  Cargo_EndCommercePleaseSelectAtLeastOne: 'Please select at least one record',
  Cargo_EndCommerceOnlySelectOne: 'Only one record can be selected for this operation',
  Cargo_EndCommerceRecordNotAllowEdit: 'The selected record cannot be edited',
  CargoMsg_CurrentIdentityNotice: 'Your current identity will be linked to subsequent permissions. If you wish to submit an inquiry with a different role, please switch your branch and department at the top right of the interface first.',

  Cargo_enterTheVoyageThereCanBeNoV: 'It\'s not possible to have V.',
  Cargo_ResubscribeBookingReceipt: 'Resubscribe booking receipt',
  Cargo_BookingReceiptSubscriptionFailed: 'Booking receipt subscription failed',
  Cargo_inputVoyage: 'Please enter the voyage number',
  Cargo_pleaseSelectAShippingGeneration: 'Please select a shipping generation',
  Cargo_pleaseSelectAShippingCompany: 'Please select a shipping company',
  Cargo_pleaseEnterAnAddressWithin140Characters: 'Please enter an address, within 140 characters',
  Cargo_pleaseEnterTheEnterpriseCode: 'Please enter the enterprise code, which must contain "+", and the + sign cannot contain spaces before and after',
  Cargo_pleaseEnterAPhoneNumber: 'Please enter a phone number',
  Cargo_pleaseEnterANameWithin140Characters: 'Please enter a name, within 140 characters',
  Cargo_pleaseEnterANameWithin140Characters2: 'Please enter a name, within 70 characters',
  Cargo_pleaseSelectACountryCode: 'Please select a country code',
  Cargo_pleaseEnterTheActualContactName: 'Please enter the actual contact name',
  Cargo_ViewShipGenerations: 'View ship generations',
  Cargo_ReferenceShipGenerations: 'Refer to ship generation',
  Cargo_CopyShipInformation: 'Copy ship information',
  Cargo_PleaseInquireWithTheBookingHatchOrCustomerService: 'Please inquire with the booking hatch or customer service',
  UnverifiedAmountForCharge: 'Outstanding amount (expense)',
  VerifiedAmountForCharge: 'Amount (expense) written off',
  ReceivableForCharge: 'Receivable (expense)',
  PayableForCharge: 'Payable (expenses)',
  Cargo_PrePlanBookingCheckSoNo: 'The dispatched/corrected pre-provisioned manifest contains a customs ticket number that has not been maintained in the promissory note business. Do you want to continue?',
  Cargo_SwitchToTheOldVersion: 'Switch to the old version',
  Cargo_MaintainChargeItem: 'Please maintain the expense items first!',
  Cargo_UsePeriodRate: 'Use Period Rate',
  Cargo_initRatePeriod: 'Init Rate Period',
  Cargo_MonthRate: 'Month Rate',
  Cargo_PartialImport: 'Partial import',
  Cargo_CopyCustomerShippingInformation: 'Copy the customer shipping information',
  Cargo_NoPermissionForModule: 'You do not have permission to open the module!',
  Cargo_OcPayment: 'Oc Payment',
  Cargo_BatchProcess: 'Batch process',
  Cargo_BatchCancelProcess: 'Batch cancel process',
  Cargo_OcPaymentTime: 'Payment time',
  Cargo_ErialNumber: 'Erial number',
  Cargo_OcErialNumber: 'OCErial number',
  Cargo_BillingAccountId: 'Billing account name',
  Cargo_BillingSettlementAgentId: 'Billing settlementAgent name',
  Cargo_Processed: 'Processed',
  Cargo_Project: 'Project name',
  Cargo_PaymentStatus: 'Payment status',
  Cargo_UnlockPaymentTimeQuery: 'Query Data Two Years Ago, May Be Slower, Determine The Cancel Date Lock?',
  Cargo_OnlyUnProcessedRecordsCanBeProcessed: 'Only un-processed records can be processed.',
  Cargo_ConfirmAndProcessSelectedRecord: 'Confirm and process selected record?',
  Cargo_OnlyProcessedRecordsCanBeCancelled: 'Only processed records can be cancelled.',
  Cargo_CancelProcessOfSelectedRecord: 'Cancel process of selected record?',
  Cargo_ProcessedSuccessfully: 'Processed success',
  Cargo_CancelProcessSuccessfully: 'Cancel process success',
  Cargo_LockedOrNot: 'Locked or not',
  Cargo_DeleteOCBillTips: 'Only unlocked bills can be deleted!',
  Cargo_DeleteRecheckedBillTips: 'Only unRechecked bills can be deleted!！',
  Cargo_OCCanWriteOff: 'Only locked bills can be write-off!',
  Cargo_Adjustment: 'Adjustment',
  Cargo_InChangeExpenseReview: 'In change expense review',
  Cargo_Verification: 'Verification',
  Cargo_BeWriteBack: 'Be write back',
  Cargo_InquiryAndQuotation: 'Inquiry & Quotation',
  Cargo_AlertTodoCategoryList: 'Alert & Todo Category List',
  Cargo_ItemDescription: 'Item Description',
  Cargo_Alert: 'Alert',
  Cargo_Todo: 'Todo',
  Cargo_TodoAlert: 'Todo/Alert',
  Cargo_ChangeFeeApplicationProgress: 'Change fee application progress',
  Cargo_userDefinedRole1: 'Custom position 1',
  Cargo_userDefinedRole2: 'Custom position 2',
  Cargo_userDefinedRole3: 'Custom position 3',
  Cargo_userDefinedRole4: 'Custom position 4',
  Cargo_userDefinedRole5: 'Custom position 5',
  Cargo_userDefinedRole6: 'Custom position 6',
  Cargo_userDefinedRole7: 'Custom position 7',
  Cargo_userDefinedRole8: 'Custom position 8',
  Cargo_DisplaysTheRequestChangeFee: 'Displays the request change fee',
  Cargo_UpdateVesselVoyageMsg: 'You have modified the ship name, {0} the existing value, do you need to empty it?',
  Cargo_UpdateMblMsg: 'You adjusted the master tracking number, obtained it through the Air Export Tracking Service, {0} Do you want to clear the relevant fields?',
  Cargo_CheckUnitRate: 'There are expenses with unit price of 0. If you continue to save, the expenses with unit price of 0 will be automatically cleared. Do you want to continue saving?',
  Cargo_ZeroUnitPrice: 'There is a fee with a unit price of 0, continue saving or remove the fee with a unit price of 0?',
  Cargo_ClearZeroFee: 'Clear fees with a value of 0',
  Cargo_NoFeesCanBeAdded: 'No fees can be added',
  Cargo_ZeroUnitPriceEntry: 'Unit price entered as 0, please confirm whether to continue saving',
  Cargo_ZeroAmountWarning: 'The unit price or amount is entered as 0. Please confirm whether to continue saving.',
  Cargo_Readjust: 'Re-adjust',
  Cargo_Validate_Insure: 'Insurance function is not allowed under the head office. Please switch to the branch office.',
  Cargo_ReceivingOperator: 'Receiving operator',
  Cargo_ReceivingOperationTime: 'Receiving operation time',
  Cargo_ClaimOperator: 'Claim operator',
  Cargo_ClaimOperationTime: 'Claim operation time',
  Cargo_OrderChangeOperator: 'Order change operator',
  Cargo_ChangeOrderOperationTime: 'Change order operation time',
  Cargo_ContinueToReleaseDocuments: 'Confirm whether to continue to release documents?',
  Cargo_ExpectedReturnDate: 'Expected return date',
  Cargo_OcPrePayment: 'PrePayment',
  Cargo_OcCancelPrePayment: 'CancelPrePayment',
  Cargo_GetKingdeId: 'Get Kingde Id',
  Cargo_RefreshData: 'Operation failed, please refresh and try again!',
  Cargo_ContinueExportTip: 'The selected record has been exported. Are you sure you want to export again?',
  Cargo_WarnRuleConfiguration: 'Warn Rule Configuration',
  Cargo_BPMApprovalProcess: 'BPM Approval Process',
  Cargo_DataServiceReminder: 'Data service reminder',
  Cargo_ValueAddedServiceReminder: 'Value-Added Service Reminder',
  Cargo_DataServiceItems: 'Data service items',
  Cargo_SopTemplate: 'SOP template',
  Cargo_SopNode: 'SOP node',
  Cargo_TriggerTypeSelection: 'Trigger type selection',
  Cargo_TriggerType: 'Trigger type',
  Cargo_WarningConditions: 'Warning conditions',
  Cargo_NodeUpdate: 'Node Update',
  Cargo_EarlyWarning: 'Early warning',
  Cargo_WarningContent: 'Warning content',
  Cargo_DataServiceConfig: 'Data Service Configuration Name',
  Cargo_ConfigureNameNotEmpty: 'Configuration name cannot be empty',
  Cargo_ConfigureNameRepeat: '{0} already exists; configuration name must be unique',
  Cargo_NotifierRoleRepeat: 'Position {0} already exists in configuration {1}; please do not configure it again',
  Cargo_NotifierIdRepeat: 'Person {0} already exists in configuration {1}; please do not configure it again',
  Cargo_RemarksInfo: 'Remarks info',
  Cargo_DesignatedPost: 'Designated post(Notifications will be sent according to the operation, sales, customer service, etc. positions set in each ticket business)',
  Cargo_SendSettings: 'Send Settings',
  Cargo_SetTheNotificationRecipients: 'Set The Notification Recipients',
  Cargo_ReminderMethod: 'Reminder Method',
  Cargo_DesignatedPersonnel: 'Designated personnel',
  Cargo_AutoIgnoreMode: 'Auto ignore mode',
  Cargo_WarningLevel: 'Warning level',
  Cargo_ShipPlanReminderMethod: 'Method of Ship Plan Reminder',
  Cargo_ShipNameAndVoyage: 'Reminder by Ship Name & Voyage',
  Cargo_Job: 'Reminder by Business',
  Cargo_AlertOnStatus: 'Alert on status',
  Cargo_EarlyWarningMode: 'Early warning mode',
  Cargo_WarningSwitch: 'Warning switch',
  Cargo_StartAlert: 'Start alert',
  Cargo_CloseAlert: 'Close alert',
  Cargo_EnablePersonalSettings: 'Enable Personal Settings',
  Cargo_ClosePersonalSettings: 'Disable Personal Settings',
  Cargo_DataServiceReminderWarning1: '1.【Push according to "Basic Configuration"】is sent at the nodes unified in 【Basic Configuration】',
  Cargo_DataServiceReminderWarning2: '2. After 【Enable Alert】-【Save】, the receiving nodes will follow personal settings',
  Cargo_ConfigurationAlert: 'Push according to "Basic Configuration"',
  Cargo_PushNodeSettings: 'Personal Push Node Settings',
  Cargo_NodPushSettings: 'Node Push Settings',
  Cargo_VesselReminderMethodDifferent: 'The original effective 【Vessel Schedule Reminder Method】 of {By Vessel & Voyage} will all be replaced with the latest {By Business}',
  Cargo_VesselReminderMethodDifferent2: 'The original effective 【Vessel Schedule Reminder Method】 of {By Business} will all be replaced with the latest {By Vessel & Voyage}',
  Cargo_UserConfigOpenDifferent: 'The original effective 【Node Push Settings】 of {Disable Personal Settings} will all be replaced with the latest {Enable Personal Settings}',
  Cargo_UserConfigOpenDifferent2: 'The original effective 【Node Push Settings】 of {Enable Personal Settings} will all be replaced with the latest {Disable Personal Settings}',
  Cargo_BringForward: 'Bring forward',
  Cargo_Postpone: 'Postpone',
  Cargo_EarlyWarningReminder: 'Minute, early warning reminder',
  Cargo_EarlyTimedIgnore: 'Timed ignore',
  Cargo_TurnOffAutoIgnore: 'Turn off auto ignore',
  Cargo_SetSOPNodeOfAlert: 'Set SOP node of alert',
  Cargo_SOPNodeOfAlert: 'SOP node of alert',
  Cargo_ApplicationScope: 'Application scope',
  Cargo_DocumentNotification: 'Document notification',
  Cargo_ApplyToAllTemplates: 'Apply to all templates',
  Cargo_UseOnlyTheCurrentTemplate: 'Use only the current template',
  Cargo_SetAlertNotificationObject: 'Set alert notification object',
  Cargo_ReminderModes: 'Reminder Mode',
  Cargo_IgnoreTime: 'Ignore time',
  Cargo_AutomaticallyIgnoreAfterHours: 'Automatically ignore after hours',
  Cargo_EditNodeAlertRules: 'Edit node alert rules',
  Cargo_CloudPlatformFeeStatus: 'Cloud platform fee status',
  Cargo_CloudPlatformSyncStatus: 'Cloud platform synchronization status',
  Cargo_CloudPlatformDocumentNumber: 'Cloud platform document number',
  Cargo_SynchronousCloudPlatform: 'Synchronous cloud platform',
  Cargo_SendThirdParty: 'Send Third Party',
  Cargo_SupplementaryInformation: 'Supplementary information',
  Cargo_InvoiceTypeOfTheOppositePlatform: 'Invoice type of the opposite platform',
  Cargo_PaymentBranch: 'Payment branch',
  Cargo_SyncInvoiceAttachment: 'Sync invoice attachments',
  Cargo_AddEmail: 'Add Email',
  Cargo_Send: 'Send',
  Cargo_SendSuccess: 'Sending succeeded',
  Cargo_SendFail: 'fail in send',
  Cargo_Remarks2: 'Remarks',
  Cargo_PaymentInstructions: 'Payment Instructions',
  Cargo_PaymentReason: 'Payment reason',
  Cargo_OurHeader: 'Our Header',
  Cargo_DeleteBookingNote: 'Are you sure you want to delete these {0} booking notes?',
  Cargo_ApplicationDetails: 'Application Details',
  Cargo_SubscribeToDataAlerts: 'Subscribe to data alerts',
  Cargo_EnableDataServiceReminder: 'Enable data service reminder',
  Cargo_ClickToLearnMore: 'Click to learn more',
  Cargo_DataServiceReminderWarning: 'If you receive too many container cargo reminders every day, you can close the reminders. The above reminders need to open the value-added service module.',
  Cargo_AskDataServiceReminder: 'After the data service is opened, the efficient and accurate automatic push notification is sent to the internal staff. For details:',
  Cargo_AskSopDataService: 'After opening the data service, you can efficiently and accurately automatically push notifications to internal staff and customers (manual circulation is not supported), and you can set data reminder service in the alert rule configuration to immediately contact your company\'s administrator for details:',
  Cargo_ContactDataServiceReminder: ', or contact walltech online customer service or operation 021-65143931',
  Cargo_DataServiceRemind: 'Data Service Remind',
  Cargo_WhetherToTurnOffAlerts: 'Whether to turn off alerts',
  Cargo_DayWarning: 'Day Warning',
  Cargo_OnlyDataNodesAreDisplayed: 'Only to-do nodes are displayed',
  Cargo_ViewProcessedAlerts: 'View processed alerts',
  Cargo_ViewIgnoredAlerts: 'View ignored alerts',
  Cargo_SelectTheSopTemplateToApplyToTheBusiness: 'Select the SOP template to apply to the business',
  Cargo_MakeSureToApplyTheSopTemplate: 'Make sure to apply the SOP template【{0}】',
  Cargo_PleaseSelectAnSOPTemplate: 'Please select an SOP template',
  Cargo_PleaseSelectSOPTemplateForChange: 'Please Select SOP Template For Change',
  Cargo_PleaseSelectOtherSOPTemplate: 'Please select other SOP template',
  Cargo_ReplaceTheSOPTemplate: 'Replace the SOP template',
  Cargo_Apply: 'Apply',
  Cargo_MoreFilters: 'More filters',
  Cargo_Handled: 'Handled',
  Cargo_ProcessSelectedData: 'Process selected data?',
  Cargo_IgnoreSelectedData: 'Ignore selected data?',
  Cargo_Personnel: 'Personnel',
  Cargo_NewSopTemplate: 'New SOP template',
  Cargo_EditSopTemplate: 'Edit SOP template',
  Cargo_CopySopTemplate: 'Copy Sop Template',
  Cargo_SopTemplateName: 'SOP template name',
  Cargo_LookNode: 'Look node',
  Cargo_NewNode: 'New node',
  Cargo_EditNode: 'Edit node',
  Cargo_NewNodeStatus: 'New node status',
  Cargo_NodeSettings: 'Node settings',
  Cargo_NodeStatusSettings: 'Node status settings',
  Cargo_NoticeOfEachBill: 'Notice of each bill',
  Cargo_NoNoticeOfTickets: 'No notice of tickets',
  Cargo_AlertSettings: 'Alert settings',
  Cargo_ConfigureSopMessagePush: 'Configure SOP message push',
  Cargo_NodeType: 'Node type',
  Cargo_WhetherToDisclose: 'Whether to disclose',
  Cargo_EditTheAlertConfiguration: 'Edit the alert configuration',
  Cargo_AddedAlertConfiguration: 'Added alert configuration',
  Cargo_EditTheStatusDetails: 'Edit the status details',
  Cargo_NewStatusDetails: 'New status details',
  Cargo_StatusDetails: 'Status details',
  Cargo_SetUpSopTemplateApplicationBusinessScenarios: 'Set up SOP template application business scenarios',
  Cargo_QuicklySelectBusinessNodes: 'Quickly select business nodes',
  Cargo_QuicklyConfigureDataServices: 'Quickly configure data services',
  Cargo_QuicklyConfigureStatusNotifications: 'Quickly configure status notifications (insiders)',
  Cargo_ShipPlanningAtThePortOfDeparture: 'Ship planning at the port of departure',
  Cargo_ContainerTracking: 'Container tracking',
  Cargo_ShipDynamicsAtThePortOfDestination: 'Ship dynamics at the port of destination',
  Cargo_CarryEmpty: 'Carry empty',
  Cargo_TheActualDischarging: 'The actual discharging',
  Cargo_ReturnBox: 'Return box',
  Cargo_TheHomePageIsDisplayed: 'The home page is displayed',
  Cargo_QuicklyConfigureSettings: 'Quickly configure settings',
  Cargo_QuickConfigurationIsCheckedByDefault: 'Quick Configuration is checked by default',
  Cargo_PleaseEnterAThemeTemplate: 'Please enter a theme template',
  Cargo_PleaseEnterTheBodyTemplateContent: 'Please enter the body template content',
  Cargo_PleaseEnterTheTemplateContent: 'Please enter the template content',
  Cargo_PleaseEnterAnExampleTemplate: 'Please enter an example template',
  Cargo_SOPPushObjectChannelRepeats: 'SOP push object channel repeats',
  Cargo_DataService: 'Data service',
  Cargo_WarningRuleTips: 'After updating the SOP node status, the corresponding alert information will be marked as processed',
  Cargo_SopTemplateChangeTips: 'The new SOP template【{0}】 has been matched, and whether the original SOP template is retained?',
  Cargo_ApplyTheSopTemplateAs: 'apply the sop template as:',
  Cargo_TheNodeIsShutDown: 'The node is shut down.',
  Cargo_CanNotUploadFileOfNewContract: 'New unsaved contract number cannot be uploaded!',
  Cargo_OrderReceiving: 'Acceptance',
  Cargo_PrintTemplate: 'Print Template',
  Cargo_ControlObject: 'Control Object',
  Cargo_ControlMode: 'Control Method',
  SetDefaultType: 'Set Default Type',
  DefaultFileType: 'Default File Type',
  DefaultType: 'Default Type',
  Cargo_ActualPaymentAmount: 'Actual payment amount',
  Cargo_ReceivedAmount: 'Received amount',
  Cargo_OcServiceCharge: 'OcService charge',
  Cargo_ChannelServiceCharge: 'Channel service charge',
  Cargo_Abnormal: 'Abnormal',
  Cargo_AbnormalState: 'Abnormal state',
  Cargo_AbnormalRemark: 'Abnormal remark',
  Cargo_ProcessedDate: 'Processed date',
  Cargo_UpdateReceivedAmount: 'Update received amount',
  Cargo_AbnormalComment: 'Abnormal comment',
  Cargo_MarkAbnormal: 'Mark abnormal',
  Cargo_ValueAddedServices: 'Value-added services',
  Cargo_CustomsMode: 'Customs Mode',
  Cargo_POD: 'Port Of Destination',
  Cargo_POL: 'Port Of Loading',
  Cargo_ServiceType: 'Service Type',
  Cargo_PODServices: 'Port of destination services',
  Cargo_InitData: 'Init Data',
  Cargo_NotInitData: 'Existing data, unable to initialize',
  Cargo_GeneratedVoucherInvoice: 'Including invoice number of generated voucher:',
  Cargo_DownLoad_Summary: 'Download detail template',
  Cargo_DownLoad_Detail: 'Download summary template',
  Cargo_Import_OnOrder: 'Import on order',
  Cargo_Not_Submit: 'Are you sure not to submit？',
  Cargo_Not_Approved: 'You can only batch not submit the orders to be approved!',
  Cargo_Not_Submit_Please: 'Please check the business of [Not Submitted]',
  Cargo_Not_Submit_Batch_Success: 'Batch update of status not submitted temporarily succeeded',
  Cargo_Submit_Batch: 'Please check the business to be submitted',
  Cargo_Submit_Pre_Qualification: 'Are you sure to submit the prequalification status?',
  Cargo_Submit_Job: 'You can only batch submit [Not Submitted] businesses',
  Cargo_Submit_Success: 'Order submitted',
  Cargo_ThirdTableCheck: 'The third-party intermediate table is pushed and cannot be operated',
  Cargo_OnlySelectedOneVoucher: 'Only one piece of data can be selected for export.',
  Cargo_BatchSetCategory: 'Batch Set Category',
  Cargo_ExportExcelTemplate: 'Export Excel template?',
  Cargo_Run: 'Run',
  Cargo_ExcelTemplateExport: 'Excel Report Export',
  CARGO_OFFICE_EMAIL_ISEMPTY: 'Current Branch E-invoiceemail not maintained, please check.',
  Cargo_ChangeChargeChanged: 'The original charge of {0} has been changed, Please check!',
  Cargo_SecondPolCode: 'Two way port of departure (code)',
  Cargo_SecondPodCode: 'Second destination port (code)',
  Cargo_SecondPol: 'Two way port of departure',
  Cargo_SecondPod: 'Second destination port',
  Cargo_WaybillDestination: 'Waybill destination',
  Cargo_PolCountry: 'Country of shipment',
  Cargo_IC: 'International Trucking',
  Cargo_IC_Master: 'International Air Card Main Ticket',
  Cargo_IC_Basic: 'International Card Airline Signature',
  Cargo_Settlement: 'Settlement',
  Cargo_ReconciliationTab: 'Reconciliation Tab',
  Cargo_BillTab: 'Bill Tab',
  Cargo_CancelApprovalCheck: 'The selected data includes businesses that have sent BO. Canceling approval is not allowed, please check!',
  Cargo_BusinessPushStatus: 'Business Push Status',
  Cargo_CostPushStatus: 'Cost Push Status',
  Cargo_AutoGenerateEnabled: 'Auto-generate?',
  Cargo_BusinessQuotationAmount: 'Business quotation amount',
  Cargo_BusinessQuotationConfirmed: 'Business quotation confirmed',
  Cargo_BusinessQuotationConfirmedCancel: 'Cancel quotation confirmation',
  Cargo_OperationAllowedOnlyForUnconfirmedQuotation: 'This operation is only allowed for expenses with quotation confirmed as "No"!',
  Cargo_OperationAllowedOnlyForConfirmedNonZeroQuotation: 'This operation is only allowed for expenses with business quotation not equal to 0 and quotation confirmed as "Yes"!',
  Cargo_VehicleModel: 'Truck Type',
  Cargo_TypeKh: 'Ka hang',
  Cargo_waybillInvoice: 'Waybill invoice info',
  Cargo_customsMethodPol: 'Customs declaration method',
  Cargo_transferAgent: 'Transit agent',
  Cargo_destinationAgent: 'Destination agent',
  Cargo_dispatchingPlace: 'Place of shipment',
  Cargo_dispatchingPlace2: 'Place of receipt/shipment',
  Cargo_dischargingPortCode: 'Place of discharge(POD)',
  Cargo_transferPortCode: 'Transit place',
  Cargo_loadingPortCode: 'Place of shipment(POL)',
  Cargo_actAta: '(Acture Time of Arrival)ATA',
  Cargo_estEta: '(Estimated Time of Arrival)ETA',
  Cargo_actAtd: '(Acture Time of Departure)ATD',
  Cargo_estEtd: '(Estimated Time of Departure)ETD',
  Cargo_OrderCar: 'Order car',
  Cargo_DestinationDelivery: 'Destination delivery',
  Cargo_trailerNumber: 'Trailer Number',
  Cargo_polInfo: 'Port information of the port of shipment',
  Cargo_estLandingTime: 'Estimated time of arrival',
  Cargo_actLandingTime: 'Actual time of arrival',
  Cargo_estEntryTime: 'Estimated time of arrival of CARA',
  Cargo_actEntryTime: 'Actual Entry Time',
  Cargo_estExitTime: 'Expected departure time of CARIGALI',
  Cargo_actExitTime: 'Actual departure time',
  Cargo_estReplacementTime: 'Expected reloading time of KAC',
  Cargo_actReplacementTime: 'Actual reloading time of KAC',
  Cargo_declareTime: 'Customs declaration time',
  Cargo_transferInfo: 'Customs transfer information of transit place',
  Cargo_declareCompletedTime: 'Completion time of transit place declaration',
  Cargo_estShippingTime: 'Estimated time of shipment at the transit place',
  Cargo_actShippingTime: 'Actual delivery time at the transit place',
  Cargo_estArrivePodTime: 'Estimated time of arrival at the border of the destination',
  Cargo_actArrivePodTime: 'Actual arrival time at the border of destination',
  Cargo_estEnterPodTime: 'Estimated time of arrival at the destination',
  Cargo_actEnterPodTime: 'Actual destination time',
  Cargo_estArriveClearTime: 'Estimated time of arrival at the customs clearance place',
  Cargo_actArriveClearTime: 'Actual time of arrival at the customs clearance place',
  Cargo_estDischargeTime: 'Estimated unloading time of CARL',
  Cargo_actDischargeTime: 'Actual unloading time',
  Cargo_estArriveTime: 'Estimated arrival time of trailer',
  Cargo_actArriveTime: 'Actual arrival time of trailer',
  Cargo_estTakeTime: 'Estimated pickup time of trailer',
  Cargo_actTakeTime: 'Actual pickup time of trailer',
  Cargo_estUnloadTime: 'Estimated unloading time of trailer',
  Cargo_actUnloadTime: 'Actual unloading time of trailer',
  Cargo_podInfo: 'Delivery information at destination port',
  Cargo_estWarehouseDeliveryTime: 'Estimated warehousing delivery time',
  Cargo_actWarehouseDeliveryTime: 'Actual warehousing delivery time',
  Cargo_estGoodsDeliveryTime: 'Estimated delivery time',
  Cargo_actGoodsDeliveryTime: 'Actual delivery time',
  Cargo_estReturnTime: 'Estimated time of return',
  Cargo_actReturnTime: 'Actual empty time',
  Cargo_polPortInfo: 'Port information of the place of departure',
  Cargo_khLandingTime: 'Foreign Truck arrival',
  Cargo_khEntryTime: 'Foreign Truck entry',
  Cargo_khExitTime: 'Foreign Truck exit country',
  Cargo_khReplacementTime: 'Foreign Truck reloaded',
  Cargo_khDeclare: 'Foreign Truck customs finished',
  Cargo_transferShipping: 'Departure from Transit customs',
  Cargo_transferTransitInfo: 'Customs transfer information of transit place',
  Cargo_transferDeclareCompleted: 'Customs Transit finished',
  Cargo_arriveDestinationBorder: 'Arrival at the Destination border',
  Cargo_podClearInfo: 'Customs clearance information of destination port',
  Cargo_arrivePod: 'Arrival at the destination',
  Cargo_arriveClear: 'Arrival at the customs clearance place',
  Cargo_khUnloading: 'Card airlines unloading',
  Cargo_polExchangeInfo: 'Loading and unloading information at the place of departure',
  Cargo_trailerLoad: 'Trailer load',
  Cargo_trailerArrive: 'Trailer arrive',
  Cargo_trailerUnload: 'Trailer unload',
  Cargo_podDeliveryInfo: 'Destination delivery information',
  Cargo_warehouseDelivery: 'Enter Warehouse',
  Cargo_goodsDelivery: 'Delivery to client',
  Cargo_podReturn: 'Empty container return',
  Cargo_estTime: 'Estimated time',
  Cargo_actTime: 'Actual time',
  Cargo_secondPlateNumber: '2nd Foreign Tractor number',
  Cargo_secondTrailerNumber: '2nd Foreign Trailer number',
  Cargo_secondVehicleType: '2nd Foreign Truck type',
  Cargo_secondEtd: 'date of dispatch',
  Cargo_secondPol: 'Place of shipment',
  Cargo_secondPod: 'destination',
  Cargo_secondLoadingTime: 'loading time',
  Cargo_secondShippingTime: 'Departure time',
  Cargo_secondArriveTime: 'Arrival time',
  Cargo_secondDischargeTime: 'Unloading time',
  Cargo_secondTransportType: 'Transshipment mode',
  Cargo_bargeInfo: 'Barge information',
  Cargo_bargeEtd: 'Delivery date of barge',
  Cargo_bargeAtd: 'Arrival date of barge',
  Cargo_bargePlateNumber: 'Barge license plate',
  Cargo_bargeTrailerNumber: 'No. of barge trailer',
  Cargo_bargePol: 'Loading place of barge(POL)',
  Cargo_bargePod: 'Barge destination(POD)',
  Cargo_ActualEntryTime: 'Actual Entry Time',
  Cargo_ActualLoadingTime: 'Actual Loading Time',
  Cargo_EstimatedDepartureTime: 'Estimated Departure Time',
  Cargo_ActualDepartureTime: 'Actual Departure Time',
  Cargo_EstimatedArrivalTime: 'Estimated Arrival Time',
  Cargo_ActualArrivalTime: 'Actual Arrival Time',
  Cargo_ActualBillingTime: 'Actual Billing Time',
  Cargo_ActualUnloadingTime: 'Actual Unloading Time',
  Cargo_ActualArrivalNotificationTime: 'Actual Arrival Notification Time',
  Cargo_ActualPickupTime: 'Actual Pickup Time',
  Cargo_EstimatedTransitArrivalTime: 'Estimated Transit Arrival Time',
  Cargo_TransitArrivalTime: 'Transit Arrival Time',
  Cargo_EstimatedTransitDepartureTime: 'Estimated Transit Departure Time',
  Cargo_TransitDepartureTime: 'Transit Departure Time',
  Cargo_bargeLine: 'Road route code',
  Cargo_bargeCarrierId: 'Barge transportation company',
  Cargo_khPlateNumber: 'Card Air License Plate No',
  Cargo_khPlateNum: 'Card Air License Plate No',
  Cargo_PlateNums: 'Domestic License Plate number',
  Cargo_khTrailerNumber: 'Caravan trailer No',
  Cargo_TypeTc: 'trailer',
  Cargo_SyncTargetDocumentNo: 'Sync target document No',
  Cargo_PleaseChooseTargetDocumentNo: 'Please choose target document No',
  Cargo_WriteOffInputFail: 'In the expenses to be written off, there are expenses that have not been applied for payment or the payment application process has not been completed, so write off is not allowed!',
  Cargo_WriteOffInputFail2: 'In the expenses to be written off, there are expenses that the payment application process has not been completed, so write off is not allowed!',
  Cargo_OFAOPOTFSIITPRPPDNOATRIC_Payment: 'Operation failed. The payment application is in the payment approval process. Please operate after the process is completed.',
  Cargo_estimation: 'Estimation',
  Cargo_estimationAmount: 'Estimation Amount',
  Cargo_CooperateBranchId: 'Cooperative branch',
  Cargo_EntrustBranchId: 'Entrusted branch',
  Cargo_CooperateBusinessType: 'Collaboration business type',
  Cargo_BillingWeightActual: 'Billing weight (actual)',
  Cargo_BillingWeightContract: 'Billing weight (contract)',
  Cargo_NumberOfItemsActual: 'Number of items (actual)',
  Cargo_NumberOfItemsContract: 'Number of items (contract)',
  Cargo_VolumeActual: 'Volume (actual)',
  Cargo_VolumeContract: 'Volume (contract)',
  Cargo_GrossWeightContract: 'Gross weight(contract)',
  Cargo_GrossWeightActual: 'Gross weight(actual)',
  Cargo_CooperateStatus: 'Collaboration status',
  Cargo_BusinessStatusRemark: 'Business status remarks',
  Cargo_ChargeStatusRemark: 'Charge status remarks',
  Cargo_CooperateStatusLog: 'Collaboration status log',
  Cargo_BusinessStatusLog: 'Business status log',
  Cargo_ChargeStatusLog: 'Charge status log',
  Cargo_AssociatedWithMasterTicket: 'Associated with master ticket',
  Cargo_SelectCooperateBranch: 'Select collaboration branch',
  Cargo_CooperateBranchCannotBeEmpty: 'The collaboration branch cannot be empty.',
  Cargo_CooperateBusinessTypeCannotBeEmpty: 'The collaboration business type cannot be empty.',
  Cargo_Cooperation: 'Cooperation',
  Cargo_CooperationReturn: 'Return',
  Cargo_CooperateStatusApprovedCanTBeDeleted: 'The collaboration status has been approved and cannot be deleted.',
  Cargo_CooperateSucceed: 'Collaboration success',
  Cargo_CooperateLogOperation: 'Operation content',
  Cargo_CooperateLogState: 'Post-operation status',
  Cargo_CooperateLogContent: 'Details',
  Cargo_AreYouSureReturn: 'Are you sure return?',
  Cargo_CooperateCreatedDate: 'Collaboration task creation time',
  Cargo_CooperateReviewSeparately: 'There are collaboration businesses in the selected records, please review them separately',
  Cargo_CooperateNoPretrialReview: 'There is no review for collaboration business',
  Cargo_ShowCooperateAll: 'More collaboration information',
  Cargo_SettleBranchId: 'Settle BranchId',
  Cargo_ShowInternalCharges: 'Show internal',
  Cargo_InternalCharges: 'Domestic',
  Cargo_IsCooperate: ' is a collaborative business, which can only be operated by the order receiving branch',
  Cargo_BranchCooperate: 'Assistance business',
  Cargo_DownLoad_Template: 'DownLoad Template',
  Cargo_EstimatedWarehousingTime: 'Estimated warehousing time',
  Cargo_ActualWarehousingTime: 'Actual warehousing time',
  Cargo_EstimatedDeliveryTime: 'Estimated delivery time',
  Cargo_ActualDeliveryTime: 'Actual delivery time',
  Cargo_SyncWarehouseData: 'Get warehouse data synchronously',
  Cargo_PleaseEnterActualWarehousingTime: 'Please enter actual warehousing time',
  Cargo_LockOrderTip: 'All eligible businesses will be updated to Approved. Do you want to continue?',
  Cargo_MatchedLockOrderCount: 'Matched businesses: {0}',
  Cargo_RefreshTcloudToken: 'Refresh openToken',
  Cargo_SeaBooking: 'Shipping booking',
  Cargo_RailwayOperate: 'Railway operate',
  Cargo_IntegratedOperate: 'Integrated operate',
  Cargo_Timezone: 'Time zone',
  Cargo_HiddenPlatform: 'Hidden platform prefabricated template',
  Cargo_TemplateName: 'Template Scheme Name',
  Cargo_PleaseEnterPlanRemark: 'Please enter a scheme description',
  Cargo_StartLine2: 'Starting line (including title)',
  Cargo_PleaseEnterStartLine: 'Please enter the starting line',
  Cargo_ImportTableSet: 'Import Table Settings',
  Cargo_PleaseQuery: 'Please search',
  Cargo_EnableFilterRowRule: 'Enable filtering row rules',
  Cargo_ImportColumnsFilterOut: 'When importing a table, each row of data that meets the settings in the table\'s valid columns will be filtered out.',
  Cargo_SpaceGreaterThan: 'The proportion of spaces is greater than',
  Cargo_PleaseEnterHeaderName: 'Excel cell name: Please enter the header name that needs to be imported into the Excel table.',
  Cargo_PleaseEnterHeaderGridNum: 'Excel cell column number: Please enter the column number that needs to be imported into the Excel table, such as A, B, AA.',
  Cargo_AddNewTemplate: 'Create a new import template scheme',
  Cargo_SerialNo: 'Serial No.',
  Cargo_InternalTableName: 'Internal Table Name',
  Cargo_ExcelCellName: 'Excel Cell Name',
  Cargo_DocumentEntry: 'Customs Declaration Document Entry',
  Cargo_QueryTags: 'Query Mark',
  Cargo_ChargebackManage: 'Chargeback Management',
  Cargo_ReconciliationRule: 'Reconciliation Rules',
  Cargo_ReconciliationRuleName: 'Reconciliation Rules Name',
  Cargo_MatchFieldSettings: 'Match Field Settings',
  Cargo_PleaseSelectField: 'Please select the fields that match when comparing',
  Cargo_Relationship: 'Relationship',
  Cargo_And: 'And',
  Cargo_Or: 'Or',
  Cargo_MatchingOrder: 'Match Order',
  Cargo_MatchFieldName: 'Match Field Name',
  Cargo_CompareFieldOperations: 'Compare Field Operations',
  Cargo_SelectFieldToCompare: 'Select the field names to compare',
  Cargo_CompareOrder: 'Compare Order',
  Cargo_CompareField: 'Compare Field',
  Cargo_ComparisonOperation: 'Comparison Operation',
  Cargo_MultiRowSumMethod: 'Multi Row Summary Method',
  Cargo_ComparisonSingleLine: 'Comparison of Single Line Details',
  Cargo_AttachFilePlaneOrNot: 'Attach file with Plane or not',
  Cargo_FlightDate: 'Flight Date',
  Cargo_OtherWarehousingInstructions: 'Other Warehousing Instructions',
  Cargo_PhotoShootingAwait: 'Photo-shooting list for goods awaiting warehousing',
  Cargo_PhotoShootingAwaitPallets: 'Photo-shooting list for goods awaiting loading onto pallets',
  Cargo_DeleteSelected: 'Delete Selected',
  Cargo_StartUploading: 'Start Uploading',
  Cargo_Register: 'Register',
  Cargo_Void: 'Void',
  Cargo_Unbind: 'Unbind',
  Cargo_OrderPassingAgent: 'Order Passing Agent',
  Cargo_BusinessBookiingAgent: 'Business booking agent',
  Cargo_RegisteredDate: 'Registered Date',
  Cargo_EstimatedBackDate: 'Estimated Back Date',
  Cargo_ActualBackDate: 'Actual Back Date',
  Cargo_FreightRateM: 'Freight Rate M',
  Cargo_FreightRateN: 'Freight Rate N',
  Cargo_FreightRate45: 'Freight Rate 45',
  Cargo_FreightRate100: 'Freight Rate 100',
  Cargo_FreightRate300: 'Freight Rate 300',
  Cargo_FreightRate500: 'Freight Rate 500',
  Cargo_FreightRate1000: 'Freight Rate 1000',
  Cargo_NewIATAFreightRate: 'New IATA Freight Rate',
  Cargo_EditIATAFreightRate: 'Edit IATA Freight Rate',
  Cargo_DeliveryStation: 'Delivery Station',
  Cargo_FlightSchedule: 'Flight Schedule',
  Cargo_Schedule: 'Schedule',
  Cargo_ArrivaledTime: 'Arrival Time',
  Cargo_Voyage: 'Voyage',
  Cargo_MustBEntered: 'Must Be Entered',
  Cargo_NewFlight: 'New Flight',
  Cargo_EditFlight: 'Edit Flight',
  Cargo_OneWayPort: 'One Way Port',
  Cargo_SecondPort: 'Second Port',
  Cargo_ThirdPort: 'Third Port',
  Cargo_TransshipmentPort: 'Transshipment Port',
  Cargo_NewLine: 'New Line',
  Cargo_EditLine: 'Edit Line',
  Cargo_NewAirTransportationArea: 'New Air Transportation Area',
  Cargo_EditAirTransportationArea: 'Edit Air Transportation Area',
  Cargo_RegionalPorts: 'Regional Ports',
  Cargo_OriginRegionCode: 'Origin Region Code',
  Cargo_TargetRegionCode: 'Target Region Code',
  Cargo_NewRoute: 'New route',
  Cargo_ResponsibilityList: 'Responsibility List',
  Cargo_ResponsibilityInformation: 'Responsibility Information',
  Cargo_ResponsibilityStep1: 'Step 1: Enter basic information of responsibilities',
  Cargo_ResponsibilityStep2: 'Step 2: Select a route',
  Cargo_ResponsibilityStep3: 'Step 3: Select an airline',
  Cargo_ResponsibilityStep4: 'Step 4: Select booking nature',
  Cargo_ResponsibilityStep5: 'Step 5: Select Airport',
  Cargo_ResponsibilityStep6: 'Step 6: Select Sales',
  Cargo_ResponsibilityStep7: 'Step 7: Determine Responsibility Information',
  Cargo_ResponsibilityNew: 'New Operation Responsibilities',
  Cargo_ResponsibilityEdit: 'Editorial responsibilities',
  Cargo_QueryType: 'Query Type',
  Cargo_NotClearedToday: 'Not Cleared Today',
  Cargo_ToBeClearedToday: 'To Be Cleared Today',
  Cargo_DeclarationTheSameDay: 'Declaration On The Same Day',
  Cargo_InculdeHistoricalData: 'Inculde Historical Data',
  Cargo_DeclarationTracking: 'Declaration Tracking',
  Cargo_FlightTracking: 'Flight Tracking',
  Cargo_ModifyDeclarationBatches: 'Modify Declaration Status in Batches',
  Cargo_PrintedTag: 'Printed Tag',
  Cargo_PrintTag: 'Print Tag',
  Cargo_CheckData: 'Check Data',
  Cargo_AWBQuantity: 'AWB Quantity',
  Cargo_AWBWeight: 'AWB Weight',
  Cargo_AWBVolume: 'AWB Volume',
  Cargo_GoodsSize: 'Goods Size',
  Cargo_ActualFlight: 'Actual Flight',
  Cargo_OnwardInformation: 'Onward information',
  Cargo_AttachmentDescription: 'Attachment Description',
  Cargo_CustomsDeclarationStatus: 'Customs Declaration Status',
  Cargo_NumberDeclaration: 'Number Of Customs Declaration Items',
  Cargo_DeclarationGrossWeight: 'Customs Declaration Gross Weight',
  Cargo_CustomsDeclarationRemarks: 'Customs Declaration Remarks',
  Cargo_DeleteAccountingEntry: 'Delete an Accounting Entry',
  Cargo_Assets: 'Assets',
  Cargo_LineNo: 'Line No',
  Cargo_LiabilitiesOwner: 'Liabilities and Owner (or Shareholder) Equity',
  Cargo_LineNo2: 'Line No ',
  Cargo_OpeningAmountOfTheYear2: 'Opening Amount of the Year ',
  Cargo_PeriodEndAmount2: 'Ending balance ',
  Cargo_AmountOfMonth: 'Amount Of Month ',
  Cargo_AmountOfYear: 'Amount Of Year ',
  Cargo_TrackingTipOne: 'This icon is used for B2B systems!',
  Cargo_TrackingTipTwo: 'Note: It is recommended to use white png format and upload icons with a size not exceeding 500KB.',
  Cargo_WarehouseMapTip: 'Note: It is recommended to upload the image format of the warehouse map as PNG/JPG.',
  Cargo_UploadDataSizeMore500KB: 'File size cannot be greater than 500KB!',
  Cargo_RuleNotesTip: 'Notes can be filled in to users to view prompts use.',
  Cargo_MainOrderRegistr: 'Main order registration',
  Cargo_MainOrderStart: 'Main order start number',
  Cargo_TotalCopies: 'Total copies',
  Cargo_LastUpdateTime: 'Last update time',
  Cargo_AddBranch: 'Add Branch',
  Cargo_CopyBranch: 'Copy Branch',
  Cargo_EORIDetail: 'EORI Detail',
  Cargo_DeleteEORITip: 'EORI cannot be recovered after being deleted. Are you sure to delete it?',
  Cargo_EORINotNull: 'EORI not null',
  Cargo_EORINotDuplicate: 'EORI not duplicate',
  Cargo_AddDept: 'Add Department',
  Cargo_BranchCnName: 'Branch English Name',
  Cargo_ChineseAddress: 'Chinese Address',
  Cargo_BranchEnName: 'Branch English Name',
  Cargo_BranchCode: 'Branch Code',
  Cargo_PostalCode: 'Postal Code',
  Cargo_Email: 'Email',
  Cargo_LocalCurrency2: 'Local Currency',
  Cargo_DefaultAirport: 'Default Airport',
  Cargo_DefaultHarbor: 'Default Harbor',
  Cargo_DefaultTimeZone: 'Default Time Zone',
  Cargo_RMBAccount: 'Payment RMB Account',
  Cargo_USDAccount: 'Payment USD Account',
  Cargo_ReceiveRMBAccount: 'Receiving RMB Account',
  Cargo_ReceiveUSDAccount: 'Receiving USD Account',
  Cargo_DefaultPaymentAccount: 'Default Payment',
  Cargo_DefaultReceiveAccount: 'Default Receive',
  Cargo_OverseasBillingAddress: 'Overseas Billing Address',
  Cargo_DomesticBillingAddress: 'Domestic Billing Address',
  Cargo_OverseasEDICode: 'Overseas EDI Code',
  Cargo_ValueAddedTaxRate: 'Value-added Tax Rate',
  Cargo_InvoicingTaxRate: 'Invoicing Tax Rate',
  Cargo_SettleEmail: 'Settle Email',
  Cargo_TaxationSystemAPIAddress: 'Taxation System API Address',
  Cargo_TaxControlMachineNo: 'Tax Control Machine No.',
  Cargo_ElectronicInvoicePlatformCode: 'Electronic Invoice Platform Code',
  Cargo_ElectronicInvoice: 'Electronic Invoice',
  Cargo_ElectronicInvoiceTaxpayer: 'Electronic Invoice Taxpayer Identification Number (TIN)',
  Cargo_ElectronicInvoiceAuthCode: 'Electronic Invoice Taxpayer Authorization Code',
  Cargo_ElectronicInvoiceRequestAddress: 'Electronic Invoice Service Request Address',
  Cargo_InvoiceCancellationRequestAddress: 'Invoice Cancellation Request Address',
  Cargo_EFreighAMSAccount: 'E-Freigh(AMS Account)',
  Cargo_EFreighACIAccount: 'E-Freigh(ACI Account)',
  Cargo_Preview: 'Preview',
  Cargo_NewBranchInformation: 'New Branch Information',
  Cargo_AssociatePartners: 'Associated Partner',
  Cargo_AddRole: 'Add Role',
  Cargo_DepartmentCode: 'Department Code',
  Cargo_JobNumberCodeField: 'Job Code Field',
  Cargo_SettlementCompanyIsOrNot: 'Settlement Company Or Not',
  Cargo_Introduction: 'Introduction',
  Cargo_EnableOpen: 'Enable',
  Cargo_DisableOpen: 'Disable',
  Cargo_GeneralSettings: 'General Settings',
  Cargo_ControlMode2: 'Control Mode:',
  Cargo_ReminderMode: 'Reminder Mode',
  Cargo_LockMode: 'Lock Mode',
  Cargo_Notification: 'Notification:',
  Cargo_LockingControl: 'Locking Control:',
  Cargo_Event: 'Event',
  Cargo_NotificationMethod: 'Notification Method',
  Cargo_NotificationObject: 'Notification Object',
  Cargo_BLRelease: 'BL Release',
  Cargo_NoLock: 'No Lock',
  Cargo_NewOrCopyJob: 'New/Copy Formal Job Sheet',
  Cargo_LockAfterSaving: 'Lock after saving',
  Cargo_CannotBeSaved: 'Cannot be saved',
  Cargo_JobSheetIsLocked: 'Job Sheet is Locked',
  Cargo_JobSheetIsUnlocked: 'Job Sheet is Unlocked',
  Cargo_CreditLimitExceeded2: 'Credit Limit Exceeded',
  Cargo_CreditLimitChanged: 'Credit Limit Changed',
  Cargo_CreditForewarning: 'Credit control and early warning',
  Cargo_PaymentPeriodForewarning: 'Early warning of payment period',
  Cargo_CreditControlManager: 'Credit Control Manager',
  Cargo_TemplateManagement: 'Template Management',
  Cargo_TemplateTypeManagement: 'Template Type Management',
  Cargo_ConfigurationManagement: 'Configuration Management',
  Cargo_MappingManagement: 'Mapping Management',
  Cargo_InitializeTemplateManagement: 'Initialize Template Management',
  Cargo_BusinessStatusManagement: 'Business Status Management',
  Cargo_TriggerTypeManagement: 'Trigger Type Management',
  Cargo_FileTypeManagement: 'File Type Management',
  Cargo_DefaultValueManagement: 'Default Value Management',
  Cargo_ValidationRuleConfiguration: 'Validation Rule Configuration',
  Cargo_EDITemplateSettings: 'EDI Settings',
  Cargo_OnlineShippingOrderSettings: 'Online Shipping Order Settings',
  Cargo_RouteAndWarehouseConfiguration: 'Route/port preset configuration',
  Cargo_PushServiceConfiguration: 'Push Service Configuration',
  Cargo_CustomInvoiceRemarks: 'Custom Invoice Remarks',
  Cargo_EmailTemplateManagement: 'Email Template Management',
  Cargo_BillOfLadingConfiguration: 'Bill of Lading Configuration',
  Cargo_BranchBankAccount: 'Branch Bank Account',
  Cargo_SetRMBAccount: 'Set as default RMB Account',
  Cargo_SetUSDAccount: 'Set as default USD Account',
  Cargo_SetReceiveRMBAccount: 'Set as default Receiving RMB Account',
  Cargo_SetReceiveUSDAccount: 'Set as default Receiving USD Account',
  Cargo_SetDefaultPaymentAccount: 'Set Default Payment Account',
  Cargo_SetDefaultReceiveAccount: 'Set Default Receive Account',
  Cargo_ShortName: 'Short Name',
  Cargo_Instructions: 'Instructions',
  Cargo_BankChineseAddress: 'Bank Chinese Address',
  Cargo_BankEnglishAddress: 'Bank English address',
  Cargo_BankCode: 'Bank account number',
  Cargo_HeaderTitle: 'Associated Title',
  Cargo_ClosingAccountRecord: 'Closing account record',
  Cargo_ClosingAccountReview: 'Closing account review',
  Cargo_SelectClosingAccountDate: 'Select closing account date',
  Cargo_EditConfigurationItem: 'Edit Configuration Item',
  Cargo_EditConfigurationDefinition: 'Edit Configuration Definition:',
  Cargo_CreditLimitExceededApproval: 'If credit limit exceeded, lock the job sheet until automatic release or manual approval',
  Cargo_CreditOnlyReminder: 'After the credit is exceeded, only a reminder will be sent, and the work order will not be locked.',
  Cargo_OperationExecutive: 'Operation Executive',
  Cargo_SalesExecutive: 'Sales Executive',
  Cargo_CreditControlSupervisor: 'Credit Control Manager',
  Cargo_BusinessCustomerService: 'Business customer service',
  Cargo_EmailsAndReminders: 'Emails and reminders',
  Cargo_Bell2: 'Internal bell',
  Cargo_Email2: 'Email',
  Cargo_BatchAddRolePermissions: 'Batch add role permissions',
  Cargo_RoleName: 'Role name',
  Cargo_PermissionName: 'Permission Name',
  Cargo_PermissionCategory: 'Permission category',
  Cargo_PermissionType: 'Permission type',
  Cargo_PermissionPoint: 'Permission point',
  Cargo_UpdatePermissionGroups: 'Update permission groups',
  Cargo_Personal2: 'Personal',
  Cargo_DepartmentGroups: 'Department groups',
  Cargo_GreaterRemove: 'Remove>>',
  Cargo_LessAdd: '<<Add',
  Cargo_PleaseEnterNameEtc: 'Please enter Chinese name, English name, email, etc.',
  QuickSearchUser: 'Quick search: login name, Chinese name, English name, email address',
  Cargo_Expired: 'Expired',
  Cargo_NearExpiration: 'Near expiration',
  Cargo_NotVetDueEytended: 'Not vet due/Eytended',
  Cargo_History: 'History',
  Cargo_QuickSearchContractNumber: 'Quick Search: Contract Number',
  Cargo_Reminder30Day: 'Reminder: System set to Near Expiration within 30 days',
  Cargo_PleaseSelectContractRecord: 'Please select a contract record.',
  Cargo_ContractAgreement: 'Contract Agreement',
  Cargo_WhetherBookingConfirmation: 'Whether Booking Confirmation has been Uploaded',
  Cargo_IsContractAgreementUploaded: 'Is Contract Agreement Uploaded',
  Cargo_ContractProhibitedOperated: 'This contract has been renewed and is prohibited from being operated.',
  Cargo_NeedToUpdateOrNot: 'Need to update or not',
  Cargo_ContractCreator: 'Contract Creator',
  Cargo_ContractCreationTime: 'Contract Creation Time',
  Cargo_PartnerCreation: 'Partner Creator',
  Cargo_ContractAuditor: 'Contract Auditor',
  Cargo_ContractAuditTime: 'Contract Audit Time',
  Cargo_TimeLeftUntilExpiry: 'Time left until expiry',
  Cargo_DayRemind: 'days remind',
  Cargo_NoteReminderMethod: 'Note: The reminder method is "system reminder", and the system will remind 2 days before expiration.',
  Cargo_ProhibitBusinessConfiguration: 'Prohibit business configuration:',
  Cargo_SettlementMethodGreaterThan0: 'Settlement method: on a specified day of each month or with a credit term greater than 0.',
  Cargo_ViewContract: 'View Contract',
  Cargo_PaymentTermPeriod: 'Payment term period',
  Cargo_WeekSettlement: 'Weekly Payment',
  Cargo_EveryMonth: 'Every month',
  Cargo_Day: 'day',
  Cargo_CAN_NOT_APPROVED: 'The selected data contains business with status {0} and cannot be approved. Please check!',
  Cargo_CAN_NOT_CANCEL_APPROVED: 'The selected data contains business with status {0}, which cannot be unapproved. Please check!',
  Cargo_HasOneOnly: 'Please select only one record!',
  Cargo_CloseAndCopySerialNumber: 'Close and copy the transaction number.',
  Cargo_QuickSearchBillPayment: 'Quick search: Payment request number.',
  Cargo_AmsNoTooltip: 'We suggest that when sending EDI messages, the number of AMS NO characters should not exceed 12.',
  Cargo_AmsNoEFreightTooltip: 'We suggest that when sending EDI messages, the number of AMS NO characters should not exceed 12,When sending, the prefix equal to Nvocc Scac will be removed.',
  Cargo_AmsNoLengthTooltip: 'AMS NO has exceeded 12 characters. Do you want to continue sending?',
  Cargo_AmsShipperLine1tip: 'Reminder: When the NAME name is too long, it can be immediately filled in ADDRESS1',
  Cargo_AmsUnitTypeTip: 'Can maintain the "Counter terrorism packaging code" mapping code in the mapping configuration',
  Cargo_VoyageFlightLengthTooltip: 'The Voyage cannot exceed 5 characters',
  Cargo_VoyageFlightSpecialCharactersTooltip: 'There are special characters in the Voyage field. Do you want to continue sending? Suggest making changes and continuing to send!',
  Cargo_BargeRemarks: 'Regional Barge Remarks',
  Cargo_CalcRuleNotes: 'Calc. Rule Notes',
  Cargo_Pending: 'Pending',
  Cargo_Processing: 'Processing',
  Cargo_Completed1: 'Completed',
  Cargo_Revoked: 'Revoked',
  Cargo_StartTime: 'Start Time',
  Cargo_StartDate: 'Start Date',
  Cargo_ProcessName: 'Process Name',
  Cargo_ApprovalSerialNumber: 'approval Serial number',
  Cargo_ApprovalDate: 'Approval Date',
  Cargo_Approver: 'Approver',
  Cargo_ApprovalTemplate: 'Approval Template',
  Cargo_ProcessingStatus: 'Status',
  Cargo_PleaseFill: 'Please fill',
  Cargo_PleaseMaintain: 'Please maintain',
  Cargo_MessageNotificationMethod: 'Message notification method',
  Cargo_AreYouSureAboutTheModificationProcess: 'Are you sure about the modification process?',
  Cargo_AreYouSureAboutTheModificationProcessTips: 'After confirming the modification, the process in process will continue according to the process at the time of initiation. Subsequent initiated processes are executed according to the modified process.',
  Cargo_SetUpTheProcessTriggerCondition: 'set up the Process trigger condition.',
  Cargo_CurrentApprover: 'Current Approver',
  Cargo_Initiator: 'Initiator',
  Cargo_ApprovalRecord: 'Approval Record',
  Cargo_SelectTheApprover: 'Select the approver',
  Cargo_RoleSelection: 'Role Selection',
  Cargo_ReviewTheProcessRecord: 'review the Process record',
  Cargo_BatchApproval: 'Batch Approval',
  Cargo_BatchReject: 'Batch Reject',
  Cargo_TerminateTheProcess: 'Terminate The Process',
  Cargo_ApprovalComments: 'Approval Comments',
  Cargo_ApprovalTime: 'Approval Time',
  Cargo_ApprovalCommentsRecord: 'Approval Comments Record',
  Cargo_IInitiated: 'I Initiated',
  Cargo_IDealWithIt: 'I deal with it',
  Cargo_SubmitAPaymentRequestForApproval: 'submit a Payment request for approval',
  Cargo_ReviewTheApprovalProcess: 'Review The Approval Process',
  Cargo_Committed: 'Committed',
  Cargo_Agreed: 'Agreed',
  Cargo_Opinion: 'Opinion',
  Cargo_ReviewWithdrawal: 'Review Withdrawal',
  Cargo_ProcessRevocation: 'Process Revocation',
  Cargo_AlreadyWithdraw: 'Already Withdraw',
  Cargo_NoHandlingRequired: 'No handling required',
  Cargo_MyApprovals: 'My Approvals',
  Cargo_ApprovalsThatIInitiated: 'Approvals That I Initiated',
  Cargo_ApprovalsThatIHandle: 'Approvals that I handle',
  Cargo_CreateProcess: 'Create Process',
  Cargo_EditProcess: 'Edit Process',
  Cargo_CopyProcess: 'Copy Process',
  Cargo_DeleteProcess: 'Delete Process',
  Cargo_ProcessComment: 'Process Comment',
  Cargo_RevertProcessStatus: 'Revert Process Status',
  Cargo_RevertProcess: 'Revert Process',
  Cargo_RejectProcess: 'Reject Process',
  Cargo_NotificationEmailCC: 'Notification Email CC',
  Cargo_Irrevocable: 'Irrevocable',
  Cargo_EstimateListQuery: 'Preliminary estimates query',
  Cargo_MappingConfiguration: 'IMappingsConfiguration',
  Cargo_CreateEstimate: 'Create a preliminary estimate',
  Cargo_SendSharingCenter: 'Sending sharing center',
  Cargo_GenerateExpenseAmount: 'Generate Expense Amount',
  Cargo_GenerateExpenseMode: 'Generate Expense Mode',
  Cargo_GenerateInReceivables: 'Generate in Receivables',
  Cargo_GenerateInPay: 'Generate in Payables',
  Cargo_GenerateAll: 'Generate in Both Receivables and Payables',
  Cargo_ChargeAmount: 'Please enter the generated expense amount',
  Cargo_PushDate: 'push out delivery date',
  Cargo_GetSendResult: 'Get send result',
  Cargo_ALittleSend: 'Push as sporadic customers',
  Cargo_MappingEditor: 'Mapping Editor',
  Cargo_NewMapping: 'New mapping',
  Cargo_Recipient: 'Recipient',
  Cargo_DataRepetition: 'Duplicate data',
  Cargo_checkTip2: '{0} or {1}.',
  Cargo_ErrorExcel: 'Postage Mode Parameter Error',
  Cargo_ImportException: 'Import exception',
  Cargo_SelectiveFinanceMonth: 'Selective finance month',
  Cargo_FinancialMonth: 'monthly financial statements',
  Cargo_PushLog: 'Push record',
  Cargo_ConfirmImport: 'Confirm import',
  Cargo_NumberOfOriginalCopies: 'Number of original copies',
  Cargo_DisplayDllInformation: 'Display all information',
  Cargo_DisplayDifferenceInformation: 'Display difference information',
  Cargo_OverrideSystemBillOfLading: 'Override system bill of lading',
  Cargo_ContainerIdTip: 'Container Information (if selected, it will be added to the bill of lading or overwrite the bill of lading data)',
  Cargo_ContainerInfo2: 'Container Information (selected to add to the business, editable)',
  Cargo_ContainerTypeQuantityMismatch: 'Container type/quantity does not match the selected container information, please confirm.',
  Cargo_SystemData: 'System data',
  Cargo_RecognitionData: 'Recognition data',
  Cargo_SETitle: 'Scheduled Departure Time/Estimated Time of Arrival (ETA)',
  Cargo_CurentSETitle: 'Current Estimated Time of Departure (ETD)/Current Estimated Time of Arrival (ETA)',
  Cargo_OriginalSETitle: 'Original Estimated Time of Departure (ETD)/Original Estimated Time of Arrival (ETA)',
  Cargo_AETitle: 'Estimated Departure Time/Estimated Arrival Time',
  Cargo_SEAtdAtaTitle: 'Actual departure time (ATD)/actual arrival time (ATA)',
  Cargo_AEAtdAtaTitle: 'Actual Time of Departure (ATD)/Actual Time of Arrival (ATA)',
  Cargo_UpdateAtdAtaDateTip: 'Please enter the actual departure time and actual arrival time that need to be modified',
  Cargo_UpdateAtdAtaDateTip2: 'Please enter the actual departure time and actual arrival time that need to be modified',
  Cargo_UpdateDateTip: 'Please enter the planned departure time and the estimated time of arrival that need to be modified',
  Cargo_UpdateDateTip2: 'Please enter the estimated departure time and the estimated arrival time that need to be modified',
  Cargo_BusinessNotPositiveOperation: '{0} is not in a positive operational status, time modification is not possible',
  Cargo_SuccessTip: 'Successfully processed {0} items, with 0 failures',
  Cargo_SuccessTip1: 'Successfully processed {0} items, with {1} failures,<br/>Failure explanation: <br/> {2} is not in a positive operational status, time modification is not possible',
  Cargo_SuccessTip2: 'Success: {0}, Failed: {1}.<br/>Failure reasons: <br/> {2} is not in operable status and cannot be modified <br/> {3} only selected house bill without master bill information, cannot be modified',
  Cargo_ErrorCause: 'anomalous cause',
  Cargo_PushMessage: 'Push message',
  Cargo_PushMessageRsp: 'Message Reception',
  Cargo_ViewMessage: 'View message',
  Cargo_Message: 'message',
  Cargo_BusinessApplicationContext: 'Business Application Context',
  Cargo_ConfigureEmailTemplate: 'Configure Email Template',
  Cargo_SendingPosition: 'Sending Position',
  Cargo_DeleteEmailTip: 'Are you sure you want to delete the selected email templates?',
  Cargo_UpdateEmailTip: 'The email template name cannot be empty!',
  Cargo_UpdateEmailTip2: 'Push segment: {0}, recipient: {1}, there is already a related setting, please do not repeat!',
  Cargo_UpdateEmailTip3: 'Template name [{0}] already exists, email template name cannot be repeated!',
  Cargo_EmailTemplate: 'Email Template',
  Cargo_OrganizeClearing: 'organize clearing',
  Cargo_DocumentCode: 'receipt number',
  Cargo_BillDate2: 'bill date',
  Cargo_EndDate2: 'due date',
  Cargo_doTip: 'The backend is processing, please refresh the page later to check',
  Cargo_TypeOfExchange: 'Type of transaction',
  Cargo_CurrentAccountCode: 'Current account code',
  Cargo_PE: 'Preliminary estimate/estimate',
  Cargo_ENo: 'Estimate the order number',
  Cargo_OrderChannel: 'Applicable order channels',
  Cargo_MonthlyFinancial: 'monthly financial statements',
  Cargo_DocumentId: 'Service system document ID',
  Cargo_NotInWarehouse: 'The goods have not been warehoused. Do you want to issue the outbound instruction in advance? Click "Confirm" to issue the instruction.',
  Cargo_NotInWarehouse2: 'The goods have not been warehoused. Do you want to withdraw the advance outbound instruction? Click "Confirm" to withdraw.',
  Cargo_OutboundInstructionIssued: 'Outbound instruction has been issued',
  Cargo_AlreadyOutbound: 'The goods have already been dispatched from the warehouse and the outbound instruction cannot be canceled.',
  Cargo_SourceSystemCoding: 'Source system coding',
  Cargo_businessShipAgency: 'Business Type (Shipping Agency)',
  Cargo_CoinsReceivable: 'Currency Receivable',
  Cargo_ArApAmount: 'Accounts Receivable/Payable Amount',
  Cargo_CostItem: 'Cost Item Code',
  Cargo_TaxNumber: 'Tax Number',
  Cargo_IsDefaultTitle: 'Is Default Title',
  Cargo_SingleTitleMode: 'Single Title Mode',
  Cargo_MultipleTitleMode: 'Multiple Title Mode',
  Cargo_UnitPrice2: 'Unit Price (Including Tax)',
  Cargo_TaxRateCode: 'Tax Rate Code',
  Cargo_Discount: 'Discount Method',
  Cargo_CanNotChargeTips: 'There are existing non-editable expenses, please handle them in a timely manner!',
  Cargo_RefreshChargeTips: 'There are existing expenses, would you like to refresh the expenses?',
  Cargo_ArAmount: 'Accounts Receivable Amount',
  Cargo_MonthCode: 'Month Code',
  Cargo_beforeChange1: 'Estimated profit for the entire ticket before change',
  Cargo_beforeChange2: 'Estimated profit for the entire ticket after change',
  Cargo_TaxPolicyCoding: 'Tax Policy Code',
  Cargo_SendingSharingCenter: 'Sending to Sharing Center',
  Cargo_SendingResult: 'Push Successful: {0} records, Failed: {1} records',
  Cargo_System2: 'System',
  Cargo_FileDelete: 'File deletion: Delete',
  Cargo_BillsPayable: 'Billable',
  Cargo_PaymentSlipDataNo: 'Payment Slip Data No',
  Cargo_Payer: 'Payer',
  Cargo_Prepaid: 'Prepaid',
  Cargo_TypeOfInvoice: 'Type of Invoice',
  Cargo_UploadInvoiceCloudStatus: 'Upload Invoice Cloud Status',
  Cargo_AccountToBeCredited: 'Account to Be Credited',
  Cargo_BankConnectionNo: 'Bank Connection No/SWIFT CODE',
  Cargo_BankConnectionNo2: 'Bank Connection No/SWIFT',
  Cargo_OriginalPaymentSlipNo: 'Original Payment Slip No',
  Cargo_ProcessNumber: 'Process Number',
  Cargo_FinancialPayStatus: 'Financial Pay Status',
  Cargo_PaymentRequisitionStatus: 'Payment Requisition Status',
  Cargo_DefaultDetailItems: 'Default detail entries',
  Cargo_GeneratePay: 'Generate Payable',
  Cargo_MergeGeneratePay: 'Merge Generate Payable',
  Cargo_PrintChannel: 'Print Channel',
  Cargo_BookingConfirmed: 'Booking confirmed',
  Cargo_OrderRecorded: 'Order recorded',
  Cargo_CreateBillsPayable: 'Create Billable',
  Cargo_FinancialPayAreSent: 'Financial Payable Sent',
  Cargo_PaymentRequestSent: 'Payment Request Sent',
  Cargo_DetailEntryID: 'Detail Entry ID',
  Cargo_PayableSingleAttribute: 'Payable Single Attribute',
  Cargo_SelectAp2: 'Please select payment requests with consistent invoice headers',
  Cargo_SelectAp: 'Please select payable',
  Cargo_LookAp: 'View Payable',
  Cargo_IdentifyTheCustomsTips: 'There are files that are being parsed or have already been parsed.',
  Cargo_IdentifyTheCustomsDeclaration: 'Identify the customs declaration',
  Cargo_RefreshCustomsDeclaration: 'Refresh the customs declaration',
  Cargo_CustomsActivatedTip: 'The customs declaration recognition service function is not activated.',
  Cargo_CustomsActivatedTip2: 'Insufficient balance, please contact customer service to recharge.',
  Cargo_CustomsDeclarationNo: 'customs declaration number',
  Cargo_AnalysisStatus: 'Analysis Status',
  Cargo_SystemFee: 'system fee',
  Cargo_InsurancePremium: 'insurance premium',
  Cargo_ProcessingFee: 'processing fee',
  Cargo_FOBValue: 'FOB value',
  Cargo_ExportCustomsDeclaration: 'export customs declaration',
  Cargo_Nonstop: 'only consider nonstop flights',
  Cargo_InternationalRoute: 'only consider international routes',
  Cargo_SelectNoDeleteAp: '【Payable】 has been pushed, cannot be deleted.',
  Cargo_SelectInvoiceAR: 'Please select Accounts Receivable invoice',
  Cargo_SelectInvoiceAR2: 'Please select the data that has already been pushed to retrieve its status.',
  Cargo_SelectNoPushData: 'Please select data that has not been pushed',
  Cargo_SelectNoDelete: '【Provisional Estimate】has been pushed and cannot be deleted',
  Cargo_SendSharedCenter: 'The sharing center status was sent',
  Cargo_SelectInvoiceType: 'Please select the invoice type',
  Cargo_EditAp: 'Edit payables',
  Cargo_NotPushAP: 'Collection situation, no need to push [financial payables]',
  Cargo_NotPushAP2: 'The link number /SWIFT is empty and cannot be sent',
  Cargo_AttachmentName: 'Various attachment names',
  Cargo_AccessoriesAddress: 'Accessories Address',
  Cargo_canNotEdit: 'Already pushed, cannot edit',
  Cargo_GetTheWriteOffResult: 'Get the write-off result',
  Cargo_RemarkMax200: 'Remarks must not exceed 200 characters',
  Cargo_RemarkAutoTruncated: 'Exceeded 200 characters, automatically truncated',
  Cargo_RemarkTip1: 'Invoice remarks total more than 230 characters',
  Cargo_RemarkTip2: 'In the ticketing scenario, when "non-detailed invoicing" is selected, the invoicing title and invoicing item name need to be filled in',
  Cargo_PortOfTransferCheck: 'Please select the "Port of Transfer"',
  Cargo_BatchServiceLocking: 'Batch service locking',
  Cargo_UnlockServicesInBatches: 'Unlock services in batches',
  Cargo_BindApprovalTemplate: 'Bind Approval Template',
  Cargo_ProcessTriggerCondition: 'process trigger condition',
  Cargo_TriggerConditionConfiguration: 'Trigger condition configuration',
  Cargo_ApplicationBusinessDivision: 'Application Business Division',
  Cargo_ApproverSource: 'Approver Source',
  Cargo_ApproverExecutionMode: 'Approver Execution Mode',
  Cargo_FirstNodeSupervisorNextNodePreviousApproverSupervisor: 'First Node Supervisor Next Node Previous Approver Supervisor',
  Cargo_AnyApproverCanHandle: 'Any Approver Can Handle',
  Cargo_AllApproversAtCurrentNodeRequired: 'All Approvers At Current Node Required',
  Cargo_TheNumberOfApprovalsInProgress: 'The number of approvals in progress',
  Cargo_NotNamed: 'not named',
  Cargo_AdministratorSettings: 'Administrator Settings',
  Cargo_FormName: 'Form Name',
  Cargo_NumberOfConfigurableBranches: 'Number of configurable branches',
  Cargo_ExistDocumentPlatformConfig: 'This branch already has this form status as enabled, please confirm before proceeding with the operation.',
  EnableOrNot: 'Enable or not',
  Cargo_InitiateApproval: 'Initiate approval',
  Cargo_InitiateBranchCompany: 'Initiate branch company',
  Cargo_ApplicationBranch1: 'Application Branch',
  Cargo_InitiateApprovalSuccessfully: 'Initiate approval successfully.',
  Cargo_AreYouSureToInitiateTheApproval: 'Are you sure to initiate the approval?',
  Cargo_AreYouSureToDo: 'Are you sure to {0}?',
  Cargo_InitiateDepartment: 'Initiate department',
  Cargo_WhetherItIsEnabled: 'Whether it is enabled',
  Cargo_Deactivate: 'Deactivate',
  Cargo_PleaseSelectTenantId: 'Please select a platform ID',
  Cargo_PleaseSelectOfficeIds: 'Please select an application branch',
  Cargo_PleaseSelectDocumentConfigId: 'Please select a form name',
  Cargo_PleaseSelectBranchCount: 'Please select the number of configurable branches',
  Cargo_PleaseSelectUserIds: 'Please select administrator settings',
  Cargo_DocumentPlatformConfigNote: 'Note: Administrators can view all approval processes related to the form.',
  Cargo_AddBranchProcess: '+Add Branch Process',
  Cargo_Priority: 'Priority',
  Cargo_TriggerConditions: 'Trigger conditions',
  Cargo_PleaseSelectDocumentConfigId2: 'Please select a binding form',
  Cargo_AddBranchProcessCheck: 'The current form has reached the maximum number of branches.',
  Cargo_BindForm: 'Bind form',
  Cargo_UnknownProcessProcessing: 'Unknown process processing',
  Cargo_AutoWriteOffAfterApproval: 'Whether to automatically write off after approval',
  Cargo_Bell: 'Bell',
  Cargo_NotifierSource: 'Cc Source',
  Cargo_PreconditionsForApproval: 'Preconditions for approval',
  Cargo_RuleConditions: 'Rule conditions',
  Cargo_ConditionalItem: 'Conditional item',
  Cargo_ConditionalRule: 'Conditional rule',
  Cargo_ConditionalValue: 'Conditional value',
  Cargo_RejectMethod: 'Reject Method',
  Cargo_AllowDirectReturnToInitiator: 'Allow direct return to initiator',
  Cargo_ReturnToTheInitiatingNode: 'Return to the initiating node',
  Cargo_Returned2: 'Returned',
  Cargo_RefuseAndReturnNode: 'Note: Refuse = Return to the previous node, Return = Return to the initiating node.',
  Cargo_RefuseTitle: 'Return to the previous node',
  Cargo_ReturnTitle: 'Return to the initiating node',
  Cargo_BillPaymentUpdateFail: 'Payment application update failed',
  Cargo_OneClickCopy: 'One click copy',
  Cargo_OneClickCopyNote: 'Note: You can copy all approval serial numbers by clicking the "One Click Copy" button for later batch queries.',
  Cargo_OneClickCopyNoteBillPaymentApply: 'Note: You can copy all application form numbers by clicking the "One Click Copy" button for later batch queries.',
  Cargo_SubmitException: 'Submit Exception',
  Cargo_ApprovalException: 'Approval Exception',
  Cargo_PriceType: 'Please select the pre-port price, trunk line price, or last-mile price. At least one inquiry type must be selected',
  Cargo_AccountPeriodRemainingDays: 'Days remaining in the accounting period',
  Cargo_WorkflowsBranchCountNotNull: 'The number of workflow branches cannot be empty',
  Cargo_WorkflowsPlatformConfigRepeat: 'This branch already has this form status as enabled, please confirm before proceeding with the operation',
  Cargo_PleaseSelectUser: 'Please select the administrator for this process',
  Cargo_Initiate: 'Initiate',
  Cargo_InitiateForm: 'Initiate form',
  Cargo_ApprovalMatters: 'Approval Matters',
  Cargo_SelectApprovalWithSameTemplate: 'Please select approval items with the same "approval template"',
  Cargo_SOPPanelNodeNotDisplayed: 'SOP panel does not display this node',
  Cargo_SOPPanelNoDataHide: 'SOP panel automatically hides when there is no data',
  Cargo_TaxInputConfig: 'Input Tax Configuration',
  Cargo_ReceiptInvoiceTitle: 'Invoice Title',
  Cargo_ReceiptInvoiceChannel: 'Invoice Channel',
  Cargo_InvoiceAssociation: 'Invoice Association',
  Cargo_BoundInvoiceOrNot: 'Bound to invoice',
  Cargo_ManualUpdate: 'Manual Update',
  Cargo_GetInvoice: 'Get invoice',
  Cargo_InvoiceTime: 'Invoice Time',
  Cargo_SellerName: 'Seller Name',
  Cargo_SellerTaxNumber: 'Seller Tax Number',
  Cargo_BuyerName: 'Buyer Name',
  Cargo_BuyerTaxNumber: 'Buyer Tax Number',
  Cargo_InvoicePool: 'Invoice pool',
  Cargo_InvoicePoolReceiving: 'Invoice Pool Receiving',
  Cargo_WriteOffBank: 'Write-off bank',
  Cargo_DepartureStation: 'Departure Station',
  Cargo_DestinationStation: 'Destination Station',
  Cargo_TransitStation: 'Transit Station',
  Cargo_TransferStation: 'Transfer Station',
  Cargo_QuickApprovalMode: 'Same approver processing method for different nodes',
  Cargo_AutoAgree: 'Auto agree',
  Cargo_PressToDo: 'Press to do',
  Cargo_CarbonCopy: 'Carbon copy',
  Cargo_ApplicationDimension: 'Application dimension',
  Cargo_ApplicationCode: 'Application code',
  Cargo_TotalReceivable: 'Total receivable',
  Cargo_TotalDues: 'Total dues',
  Cargo_PackingType: 'Packing type',
  Cargo_ViewChargeDetails: 'View charge details',
  Cargo_StartingPort: 'Starting port',
  Cargo_SubmitJobChargeForApproval: 'Submit job charge application for approval',
  Cargo_SubmitJobChargeTip: 'This ticket business needs to initiate the submission and approval process first. After the process passes, it will be automatically submitted. If it fails, the submission will fail. \nDo you want to initiate approval now?',
  Cargo_SubmitJobChargeFailTip: 'There is currently no matching expense approval process. Please contact your supervisor to improve the triggering conditions in the approval process and resubmit.',
  Cargo_BillHasBeenInitiatedForApproval: 'This bill has already been approved. You can view the approval progress and details under the "I Initiate" tab on the approval list page.',
  Cargo_SubmitInvoiceFailTip: 'There is currently no matching invoicing approval process. Please contact your supervisor to improve the triggering conditions in the approval process and resubmit.',
  Cargo_SubmitInvoiceTip: 'Initiate the invoicing approval process before invoicing. Do you want to initiate approval now?',
  Cargo_SubmitCollectionInvoiceTip: 'Before collecting tickets, initiate the ticket collection approval process first. Do you want to initiate the approval now?',
  Cargo_SOURCE_CURRENCY_NOT_NULL: 'Original currency cannot be empty!',
  Cargo_SOURCE_AMOUNT_NOT_NULL: 'Original currency amount cannot be empty!',
  Cargo_imWarning: 'This job has not enough role people to open the “CargoWare IM” chat group.',
  Cargo_ReceiptPaymentOffset: 'Pre ReceiptPayment Offset',
  Cargo_InvoicePayableOffset: 'Operating Cost Offset',
  Cargo_CheckFreightTermOne: 'When using "{0}" transportation terms, {1} and {2} cannot be empty',
  Cargo_CheckFreightTermTwo: 'When using "{0}" transportation terms, {1} cannot be empty',
  Cargo_CheckMergeExport: 'The payable invoice and prepayment voucher are merge exported, but other types cannot be selected. Please check',
  CargoMsg_QQ: 'QQ',
  CargoMsg_CorporateName: 'Corporate name',
  Cargo_DeleteUnApprovedBillTips: 'Only unapproved bills can be deleted!',
  Cargo_EditUnApprovedBillTips: 'Only unapproved bills can be edited!',
  Cargo_DeleteUnApprovedInvoiceTips: 'Only unapproved invoices can be deleted!',
  Cargo_InvalidUnApprovedInvoiceTips: 'Only unapproved invoices can be invalided!',
  Cargo_InvoiceID: 'Invoice ID',
  Cargo_PleaseSelectNeedInvalidBillPaymentTip: 'Please select the payment application that needs to be voided.',
  Cargo_Deleted: 'Deleted',
  Cargo_EnableSopTemplate: 'Enable Sop Template',
  Cargo_UnableSopTemplate: 'Unable Sop Template',
  Cargo_EnableSopTemplateConfirm: 'Are you sure to enable the current SOP template？',
  Cargo_UnableSopTemplateConfirm: 'Are you sure to disable the current SOP template? After disabling, the business cannot apply this template. But it will not affect businesses that have already used this template.',
  Cargo_Disabled2: 'Disabled',
  Cargo_Got_It: 'Got it',
  Cargo_RepeatGoldenTaxExport: 'Do not repeat the Golden Tax export.',
  Cargo_Canceled: 'Canceled',
  Cargo_UpdateCustomerInfo: 'Update customer information',
  Cargo_SyncCustomerData: 'Synchronize Customer Data',
  Cargo_Synchronizing: 'Synchronizing, please check later',
  Cargo_Prediction: 'Forecast',
  Cargo_PlaceOfDeliveryRegion: 'Place Of Delivery Region',
  Cargo_IsTransfer: 'Transfer or not',
  Cargo_TotalAmountTax: 'Total tax amount (invoice)',
  Cargo_CustomerNotOwn: 'The customer subsidiary is inconsistent with the current company',
  Cargo_SimilarPartners: 'There are already {1} companies with similar names, such as [{0}].',
  Cargo_GoBackSuccess: 'Retrieved successfully!',
  Cargo_SendBackSuccess: 'Refund successful',
  Cargo_AddSignature: 'Signed',
  Cargo_Appoint2: 'Appoint',
  Cargo_Appointer: 'Appointer',
  Cargo_ApproverRepeat: 'The approver is not allowed to be duplicate',
  Cargo_ApproverAndAppointerRepeat: 'Users cannot have both "approver" and "delegate" identities',
  Cargo_CancelAddSignature: 'It is not allowed to "cancel adding signatures" to oneself',
  Cargo_CancelAddSignatureNotSupport: 'User \'approved\' or \'delegated\' does not support \'cancel signature\'',
  Cargo_RuleError: 'Form type change, process rule configuration error',
  Cargo_SelectCcTo: 'Select CC recipient',
  Cargo_SelectSigner: 'Select signer',
  Cargo_SelectTransferor: 'Select transferor',
  Cargo_TransferSignature: 'Transferred',
  Cargo_Appointed: 'Delegated',
  Cargo_CancelSignature: 'Cancel signing',
  Cargo_OnlySupportedFCL: 'Currently, only full container business is supported',
  Cargo_CannotExceedThree: 'There are more than 3 different box types in the system, and the relevant data cannot be sent at this time. Please contact customer service personnel in a timely manner.',
  Cargo_AddSignatureSelf: 'You can\'t add signatures to yourself',
  Cargo_TransferSignatureSelf: 'It is not allowed to choose oneself as the \'transferor\'',
  Cargo_AddSignatureCurrentNode: 'Adding signatures to the current node person is not allowed',
  Cargo_ApproverNotEmpty: 'Approver cannot be empty',
  Cargo_AppointerNotEmpty: 'The delegate cannot be empty',
  Cargo_NewWarehouseFee: 'Only active operations are allowed to add warehouse fees!',
  Cargo_DefaultCurrencyConversion: 'Default Currency Conversion',
  Cargo_ChargeGroupCheck: 'Charge group[{0}], duplicate selection is not supported. Please readjust and save.',
  Cargo_RelatedChargeItems: 'Related Charge Items',
  Cargo_IncludeSoc: 'Is it include SOC',
  Cargo_SubsidiaryLedgerDay: 'Subsidiary Ledger Daily Report',
  AccountingDate: 'Accounting date',
  PleaseSelectAccountDate: 'Please select accounting date.',
  CurrentDayAmountTo: 'Total(CurrentDay)',
  TotalReportingCurrencyOfThisDay: 'Total reporting currency of this day',
  Cargo_LastOverseasPort: 'When the unloading port is a US port, it can be directly equivalent to the loading port.\n' +
      'When the unloading port is not a US port, the previous non US port before the US should be filled in here.',
  Cargo_FirstPortOfCall: 'When the unloading port is a US port, it can be directly equivalent to the unloading port.\n' +
      'When the unloading port is not a US port, the first US port passing through the US should be filled in here.',
  Cargo_PoNoExistTips: 'The project number is duplicate. Are you sure to save it?',
  Cargo_Assignment: 'assignment',
  Cargo_SetMarginReminder: 'Set margin reminder',
  Cargo_NumberOfCompanyReminders: 'Number of company reminders',
  Cargo_CompanyTrackingNumLower: 'The current company tracking number has a remaining balance lower than [{0}]',
  Cargo_BatchAdd: 'Bulk additions',
  Cargo_DownloadTemplate: 'Download the template',
  Cargo_AssignCompany: 'Assign the company',
  Cargo_MawbSource: 'Master single source',
  CARGO_CAN_NOT_ASSIGNMENT: 'Only new status tickets can be assigned',
  CARGO_Confirm_Assignment: 'Confirm the assignment',
  CARGO_Confirm_Assignment_Success: 'Assignment succeeded',
  CARGO_Confirm_Assignment_Error: 'Allocation failed',
  CARGO_Only_Invalidated: 'Only invalidated, non-invalidated master orders are supported',
  CARGO_Only_Unbind: 'You can only unbind a bound ticket',
  CARGO_Not_Met_New_Conditions: 'The following master orders do not meet the new conditions',
  Cargo_Assign_People: 'Assign people',
  AERequiredChecksum: 'One of the main single start number and batch addition must be filled in',
  Cargo_DeleteCharge: 'If no expenses are selected, all selected business expenses are deleted by default',
  Cargo_BusinessOperationUpdateDynamics: 'Business operation update dynamics',
  Cargo_UpdateDetails: 'Update details',
  Cargo_UpdateContent: 'Update content',
  Cargo_ChangeLogRecord: 'Change log record',
  Cargo_BusinessNoChangeLogRecord: 'Business number change log record',
  Cargo_ResultsDisplayedInRed: 'The query results will be displayed in red',
  Cargo_ChangeLocation: 'Change location',
  Cargo_TimeQuery: 'Time query',
  Cargo_BusinessNotExist: 'Business does not exist!',
  Cargo_UserNoRole: 'This user is not associated with any roles. Are you sure to save?',
  Cargo_ResultsDisplayedInYellow: 'The query results will be displayed in yellow',
  Cargo_CreateBillYesOrNo: 'Whether to generate a bill',
  CurrencyReceivable: '{0} receivable',
  CurrencyPayable: '{0} payable',
  CurrencyNotReceived: '{0} not received',
  CurrencyUnpaid: '{0} unpaid',
  CurrencyReceived: '{0} received',
  CurrencyPaid: '{0} paid',
  Cargo_CheckShippingCompanyCargoTracking: 'You have activated the shipping company\'s cargo tracking service. Please select the shipping company and save it to ensure that the field information is successfully obtained.',
  Cargo_PodPortInfoPrompt: 'If you open the shipping company\'s cargo tracking service, Basic tab - Shipping company is a required field, please Properly selecting a shipping company and saving business, ensuring Successfully obtained field information.',
  Cargo_StatementReviewStatus: 'Statement review status',
  Cargo_StatementReviewer: 'Statement reviewer',
  Cargo_StatementReviewTime: 'Statement review time',
  Cargo_Port_Departure_Sea: 'Port of Departure (Sea)',
  Cargo_Port_Destination_Sea: 'Port of Destination (Sea)',
  Cargo_Port_Departure_Air: 'Port of Departure (Air Freight)',
  Cargo_Port_Destination_Air: 'Port of Destination (Air Freight)',
  Cargo_Port_Departure_Rail: 'Port of Departure (Rail)',
  Cargo_Port_Destination_Rail: 'Destination Port (Rail)',
  Cargo_Lob_NEQ_Port: 'If the business type does not match the port type, click OK to clear the selected port',
  Cargo_DuplicateLaneCodePleaseTryItAgain: 'The voyage is repeated, please re-enter.',
  Need: 'Need',
  NoNeed: 'No need',
  Cargo_VAT_FEI: 'Electronic invoice (VAT special invoice)',
  Cargo_NORMAL_FEI: 'Electronic invoice (ordinary invoice)',
  Responsible: 'Responsible',
  No_Responsibility: 'No responsibility',
  Cargo_ViewMoreLogs: 'View more logs',
  Cargo_ThreeDaysLogs: 'Operation dynamics in the past three days',
  Cargo_ReconciliationNewVersion: 'Reconciliation new version',
  Cargo_NuoNuo: 'NuoNuo',
  Cargo_AISINO_EI: 'AISINO_EI',
  Pigeonhole: 'Pigeonhole',
  Unarchive: 'Unarchive',
  Confirm_Archiving_Business: 'Confirm the archiving of the selected business',
  Confirm_Unarchiving_Business: 'Confirm the unarchiving of the selected business',
  Is_Pigeonhole: 'Whether to archive',
  Financial_Review_Status: 'Financial review status',
  Other_Reminders: 'Other reminders',
  Can_Be_Archived: 'Whether it can be archived',
  Not_Accrued: 'Not accrued',
  Receivables_Not_Fully_Written_Off: 'Receivables are not fully written off',
  Payable_Not_Fully_Written_Off: 'Payable is not fully written off',
  Financial_Archiving_Settings: 'Financial archiving settings',
  Financial_Filing_Preconditions: 'Financial filing preconditions',
  Financial_Filing_Effective_Effect: 'Financial filing effective effect',
  WHETHER_FINANCIAL_AUDIT: 'Whether financial audit:',
  WHETHER_ACCRUED: 'Whether it has been accrued:',
  CARGO_RECOGNITION_SETTING: 'OCR recognition Settings',
  AE_IDENTIFY_VENDORS: 'Add/edit identify vendors',
  TENANT_BUSINESS_NAME: 'Tenant business name',
  OFFSHORE_CONSIGNMENT_IDENTIFICATION_SUPPLIER: 'Offshore consignment identification supplier',
  OCEAN_BILL_OF_LADING_IDENTIFICATION_SUPPLIER: 'Ocean Bill of Lading identification supplier',
  DTip: 'Are you sure you want to delete the Settings for this tenant? After removal, the platform Settings are used to identify suppliers',
  FormEditTip: 'Please check the tenant identification Settings that you want to edit',
  FormDeleteTip: 'Select the tenant identification Settings to be deleted',
  OCRRecognition: 'OCR recognition',
  FINANCIAL_RECEIVABLES_VERIFICATION: 'Whether all receivables should be written off:',
  FINANCIAL_DUE_VERIFICATION: 'Whether full write-offs should be due:',
  FINANCIAL_CHARGE: 'Whether there are ongoing charges, new changes, and deletions:',
  CANCEL_FINANCIAL_AUDIT: 'Cancel financial audits:',
  MODIFY_CHARGE: 'Modify fees:',
  MODIFY_JOB: 'Modify business information:',
  MODIFY_RATE: 'Modify the exchange rate:',
  MODIFY_FINANCE_JOB_DATE: 'Modify the financial date business date:',
  GENERATE_RED_INVOICE: 'Generate red-flush invoices:',
  RECEIVABLE_GENERATES_INVOICE: 'A/R generates invoices:',
  COPE_GENERATES_INVOICE: 'A/P generates an invoice:',
  CANCEL_RECEIVABLE_VERIFICATION: 'Cancellation of write-offs of receivables:',
  COPE_RECEIVABLE_VERIFICATION: 'Cancellation of payables write-offs:',
  MODIFY_ACCRUAL: 'Modify the accrual:',
  NON_FILEABLE_BUSINESS: 'There is a non-fileable business',
  NOT_FULLY_COMPLETED: 'There is a business that is not completely completed, please check the reminder',
  BUSINESS_CAN_ARCHIVED: 'Business can be archived',
  ARCHIVE_DATE: 'Archive date',
  NOT_OPERATIONAL: 'Inoperable, Reason: The business has been archived.',
  CHANGE_CHARGE_IN_PROGRESS: 'If there is a "change fee review" in progress, please complete it first',
  ONLY_NOT_ARCHIVED_TRANSACTIONS: 'Filter to select Unfiled Transactions',
  ONLY_ARCHIVED_TRANSACTIONS: 'Filter to select Archived Transactions',
  Cargo_CarryForward: 'Carry forward',
  Cargo_From_Import: 'Import synchronization',
  Cargo_From_Export: 'Export synchronization',
  Cargo_Preplan: 'preplan',
  Cargo_SeaManagerSendPreplan: 'Sea manager (sending pre configuration)',
  Cargo_SeaManagerUpdatePreplan: 'Sea manager (modified pre configuration)',
  Cargo_SeaManagerDeletePreplan: 'Sea manager (delete pre configuration)',
  Cargo_SeaManagerSendingVGM: 'Sea manager (sending VGM)',
  Cargo_WseSendMPreplanQd: 'CW (Qingdao Port Master sends manifest)',
  Cargo_WseSendPreplanQd: 'CW (Qingdao Port sends manifest separately)',
  Cargo_WseSendUpdatePreplanQd: 'CW (Qingdao Port changes manifest)',
  Cargo_WseDeletePreplanQd: 'CW (Qingdao Port deletes manifest)',
  Cargo_WseSendPreplanSh: 'CW (manifest sent to Shanghai Port)',
  Cargo_WseSendUpdatePreplanSh: 'CW (Shanghai Port changes manifest)',
  Cargo_WseDeletePreplanSh: 'CW (Shanghai Port deletes manifest)',
  Cargo_WseSendingVGM: 'Sending VGM',
  Cargo_Ams: 'AMS send',
  Cargo_Aci: 'ACI send',
  Cargo_Afr: 'AFR send',
  Cargo_EMainfest: 'eMainfest send',
  Cargo_Ens: 'ENS send',
  Cargo_Send_error: 'Sending exception',
  Cargo_Confirm_Delete: 'Confirm you want to delete the selected data?',
  Cargo_ApiCallBack: 'api callBack',
  Cargo_BWJS: 'Baiwang Jinsuiyun',
  Cargo_TaxEasy: 'Rongjin',
  Cargo_YGSH: 'Sunshine Express',
  Cargo_BaiHui: 'Baihui Jinren',
  Cargo_OverseasSettlementCenter: 'Overseas settlement center',
  Cargo_Receivable2: 'Receivable:',
  Cargo_Payable2: 'Payable:',
  Approval_Approved_Time: 'The time when the approval was approved',
  CheckingExportToImport: 'This business cannot be transferred from export to import. Please check and try again!',
  OnlySupportOneCustomsInfo: 'When opening the xinHaoQi interface, only one customs declaration detail is supported',
  CustomsDeclareTime: 'Required customs declaration date',
  SendContainer: 'Push the LCL list to the customs broker',
  IsTheLCLListSent: 'Is the LCL list sent',
  LCLList: 'LCL List',
  iEPort: 'iEPort',
  OceanBillOfLadingNumber: 'Ocean Bill Of Lading Number',
  NoticeBgh: 'Waiting For Notification Of Customs Declaration',
  SelfDeclaration: 'Self Declaration',
  NotSentCustomsFile: 'Have not sent any customs declaration documents. (If other offline channels have already sent it, this reminder can be ignored)',
  FilledMustFill: 'When Fill sends customs declaration information, the [{0}] field must be filled in',
  NoContainerInfo: 'There is no packing information below the box',
  InformationComparison: 'Information Comparison',
  Diff: 'Difference',
  PostLCLTask: 'Post LCL Task',
  ForceDeleteCustomsTips: 'The customs declaration information has been pushed to the xinHaoQi. Are you sure you want to forcibly delete it?',
  AddCustomerFileFirst: 'Please add customs declaration information first',
  Local: 'Local',
  CustomsDocumentPreparation: 'Document preparation',
  PleaseCreateSplitBillFirst: 'Please Create Split Bill First',
  Cargo_DisplaySell: 'Display the seller\'s bank account number',
  Cargo_DisplayBuyer: 'Display the buyer\'s bank account number',
  ExitCustoms: 'Exit Customs',
  ItIsRecommendedToFillInWhenTheExitPortIsShanghai: '(PS: It Is Recommended To Fill In When The Exit Port Is Shanghai)',
  PleaseFillInTheIEPort: 'Please FillIn The IEPort',
  CustomsUnFrozen: 'Customs UnFrozen',
  UnFrozen: 'UnFrozen',
  LCLTaskSent: 'LCL Task Sent',
  LCLTaskNotSent: 'LCL Task Not Sent',
  Unfreeze: 'UnFreeze',
  NotUnfreeze: 'Not UnFreeze',
  CustomerFileHasBeenSent: 'Customer File Has Been Sent',
  NotSendingCustomerFile: 'Not Sending Customer File',
  XhqCustomerState: 'Xhq Customer State',
  VGMWeighingAddressCannotBeEmpty: 'The VGM weighing address cannot be empty',
  Empty: '(empty)',
  unfrozenOffline: 'unfrozen Offline',
  NotifyCustomsUnfreeze: 'Notify customs clearance to unfreeze',
  CargoOwnerSOC: 'Cargo Owner SOC',
  ForwarderSOC: 'Forwarder SOC',
  SOCType: 'SOC Type',
  InvoiceConfig: 'Invoice configuration',
  FEI_NuoNuo: 'Nuonuo\'s full electronic invoice: Nuonuo',
  FEI_Bwjsy: 'Baiwang Jinsui Cloud: BWJSY',
  FEI_Kpzddm: 'Invoice terminal code (kpzddm)',
  FEI_Yhdm: 'User code (yhdm)',
  FEI_NotUse: 'not enabled',
  InvoicerConfig: 'Invoicer configuration',
  InvoiceChannel: 'Invoice Channel',
  Invoicer: 'Invoicer',
  ExtensionNumber: 'Extension number',
  OnlyInvoicer: 'Only corresponding to the invoicer for invoicing',
  AllInvoicer: 'Shared by all users',
  Cargo_ReceiveAmount: 'Accounts receivable amount',
  Cargo_BatchDeleteChargeTips: 'No fees have been selected, all selected business fees will be deleted by default. Do you want to continue?',
  Cargo_Template_Push: 'Template push',
  Cargo_UploadTemplateDataSample: 'Upload template data sample',
  Cargo_SureDeleteTheFile: 'Are you sure you want to delete the file?',
  Cargo_DownloadContent: 'Download content',
  Cargo_ImportOrderTemplateFile: ':Import order template file',
  Cargo_ImportOrderTemplateDataSampleFile: ':Import order template data sample file',
  Cargo_Sample: 'Sample',
  Cargo_Sample_Tip: '*If HQ has already uploaded the data sample file and other subsidiaries have not uploaded it, other subsidiaries will default to using HQ\'s data sample file',
  OpenXhqChat: 'Open xinHaoQi chat',
  OpenXhqChatTips: 'The business has not sent customs declaration information, please send customs declaration information first',
  CustomsBrokerNotEntered: 'Customs broker not entered',
  Cargo_CanNotSplitMasterJob: 'The consolidation type does not equal to self consolidation or Buyer Console, cannot be split!',
  RespMsg: 'Response Message',
  Cargo_WarehouseCode: 'Warehouse entry number code',
  Cargo_WarehouseCodeLengthLimit: 'Used for warehouse number generation configuration, with a maximum code character length of 10 digits.',
  Cargo_ValueSetting: 'Value setting',
  Cargo_SettingValuePriority: 'Set value priority',
  Cargo_PleaseToPartnerWarehouseCode: 'Please refer to the Partner Warehouse Entry Code',
  Cargo_LineSeaAir: 'Airline (sea/air)',
  Cargo_LineRailWay: 'Airline (railway)',
  Cargo_BatchDeleteCharge: 'Batch deletion of fees',
  Cargo_SetDeleteCondition: 'Set deletion conditions',
  Cargo_ToBeDeletedCharge: 'Expense data to be deleted',
  Cargo_ToBeDeletedChargeSelected: 'Selected to delete expense data: ',
  Cargo_MatchCharge: 'Matching fees',
  Cargo_SureDelete: 'Are you sure to delete {0} selected data items?',
  Cargo_ShowChargeDeleteResult: 'Display expense deletion results',
  Cargo_DeletedTips: 'Has been deleted {0} piece of data',
  Cargo_NotSelectDeletedTips: 'Display expense deletion results',
  Cargo_PleaseMatchDataFirstTips: 'Please match the data first and confirm the data that needs to be processed in bulk.',
  Cargo_NotSelectDeleteConditionTips: 'No expense deletion criteria selected!',
  Cargo_BatchEditCharge: 'Batch editing fees',
  Cargo_SetEditCondition: 'Set adjustment conditions',
  Cargo_ToBeEditCharge: 'Cost data to be adjusted',
  Cargo_ToBeEditChargeSelected: 'Selected to adjust expense data: ',
  Cargo_SureEdit: 'Confirm adjustment selected{0}are there any data items?',
  Cargo_ShowChargeEditResult: 'Display expense update results',
  Cargo_EditTips: 'updated {0} piece of data',
  Cargo_NotSelectEditTips: 'No expense data selected for adjustment!',
  Cargo_NotSelectEditConditionTips: 'No fee adjustment conditions selected!',
  Cargo_EditAmountNoZero: 'Unit price adjustment cannot be 0 !',
  Cargo_EditUnitRate: 'Pro-rata Rates',
  Cargo_EditSettleAccountsTo: 'Adjusting settlement objects',
  Cargo_HandleResult: 'Processing results',
  Cargo_LoadMore: 'Scroll to load more',
  Cargo_NoMoreData: 'No more data',
  Cargo_RandomPassword: 'Random passwords',
  Cargo_ChargeHasDiffAmount: 'The cost has been processed as a difference and cannot be modified!',
  Cargo_ChargeHasConfirm: 'The cost has been confirmed and cannot be modified!',
  Cargo_ChargeHasVerified: 'The expense has been written off and cannot be modified!',
  Cargo_ChargeHasCommit: 'The fee has been submitted and cannot be modified!',
  Cargo_ChargeHasCreateBillPayment: 'The fee has been created and payment request cannot be modified!',
  Cargo_ChargeHasCreateInvoice: 'The cost has been invoiced and cannot be modified!',
  Cargo_JobStateNotAllowModified: 'The business has been submitted/reviewed and cannot be modified!',
  Cargo_InvoiceChargeItemSetup: 'ChargeItem Setup(Vietnam)',
  Cargo_InvoiceChargeUnitSetup: 'ChargeUnit Setup(Vietnam)',
  Cargo_ChargeItemId: 'ChargeItem(Cargoware)',
  Cargo_ChargeItemName: 'ChargeItem Name(Vietnam)',
  Cargo_ChargeUnitCode: 'ChargeUnit(Cargoware)',
  Cargo_ChargeUnitName: 'ChargeUnit Name(Vietnam)',
  Cargo_InvoicingByTaxRate: 'Invoicing By TaxRate',
  Cargo_SureToVoidTheInvoiceVietnam: 'According to Vietnam\'s tax control policy. Please confirm that the customer has been contacted to ensure that the invoice has not been taxed yet. If already bonded, please do not invalidate the invoice. <br/><br/>Are you sure you want to void this invoice?',
  ChargeSchemeCopy: 'Charge Scheme Copy',
  mpanyCopy: 'Company Copy',
  SourceCompany: 'Source Company',
  QueryChargeScheme: 'Query Charge Scheme',
  CopyChargeScheme: 'Copy Charge Scheme',
  QueryCompany: 'Query Company',
  CopyCompany: 'Copy Company',
  FuzzyQueryOfIdOrName: 'Fuzzy query of ID or name',
  CopyToCompany: 'Copy To Company',
  CopySuccessCount: 'Copy Success {0} Count',
  PleaseSelectTargetTenant: 'Please Select Target Tenant',
  Cargo_TemplateNodeWorkTaskSetting: 'Template node work task settings',
  Cargo_WorkTaskEnable: 'Enable work task settings for nodes',
  Cargo_SetNodeResponsible: 'Set this node to be responsible for',
  Cargo_DesignatedPosition: 'Designated position (based on the job responsibilities of the position setting node, only one can be selected)',
  Cargo_SetPreNode: 'Set the pre node (the pre node state required for the node to start)',
  Cargo_SetPreNodeTips: 'Set the predecessor nodes for this node (up to 5 predecessor nodes, to establish a relationship with)',
  Cargo_HandlingPriorityMarkers: 'Handling priority markers',
  Cargo_HandlingPriorityMarkersTips: 'Set processing priority (up to 3, default to low priority when not set)',
  Cargo_HandlingPriorityMarkersHigh: 'Set processing priority to high',
  Cargo_HandlingPriorityMarkersMedium: 'Set processing priority to medium',
  Cargo_HandlingPriorityMarkersLow: 'Set processing priority to low',
  Cargo_SOPWorkTaskBoard: 'SOP work task board',
  Cargo_High: 'High: ',
  Cargo_Medium: 'Medium: ',
  Cargo_Low: 'Low: ',
  Cargo_SopBusinessFlowDashboard: 'SOP Business Flow Dashboard',
  Cargo_WarnTodoList: 'List of Alert Tasks',
  Cargo_BpmTodoList: 'List of Approval Items',
  Cargo_BusinessTime: 'Business time',
  Cargo_HandleLevel: 'Processing level',
  Cargo_PreNode: 'Front node',
  Cargo_PriorityHigh: 'High priority',
  Cargo_PriorityMedium: 'Medium priority',
  Cargo_PriorityLow: 'Low priority',
  Cargo_SetDefaultDisplayItem: 'Set as default display',
  Cargo_PreNodeRepeat: 'Duplicate front-end node configuration',
  Cargo_PriorityRepeat: 'In priority configuration, [condition item+trigger method+date] cannot be duplicated',
  Cargo_TrackingIconTip: 'This icon is used as a dashboard for B2B systems and SOP work tasks！',
  Cargo_LoadData: 'Refresh data',
  Cargo_TemplateNodeMergeShow: 'Merge and display template nodes',
  Cargo_PortPlaceOfDeparture: 'Port/Place of Departure',
  Cargo_PortPlaceOfDischarge: 'Port/Place of Discharge',
  Cargo_MsgClassifyManager: 'Message classify manager',
  Cargo_BellMsg: 'Bell message',
  QuickSearchMsgClassify: 'Please enter name fuzzy search',
  Cargo_GroupingDimensionForRate: '"Group Condition" is equal to "Tax Rate", and "Value" must be filled in as "Number"!',
  Cargo_CheckAccountSetBranchId: 'If the branch to which the current set of accounts belongs does not belong to the current branch or the parent branch, should I continue to operate?',
  Cargo_BillPayment: 'Payment application form',
  Cargo_MakeInvoice: 'Invoice application form',
  Cargo_JobCharge: 'Business expense application form',
  Cargo_MblTip: 'Please enter 6-30 uppercase characters and numbers',
  Cargo_VesselTip: 'Please enter uppercase and lowercase letters, as well as numbers that may include ". -" and "spaces"',
  Cargo_VesselTip2: 'Cannot enter Chinese and full-width characters',
  Cargo_VoyageTip: 'Please enter voyage without V',
  Cargo_ShippingCompanyTip: 'Please select the shipping company',
  Cargo_CarrierAgentTip: 'Please select a shipping agent',
  Cargo_SailingDateTip: 'Please enter the departure date',
  Cargo_PortOfLoadingHgjTip: 'Sea Steward only supports sending from Shanghai Port',
  Cargo_PortOfLoadingWsTip: 'Please select the port of departure, supporting Shanghai and Qingdao',
  Cargo_PortOfLoadingTip: 'Please choose the full name of the port in uppercase English',
  Cargo_PortOfDischargeTip: 'Please select the unloading port',
  Cargo_PortOfDestinationTip: 'Please select the destination port',
  Cargo_PortOfDestinationTip2: 'Please choose the full name of the port in uppercase English',
  Cargo_BlNumberTip: 'Please select the bill of lading method',
  Cargo_DispatchingPlaceCodeTip: 'If the goods are received from Nanjing and shipped from Shanghai, please fill in Nanjing as the place of shipment',
  Cargo_DispatchingPlaceCodeTip2: 'Please select the shipping location',
  Cargo_ShipperEnterpriseNameTip: 'Please enter characters up to 140',
  Cargo_ShipperEnterpriseNameTip2: 'Please enter characters up to 70',
  Cargo_ShipperContactsTip: 'Please enter a phone number within 20 characters',
  Cargo_CopyNotifier: 'Copy notifier',
  Cargo_CopyRecipient: 'Copy recipient',
  Cargo_InputIMO: 'Please enter IMO number',
  Cargo_InputBLFreightTermTootip: 'Please select the shipping terms',
  Cargo_PureNumbers: 'Please enter pure numbers',
  Cargo_IMO: 'IMO',
  Cargo_DangerousGoodsCheck: 'You have filled in {0}, but the type of goods selected is\' ordinary goods\'. Please verify and resend',
  Cargo_DefaultShanghai: 'Default SHANGHAI | CNSHA, cannot be changed',
  ChinaPostProductConfiguration: 'China Post Product Configuration',
  AllowSaleProduct: 'Allow Sale Product',
  NewChargeGroup: 'New Charge Group',
  ChargeMapping: 'Charge Mapping',
  ChargeMappingFuzzySearch: 'Please enter the transmission charge code or name for ambiguous query',
  RailwayUse: 'Railway use',
  FullOrInside: 'Full Or Inside',
  TransmitChargeName: 'Transmit Charge Group',
  TransmitChargeCode: 'Transmit Charge Group Code',
  MaintainerRemarks: 'Maintainer Remarks',
  AllowSaleProductNotNull: 'Allow Sale Product not selected',
  TransmitChargeNameNotNull: 'Transmit Charge Group not selected',
  FullOrInsideNotNull: 'Full Or Inside not selected',
  Cargo_TaxRateNotNull: 'Please fill in the tax rate',
  PushOrNot: 'Push or not',
  Cargo_BusinessLeaderCompanyPrePort: 'Pre-Port Business Leader Company',
  Cargo_BusinessLeaderDeptPrePort: 'Pre-Port Business Leader Department',
  Cargo_BusinessLeaderCompanyEndPort: 'End-Port Business Leader Company',
  Cargo_BusinessLeaderDeptEndPort: 'End-Port Business Leader Department',
  Cargo_CurrentNode: 'Current Node',
  Cargo_WorkNode: 'Work Node',
  Cargo_EditStateTip: 'Are you sure to modify the node status of {0} selected data items?',
  Cargo_BpmSubmitDuplicated: 'the current document already has an approval form. please do not resubmit',
  Cargo_TempCreditApply: 'Temporary Credit Control Application Form',
  Cargo_PartnerName: 'Partner Name',
  Cargo_ContractAmount: 'Contract amount',
  Cargo_ContractAccountingPeriod: 'Contract accounting period',
  VerificationSheetRequired: 'Verification sheet required',
  Cargo_TransportSource: 'Transport Source',
  Cargo_CustomerExpandMode: 'Customer Expand Mode',
  Cargo_SubmitTempCreditTip: 'To maintain temporary credit control, a temporary credit control approval process needs to be initiated. Do you want to initiate the approval now?',
  Cargo_CustomFields: 'Custom Fields',
  Cargo_CustomerCode: 'Voucher system customer/supplier code',
  Cargo_NoHasFinanceCode: 'The corresponding invoice header does not have a corresponding "voucher system customer/supplier code" for UFIDA.',
  Cargo_MultiCurrency: 'The selected invoice has multiple currencies.',
  Cargo_YongYouDeleteTip: 'The current invoice has been pushed to UFIDA. To proceed, please go to the voucher system and delete the corresponding record. Are you sure you want to proceed?',
  Cargo_SyncVerifyDoc: 'Synchronize verification of documents',
  Cargo_HasSync: 'The selected data has been synchronized',
  Cargo_OverseaActualAmount: 'Foreign account cancellation data cannot be synchronized with UFIDA.',
  Cargo_MultiInvoiceTitle: 'There is a write off statement that contains multiple invoicing headers. Unable to push to UFIDA, please adjust the data.',
  Cargo_InvoiceTitleMustBeIdentical: 'The invoice header must be the same.',
  Cargo_ChargeChangeApply: 'Charge Change Application Form',
  Cargo_CollectInvoiceApply: 'Collect Invoice Application Form',
  Cargo_HideUnmodifiedFees: 'Hide unmodified fees',
  Cargo_ChargeChangeTip: 'Note: The current changes are pending approval and can only be adjusted again after the changes are completed.',
  Cargo_UniqueIdentification: 'Unique identification',
  Cargo_CostNumber: 'Cost Number',
  Cargo_OriginalCostUniqueIdentifier: 'Original cost unique identifier',
  Cargo_OriginalExpenseNumber: 'Original expense number',
  Cargo_ChargeChange: 'Cost change',
  Cargo_ApprovalProcessForChargeChange: 'Approval process for expense change application',
  Cargo_ChargeChangeTip2: 'Do I need to confirm the initiation of expense change approval now?',
  Cargo_ChargeChangeTip3: 'Note: No further changes can be made to the expenses until the end of this approval process.',
  Cargo_ViewChangeData: 'View Change Data',
  Cargo_GrossProfitMarginBeforeChange: 'Gross profit margin before change',
  Cargo_GrossProfitMarginAfterChange: 'Gross profit margin after change',
  CustomFieldDisplayConfiguration: 'Custom Field Display Configuration',
  Field: 'Field',
  ChineseDisplayName: 'Chinese display name',
  EnglishDisplayName: 'English display name',
  FieldNotEmpty: 'Field cannot be empty',
  ChineseDisplayNameNotEmpty: 'Chinese display name not filled in',
  EnglishDisplayNameNotEmpty: 'English display name not filled in',
  Cargo_ContractRule: 'Contract rule',
  Cargo_ApplicationConditions: 'Application conditions',
  Cargo_ConditionValue: 'Condition value',
  Cargo_ContractWarning: 'Contract warning',
  Cargo_ApplicationRules: 'Application rules',
  Cargo_ContractRuleChangeTip: 'The current rule has been applied to some contracts. Please change the contract to a new rule before proceeding.',
  Cargo_DailySettlement: 'Daily settlement',
  Cargo_ContractNumber2: 'Contract Number ',
  CheckArApDisparity: 'Exist validation for Billing.Please operate AR and AP Bill separately.',
  VASChannelSetting: 'Value added service channel configuration',
  ManifestChannel: 'Pre shipping bill supplier',
  VGMChannel: 'VGM send supplier',
  VASChannelFormEditTip: 'Please check the tenant sending channel settings that need to be edited',
  VASChannelFormDeleteTip: 'Please check the tenant sending channel settings that need to be deleted',
  VASChannelSelectOneTip: 'Select at least one supplier for sending pre allocated manifest/VGM sending supplier',
  VASChannelDeleteTip: 'Are you sure you want to delete the settings for this tenant',
  VASChannelDTip: 'Are you sure you want to delete the settings for this tenant',
  Cargo_PushAddCustomer: 'Push new customers',
  Cargo_ChooseArea: 'Please select region',
  Cargo_AllocationSuccessful: 'Allocation successful',
  Cargo_CreatedSuccessful: 'Created Successfully',
  Cargo_DuplicateCustomerName: 'Duplicate customer name',
  Cargo_ExistFinanceCode: 'Customer code already exists, no need to push it',
  Cargo_EntrustedReceiveInfo: 'Entrusted to receive information',
  Cargo_ContainerLoadTypeRailWay: 'Container Load Type(RailWay)',
  ExclusionOffice: 'Exclusion Office Setting',
  Cargo_MultiOrderTip: 'If there are multiple sets of data, generate orders in batches',
  Cargo_IdentifyTemplateName: 'Identify template name',
  Cargo_IdentifyTemplateName2: 'Identify template name:',
  Cargo_TemplateId: 'Template id',
  Cargo_CodeProcessing: 'Code processing',
  Cargo_TestFile: 'Test file',
  Cargo_TemplateIdAutomaticallyGenerated: 'Template ID (automatically generated):',
  Cargo_TemplateStatus: 'Template status:',
  Cargo_DocumentTypeDescription: 'Document type description',
  Cargo_DocumentTypeDescription2: 'Document type description:',
  Cargo_ReadField: 'Read field',
  Cargo_FieldName: 'Field name',
  Cargo_FieldRuleDescription: 'Field rule description',
  Cargo_PreviewPromptWords: 'Preview prompt words',
  Cargo_Invalid3: 'Invalid',
  Cargo_Sequence: 'Sequence',
  Cargo_FieldAdd: 'Field add',
  Cargo_FieldEdit: 'Field edit',
  Cargo_FieldView: 'Field view',
  Cargo_PlatformEnterpriseName: 'Platform enterprise name',
  Cargo_AccessKey: 'Access Key',
  Cargo_SecretKey: 'Secret Key',
  Cargo_CallBackUrl: 'Callback address',
  Cargo_PlatformEnterpriseInterfaceConfiguration: 'Platform Enterprise Interface Configuration',
  Cargo_OcrTemplateConfig: 'OCR Template Settings',
  Cargo_OcrCode: 'Embedded code processing (secondary processing of embedded code returns the final result as an API output value)',
  Cargo_originalValue: 'Original value',
  Cargo_DebuggingResults: 'Debugging results',
  Cargo_UsageStatistics: 'Usage Statistics',
  Cargo_NumberOfSuccessfulCalls: 'Number of successful calls',
  Cargo_UsingFlowingWater: 'Using Flowing Water',
  Cargo_CallTemplateId: 'Call template ID',
  Cargo_CallResult: 'Call result',
  Cargo_Template: 'Template',
  Cargo_QueryFlowingWater: 'Query flowing water',
  Cargo_TemplateId2: 'Template id:',
  Cargo_FileName2: 'File name:',
  Cargo_IdentifyReturnResult: 'Identify the return result:',
  Cargo_CustomsChannel: 'Identify suppliers on the customs declaration form',
  Cargo_IdentifyTheSupplier: 'Identify the supplier',
  Cargo_PleaseSet: 'Please set',
  Cargo_OnlyOneSupplier: 'Only one supplier can be set for one type',
  Cargo_IdentificationCannotBePerformedTip: 'Identification cannot be performed without setting the identification type. If needed, please contact customer service.',
  Cargo_TemplateSettings: 'Template settings',
  Cargo_IdentificationTip1: 'Please set the supplier corresponding to the identification type',
  Cargo_PleaseSelectSpecificFields: 'Confirm to delete this field',
  Cargo_ConfirmToDeleteThisField: 'Are you sure you want to delete this field? After deletion, the interface will no longer return this field info',
  Cargo_ValidThisRecognitionTemplate: 'Are you sure you want to restore this recognition template to its validity?',
  Cargo_InValidThisRecognitionTemplate: 'Are you sure you want to disable this configuration? The calling interface will not return data after failure',
  Cargo_ValidThisRecognitionEnterprise: 'Are you sure you want to restore the enterprise as effective?',
  Cargo_InValidThisRecognitionEnterprise: 'Are you sure you want to invalidate this company? After failure, the interface cannot be called',
  Cargo_DateErrorTip: 'The expiration date must be later than the effective date',
  Cargo_ModifyCodeHandle: 'Modify "Code Processing"',
  Cargo_ModifyPromptWords: 'Modify the "prompt words"',
  Cargo_CannotEnable: 'Not within the effective period, unable to click [Enable]',
  Cargo_InputTokenCount: 'Number of input_token for large model recognition',
  Cargo_OutputTokenCount: 'Number of output_token for large model recognition',
  Cargo_PlsGenerate: 'Please generate',
  Cargo_TemplateUsed: 'This template has been used by the customer and cannot be edited. Unbind before editing or copying the template for editing',
  Cargo_SelectOneData: 'Only one data can be selected for copying!',
  Cargo_OutputRequirements: 'Output requirements:',
  Cargo_AnalyticMethod: 'analytic method:',
  Cargo_BLNoStatistics: 'Bill of Lading Number Statistics',
  Cargo_RemainingQuantity: 'Remaining Quantity',
  Cargo_RegistrationDate: 'date of registration',
  AnalyzeChannelSettings: 'Analyze Channel Settings',
  EmailParsingSettings: 'Email Parsing Settings',
  EmailPasswordAuthorizationCode: 'Email Password/Authorization Code',
  SenderServer: 'Sender Server',
  Port: 'Port',
  AddOrEditEmail: 'Add/Edit Email',
  EmailPurpose: 'Email Purpose',
  EnterCorrectEmail: 'Please enter a valid email address',
  SelectDeleteEmail: 'Please select the email to delete',
  DeleteEmailConfirm: 'Are you sure you want to delete the selected email? After deletion, the deleted email will no longer be read for parsing.',
  ImportMblNo: 'Import mbl no',
  ApplicableDepartment: 'Applicable Department',
  Cargo_QuoteMethod_ExistingRate: 'Quotations with "Existing Rate" cannot be withdrawn',
  Cargo_QuoteMethod: 'Quote method',
  Cargo_ExistingRate: 'Existing rate',
  Cargo_CommercialQuote: 'Commercial quote',
  Cargo_PrePortQuoteMethod: 'Pre-port quote method',
  Cargo_MainlineQuoteMethod: 'Mainline quote method',
  Cargo_EndlineQuoteMethod: 'Endline quote method',
  PleaseSelectApplicableBranch: 'Please Select Applicable Branch',
  Cargo_CheckSetting: 'Check setting',
  Cargo_BookNoteFieldName: 'Name field in book note',
  Cargo_IfRequired: 'Is it mandatory',
  Cargo_Channel: 'Channel',
  Cargo_IfSame: 'Inconsistent comparison',
  Cargo_DefaultValue2: 'Empty default value',
  Cargo_BookFieldNameRepeat: 'Duplicate field names in the consignment note',
  Cargo_BookNoteFieldAndSort: 'Display fields and order of the consignment note',
  Cargo_IfAutoBooking: 'Is it automatic booking',
  Cargo_BookRecognitionResults: 'Book recognition results',
  Cargo_ConfirmedBusinessData: 'Recording information',
  Cargo_OtherData: 'Other data',
  Cargo_BranchOffice: 'Branch office(BranchOffice)',
  Cargo_ShippingCompany: 'Shipping company(ShippingCompany)',
  Cargo_IfAutomaticBooking: 'If automatic booking(IfAutomaticBooking)',
  Cargo_Book: 'Book of Documents',
  Cargo_GoodNameContainSensitiveWord: 'The product name contains the sensitive word <span style="color: red">{0}</span>. Do you want to continue booking?',
  Cargo_OnlyGenerateJob: 'Only generate business',
  Cargo_PleaseReceiveCallback: 'Please note to receive the receipt',
  Cargo_JobProcess: 'Business Progress',
  Cargo_IdentificationMethod: 'Identification method',
  Cargo_NoNeedSupplementaryInformationBookNote: 'There is no letter of request for additional information',
  Cargo_SupplementaryInformationTip: 'Please select the record with \'Upload Progress\' as\' Analysis Completed\' and \'Recognition Channel\' as\' CW Multimodal Recognition \'and\' Recognition Type \'as\' Overseas Shipping Letter\'',
  CannotBeLongerThan35: 'Replace the line separator with a maximum length of 35 characters per line',
  Cargo_OcrSetTip: 'You have not set any information yet. The following fields and verification settings are system defaults, and the platform default settings are displayed in the consignment note<br/><br/>Value priority: If the application headquarters is selected, priority will be given to the application headquarters>tenant settings>platform settings',
  Cargo_AutomaticAllocation: 'Automatic Allocation Charge',
  Cargo_ChargeAutomaticAllocationConfig: 'Charge automatic allocation config',
  Cargo_EditAutomaticAllocationConfig: 'Edit automatic allocation config',
  Cargo_AddAutomaticAllocationConfig: 'Add automatic allocation config',
  Cargo_MatchingCriteriaSelection: 'Matching criteria selection',
  Cargo_AutomaticAllocationRuleConfig: 'Automatic allocation rule config',
  Cargo_AllocationNature: 'Allocation nature',
  Cargo_HblSingleAllocation: 'HblSingle allocation',
  Cargo_OnlyAllocatedToHblSingle: 'Only allocated to hblsingle',
  Cargo_MasterBill: 'Master bill',
  Cargo_AddEditReceivablePayableFees: 'Add/Edit Receivable and Payable Fees',
  Cargo_AddEditReceivableFees: 'Add/Edit Receivable Fees',
  Cargo_AddEditPayableFees: 'Add/Edit Payable Fees',
  Cargo_AddEditReceivableSpecialFees: 'Add/Edit Receivable Special Fees',
  Cargo_AddEditPayableSpecialFees: 'Add/Edit Payable Special Fees',
  Cargo_DeleteReceivablePayableFees: 'Delete Receivable and Payable Fees',
  Cargo_DeleteReceivableFees: 'Delete Receivable Fees',
  Cargo_DeletePayableFees: 'Delete Payable Fees',
  Cargo_ImportReceivablePayableFees: 'Import Receivable and Payable Fees',
  Cargo_ImportReceivableFees: 'Import Receivable Fees',
  Cargo_ImportPayableFees: 'Import Payable Fees',
  Cargo_BusinessTypeError: 'The selected document business type is inconsistent and cannot be modified!',
  Cargo_ReceivableSpecialFee: 'Receivable Special Fee',
  Cargo_PayableSpecialFee: 'Payable Special Fee',
  Cargo_ReceivablePayableSpecialFee: 'Receivable Payable Special Fee',
  Cargo_PleaseSetChargeNameAndAllocationType: 'Please set charge name and allocation type',
  Cargo_PleaseSetChargeName: 'Please set charge name',
  Cargo_PleaseSetAllocationType: 'Please set allocation type',
  Cargo_HasDuplicateConfigItem: 'There is already duplicate configuration item!',
  Cargo_ConfirmDeleteTheConfigItem: 'Confirm whether to delete the configuration item?',
  Cargo_ConfirmSaveModifiedInfo: 'Confirm whether to save the configuration item?',
  Cargo_InvoiceRepeat: 'Duplicate invoice number',
  Cargo_TurnOffAutomaticAllocation: 'Turn off charge automatic allocation and switch to manual allocation!',
  Cargo_RemainingAmountNotEnough: 'Insufficient balance, please recharge',
  Cargo_RemainingAmountNotEnough2: 'Insufficient balance, cannot generate business again.',
  Cargo_ExpandAll: 'expand>',
  Cargo_PackUp: '<pack up',
  Cargo_OcrTip: 'Reminder: Record information refers to the data written into the business, where the highlighted red font indicates errors that cannot be mapped to the platform and need to be modified before recording',
  Cargo_OcrTip2: 'Reminder: The order entry information refers to the data written into the business. The red font indicates an error that cannot be mapped to the platform.',
  Cargo_ClaimSettlement: 'settlement of claim',
  Cargo_BillStatusDoesNotMeetPaymentRequestRequirements: 'Bill status does not meet payment request requirements',
  Cargo_GetReceiptSettings: 'Get receipt settings',
  Cargo_AddEditReadReceiptMethod: 'Add/Edit Read Receipt Method',
  Cargo_ReadReceiptMethod: 'Read receipt method',
  Cargo_DeleteReceiptTip: 'Are you sure you want to delete this configuration? After deletion, the receipt will no longer be read according to this rule',
  Cargo_PleaseInputTitleOrContentTip: 'Please enter a title or main text',
  Cargo_BookingState: 'Booking state',
  Cargo_BookingChannelConfig: 'Booking channel config',
  Cargo_BookingMode: 'Booking mode',
  Cargo_RpaSupplier: 'RPA supplier',
  Cargo_BookingChannel: 'Booking channel',
  Cargo_ConfirmRejectQuote: 'Are you sure you want to reject the quote?',
  Cargo_MainlineRejectReason: 'Mainline reject reason',
  Cargo_PortRejectReason: 'Pre-port reject reason',
  Cargo_EndlineRejectReason: 'Endline reject reason',
  Cargo_WebSite: 'Web site',
  Cargo_CompanyCode: 'Company code',
  Cargo_ReceiptConfig: 'Receipt config',
  Cargo_EditBookingChannelConfig: 'Edit booking channel config',
  Cargo_AddBookingChannelConfig: 'Add booking channel config',
  Cargo_ReceiptConfigCannotBeEmpty: 'Receipt config  cannot be empty',
  Cargo_IndiaLineInfo: 'India line info',
  Cargo_CargoAmount: 'Cargo amount',
  Cargo_CargoCurrency: 'Cargo currency',
  Cargo_YdShipCode: 'Yd ship code',
  Cargo_SendThisPageEDI: 'Send this page EDI',
  Cargo_SendAllEDI: 'Send all EDI',
  Cargo_SendEDI: 'Send EDI?',
  Cargo_IsSendAllEDI: 'Send all EDI?',
  Cargo_SendEDISucceeded: 'Send EDI succeeded',
  Cargo_FailedToSendEDI: 'Failed to send EDI',
  Cargo_CheckCanSendEDI: 'Booking in progress or already booked, unable to resend',
  Cargo_OneKeyBooking: 'One key booking',
  Cargo_OneKeyBookingTip1: 'Initiate booking business when conditions are met: <span style="color: blue">{0}</span>strip. After clicking [Confirm], the booking will be initiated directly. You can check the booking status in the EDI or ocean freight booking tab',
  Cargo_OneKeyBookingTip2: 'Warm prompt: Orders that meet the following conditions will be initiated for booking with just one click<br/>1) date of departure>today<br/>2) The booking status is "recorded, not booked yet"<br/>3) type of goods: general goods<br/>4) loading type：FCL',
  Cargo_CanNotBooking: 'There are no businesses that meet the booking conditions',
  Cargo_CurrentlyBooking: 'In the past two months booking a shipment:',
  Cargo_SendSuccess2: 'Successfully sent:',
  Cargo_CallEdiFail: 'Call exception:',
  Cargo_ValidFail: 'Verification error:',
  Cargo_TemplateMatchFail: 'Template matching failed:',
  Cargo_BookingSendMethod: 'Booking and shipping method',
  Cargo_BookingSendChannel: 'Booking and shipping channels',
  Cargo_BookingSendDate: 'Booking and shipping time',
  Cargo_BookingReceiptDate: 'Booking receipt time',
  Cargo_OriginBookingState: 'Original booking status',
  Cargo_NotBooking: 'Not booking',
  Cargo_ContinueBooking: 'Continue booking',
  Cargo_ChangeInfo: 'Change info',
  Cargo_BookingTransportMode: 'Booking transport mode',
  Cargo_EdiBookingExportState: 'Export status',
  Cargo_OneKeyBookingTip3: 'Initiating booking, please check the specific booking status later',
  Cargo_BookingInProgress: 'Booking in progress',
  Cargo_NewSpaceCarrier: 'New space carrier',
  Cargo_AlreadyExistsCheck: 'The same data already exists and does not need to be saved.',
  Cargo_portOfLoadingSeaport: 'Loading Port (Seaport) - Cargo Information',
  Cargo_portOfDestinationSeaport: 'Destination Port (Seaport) - Cargo Information',
  Cargo_portOfLoadingAirport: 'Loading Airport (Airport) - Cargo Information',
  Cargo_portOfDestinationAirport: 'Destination Airport (Airport) - Cargo Information',
  Cargo_shippingCarrier: 'Shipping Carrier - Cargo',
  Cargo_shippingAirline: 'Airline - Cargo Information',
  Cargo_newEventRecord: 'New event record',
  Cargo_SelectInquiryToCopy: 'Please select the inquiry to copy',
  Cargo_VerifyStateReceivableDomestic: 'Domestic receivable write off status',
  Cargo_VerifyStateReceivableOversea: 'Foreign receivable write off status',
  Cargo_ReturnActualAmountNo: 'Associated Receipt No.',
  Cargo_ReturnAmount: 'Return amount',
  Cargo_ReturnApplyAmount: 'Return apply amount',
  Cargo_ReturnApplyState: 'Return apply state',
  Cargo_ReturnApply: 'Return apply',
  Cargo_ReturnApplyCancel: 'Return apply cancel',
  Cargo_ReturnApplyAudit: 'Return apply audit',
  Cargo_ReturnApplyReject: 'Return apply reject',
  Cargo_RemainingClaimedAmount: 'Remaining claimed amount',
  Cargo_RefundAmount: 'Refund amount',
  Cargo_ReturnApplyCheck: 'There are pending refund records, and a new refund request cannot be initiated!',
  Cargo_RemainingClaimedAmountZero: 'The remaining claimed amount is 0 and cannot be refunded!',
  Cargo_ReturnApplyAmountZero: 'The refund amount is 0 and cannot be refunded!',
  Cargo_ReturnApplyAuditCheck: 'Only records in the approval status can be checked again!',
  Cargo_WaterRefundedNoWriteOff: 'The record of water receipt refund does not support claiming!',
  Cargo_WaterRefundingNoWriteOff: 'The refund status is a record under approval and cannot be claimed!',
  Cargo_WaterRefundedNoCancel: 'The record of water receipt refund does not support revocation of claim!',
  Cargo_khEntryActTime: 'Foreign Truck entry(Actual time)',
  Cargo_transferDeclareCompletedActTime: 'Customs Transit finished(Actual time)',
  Cargo_khExitActTime: 'Foreign Truck exit country(Actual time)',
  Cargo_khDeclareActTime: 'Foreign Truck customs finished(Actual time)',
  Cargo_khReplacementActTime: 'Act Replacement Time',
  Cargo_arrivePodActTime: 'Act Enter Pod Time',
  Cargo_arriveClearActTime: 'Act Arrive Clear Time',
  Cargo_khUnloadingActTime: 'Act Discharge Time',
  Cargo_CustomerReserveVoyage: 'Customer reserve voyage',
  Cargo_CustomsDeclarationInformation: 'Customs declaration information',
  Cargo_CustomsDeclarationCommissionNumber: 'Customs declaration commission number',
  Cargo_CustomsDeclarationNotExist: 'Please maintain at least one customs declaration information',
  Cargo_QuantityWeightCubageChange: 'Is the change in hair body information covered?',
  Cargo_ReferenceNoRepeat: 'Reference no in VGM cannot be duplicated',
  Cargo_CustomerDemandClearanceNumber: 'Customer demand clearance number',
  Cargo_Empty2: '(Empty)',
  Cargo_QuantityWeightCubage: 'Quantity weight cubage',
  Cargo_CustomsDeclarationDeleteTip: 'The previous customs declaration number has been associated with the customs declaration commission and cannot be deleted',
  Cargo_CustomsDeclarationValidTip: 'The body of the customs declaration information cannot be 0',
  Cargo_CustomsDeclarationSoNoRepeat: 'The \'customs number\' in the customs clearance information of the same transaction cannot be duplicated',
  Cargo_AuditCancel: 'Are you sure you want to cancel the audit!',
  Cargo_AuditCancelReason: 'Reason for canceling the audit',
  Cargo_NuoNuoTipOne: 'When the invoicing channel is Nono, fill in 1 for this configuration item in the case of red offset not automatically issuing. No configuration is required for automatic issuance.',
  Cargo_DestinationVehicleNumberOne: 'Number one destination delivery vehicle',
  Cargo_DestinationVehicleRegister: 'Destination delivery vehicle registration',
  Cargo_ConfirmLockLabelBuyingPrice: 'Are you sure to lock in the purchase price?',
  Cargo_ConfirmLockLabelSellingPrice: 'Are you sure to lock in the selling price?',
  Cargo_ConfirmUnlockLabelBuyingPrice: 'Are you sure to unlock in the purchase price?',
  Cargo_ConfirmUnlockLabelSellingPrice: 'Are you sure to unlock in the selling price?',
  Cargo_PurchasePriceLockedStatus: 'Purchase price locked status',
  Cargo_SellingPriceLockedStatus: 'Selling price locked status',
  Cargo_BatchPurchasePriceLock: 'Batch lock in purchase price',
  Cargo_BatchPurchasePriceUnLock: 'Batch unlock purchase price',
  Cargo_BatchSellingPriceUnLock: 'Batch unlock selling price',
  Cargo_BatchSellingPriceLock: 'Batch lock in selling price',
  Cargo_NotActiveCompanyCleared: 'This ticket contains inactive partners: {0}. The system has automatically cleared them. Please select and enter them again.',
  Cargo_FBA_SE: 'FBA Sea Freight',
  Cargo_FBA_AE: 'FBA Air Freight',
  Cargo_FBA_RE: 'FBA Railroad',
  Cargo_SyncCreditTip: 'After clicking the \'Sync\' button, the temporary credit control that meets the requirements on the current page will take effect immediately. The limit and payment period will be recalculated, and there may be some delays. Please be patient.',
  Cargo_SyncTempCreditTip: 'Do not synchronize immediately when there is a temporary credit control approval process.',
  Cargo_OperationInstructions: 'Operation Instructions',
  Cargo_InstructionName: 'Instruction Name',
  Cargo_InstructionType: 'Instruction Type',
  Cargo_RuleCode: 'Rule Code',
  Cargo_CodeParameterValues: 'Code Parameter Values',
  Cargo_InstructionCode: 'Instruction Code',
  Cargo_CommandDisplayName: 'Command Display Name',
  Cargo_InstructionDescription: 'Instruction Description',
  Cargo_InstructionRuleSetting: 'Instruction Rule Setting',
  Cargo_IfAllowedSendMultipleTimes: 'If Allowed Send Multiple Times',
  Cargo_CanOnlyBeSentOnce: 'Can Only Be Sent Once',
  Cargo_CanBeSentMultipleTimes: 'Can Be Sent Multiple Times',
  Cargo_TemplateMatching: 'Template Matching',
  Cargo_UnifiedBusinessScenario: 'When selecting the push link, if different branches have independent maintenance templates, match them with the corresponding branch templates',
  Cargo_SelectEmailTemplate: 'Select Email Template',
  Cargo_SelectOperationInstruction: 'Select Operation Instruction',
  Cargo_SelectSpecificBusinessRule: 'Select specific business rules',
  Cargo_SelectThePushLink: 'Select the Push Link',
  Cargo_OperationButtonSettingsAndTip: 'Operation Button Settings (maximum of 5 operation instructions)',
  Cargo_SelectInstruction: 'Select Instruction',
  Cargo_SetParameters: 'Set Parameters',
  Cargo_SetParameterValues: 'Set Parameter Values',
  Cargo_InstructionChineseName: 'Instruction chinese name',
  Cargo_InstructionEnglishName: 'Instruction english name',
  Cargo_InstructionJapaneseName: 'Instruction japanese name',
  Cargo_CheckRuleNameExist: 'Rule name [{0}] already exists',
  Cargo_LatestInstructionRecord: 'Recent execution status of operation instructions',
  Cargo_InstructionRecords: 'Operation instruction log',
  Cargo_QueryInstructionRecords: 'View instruction execution logs',
  Cargo_ExecuteResult: 'Results of execution',
  Cargo_OperationInstructionsManagement: 'Operation instructions management',
  Cargo_PlatformInstructionDisabled: 'This command is no longer available, please check if the configuration is correct!',
  Cargo_NotMatchInstruction: 'There are no businesses that meet the conditions of this instruction',
  Cargo_SelectJobCount: 'Number of selected business transactions',
  Cargo_MatchInstructionTip: 'Select {0} items, {1} items that meet the operation instruction conditions',
  Cargo_OperationInstructionSetTip: 'When setting operation instructions, the value of \'Select Instruction\' cannot be empty!',
  Cargo_OperationInstructionRepeatTip: 'When setting operation instructions, the selected instructions cannot be repeated!',
  Cargo_OperationInstructionBatchTip: 'Please do not select more than 30 business data items when sending emails in bulk each time.',
  Cargo_CurrentUserRole: 'Current User Role',
  Cargo_DisabledUnableToSave: '\'{0}\' has been disabled and cannot be saved. Please remove the relevant fees and save again.',
  Cargo_CompanyDateOfCreation: 'Creation time of the commissioning unit',
  Cargo_BringInBusinessInformation: 'Supplement order information',
  Cargo_LclSendDestinationPortAgentTip: 'Only one main ticket business can be selected for sending to the destination port agent',
  Cargo_LclSendPackageAgentTip: 'Only one main ticket business can be selected for sending a set of port agents',
  Cargo_SetUploadFileType: 'Set upload file type',
  Cargo_PillReportData: 'Manually generate and replace data sources',
  Cargo_CanOnlyPrintOnce: 'Only able to print once',
  Cargo_CanPrintMultipleTimes: 'Can print multiple times',
  Cargo_IfSelectTemplateType: 'Select the template file type, and when different subsidiaries have independently maintained templates, match them with the corresponding subsidiary templates',
  Cargo_PrintMode: 'print mode',
  Cargo_SingleJobPrint: 'Single ticket business printing',
  Cargo_BatchJobPrint: 'Batch business printing',
  Cargo_SinglePrintFileType: 'Single ticket printing file type',
  Cargo_CabinRetrievalSuccessful: 'Cabin retrieval successful',
  Cargo_CabinRetrievalAndReturnSuccessful: 'Successful retrieval and return of cabin space',
  Cargo_revokeCabinSpace: 'The order you have selected will undergo the process of withdrawing the cabin space',
  Cargo_CancelCabinAtTheSameTime: 'Simultaneously exiting the cabin',
  Cargo_CabinFlowExitAndNo: 'Data with and without cabin records cannot be operated together',
  Cargo_BatchPrintFileType: 'Batch printing file types',
  Cargo_SinglePrintFileTemplate: 'Single ticket printing file template',
  Cargo_BatchPrintFileTemplate: 'Batch printing file templates',
  Cargo_SelectPrintFileTemplate: 'Select Print File Template',
  Cargo_SelectPrintFileType: 'Select file type for printing',
  Cargo_SelectPrintFileTypeTip: 'The selected print template does not have a file type set! Please first set the file type corresponding to the print template',
  Cargo_DeleteConfigTip: 'Are you sure to delete? After deletion, the original function settings will no longer be available!',
  Cargo_PreviewVoucher: 'Preview voucher',
  Cargo_InvoiceNotVoucher: 'This invoice has not generated a voucher, please select again.',
  Cargo_BankSlipNotVoucher: 'This bank slip has not generated a voucher, please select again.',
  Cargo_PleaseChooseDataThatHasVouchered: 'Please select data that has already generated vouchers.',
  Cargo_ExportVoucherSuccessfully: '{0} vouchers exported successfully.',
  Cargo_ExportVoucherFailedByBankSlip: 'BankSlip {0} export failed, reason {1}, please try again.',
  Cargo_ExportVoucherFailedByInvoice: 'Invoice {0} export failed, reason {1}, please try again.',
  Cargo_UpdatePaidOffFlag: 'Update PaidOff Flag',
  Cargo_CheckMblSame: 'MB/L NO is inconsistent with the basic tab',
  Cargo_IfExistMblNumberRange: 'Is there a main tracking number range',
  Cargo_UserName_Password_Maintained: 'Please contact the administrator to maintain the "Basic Settings - Resolution Channel Settings"',
  Cargo_ShipCompany_Maintained: 'Please contact the administrator to maintain the associated shipping company in the "Partner" section',
  Cargo_ShippingCompanyCode_Maintained: 'Map shipping company not maintained, please contact platform customer service for maintenance',
  Cargo_ShippingCompanyCode_MaintainedTip: 'Please contact platform customer service for maintenance',
  Cargo_BookingChannelConfig_Maintained: 'Not matched with bookingChannel config. Please contact the administrator to maintain the "Basic Configuration - Booking Channel Configuration"',
  Cargo_BookingChannelConfig_MaintainedTip: 'Please contact the administrator to maintain the "Basic Configuration - Booking Channel Configuration"',
  Cargo_ErrorMsg: 'Abnormal cause',
  Cargo_SelectJumpErrorTip: '【{0}】 not a clickable page, please select a page, such as:【basic】',
  Cargo_SelectJumpPage: 'Select the page to jump to',
  Cargo_JumpSet: 'Jump settings',
  Cargo_ClickJobNoJumpPage: 'Click on the business number to jump to the page',
  Cargo_JumpPage: 'Jump page',
  Cargo_TabNotExistTip: 'Unable to access this page, please confirm if you have access permission or if the document contains this page.',
  Cargo_CargoValue: 'System Value',
  Cargo_YdValue: 'Receipt information',
  Cargo_ConfirmReplace: 'Confirm coverage',
  Cargo_NotReplace: 'Not covered by anything',
  Cargo_ReplaceSystemValue: 'Covering system information',
  Cargo_PleaseSelectDataToReplace: 'Please select the field information that needs to be overwritten',
  Cargo_YdBookingResultTip: 'Detected a deviation between the information in the receipt and the data entered in the system. Please confirm',
  Cargo_NoMappingValuesTip: '{0} does not match the system value, please manually select if modification is needed',
  Cargo_NonReplaceDataTip: 'No data that needs to be covered',
  Cargo_JobNotFound: 'Not found job【{0}】',
  Cargo_AE_IDENTIFICATION_SUPPLIER: 'Air export identification supplier',
  Cargo_AIR_BILL_SUPPLIER: 'Air waybill identification supplier',
  Cargo_LoadingDate: 'Door service - pick-up time',
  Cargo_DoorAddr: 'Door service - Door Address',
  Cargo_DoorMan: 'Door service - Door Contact Person',
  Cargo_DriverTel: 'Door service - Tel',
  Cargo_aeFile: 'Letter of Lading for Air Export',
  Cargo_aiFile: 'Bill of lading documents for air freight imports',
  Cargo_carrierType: 'carrier Type',
  Cargo_DeclaredValue: 'Declared value',
  Cargo_DeclaredValueForCustoms: 'Declared Value for Customs',
  Cargo_RateLevel: 'Rate level',
  Cargo_PleaseSelectOperateType: 'Please select the operation mode for the book on page [{0}]',
  Cargo_ServiceProductID: 'Service Product ID',
  Cargo_ServiceProductName: 'Service Product Name',
  Cargo_ForceRoutingBooking: 'Mandatory Routing Booking',
  Cargo_UsedAsRoutingProduct: 'Used as Routing Product',
  Cargo_AirCargoServiceProduct: 'Air Service Product',
  Cargo_DeleteServiceProductWarning: 'You are about to delete {0} service product(s). Please proceed with caution.',
  Cargo_RouteProductName: 'Route Product Name',
  Cargo_ServiceProduct: 'Service Product',
  Cargo_PurchaseMethod: 'Purchase Method',
  Cargo_Airline2: 'Airline',
  Cargo_PurchaseSource: 'Purchase Source',
  Cargo_OriginPort: 'Origin Port',
  Cargo_RouteOfficer: 'Route Officer',
  Cargo_IsEffective: 'Is Effective',
  Cargo_BaseWeight: 'Base Weight',
  Cargo_LimitWeight: 'Limit Weight',
  Cargo_SellableSpace: 'Sellable Space',
  Cargo_LengthLimit: 'Length Limit',
  Cargo_HeightLimit: 'Height Limit',
  Cargo_TheoreticalVolume: 'Theoretical Volume',
  Cargo_SellableVolume: 'Sellable Volume',
  Cargo_Box: 'Box',
  Cargo_PayingParty: 'Paying Party',
  Cargo_UnitPrice_TotalPrice: 'Unit Price/Total Price',
  Cargo_RouteProductCode: 'Route Product Code',
  Cargo_BoardCount: 'Board count',
  Cargo_EffectiveDateMustBeLessThanTheExpirationDate2: 'The effective date must be less than or equal the expiration date',
  Cargo_AirlineProductCode: 'Airline product',
  Cargo_EffectiveDateMustBeLessThanTheExpirationDate2: 'The effective date must be less than or equal the expiration date',
  Cargo_DeleteServiceProductWarning: 'You are about to delete {0} service product(s). Please proceed with caution.',
  Cargo_PleaseSelectOperateType: 'Please select the operation mode for the book on page [{0}]',
  Cargo_BaoDiCreditInfoNote: 'Note: When the date type configured in the system is empty, the minimum accounting period will be used for calculation (uniformly settled on a monthly basis). When the date type in the business has a value, the fee due date will be recalculated',
  Cargo_BottomLineCreditControl: 'Bottom Line Credit Control',
  Cargo_ProfitShareConfig: 'Profit sharing allocation',
  Cargo_CreateRule: 'Create Rule',
  Cargo_EditRule: 'Edit Rule',
  Cargo_CopyRule: 'Copy Rule',
  Cargo_RuleName: 'Name of profit sharing rule',
  Cargo_RuleConfig: 'Rule configuration',
  Cargo_RuleRole: 'Role',
  Cargo_ShareMode: 'Profit sharing mode',
  Cargo_ShareModeJob: 'Share profits based on the entire ticket',
  Cargo_ShareModeCurrency: 'Profit sharing by currency',
  Cargo_UsdRatio: 'Profit sharing ratio',
  Cargo_NonUsdRatio: 'Non USD ratio',
  Cargo_ShareModeTip: 'pattern:',
  Cargo_ShareModeJobTip: 'Job',
  Cargo_BankSlipDateCreated: 'Bank slip creation date',
  Cargo_ShareRatio: 'Split profit:',
  Cargo_PleaseSelectSalesBranch: 'Please select a sales branch',
  Cargo_RuleConfigSubCountNotNull: 'The number of rule configuration branches cannot be empty',
  Cargo_SetUpConfigSubTriggerCondition: 'Please set triggering conditions.',
  Cargo_ConfigSubRuleError: 'Change in distribution rule conditions, triggering incorrect condition configuration',
  Cargo_AddRuleConfigSub: '+Add branch configuration',
  Cargo_AreYouSureModifyRuleConfigTips: 'Are you sure about the modifications?',
  Cargo_ProfitShare: 'Whether to distribute profits',
  Cargo_ProfitShareColumn: 'Whether to distribute profits',
  Cargo_ProfitShareAdjust: 'Adjust Profit Share',
  Cargo_ProfitShareReset: 'Reset Profit Share',
  Cargo_NonProfitShareBranch: 'No branch offices to distribute profits',
  Cargo_ProfitShareRatioSumExceed: 'The current profit sharing ratio exceeds 100%, please adjust and confirm again.',
  Cargo_UsdProfit: 'Profit in US dollars',
  Cargo_NonUsdProfit: 'Non USD profit',
  Cargo_JobProfit: 'Whole ticket profit',
  Cargo_ShareBranchId: 'Fenrun Fang',
  Cargo_UsdRatioColumn: 'Profit sharing ratio in US dollars',
  Cargo_UsdProfitColumn: 'Expected profit in US dollars',
  Cargo_UsdProfitColumn2: 'Expected profit',
  Cargo_NonUsdRatioColumn: 'Non USD profit sharing ratio',
  Cargo_NonUsdProfitColumn: 'Expected non USD profits',
  Cargo_CheckProfitShareResetTip: 'The {0} profit sharing fee is used for subsequent financial actions (invoicing, payment, billing, write off, etc.), and cannot be redistributed temporarily. Please try again after canceling the corresponding financial actions.',
  Cargo_AdjustColumn: 'Change',
  Cargo_UsdProfitAdjustColumn: 'Expected additional profit in US dollars',
  Cargo_UsdProfitAdjustColumn2: 'Expected additional profit',
  Cargo_NonUsdProfitAdjustColumn: 'Expected additional profits in non US dollars',
  Cargo_JobProfitShare: 'Has the profit sharing been completed',
  Cargo_ReceivableFeeLockTime: 'Receivable Fee Lock Time',
  Cargo_ReceivableFeeLockTime2: 'Receivable Lock Time',
  Cargo_PayableFeeLockTime: 'Payable Fee Lock Time',
  Cargo_PayableFeeLockTime2: 'Payable Lock Time',
  Cargo_PayableFeeLockPerson: 'Payable Fee Lock Person',
  Cargo_RpaAccount: 'RPA hosting account',
  Cargo_WechatGroupName: 'Enterprise WeChat group name',
  Cargo_TabEnterpriseWechat: 'Enterprise WeChat account hosting',
  Cargo_LoginEnterpriseWechat: 'Login to Enterprise WeChat',
  Cargo_LoginEnterpriseWechatTip: 'Please use Enterprise WeChat to scan the code and log in to Enterprise WeChat',
  Cargo_RpaAccountSummary: 'RPA hosting account information',
  Cargo_RpaAccountSummaryTip: 'If adjustments are needed, they can be made on the [Partner Contact] tab.',
  Cargo_RpaAccountColumn: 'Enterprise WeChat account',
  Cargo_RpaAccountEnabled: 'Account status',
  Cargo_BatchEditEnterpriseWechat: 'Batch modify contacts for enterprise WeChat group chat',
  Cargo_EditEnterpriseWechatButton: 'Batch modify enterprise WeChat group chat names',
  Cargo_RpaAccountColumn2: 'RPA hosting account',
  Cargo_EditEnterpriseWechatTitle: 'Modify Contact Person Enterprise WeChat Group Chat',
  Cargo_RpaAccountWechatGroupNameCanTBeEmpty: 'Please fill in the RPA hosting account/enterprise WeChat group chat field and save it.',
  Cargo_EnterpriseWechat: 'Enterprise Wechat',
  Cargo_MessageContent: 'Message content',
  Cargo_PushFiles: 'Push files',
  Cargo_PushFilesTip: 'The file will be compressed into a ZIP file and sent to the enterprise WeChat group through the download link address',
  Cargo_EnterpriseWechat2DataServiceReminder: '(Only applicable to changes in ship plans)',
  Cargo_EnterpriseWechatSopTip: 'Please fill in the group chat name accurately, otherwise it cannot be pushed. If there are multiple items, please use "," to separate and fill in.',
  Cargo_PleaseInputVerificationCode: 'Please enter the verification code',
  Cargo_InputVerificationCodeTip1: 'This device is logging in for the first time and requires a verification code. Please enter the verification code received by the enterprise WeChat account mobile client',
  Cargo_InputVerificationCodeTip2: 'Verification failed, verification code is invalid or expired, please re-enter',
  Cargo_CaptchaUsing: 'Verification in progress, please refresh status later...',
  Cargo_LoginSuccess: 'Account: {0}, successfully logged in.',
  Cargo_PushEnterpriseWechat: 'Push Enterprise WeChat',
  Cargo_PushEnterpriseWechatTip: 'The contact has not set up a WeChat account or group chat name, and message push will fail',
  Cargo_ServiceProductID: 'Service Product ID',
  Cargo_ServiceProductName: 'Service Product Name',
  Cargo_ForceRoutingBooking: 'Mandatory Routing Booking',
  Cargo_UsedAsRoutingProduct: 'Used as Routing Product',
  Cargo_AirCargoServiceProduct: 'Air Service Product',
  Cargo_BusinessManager: 'Business Manager',
  Cargo_AirlinePersonSetting: 'The establishment of the route manager',
  Cargo_PrePortFreightRateOfficer: 'Pre-port freight rate officer',
  Cargo_PersonChargeTrunkLineFreightRates: 'Person in charge of trunk line freight rates',
  Cargo_PersonChargeLastMileFreightRates: 'Person in charge of last-mile freight rates',
  Cargo_NamePersonResponsible: 'Name of the person in charge',
  Cargo_ResponsiblePortDeparture: 'Be responsible for the port of departure',
  Cargo_OnlyOneFullPerson: 'There can only be one full person in charge when the port is empty',
  Cargo_OnlyOneFullPersonSameType: 'Under the same type, there can only be one person in charge',
  Cargo_AdministrativeDivision: 'Administrative division',
  Cargo_StreetTownship: 'Street/town/township level',
  Cargo_PostalCodeManagement: 'Postal Code Management',
  Cargo_UsPostalCode: 'American postal code',
  Cargo_preportAudit: 'Pre-port audit',
  Cargo_TrunkLineAudit: 'Trunk line review',
  Cargo_TailEndAudit: 'Last-mile review',
  Cargo_preportAuditStatus: 'Pre-port review status',
  Cargo_TrunkLineAuditStatus: 'Trunk line review status',
  Cargo_TailEndAuditStatus: 'Final review status',
  Cargo_NoReviewRequired: 'No review required',
  Cargo_HasBeenReviewed: 'Already reviewed',
  Cargo_NoAuthorityReview: 'Have no authority to review',
  Cargo_DeleteServiceProductWarning: 'You are about to delete {0} service product(s). Please proceed with caution.',
  Cargo_RouteProductName: 'Route Product Name',
  Cargo_ServiceProduct: 'Service Product',
  Cargo_PurchaseMethod: 'Purchase Method',
  Cargo_Airline2: 'Airline',
  Cargo_PurchaseSource: 'Purchase Source',
  Cargo_OriginPort: 'Origin Port',
  Cargo_RouteOfficer: 'Route Officer',
  Cargo_IsEffective: 'Is Effective',
  Cargo_BaseWeight: 'Base Weight',
  Cargo_LimitWeight: 'Limit Weight',
  Cargo_SellableSpace: 'Sellable Space',
  Cargo_LengthLimit: 'Length Limit',
  Cargo_HeightLimit: 'Height Limit',
  Cargo_TheoreticalVolume: 'Theoretical Volume',
  Cargo_SellableVolume: 'Sellable Volume',
  Cargo_Box: 'Box',
  Cargo_PayingParty: 'Paying Party',
  Cargo_UnitPrice_TotalPrice: 'Unit Price/Total Price',
  Cargo_RouteProductCode: 'Route Product Code',
  Cargo_BoardCount: 'Board count',
  Cargo_EffectiveDateMustBeLessThanTheExpirationDate2: 'The effective date must be less than or equal the expiration date',
  Cargo_AirlineProductCode: 'Airline product',
  Cargo_NotAssemblyQuantity: 'Assembled Quantity',
  Cargo_NotAssemblyGrossWeight: 'Assembled Gross Weight',
  Cargo_NotAssemblyVolume: 'Assembled Volume',
  Cargo_NotAssemblyChargeableWeight: 'Assembled Chargeable Weight',
  Cargo_Density_Weight: 'Density/Weight',
  Cargo_PreWarehouseStatus: 'Pre-Warehouse Status',
  Cargo_DeliveryStation2: 'Delivery Station',
  Cargo_DeliveryStatus: 'Delivery Status',
  Cargo_PreAssemblyPlanProductionPlan: 'Pre-Assembly Plan - Production Plan',
  Cargo_ShipmentOrder: 'Shipment Order',
  Cargo_GenerateAssemblyPlan: 'Generate Assembly Plan',
  Cargo_AssemblyPlanNumber: 'Assembly Plan Number',
  Cargo_AssemblyPlanStatus: 'Assembly Plan Status',
  Cargo_AssemblyItemCount: 'Assembly Item Count',
  Cargo_AssemblyGrossWeight: 'Assembly Gross Weight',
  Cargo_AssemblyVolume: 'Assembly Volume',
  Cargo_AssemblyChargeableWeight: 'Assembly Chargeable Weight',
  Cargo_ContainerGroup: 'Container Group',
  Cargo_LoadingPool: 'Loading Pool',
  Cargo_MergeGroup: 'Merge Group',
  Cargo_DeleteGroup: 'Delete Group',
  Cargo_AddToPlan: 'Add to Plan',
  Cargo_AssemblyPlan: 'Assembly Plan',
  Cargo_PlanIssued: 'Plan Issued',
  Cargo_CancelPlanIssued: 'Cancel Plan Issued',
  Cargo_PlanPrint: 'Plan Print',
  Cargo_AssemblyCompleted: 'Assembly Completed',
  Cargo_CancelAssemblyCompleted: 'Cancel Assembly Completed',
  Cargo_ConfirmCompleted: 'Confirm Completed',
  Cargo_CancelConfirmCompleted: 'Cancel Confirm Completed',
  Cargo_ImportAssemblyPlan: 'Import Assembly Plan',
  Cargo_UnifiedError: 'The 【{0}】 is not unified, do you want to continue?',
  Cargo_JoinExistingAssemblyPlan: 'Do you want to merge with the existing assembly plan?',
  Cargo_ExistingPlanIssued: 'An assembly plan has already been issued, merging is not allowed. Please revoke the issued plan and try again.',
  Cargo_CostAllocated: 'The cost has already been allocated. Please delete the allocated cost manually. Do you want to continue?',
  Cargo_MaintainAtLeastOneGroup: 'Please maintain at least one container group',
  Cargo_FieldsCannotBeEmpty: '【Piece/Gross/Net/Unit】 must be greater than 0, please check.',
  Cargo_AssemblyPlanExceedsContainerGroup: 'The quantity of 【Assembly Plan - Container Groups】 is greater than the quantity of 【Route Product - Voyage - Pallets】, do you want to continue?',
  Cargo_PlanIssuedTip: 'The assembly plan has been issued and cannot be operated. Please cancel the issuance and try again.',
  Cargo_PieceWeightVolumeUnit: 'Piece, Gross, Net, Unit',
  Cargo_EstimatedAmazonArrivalTime: 'Estimated Amazon Warehouse Arrival Time',
  Cargo_SelectCommonShipper: 'Select Common Shipper',
  Cargo_SaveAsCommonShipper: 'Save as Common Shipper',
  Cargo_SelectCommonConsignee: 'Select Common Consignee',
  Cargo_SaveAsCommonConsignee: 'Save as Common Consignee',
  Cargo_SelectCommonNotifier: 'Select Common Notifier',
  Cargo_SaveAsCommonNotifier: 'Save as Common Notifier',
  Cargo_BoxQuantity: 'Box Quantity',
  Cargo_OutboundMode: 'Outbound Mode',
  Cargo_PalletQuantity: 'Pallet Quantity',
  Cargo_InventoryAge: 'Inventory Age (Days/Weeks)',
  Cargo_OutboundOperator: 'Outbound Operator',
  Cargo_RemainingBoxes: 'Remaining Boxes in Stock',
  Cargo_Goods: 'Goods',
  Cargo_InventoryInfo: 'Inventory Information',
  Cargo_OutboundByPallet: 'Outbound by Pallet',
  Cargo_OutboundByBox: 'Outbound by Box',
  Cargo_Outbound: 'Outbound',
  Cargo_NotOutbound: 'Not Outbound',
  Cargo_OutboundBatch: 'Outbound Batch',
  Cargo_BoxesInStock: 'Boxes in Stock',
  Cargo_PalletsInStock: 'Pallets in Stock',
  Cargo_PromptWord: '##Attachment Overview：\n' +
    'This is a consumption invoice. Please determine the currency based on the language of the invoice. Please identify the following fields: Charge Entity (Service Provider), Consumption Amount, Consumption Tax (Tax Amount), Tax Rate, and Currency.\n' +
    '##Output Requirements：\n' +
    '1、Return in JSON format. All field names in the JSON should be in Chinese.\n' +
    '2、Example JSON format：\n' +
    '      { \n' +
    '        "data": {\n' +
    '          "Consignee": "",\n' +
    '          ……\n' +
    '        }\n' +
    '      }\n' +
    '##Definitions and Rules for Each Field：\n' +
    '#1、Charge Entity (Service Provider)\n' +
    '#2、Consumption Amount\n' +
    '#3、Consumption Tax (Tax Amount)\n' +
    '#4、Tax Rate\n' +
    '#5、Currency',
  CargoMsg_AIAddressRecognition: 'AI Smart Address Recognition',
  Cargo_ContainerGroupHasOrder: 'There are orders in the container group, deletion is prohibited. Please move the orders out before deleting.',
  Cargo_HSCode: 'HS CODE',
  ChargeHasUpdate: 'The fee was modified by {0} in {1}. Please recheck the data and perform the operation again!',
  Cargo_QuickSearchCustomPage: 'Quick search: Form name',
  Cargo_ApplicationScene: 'Application Scene',
  Cargo_FormId: 'Form ID',
  Cargo_FormType: 'Form Type',
  Cargo_AddSelectedElements: 'Add Selected Elements',
  Cargo_ElementsAddedSuccessfully: 'Elements added successfully',
  Cargo_SelectPagePart: 'Select Page Part',
  Cargo_AddPagePart: 'Add Page Part',
  Cargo_ChatUser: 'User',
  Cargo_ChatAI: 'AI Assistant',
  Cargo_ChatInputPlaceholder: 'Send message... (Enter for new line, Ctrl+Enter to send)',
  Cargo_ChatThinking: 'Thinking...',
  Cargo_ChatCopySuccess: 'Copied to clipboard',
  Cargo_ChatConfirmTitle: 'Prompt',
  Cargo_ChatDeleteConfirm: 'Are you sure you want to delete this message?',
  Cargo_ChatCopyFailed: 'Copy failed',
  Cargo_ChatDeleteSuccess: 'Deleted',
  Cargo_ChatNoResponse: 'No response received',
  Cargo_ChatConnectionError: 'Sorry, connection error occurred. Please try again.',
  Cargo_Debug: 'Debug',
  Cargo_DebugAndConfig: 'Debug and Settings',
  Cargo_EnterValue: 'Please enter value',
  Cargo_CreateForm: 'Create Form',
  Cargo_ConfigForm: 'Configure Form',
  Cargo_Branch: 'Application Company',
  Cargo_FormNamePlaceholder: 'Please enter form name',
  Cargo_BranchPlaceholder: 'Please select application company',
  Cargo_ApplicationScenePlaceholder: 'Please select application scene',
  Cargo_BusinessTypePlaceholder: 'Please select business type',
  Cargo_RemarksPlaceholder: 'Please enter remarks',
  Cargo_APIApplication: 'API Application',
  Cargo_BusinessSingleMode: 'Business Single Mode',
  Cargo_BusinessBatchMode: 'Business Batch Mode',
  Cargo_ConfirmMessageNotEditableAfterCreate: ' cannot be modified after creation, confirm to proceed?',
  Cargo_Tip2: 'Tip',
  Cargo_SelectDeleteTip4: 'Please select the data you want to delete',
  Cargo_SelectDeleteTip5: 'Are you sure you want to delete the selected data? This operation cannot be undone.',
  Cargo_FormDisableWarning: 'Disabled forms will be unavailable, please adjust modules using this form promptly!',
  Cargo_ElementSettings: 'Element Settings',
  Cargo_ElementRules: 'Element Rules',
  Cargo_IsReadOnly: 'read-only',
  Cargo_IsRequired: 'required',
  Cargo_FormInfo: 'Form Information',
  Cargo_InputOutputConfig: 'Input/Output Settings',
  Cargo_FormInputConfigDescription: 'Load Form (Request Params): When loading the form, request interfaces in sequence to process form fields',
  Cargo_FormInputAPI: 'Input API',
  Cargo_FormInputAPIPlaceholder: 'Please enter input API list',
  Cargo_FormOutputConfigDescription: 'Submit Form (Function Call): When submitting the form, request application interfaces in sequence',
  Cargo_FormOutputAPI: 'Output API',
  Cargo_FormOutputAPIPlaceholder: 'Please enter output API list',
  Cargo_SaveDraft: 'Save Draft',
  Cargo_PublishForm: 'Publish Form',
  Cargo_LastOperateTime: 'Last Operation Time',
  Cargo_Draft: 'Draft',
  Cargo_Published: 'Published',
  Cargo_ConfigPagePart: 'Configure Area',
  Cargo_ConfigName: 'Config Name',
  Cargo_PagePartFunction: 'Area Function',
  Cargo_PleaseSelectFunction: 'Please select function',
  Cargo_BusinessElements: 'Business Elements',
  Cargo_ConsigneeShipperAndNotifyInfo: 'Consignee/Shipper/Notify Info',
  Cargo_AccountsReceivable: 'Accounts Receivable',
  Cargo_AccountsPayable: 'Accounts Payable',
  Cargo_UploadFile: 'Upload File',
  Cargo_UploadInstruction: 'Upload Instruction',
  Cargo_InstructionParameter: 'Instruction Parameter',
  Cargo_FormPreviewInListViewIsReadOnly: 'To edit debug data, please click "Edit" to enter the details page.',
  Cargo_BPM: 'BPM',
  Cargo_OCR: 'OCR',
  Cargo_PublishSuccess: 'Published successfully',
  Cargo_PublishFailed: 'Publish failed',
  Cargo_ValueRequired: 'This value cannot be empty',
  Cargo_FixFormErrors: 'Please check if the form is filled correctly',
  Cargo_ValidationFailed: 'Validation failed, please check if the values are correct',
  Cargo_ToggleStatusFailed: 'Failed to toggle form status',
  Cargo_CopySucceed: 'Copy successful',
  Cargo_CopyFailed: 'Copy failed',
  Cargo_CopyFormConfirm: 'Are you sure you want to copy this form and all its blocks, element layouts, and other configuration information?',
  Cargo_CannotDeleteEnabledForm: 'Cannot delete an enabled form, please disable it first',
  Cargo_GetFormConfigFailed: 'Failed to get form configuration',
  Cargo_ConfirmChangeBlockType: 'Change area function, do you want to clear the configuration content of the original area?',
  Cargo_CopyOne: 'Please select one record to copy!',
  Cargo_ConfirmDeleteBlock: 'Are you sure you want to delete this area and uncheck the selected fields?',
  Carog_ConfirmSaveBeforeGoBack: 'Do you want to save the current configuration?',
  Cargo_FormValidation: 'Form Validation',
  Cargo_Problem: 'Problem',
  Cargo_Description: 'Description',
  Cargo_ValidationSucceed: 'Validation Succeeded',
  Cargo_NoChanges: 'No Data Changes',
  Cargo_JobUuidRequired: 'Business Form UUID is Required',
  Cargo_LoadFormDataFailed: 'Failed to Load Form Data',
  Cargo_SyncRuleExecutionFailed: 'Data Association Rule Execution Failed',
  Cargo_PreviewRevision: 'Preview this version',
  Cargo_Current: 'Current',
  Cargo_FormPreviewInRevisionViewIsReadOnly: 'Current preview is a historical version, read-only mode only.',
  Cargo_VisualizationView: 'Visualization Layout',
  Cargo_CodeView: 'Code View',
  Cargo_ChatView: 'AI Assistant',
  Cargo_RestoreRevision: 'Restore to this version',
  Cargo_RestoreSucceed: 'Restore successful',
  Cargo_RestoreFailed: 'Restore failed',
  Cargo_ConfirmRestoreRevision: 'Are you sure you want to restore this version?',
  Cargo_NeedAtLeastOnePagePart: 'At least one information area must remain',
  Cargo_DataFill: 'Data Fill',
  Cargo_CSNInfo_BASIC: 'CSN Info (Basic Tab)',
  Cargo_CSNInfo_MBL: 'CSN Info (MBL)',
  Cargo_CSNInfo_HBL: 'CSN Info (HBL)',
  Cargo_CSNInfo_HBL2: 'CSN Info (Split Bill)',
  Cargo_ReadOnly: 'Read Only',
  Cargo_Notify: 'Notify Party',
  Cargo_AlsoNotify: 'Second Notify Party',
  Cargo_AgentParty: 'Agent Info',
  Cargo_ShippingExchangeRateBatchConfig: 'Shipping Exchange Rate Batch Configuration',
  Cargo_DeclarationScope: 'Declaration Scope',
  Cargo_DeclarationBusiness: 'Declaration Business',
  Cargo_DeclarationFee: 'Declaration Fee',
  Cargo_SetBranch: 'Set Branch',
  Cargo_FollowHQ: 'Follow HQ',
  Cargo_FreightRate: 'Freight Rate',
  Cargo_ContainerLock: 'Container Lock Fee',
  Cargo_OtherAdditionalCharges: 'Other Additional Charges',
  Cargo_UpperLimit: 'Upper Limit',
  Cargo_LowerLimit: 'Lower Limit',
  Cargo_AlertNotification: 'Alert Notification',
  Cargo_RPASettings: 'RPA Settings',
  Cargo_UnregisteredShippingRate: 'When the created business freight rate is not declared in the shipping exchange',
  Cargo_ExceedMaintainedLimit: 'When the created business freight rate exceeds the maintained limit',
  Cargo_RPAPaused: 'When RPA is paused',
  Cargo_RPACompleted: 'When RPA is completed',
  Cargo_ProhibitSaving: 'Prohibit saving',
  Cargo_RecordOnly: 'Record only without alert',
  Cargo_NoRecordNoAlert: 'No record no alert',
  Cargo_NotifyRoleByEmail: 'Email notification to specified role',
  Cargo_NotifyPersonByEmail: 'Email notification to specified person',
  Cargo_NotifyPositionByEmail: 'Email Notification to Specified Position',
  Cargo_RPAService: 'RPA Service',
  Cargo_EnableRPAService: 'Enable RPA Service',
  Cargo_ShippingExchangeAccount: 'Shipping Exchange Account',
  Cargo_ShippingExchangePassword: 'Shipping Exchange Password',
  Cargo_RPASubmission: 'Submit data on {0} by RPA',
  Cargo_WarningReason: 'Warning Reason',
  Cargo_WarningMessage: 'Warning Message',
  Cargo_UnregisteredRateSaveError: 'Our company has enabled the shipping exchange rate publication function. The current business freight rate has not been declared in the shipping exchange, so it cannot be saved. If you need to enter the business, please contact the filing person: <br/>{0}',
  Cargo_UnregisteredRateWarning: 'Our company has enabled the shipping exchange rate publication function. The current business freight rate has not been declared in the shipping exchange. To avoid non-compliant operations, please promptly contact the filing person: <br/>{0}',
  Cargo_ExceedDeclaredLimitSaveError: 'Our company has enabled the shipping exchange rate publication function. The current business freight rate exceeds the declared limit and therefore cannot be saved. If you need to enter the business, please contact the filing person: <br/>{0}',
  Cargo_ExceedDeclaredLimitWarning: 'Our company has enabled the shipping exchange rate publication function. The current business freight rate exceeds the declared limit. To avoid non-compliant operations, please promptly contact the filing person: <br/>{0}',
  Cargo_GoToProcess: 'Go to Process',
  Cargo_GoToDeclare: 'Go to Declare',
  Cargo_CheckWarningToProcess: 'Please check the warning information that needs to be processed',
  Cargo_SelectedWarningMarkedProcessed: 'The selected warning information has been marked as "Processed"',
  Cargo_SelectInfoToDeclare: 'Please select the information that needs to be declared',
  Cargo_SureSaveUnControlledProduct: 'Are you sure to save? After saving, the business will be locked and cannot be operated or revoked again! ',
  Cargo_ScmNeedAllowProduct: 'When exporting controlled products, relevant permits must be obtained in advance. For details, please contact the SCM Promotion Office.',
  Cargo_SureSave: 'Confirm Save',
  Cargo_DataLoadingPleaseWait: 'Data loading, please wait.',
  Cargo_RuleID: 'Rule ID',
  Cargo_ValidationRule: 'Validation Rule',
  Cargo_TriggerElement: 'Trigger Field',
  Cargo_RelatedElements: 'Related Fields',
  Cargo_TriggerCondition: 'Trigger Condition',
  Cargo_FunctionCode: 'Function Code',
  Cargo_AddedValidationRules: 'Added the following validation rules',
  Cargo_AddedSyncRules: 'Added the following sync rules',
  Cargo_AddedVisibilityRules: 'Added the following visibility rules',
  Cargo_NoRuleDetected: 'Sorry, no valid data validation or data association editing functions were detected. You can try adjusting the query and try again.',
  Cargo_ConnectionError: 'Sorry, there was a connection problem. Please try again.',
  Cargo_OperationArea: 'Operation Area',
  Cargo_BlDataNotFound: 'Bill of Lading data not found',
  Cargo_SelectBlDocument: 'Please select bill of lading document',
  Cargo_SelectHblDocument: 'Please select HBL document',
  Cargo_SelectHawb2Document: 'Please select formal split document',
  Cargo_AIChangRulesNumber: 'Successfully modified {0} rules',
  Cargo_AIDeleteRulesNumber: 'Successfully deleted {0} rules',
  Cargo_AIAddRulesNumber: 'Successfully added {0} rules',
  Cargo_UnknownIntent: 'Your query does not contain specific rules',
  Cargo_AIDeleteUnexistRulesNumber: 'The rule to be deleted does not exist',
  CanNotEditCustomer: 'The trustFromEditSales parameter is not enabled. Modification of the commissioning unit is not allowed in cross-commission business!',
  CustomerRefreshChargeTips: 'The commissioning unit already has costs. Refresh costs?',
  BookingAgentRefreshChargeTips: 'The booking agent already has costs. Refresh costs?',
  refreshCargoSourceForNc: 'Would you like to switch the cargo type to specified cargo?',
  Cargo_FilingBatchNo: 'Filing BatchNo',
  Cargo_FilingState: 'Filing State',
  Cargo_SubmitDate: 'Submit Date',
  Cargo_DeclareFinal: 'Declare/Final',
  Cargo_FiletotalRecordPass: 'Filetotal/Record/Pass',
  Cargo_StartRPA: 'Start RPA',
  Cargo_SuspendRPA: 'Suspend RPA',
  Cargo_SuspendRPA2: 'Suspend',
  Cargo_RpaState: 'RPA State',
  Cargo_ImportFinalResult: 'Import Final Result',
  Cargo_ManuallyExportFile: 'Manually Export File',
  Cargo_FilingBatchInfo: 'Filing Batch Info',
  Cargo_FilingDate: 'Filing Date',
  Cargo_OpenPriceInfo: 'Open Price Info',
  Cargo_Past6MonthPort: 'Obtain ports with business in the past 6 months',
  Cargo_Past1MonthPrice: 'Obtain the freight rates for ships departing in the past month',
  Cargo_CompanyCode2: 'Company Code',
  Cargo_Lane: 'Lane',
  Cargo_DepartureDay: 'Departure Day',
  Cargo_CargoType2: 'Cargo Type',
  Cargo_EqSize: 'EqSize',
  Cargo_Cost2: 'Freight rate',
  Cargo_CostRange: 'Freight rate range',
  Cargo_CostMin: 'Lowest freight rate',
  Cargo_CostMax: 'Highest freight rate',
  Cargo_EqDeduct: 'Eq Deduct',
  Cargo_BatchReturnPreApproval: 'Batch Return to Pre-Approval/Remote Booking',
  Cargo_ReturnPreApprovalRemoteBooking: 'Return to Pre-Approval/Remote Booking',
  Cargo_ConfirmReturnResubmit: 'Confirm return to booking pre-approval/remote booking for resubmission?',
  Cargo_ReturnModuleSelection: 'Select return module',
  Cargo_ReturnModule: 'Return module',
  Cargo_ReturnReason: 'Reason for return',
  Cargo_MasterTicketRelationError: 'Master-ticket relationship exists, return not allowed',
  Cargo_CostStatusReturnError: 'Cost already {0}, return not allowed',
  Cargo_RouteManagerEmptyError: 'Business No.: {0} Route manager is empty, return not allowed',
  Cargo_FOBReturnRestriction: 'FOB business can only be returned to remote booking',
  Cargo_SelectedBusiness: 'Selected business',
  Cargo_RemoteBooking: 'Remote Booking',
  Cargo_RemoteBookingExportOnly: 'Remote booking only supports return of export business',
  Cargo_ReturnResult: 'Successfully returned: {0}, Failed: {1}',
  Cargo_MasterTicketRelationAlert: '[{0}] Master-ticket relationship exists',
  Cargo_NotFromRemoteBookingError: '[{0}] Orders not from remote booking cannot be returned',
  Cargo_NotFromPreApprovalError: '[{0}] Orders not from booking pre-approval cannot be returned',
  Cargo_CostStatusAlert: '[{0}] Cost already {1}',
  Cargo_ReturnCurrentOperationOnly: 'Only supports return of currently operating business',
  Cargo_MixedBusinessTypeError: 'Selected businesses contain both FOB and non-FOB types, cannot be returned together',
  Cargo_CollabBatchRejectError: 'Includes {0} collaborative business, batch rejection not supported',
  Cargo_OtherSurcharge: 'Other Surcharge',
  Cargo_MoreDetails: 'More Details',
  Cargo_SureToStartRPA: 'After RPA is launched, the system will automatically transmit data to the website of the aviation exchange. Before starting, please ensure that the data has been filled in completely.',
  Cargo_SureToSuspendRPA: 'After RPA is paused, if restarted, the system will update the data status on the aviation exchange. If the loading is not confirmed, the system will create a new schedule and upload it. If there are no serious issues, please try not to pause RPA.',
  Cargo_SureToDeleteOpenPrice: 'Please confirm whether to delete the data of batch [{0}]?',
  Cargo_SureToImportFinalResult: 'Manually importing the final result means that you confirm that the batch has been completed and RPA will no longer be executed.',
  Cargo_SureToExportFile: 'Please confirm if you want to export the data for batch [{0}]?',
  FileBeLargerThan10MB: 'The file size cannot exceed 10MB',
  FileBeLargerThan5MB: 'The file size cannot exceed 5MB',
  Cargo_DeclareFile: 'Declare file',
  Cargo_ImportFinalFile: 'Import final file',
  Cargo_FinalPriceInfo: 'Final price',
  Cargo_DeclareNumLabel: 'Total freight rates: {0} items',
  Cargo_DeclareFinalLabel: 'Number of declaration lines/final number of lines: {0}',
  Cargo_QuerySuccess: 'Successfully obtained data',
  HasDeletedForDeleteJob: 'The currently selected business has been deleted!',
  HasSlaveJobForDeleteJob: '[{0}]Please remove the receipt first!',
  HasChargeForDeleteJob: '[{0}]The expense has been entered!',
  HasMergeForDeleteJob: '[{0}]The orders have already been combined!',
  refreshCargoSourceForSc: 'Would you like to switch the cargo solicitation type to self-solicitation?',
  Cargo_ArCustomerPaidOff: 'Customer write off status',
  Cargo_ContainsAdvancePayment: 'Whether contains advance payment',
  Cargo_JdySendStatus: 'JianDaoYun Send Status',
  Cargo_JdySendTime: 'JianDaoYun Send Time',
  Cargo_DetailsLockedStatus: 'Cargo Details Locked Status',
  Cargo_InterestAmountCurrency: 'Overdue interest',
  Cargo_CheckRuleResult: 'CheckRule result',
  BatchProcessingIsNotSupported: 'Batch processing is not supported',
  BatchFillingIsNotConfigured: 'Batch form filling is not configured',
  SingleEntryIsNotSupported: 'Single ticket business entry is not supported',
  SingleFormIsNotConfigured: 'Single ticket form is not configured',
  TheFormDoesNotExist: 'The form does not exist.',
  DataHasModified: 'Data was modified by [{0}] at {1}, please refresh!',
  Cargo_CheckNeedSynccloud: 'Please select bill to sync cloud platform.',
  Cargo_CheckJingdiesynccloud: 'Only foreign bills and agency payment/receipt bills can be pushed to Kingdee.',
  DisplayReceiptsOnly: 'Display receipts only',
  AssignedWorkResponsibleForNode: 'Assigned position (based on the work responsible for the position setting node)',
  Cargo_CheckZySave: 'Please confirm whether the goods in the order involve the "Export Control Law of the People\'s Republic of China", "Regulations on the Export Control of Dual use Items of the People\'s Republic of China", and "List of Dual use Item Export Control of the People\'s Republic of China". If so, please provide the "Dual Use Item Export License" as the accompanying material for export customs declaration. The goods in the order can be searched by their product name and HSCODE. The search database can be found on the following webpage:',
  Cargo_HasVerified: 'verified',
  Cargo_ContainSensitiveWord: 'Does it contain sensitive words',
  Cargo_VoiceRecording: 'Recording... {0} seconds remaining',
  Cargo_VoiceRecordingInput: 'Recording for speech recognition, please speak...',
  Cargo_VoiceRecognizing: 'Recognizing...',
  Cargo_VoiceStopRecording: 'Stop Recording',
  Cargo_VoiceStartRecording: 'Start Recording',
  Cargo_VoiceNotInitialized: 'Voice recognition function not initialized',
  Cargo_VoiceStartRecordingTip: 'Start recording, please speak... (Maximum 60 seconds)',
  Cargo_VoiceRecordingEnd: 'Recording ended',
  Cargo_VoiceRecognitionError: 'Voice recognition error',
  Cargo_VoiceTimeLimitReached: 'Recording time limit of 60 seconds reached, automatically stopped',
  Cargo_VoiceBrowserNotSupported: 'Current browser does not support voice recognition',
  Cargo_JobsSavedSuccessfully: '{0} jobs saved successfully',
  Cargo_JobsFailedToSave: '{0} jobs failed to save',
  Cargo_BatchSaveFailed: 'Batch save failed',
  Cargo_BatchFill: 'Batch Fill',
  Cargo_PleaseAddGoods: '',
  confirmLock: '',
  confirmUnLock: '',
  Cargo_PleaseselectedGoods: '',
  Cargo_PleaseAddCheck: '',
  PriorityDisplay: 'Priority Display',
  WhenTheNodeAllDisplayed: 'When no priority is set for the node, all node data will be displayed!',
  DefaultDisplay: 'Default display:',
  PrioritizationSettings: 'Prioritization Settings',
  Cargo_OperationProvince: 'Operating province',
  Cargo_SalesProvince: 'Sales province',
  Cargo_PushTime: 'Push time',
  CargoMsg_CheckSecondCustomJobType: 'When the custom business type is level 2, the higher-level custom business type cannot be empty!',
  Cargo_OnlyApprovedAndNotFullyWrittenOffCanProcess: 'Only payment requests that are "Approved" and "Not Fully Written Off" can perform this operation!',
  Cargo_ConfirmAutoWriteOffSelectedPaymentRequests: 'Confirm automatic write-off for selected payment requests?',
  Cargo_ProcessSuccessWrittenOff: 'Process successful, {0} records written off',
  Cargo_EnterpriseWechatApprovalPayCompany: 'WeCom approval payment company',
  Cargo_ProcessFailed: 'Process failed',
  Cargo_ReleaseNumberConfigTab: 'Release Number Config',
  Cargo_LimitReleaseWithoutContract: 'Limit release without contract upload',
  Cargo_TrialOrderDays: 'Trial order days',
  Cargo_ReleaseNumberNoContract: 'Contract not uploaded, release not allowed',
  Cargo_ReleaseNumberContractExpired: 'Contract expired, release not allowed',

  // SeaExport booking list - custom position headers (named by business role)
  Cargo_UserDefinedRoleHeader1: 'Side line booking clerk',
  Cargo_UserDefinedRoleHeader2: 'Trunk line booking clerk',
  Cargo_UserDefinedRoleHeader3: 'Insurance Clerk',
  Cargo_UserDefinedRoleHeader4: 'Overseas Merchandiser',
  Cargo_UserDefinedRoleHeader5: 'Customer Service Assistant',

  Cargo_ReleaseNumberContractExpired: 'Contract expired, release not allowed',
  Cargo_InternalFeeMarkupRuleConfig: 'Internal Fee Markup Rule',
  Cargo_FeeName: 'Fee Name',
  Cargo_AllStatus: 'All Status',
  Cargo_AddRule: 'Add Rule',
  Cargo_IncomeExpenseType: 'Income/Expense Type',
  Cargo_MarkupType: 'Markup Type (Unit Price)',
  Cargo_FixedAmount: 'Fixed Amount',
  Cargo_PercentMarkup: 'Percentage Markup',
  Cargo_MarkupValue: 'Markup Value',
  Cargo_MarkupValueFixedTip: 'Please enter a valid amount with up to 2 decimals (e.g. 100.00)',
  Cargo_MarkupValuePercentTip: 'Please enter a valid percentage ending with % (e.g. 10%)',
  Cargo_ApplicableCompany: 'Applicable Company',
  Cargo_EnabledStatus: 'Enabled Status',
  Cargo_AccountsPayable: 'Payable',
  Cargo_SellTitleChangeTitle: 'Seller Title Change Notice',
  Cargo_SellTitleChangeTip: 'Modifying the seller title will overwrite the current remarks. Are you sure you want to continue modifying the seller title?'
}
